export const AirportData = [
{
	"citycode": "DXB", 
	"airport": "Dubai International Airport", 
	"country": "United Arab Emirates", 
	"city": "Dubai"}, 
{
	"citycode": "KTM", 
	"airport": "Tribhuvan International Airport", 
	"country": "Nepal", 
	"city": "Kathmandu"}, 
{
	"citycode": "MCT", 
	"airport": "Muscat International Airport", 
	"country": "Oman", 
	"city": "Muscat"}, 
{
	"citycode": "ISB", 
	"airport": "Islamabad International Airport", 
	"country": "Pakistan", 
	"city": "Islamabad"}, 
{
	"citycode": "LHE", 
	"airport": "Allama Iqbal International Airport", 
	"country": "Pakistan", 
	"city": "Lahore"}, 
{
	"citycode": "MNL", 
	"airport": "Ninoy Aquino International Airport", 
	"country": "Philippines", 
	"city": "Manila"}, 
{
	"citycode": "DMM", 
	"airport": "King Fahad International Airport", 
	"country": "Saudi Arabia", 
	"city": "Dammam"}, 
{
	"citycode": "JED", 
	"airport": "King Abdulaziz International Airport", 
	"country": "Saudi Arabia", 
	"city": "Jeddah"}, 
{
	"citycode": "RUH", 
	"airport": "King Khaled International Airport", 
	"country": "Saudi Arabia", 
	"city": "Riyadh"}, 
{
	"citycode": "SIN", 
	"airport": "Singapore Changi Airport", 
	"country": "Singapore", 
	"city": "Singapore"}, 
{
	"citycode": "BOM", 
	"airport": "Chhatrapati Shivaji Maharaj International Airport", 
	"country": "India", 
	"city": "Mumbai"}, 
{
	"citycode": "CCJ", 
	"airport": "Calicut International Airport", 
	"country": "India", 
	"city": "Kozhikode"}, 
{
	"citycode": "COK", 
	"airport": "Cochin International Airport", 
	"country": "India", 
	"city": "Cochin"}, 
{
	"citycode": "ABJ", 
	"airport": "Felix Houphouet Boigny International Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Abidjan"}, 
{
	"citycode": "ABE", 
	"airport": "Lehigh Valley International Airport", 
	"country": "USA", 
	"city": "Allentown, PA"}, 
{
	"citycode": "ABI", 
	"airport": "Abilene Regional Airport", 
	"country": "USA", 
	"city": "Abilene"}, 
{
	"citycode": "ABL", 
	"airport": "Ambler Airport", 
	"country": "USA", 
	"city": "Ambler, AK"}, 
{
	"citycode": "ABQ", 
	"airport": "Albuquerque International Sunport", 
	"country": "USA", 
	"city": "Albuquerque, NM"}, 
{
	"citycode": "ABR", 
	"airport": "Aberdeen Regional Airport", 
	"country": "USA", 
	"city": "Aberdeen, SD"}, 
{
	"citycode": "ABY", 
	"airport": "Southwest Georgia Regional Airport", 
	"country": "USA", 
	"city": "Albany, GA"}, 
{
	"citycode": "ACK", 
	"airport": "Nantucket Memorial Airport", 
	"country": "USA", 
	"city": "Nantucket, MA"}, 
{
	"citycode": "ACT", 
	"airport": "Waco Regional Airport", 
	"country": "USA", 
	"city": "Waco, TX"}, 
{
	"citycode": "ACV", 
	"airport": "California Redwood Coast-Humboldt County Airport", 
	"country": "USA", 
	"city": "Arcata, CA"}, 
{
	"citycode": "ADK", 
	"airport": "Adak Airport", 
	"country": "USA", 
	"city": "Adak Island, AK"}, 
{
	"citycode": "ADQ", 
	"airport": "Kodiak Airport", 
	"country": "USA", 
	"city": "Kodiak, AK"}, 
{
	"citycode": "ADS", 
	"airport": "Addison Airport", 
	"country": "USA", 
	"city": "Dallas, Addison, TX"}, 
{
	"citycode": "AEX", 
	"airport": "Alexandria International Airport", 
	"country": "USA", 
	"city": "Louisiana"}, 
{
	"citycode": "AGC", 
	"airport": "Allegheny County Airport", 
	"country": "USA", 
	"city": "Pittsburgh, PA"}, 
{
	"citycode": "AGS", 
	"airport": "Augusta Regional Airport ", 
	"country": "USA", 
	"city": "Augusta, GA"}, 
{
	"citycode": "AIA", 
	"airport": "Athens International Airport", 
	"country": "USA", 
	"city": "Alliance, NE"}, 
{
	"citycode": "AIN", 
	"airport": "Wainwright", 
	"country": "USA", 
	"city": "Wainwright, AK"}, 
{
	"citycode": "AIY", 
	"airport": "Bader Field (closed 2006)", 
	"country": "USA", 
	"city": "Atlantic City, NJ"}, 
{
	"citycode": "AKN", 
	"airport": "King Salmon Airport", 
	"country": "USA", 
	"city": "King Salmon, AK"}, 
{
	"citycode": "ALB", 
	"airport": "Albany International Airport", 
	"country": "USA", 
	"city": "Albany, NY"}, 
{
	"citycode": "ALM", 
	"airport": "Alamogordo–White Sands Regional Airport", 
	"country": "USA", 
	"city": "Alamogordo, NM"}, 
{
	"citycode": "ALO", 
	"airport": "Waterloo Regional Airport", 
	"country": "USA", 
	"city": "Waterloo, IA"}, 
{
	"citycode": "ALS", 
	"airport": "San Luis Valley Regional Airport", 
	"country": "USA", 
	"city": "Alamosa, CO"}, 
{
	"citycode": "ALW", 
	"airport": "Walla Walla Regional Airport", 
	"country": "USA", 
	"city": "Walla Walla, WA"}, 
{
	"citycode": "ALZ", 
	"airport": "Alitak Seaplane Base", 
	"country": "USA", 
	"city": "Alitak, AK"}, 
{
	"citycode": "AMA", 
	"airport": "Rick Husband Amarillo International Airport", 
	"country": "USA", 
	"city": "Amarillo, TX"}, 
{
	"citycode": "ANB", 
	"airport": "Anniston Regional Airport", 
	"country": "USA", 
	"city": "Anniston, AL"}, 
{
	"citycode": "ANC", 
	"airport": "Ted Stevens Anchorage International Airport", 
	"country": "USA", 
	"city": "Anchorage, AK"}, 
{
	"citycode": "ANI", 
	"airport": "Aniak Airport", 
	"country": "USA", 
	"city": "Aniak, AK"}, 
{
	"citycode": "ANV", 
	"airport": "Anvik Airport", 
	"country": "USA", 
	"city": "Anvik, AK"}, 
{
	"citycode": "AOO", 
	"airport": "Altoona–Blair County Airport", 
	"country": "USA", 
	"city": "Altoona, PA"}, 
{
	"citycode": "AOS", 
	"airport": "Amook Bay Airport", 
	"country": "USA", 
	"city": "Amook, AK"}, 
{
	"citycode": "APA", 
	"airport": "Arapahoe County - Centennial Airport", 
	"country": "USA", 
	"city": "Denver, CO"}, 
{
	"citycode": "APC", 
	"airport": "Napa County Airport", 
	"country": "USA", 
	"city": "Napa, CA"}, 
{
	"citycode": "APF", 
	"airport": "Naples Airport", 
	"country": "USA", 
	"city": "Naples, FL"}, 
{
	"citycode": "APN", 
	"airport": "Alpena County Regional Airport", 
	"country": "USA", 
	"city": "Alpena, MI"}, 
{
	"citycode": "ARC", 
	"airport": "Arctic Village Airport", 
	"country": "USA", 
	"city": "Arctic Village, AK"}, 
{
	"citycode": "ART", 
	"airport": "Watertown International Airport", 
	"country": "USA", 
	"city": "Watertown, NY"}, 
{
	"citycode": "ARV", 
	"airport": "Lakeland Airport", 
	"country": "USA", 
	"city": "Minocqua, WI"}, 
{
	"citycode": "ASE", 
	"airport": "Aspen/Pitkin County Airport", 
	"country": "USA", 
	"city": "Aspen, CO"}, 
{
	"citycode": "ATK", 
	"airport": "Atqasuk Edward Burnell Sr. Memorial Airport", 
	"country": "USA", 
	"city": "Atqasuk, AK"}, 
{
	"citycode": "ATL", 
	"airport": "Hartsfield-Jackson Atlanta International Airport", 
	"country": "USA", 
	"city": "Atlanta, GA"}, 
{
	"citycode": "ATT", 
	"airport": "Atmautluak Airport", 
	"country": "USA", 
	"city": "Atmautluak, AK"}, 
{
	"citycode": "CAI", 
	"airport": "Cairo International Airport", 
	"country": "Egypt", 
	"city": "Cairo"}, 
{
	"citycode": "DAC", 
	"airport": "Hazrat Shahjalal International Airport", 
	"country": "Bangladesh", 
	"city": "Dhaka"}, 
{
	"citycode": "SPX", 
	"airport": "Sphinx international airport", 
	"country": "Egypt", 
	"city": "Giza"}, 
{
	"citycode": "ATW", 
	"airport": "Appleton International Airport", 
	"country": "USA", 
	"city": "Appleton, WI"}, 
{
	"citycode": "ATY", 
	"airport": "Watertown Regional Airport", 
	"country": "USA", 
	"city": "Watertown, SD"}, 
{
	"citycode": "AUG", 
	"airport": "Augusta State Airport", 
	"country": "USA", 
	"city": "Augusta, ME"}, 
{
	"citycode": "AUK", 
	"airport": "Alakanuk Airport", 
	"country": "USA", 
	"city": "Alakanuk, AK"}, 
{
	"citycode": "AUS", 
	"airport": "Austin-Bergstrom International Airport", 
	"country": "USA", 
	"city": "Austin, TX"}, 
{
	"citycode": "AVL", 
	"airport": "Asheville Regional Airport", 
	"country": "USA", 
	"city": "Asheville, NC"}, 
{
	"citycode": "AVP", 
	"airport": "Wilkes-Barre International", 
	"country": "USA", 
	"city": "Scranton, PA"}, 
{
	"citycode": "AVW", 
	"airport": "Marana Regional Airport", 
	"country": "USA", 
	"city": "Tucson, AZ"}, 
{
	"citycode": "AVX", 
	"airport": "Catalina Airport", 
	"country": "USA", 
	"city": "Catalina Island, CA"}, 
{
	"citycode": "AZO", 
	"airport": "Kalamazoo/Battle Creek International Airport", 
	"country": "USA", 
	"city": "Kalamazoo, MI"}, 
{
	"citycode": "BBB", 
	"airport": "Benson Municipal Airport", 
	"country": "USA", 
	"city": "Benson, MN"}, 
{
	"citycode": "BBF", 
	"airport": "Burlington Airport", 
	"country": "USA", 
	"city": "Burlington, MA"}, 
{
	"citycode": "BBX", 
	"airport": "Wings Field Airport", 
	"country": "USA", 
	"city": "Blue Bell, PA"}, 
{
	"citycode": "BCE", 
	"airport": "Bryce Canyon Airport", 
	"country": "USA", 
	"city": "Bryce, UT"}, 
{
	"citycode": "BCT", 
	"airport": "Boca Raton Airport", 
	"country": "USA", 
	"city": "Boca Raton, FL"}, 
{
	"citycode": "BDL", 
	"airport": "Bradley International Airport", 
	"country": "USA", 
	"city": "Hartford, Windsor Locks, CT"}, 
{
	"citycode": "BDR", 
	"airport": "Sikorsky Memorial Airport", 
	"country": "USA", 
	"city": "Bridgeport, CT"}, 
{
	"citycode": "BEC", 
	"airport": "Beech Factory Airport", 
	"country": "USA", 
	"city": "Wichita, KS"}, 
{
	"citycode": "BET", 
	"airport": "Bethel Airport", 
	"country": "USA", 
	"city": "Bethel, AK"}, 
{
	"citycode": "BFD", 
	"airport": "Bradford Regional Airport", 
	"country": "USA", 
	"city": "Bradford, PA"}, 
{
	"citycode": "BFF", 
	"airport": "Western Nebraska-Scottsbluff Regional Airport", 
	"country": "USA", 
	"city": "Scottsbluff, NE"}, 
{
	"citycode": "BFI", 
	"airport": "King County International Airport", 
	"country": "USA", 
	"city": "Seattle, WA"}, 
{
	"citycode": "BFL", 
	"airport": "Meadows Field Airport", 
	"country": "USA", 
	"city": "Bakersfield, CA"}, 
{
	"citycode": "BGM", 
	"airport": "Greater Binghamton Airport", 
	"country": "USA", 
	"city": "Johnson City, NY"}, 
{
	"citycode": "BGR", 
	"airport": "Bangor International Airport", 
	"country": "USA", 
	"city": "Bangor, ME"}, 
{
	"citycode": "BHB", 
	"airport": "Hancock County-Bar Harbor Airport", 
	"country": "USA", 
	"city": "Bar Harbour, ME"}, 
{
	"citycode": "BHM", 
	"airport": "Birmingham–Shuttlesworth International Airport", 
	"country": "USA", 
	"city": "Birmingham, AL"}, 
{
	"citycode": "BID", 
	"airport": "Block Island State Airport", 
	"country": "USA", 
	"city": "Block Island, RI"}, 
{
	"citycode": "BIH", 
	"airport": "Eastern Sierra Regional Airport", 
	"country": "USA", 
	"city": "Bishop, CA"}, 
{
	"citycode": "BIL", 
	"airport": "Billings-Logan International Airport", 
	"country": "USA", 
	"city": "Billings, MT"}, 
{
	"citycode": "BIS", 
	"airport": "Bismarck Municipal Airport", 
	"country": "USA", 
	"city": "Bismarck, ND"}, 
{
	"citycode": "BJI", 
	"airport": "Bemidji Regional Airport", 
	"country": "USA", 
	"city": "Bemidji, MN"}, 
{
	"citycode": "BKC", 
	"airport": "Buckland Airport", 
	"country": "USA", 
	"city": "Buckland, AK"}, 
{
	"citycode": "BKL", 
	"airport": "Cleveland Burke Lakefront Airport", 
	"country": "USA", 
	"city": "Cleveland, OH"}, 
{
	"citycode": "BKW", 
	"airport": "Raleigh County Memorial Airport", 
	"country": "USA", 
	"city": "Beckley, WV"}, 
{
	"citycode": "BKX", 
	"airport": "Brookings Regional Airport", 
	"country": "USA", 
	"city": "Brookings, SD"}, 
{
	"citycode": "BLF", 
	"airport": "Mercer County Airport", 
	"country": "USA", 
	"city": "Princeton, WV"}, 
{
	"citycode": "BLI", 
	"airport": "Bellingham International Airport", 
	"country": "USA", 
	"city": "Bellingham, WA"}, 
{
	"citycode": "BMG", 
	"airport": "Monroe County Airport", 
	"country": "USA", 
	"city": "Bloomington, IN"}, 
{
	"citycode": "BMI", 
	"airport": "Central Illinois Regional Airport at Bloomington-Normal", 
	"country": "USA", 
	"city": "Bloomington-Normal, IL"}, 
{
	"citycode": "BNA", 
	"airport": "Nashville International Airport", 
	"country": "USA", 
	"city": "Nashville, TN"}, 
{
	"citycode": "BOI", 
	"airport": "Boise Airport", 
	"country": "USA", 
	"city": "Boise, ID"}, 
{
	"citycode": "BOS", 
	"airport": "Logan International Airport", 
	"country": "USA", 
	"city": "Boston, MA"}, 
{
	"citycode": "BPT", 
	"airport": "Jack Brooks Regional Airport", 
	"country": "USA", 
	"city": "Beaumont, TX"}, 
{
	"citycode": "BQK", 
	"airport": "Brunswick Golden Isles Airport", 
	"country": "USA", 
	"city": "Brunswick, GA"}, 
{
	"citycode": "BRL", 
	"airport": "Southeast Iowa-Burlington Regional Airport", 
	"country": "USA", 
	"city": "Burlington, IA"}, 
{
	"citycode": "BRO", 
	"airport": "Brownsville South Padre Island International Airport", 
	"country": "USA", 
	"city": "Brownsville, TX"}, 
{
	"citycode": "BRW", 
	"airport": "Wiley Post-Will Rogers Memorial Airport", 
	"country": "USA", 
	"city": "Barrow, AK"}, 
{
	"citycode": "BTI", 
	"airport": "Barter Island Long Range Radar Service Airport", 
	"country": "USA", 
	"city": "Barter Island, AK"}, 
{
	"citycode": "BTL", 
	"airport": "WK Kellogg Regional Airport", 
	"country": "USA", 
	"city": "Battle Creek, MI"}, 
{
	"citycode": "BTM", 
	"airport": "Bert Mooney Airport", 
	"country": "USA", 
	"city": "Butte, MT"}, 
{
	"citycode": "BTR", 
	"airport": "Baton Rouge Metropolitan Airport", 
	"country": "USA", 
	"city": "Baton Rouge, LA"}, 
{
	"citycode": "BTT", 
	"airport": "Bettles Airport", 
	"country": "USA", 
	"city": "Bettles, AK"}, 
{
	"citycode": "BTV", 
	"airport": "Patrick Leahy Burlington International Airport", 
	"country": "USA", 
	"city": "Burlington, VT"}, 
{
	"citycode": "BUF", 
	"airport": "Buffalo Niagara International Airport.", 
	"country": "USA", 
	"city": "Buffalo, NY"}, 
{
	"citycode": "BUR", 
	"airport": "Hollywood Burbank Airport", 
	"country": "USA", 
	"city": "Burbank, CA"}, 
{
	"citycode": "BWD", 
	"airport": "Brownwood Regional Airport", 
	"country": "USA", 
	"city": "Brownwood, TX"}, 
{
	"citycode": "BWI", 
	"airport": "Baltimore-Washington International Airport", 
	"country": "USA", 
	"city": "Baltimore, MD"}, 
{
	"citycode": "BXC", 
	"airport": "Boxborough Airport", 
	"country": "USA, MA", 
	"city": "Boxborough"}, 
{
	"citycode": "BZN", 
	"airport": "Bozeman Yellowstone International Airport", 
	"country": "USA", 
	"city": "Bozeman, MT"}, 
{
	"citycode": "CAE", 
	"airport": "Columbia Metropolitan Airport", 
	"country": "USA", 
	"city": "Columbia, SC"}, 
{
	"citycode": "CAK", 
	"airport": "Akron-Canton Airport", 
	"country": "USA", 
	"city": "Akron-Canton, OH"}, 
{
	"citycode": "CCR", 
	"airport": "Buchanan Field Airport", 
	"country": "USA", 
	"city": "Concord, CA"}, 
{
	"citycode": "CDB", 
	"airport": "Cold Bay Airport", 
	"country": "USA", 
	"city": "Cold Bay, AK"}, 
{
	"citycode": "CDC", 
	"airport": "Cedar City Regional Airport", 
	"country": "USA", 
	"city": "Cedar City, UT"}, 
{
	"citycode": "CDR", 
	"airport": "Chadron Municipal Airport", 
	"country": "USA", 
	"city": "Chadron, NE"}, 
{
	"citycode": "CDV", 
	"airport": "Merle K (Mudhole) Smith Airport", 
	"country": "USA", 
	"city": "Cordova, AK"}, 
{
	"citycode": "CEA", 
	"airport": "Cessna Aircraft Field Airport", 
	"country": "USA", 
	"city": "Wichita, KS"}, 
{
	"citycode": "CEC", 
	"airport": "Del Norte County Regional Airport", 
	"country": "USA", 
	"city": "Crescent City, CA"}, 
{
	"citycode": "CEF", 
	"airport": "Westover Metropolitan Airport ", 
	"country": "USA", 
	"city": "Chicopee, MA"}, 
{
	"citycode": "CEZ", 
	"airport": "Cortez Municipal Airport", 
	"country": "USA", 
	"city": "Cortez, CO"}, 
{
	"citycode": "CGA", 
	"airport": "Craig Seaplane Base Airport", 
	"country": "USA", 
	"city": "Craig, AK"}, 
{
	"citycode": "CGF", 
	"airport": "Cuyahoga County Airport", 
	"country": "USA", 
	"city": "Cleveland, OH"}, 
{
	"citycode": "CGI", 
	"airport": "Cape Girardeau Regional Airport", 
	"country": "USA", 
	"city": "Cape Girardeau, MO"}, 
{
	"citycode": "CGS", 
	"airport": "College Park Airport", 
	"country": "USA", 
	"city": "College Park, MD"}, 
{
	"citycode": "CGX", 
	"airport": "Merrill C Meigs Airport", 
	"country": "USA", 
	"city": "Chicago, IL"}, 
{
	"citycode": "CHA", 
	"airport": "Chattanooga Metropolitan Airport", 
	"country": "USA", 
	"city": "Chattanooga, TN"}, 
{
	"citycode": "CHO", 
	"airport": "Charlottesville–Albemarle Airport", 
	"country": "USA", 
	"city": "Charlottesville, VA"}, 
{
	"citycode": "CHU", 
	"airport": "Chuathbaluk Airport", 
	"country": "USA", 
	"city": "Chuathbaluk, AK"}, 
{
	"citycode": "CIB", 
	"airport": "Catalina Airport", 
	"country": "USA", 
	"city": "Catalina Island, CA"}, 
{
	"citycode": "CIC", 
	"airport": "Chico Regional Airport", 
	"country": "USA", 
	"city": "Chico, CA"}, 
{
	"citycode": "CID", 
	"airport": "Eastern Iowa Airport", 
	"country": "USA", 
	"city": "Cedar Rapids, IA"}, 
{
	"citycode": "CIK", 
	"airport": "Chalkyitsik Airport", 
	"country": "USA", 
	"city": "Chalkyitsik, AK"}, 
{
	"citycode": "CIL", 
	"airport": "Council Airport", 
	"country": "USA", 
	"city": "Council, AK"}, 
{
	"citycode": "CIU", 
	"airport": "Chippewa County International Airport", 
	"country": "USA", 
	"city": "Sault Ste Marie, MI"}, 
{
	"citycode": "CKB", 
	"airport": "North Central West Virginia Airport", 
	"country": "USA", 
	"city": "Clarksburg, WV"}, 
{
	"citycode": "CKD", 
	"airport": "Crooked Creek Airport", 
	"country": "USA", 
	"city": "Crooked Creek, AK"}, 
{
	"citycode": "CLD", 
	"airport": "McClellan-Palomar Airport", 
	"country": "USA", 
	"city": "Carlsbad, CA"}, 
{
	"citycode": "CLE", 
	"airport": "Cleveland Hopkins International Airport", 
	"country": "USA", 
	"city": "Cleveland, OH"}, 
{
	"citycode": "CLL", 
	"airport": "Easterwood Airport", 
	"country": "USA", 
	"city": "College Station, TX"}, 
{
	"citycode": "CLM", 
	"airport": "Fairchild International Airport", 
	"country": "USA", 
	"city": "Port Angeles, WA"}, 
{
	"citycode": "CLP", 
	"airport": "Clarks Point Airport", 
	"country": "USA", 
	"city": "Clarks Point, AK"}, 
{
	"citycode": "CLT", 
	"airport": "Charlotte Douglas International Airport", 
	"country": "USA", 
	"city": "Charlotte, NC"}, 
{
	"citycode": "CMH", 
	"airport": "John Glenn Columbus International Airport", 
	"country": "USA", 
	"city": "Columbus, OH"}, 
{
	"citycode": "CMI", 
	"airport": "Willard Airport", 
	"country": "USA", 
	"city": "Champaign, IL"}, 
{
	"citycode": "CMX", 
	"airport": "Houghton County Memorial Airport", 
	"country": "USA", 
	"city": "Hancock, MI"}, 
{
	"citycode": "CNM", 
	"airport": "Cavern City Air Terminal", 
	"country": "USA", 
	"city": "Carlsbad, NM"}, 
{
	"citycode": "CNO", 
	"airport": "Chino Airport", 
	"country": "USA", 
	"city": "Chino, CA"}, 
{
	"citycode": "CNW", 
	"airport": "TSTC Waco Airport", 
	"country": "USA", 
	"city": "Waco, TX"}, 
{
	"citycode": "CNY", 
	"airport": "Canyonlands Field Airport", 
	"country": "USA", 
	"city": "Moab, UT"}, 
{
	"citycode": "COD", 
	"airport": "Yellowstone Regional Airport", 
	"country": "USA", 
	"city": "Cody-Yellowstone, WY"}, 
{
	"citycode": "COE", 
	"airport": "Coeur D`Alene Airport", 
	"country": "USA", 
	"city": "Coeur D`Alene, ID"}, 
{
	"citycode": "COS", 
	"airport": "Colorado Springs Municipal Airport", 
	"country": "USA", 
	"city": "Colorado Springs, CO"}, 
{
	"citycode": "COU", 
	"airport": "Columbia Regional Airport ", 
	"country": "USA", 
	"city": "Columbia, MO"}, 
{
	"citycode": "CPM", 
	"airport": "Compton/Woodley Airport", 
	"country": "USA", 
	"city": "Compton, CA"}, 
{
	"citycode": "CPR", 
	"airport": "Casper-Natrona County International Airport", 
	"country": "USA", 
	"city": "Casper, WY"}, 
{
	"citycode": "CRP", 
	"airport": "Corpus Christi International Airport", 
	"country": "USA", 
	"city": "Corpus Christi, TX"}, 
{
	"citycode": "CRW", 
	"airport": "West Virginia International Yeager Airport", 
	"country": "USA", 
	"city": "Charleston, WV"}, 
{
	"citycode": "CSG", 
	"airport": "Columbus Airport", 
	"country": "USA", 
	"city": "GEORGIA"}, 
{
	"citycode": "CSL", 
	"airport": "Cabo San Lucas International Airport", 
	"country": "USA", 
	"city": "San Luis Obispo, CA"}, 
{
	"citycode": "CSN", 
	"airport": "Carson Airport", 
	"country": "USA", 
	"city": "Carson City, NV"}, 
{
	"citycode": "CVG", 
	"airport": "Cincinnati/Northern Kentucky International Airport", 
	"country": "USA", 
	"city": "Cincinnati, OH"}, 
{
	"citycode": "CVN", 
	"airport": "Clovis Regional Airport", 
	"country": "USA", 
	"city": "Clovis, NM"}, 
{
	"citycode": "CVR", 
	"airport": "Hughes Airport", 
	"country": "USA", 
	"city": "Culver City, CA"}, 
{
	"citycode": "CWA", 
	"airport": "Central Wisconsin Airport", 
	"country": "USA", 
	"city": "Wausau, WI"}, 
{
	"citycode": "CXL", 
	"airport": "Calexico International Airport", 
	"country": "USA", 
	"city": "Calexico, CA"}, 
{
	"citycode": "CYF", 
	"airport": "Chefornak Airport", 
	"country": "USA", 
	"city": "Chefornak, AK"}, 
{
	"citycode": "CYS", 
	"airport": "Cheyenne Regional Airport", 
	"country": "USA", 
	"city": "Cheyenne, WY"}, 
{
	"citycode": "DAB", 
	"airport": "Daytona Beach International Airport", 
	"country": "USA", 
	"city": "Daytona Beach, FL"}, 
{
	"citycode": "DAL", 
	"airport": "Dallas Love Field", 
	"country": "USA", 
	"city": "Dallas, TX"}, 
{
	"citycode": "DAN", 
	"airport": "Danville Regional Airport", 
	"country": "USA", 
	"city": "Danville, VA"}, 
{
	"citycode": "DAY", 
	"airport": "Dayton International Airport", 
	"country": "USA", 
	"city": "Dayton, OH"}, 
{
	"citycode": "DBQ", 
	"airport": "Dubuque Regional Airport", 
	"country": "USA", 
	"city": "Dubuque, IA"}, 
{
	"citycode": "DCA", 
	"airport": "Ronald Reagan Washington National Airport", 
	"country": "USA", 
	"city": "Washington, DC"}, 
{
	"citycode": "DDC", 
	"airport": "Dodge City Regional Airport", 
	"country": "USA", 
	"city": "Dodge City, KS"}, 
{
	"citycode": "DEC", 
	"airport": "Decatur Airport", 
	"country": "USA", 
	"city": "Decatur, IL"}, 
{
	"citycode": "DEN", 
	"airport": "Denver International", 
	"country": "USA", 
	"city": "Denver, CO"}, 
{
	"citycode": "DET", 
	"airport": "Coleman A. Young International Airport", 
	"country": "USA", 
	"city": "Detroit, MI"}, 
{
	"citycode": "DFW", 
	"airport": "Dallas-Fort Worth International Airport", 
	"country": "USA", 
	"city": "Dallas, TX"}, 
{
	"citycode": "DHN", 
	"airport": "Dothan Regional Airport", 
	"country": "USA", 
	"city": "Dothan, AL"}, 
{
	"citycode": "DIO", 
	"airport": "Diomede Island Airport", 
	"country": "USA", 
	"city": "Diomede Island, AK"}, 
{
	"citycode": "DJN", 
	"airport": "Delta Junction Airport", 
	"country": "USA, AK", 
	"city": "Delta Junction"}, 
{
	"citycode": "DLG", 
	"airport": "Dillingham Airport", 
	"country": "USA", 
	"city": "Dillingham, AK"}, 
{
	"citycode": "DLH", 
	"airport": "Duluth International Airport", 
	"country": "USA", 
	"city": "Duluth, MN"}, 
{
	"citycode": "DLO", 
	"airport": "Dolomi Airport", 
	"country": "USA", 
	"city": "Dolomi, AK"}, 
{
	"citycode": "DNE", 
	"airport": "Dallas North Airport", 
	"country": "USA", 
	"city": "Dallas, TX"}, 
{
	"citycode": "DNL", 
	"airport": "Daniel Field Airport", 
	"country": "USA", 
	"city": "Augusta, GA"}, 
{
	"citycode": "DOF", 
	"airport": "Dora Bay Airport", 
	"country": "USA", 
	"city": "Dora Bay, AK"}, 
{
	"citycode": "DPA", 
	"airport": "Dupage Airport", 
	"country": "USA", 
	"city": "Chicago, IL"}, 
{
	"citycode": "DRG", 
	"airport": "Deering Airport", 
	"country": "USA", 
	"city": "Deering, AK"}, 
{
	"citycode": "DRO", 
	"airport": "Durango–La Plata County Airport ", 
	"country": "USA", 
	"city": "Durango, CO"}, 
{
	"citycode": "DSM", 
	"airport": "Des Moines International Airport", 
	"country": "USA", 
	"city": "Des Moines, IA"}, 
{
	"citycode": "DTT", 
	"airport": "Detroit - All Airports", 
	"country": "USA", 
	"city": "Detroit"}, 
{
	"citycode": "DTW", 
	"airport": "Detroit Metro Wayne County", 
	"country": "USA", 
	"city": "Detroit, MI"}, 
{
	"citycode": "DUJ", 
	"airport": "Dubois Regional Airport", 
	"country": "USA", 
	"city": "Dubois, PA"}, 
{
	"citycode": "DVT", 
	"airport": "Phoenix-Deer Valley Airport", 
	"country": "USA", 
	"city": "Phoenix, AZ"}, 
{
	"citycode": "EAA", 
	"airport": "Eagle Airport", 
	"country": "USA", 
	"city": "Eagle, AK"}, 
{
	"citycode": "EAR", 
	"airport": "Kearney Regional Airport", 
	"country": "USA", 
	"city": "Kearney, NE"}, 
{
	"citycode": "EAT", 
	"airport": "Pangborn Memorial Airport", 
	"country": "USA", 
	"city": "Wenatchee, WA"}, 
{
	"citycode": "EAU", 
	"airport": "Chippewa Valley Regional Airport", 
	"country": "USA", 
	"city": "Eau Claire, WI"}, 
{
	"citycode": "ECG", 
	"airport": "Elizabeth City regional Airport", 
	"country": "USA", 
	"city": "Elizabeth City, NC"}, 
{
	"citycode": "EDA", 
	"airport": "Edna Bay Airport", 
	"country": "USA", 
	"city": "Edna Bay, AK"}, 
{
	"citycode": "EDF", 
	"airport": "Elmendorf AFB Airport", 
	"country": "USA", 
	"city": "Anchorage, AK"}, 
{
	"citycode": "EEK", 
	"airport": "Eek Airport", 
	"country": "USA", 
	"city": "Eek, AK"}, 
{
	"citycode": "EFD", 
	"airport": "Ellington Airport", 
	"country": "USA", 
	"city": "Houston, TX"}, 
{
	"citycode": "EGE", 
	"airport": "Eagle County Regional Airport", 
	"country": "USA", 
	"city": "Vail-Eagle, CO"}, 
{
	"citycode": "EGV", 
	"airport": "Eagle River Union Airport", 
	"country": "USA", 
	"city": "Eagle River, WI"}, 
{
	"citycode": "EGX", 
	"airport": "Egegik Airport", 
	"country": "USA", 
	"city": "Egegik, AK"}, 
{
	"citycode": "EKN", 
	"airport": "Elkins-Randolph Co-Jennings Randolph Field Airport", 
	"country": "USA", 
	"city": "Elkins, WV"}, 
{
	"citycode": "EKO", 
	"airport": "Elko Regional Airport", 
	"country": "USA", 
	"city": "Elko, NV"}, 
{
	"citycode": "ELI", 
	"airport": "Elim Airport", 
	"country": "USA", 
	"city": "Elim, AK"}, 
{
	"citycode": "ELM", 
	"airport": "Elmira Corning Regional Airport", 
	"country": "USA", 
	"city": "Elmira, NY"}, 
{
	"citycode": "ELP", 
	"airport": "El Paso International Airport", 
	"country": "USA", 
	"city": "El Paso, TX"}, 
{
	"citycode": "ELV", 
	"airport": "Elfin Cove SPB Airport", 
	"country": "USA", 
	"city": "Elfin Cove, AK"}, 
{
	"citycode": "ELY", 
	"airport": "ELY Airport", 
	"country": "USA", 
	"city": "Ely, NV"}, 
{
	"citycode": "EMK", 
	"airport": "Emmonak Airport", 
	"country": "USA", 
	"city": "Emmonak, AK"}, 
{
	"citycode": "ENA", 
	"airport": "Kenai Municipal Airport", 
	"country": "USA", 
	"city": "Kenai, AK"}, 
{
	"citycode": "ERI", 
	"airport": "Erie International Airport ", 
	"country": "USA", 
	"city": "Erie, PA"}, 
{
	"citycode": "ESC", 
	"airport": "Delta County Airport", 
	"country": "USA", 
	"city": "Escanaba, MI"}, 
{
	"citycode": "ESD", 
	"airport": "Orcas Island Airport", 
	"country": "USA", 
	"city": "Eastsound, WA"}, 
{
	"citycode": "ESF", 
	"airport": "Esler Regional Airport", 
	"country": "USA", 
	"city": "Alexandria, LA"}, 
{
	"citycode": "EUG", 
	"airport": "Eugene Airport", 
	"country": "USA", 
	"city": "Eugene, OR"}, 
{
	"citycode": "EVV", 
	"airport": "Evansville Regional Airport ", 
	"country": "USA", 
	"city": "Evansville, IN"}, 
{
	"citycode": "EWB", 
	"airport": "New Bedford Regional Airport ", 
	"country": "USA", 
	"city": "Fall River, MA"}, 
{
	"citycode": "EWN", 
	"airport": "Coastal Carolina Regional Airport", 
	"country": "USA", 
	"city": "New Bern, NC"}, 
{
	"citycode": "EWR", 
	"airport": "Newark Liberty International Airport", 
	"country": "USA", 
	"city": "Newark, NJ"}, 
{
	"citycode": "EXI", 
	"airport": "Excursion Inlet Seaplane Base", 
	"country": "USA", 
	"city": "Excursion Inlet, AK"}, 
{
	"citycode": "EYW", 
	"airport": "Key West International Airport", 
	"country": "USA", 
	"city": "Key West, FL"}, 
{
	"citycode": "FAI", 
	"airport": "Fairbanks International Airport", 
	"country": "USA", 
	"city": "Fairbanks, AK"}, 
{
	"citycode": "FAR", 
	"airport": "Hector International Airport", 
	"country": "USA", 
	"city": "Fargo, ND"}, 
{
	"citycode": "FAT", 
	"airport": "Fresno Yosemite International Airport", 
	"country": "USA", 
	"city": "Fresno, CA"}, 
{
	"citycode": "FAY", 
	"airport": "Fayetteville Regional Airport", 
	"country": "USA", 
	"city": "Fayetteville, NC"}, 
{
	"citycode": "FCA", 
	"airport": "Glacier Park International Airport", 
	"country": "USA", 
	"city": "Kalispell, MT"}, 
{
	"citycode": "FFO", 
	"airport": "Wright-Patterson Air Force Base ", 
	"country": "USA", 
	"city": "Dayton, OH"}, 
{
	"citycode": "FHU", 
	"airport": "Sierra Vista Municipal Airport", 
	"country": "USA", 
	"city": "Sierra Vista, AZ"}, 
{
	"citycode": "FIC", 
	"airport": "Fire Cove Airport", 
	"country": "USA", 
	"city": "Fire Cove, AK"}, 
{
	"citycode": "FID", 
	"airport": "Elizabeth Field Airport", 
	"country": "USA", 
	"city": "Fishers Island, NY"}, 
{
	"citycode": "FKL", 
	"airport": "Venango Regional Airport", 
	"country": "USA", 
	"city": "Franklin, PA"}, 
{
	"citycode": "FLG", 
	"airport": "Flagstaff Pulliam Airport ", 
	"country": "USA", 
	"city": "Grand Canyon, AZ"}, 
{
	"citycode": "FLL", 
	"airport": "Fort Lauderdale-Hollywood International Airport", 
	"country": "USA", 
	"city": "Fort Lauderdale, FL"}, 
{
	"citycode": "FLO", 
	"airport": "Florence Regional Airport", 
	"country": "USA", 
	"city": "Florence, SC"}, 
{
	"citycode": "FLT", 
	"airport": "Flat Airport", 
	"country": "USA", 
	"city": "Flat, AK"}, 
{
	"citycode": "FMN", 
	"airport": "Four Corners Regional Airport", 
	"country": "USA", 
	"city": "Farmington, NM"}, 
{
	"citycode": "FMY", 
	"airport": "Page Field Airport", 
	"country": "USA", 
	"city": "Fort Myers, FL"}, 
{
	"citycode": "FNL", 
	"airport": "Northern Colorado Regional Airport", 
	"country": "USA", 
	"city": "Fort Collins-Loveland, CO"}, 
{
	"citycode": "FNT", 
	"airport": "Flint Bishop International Airport", 
	"country": "USA", 
	"city": "Flint, MI"}, 
{
	"citycode": "FOD", 
	"airport": "Fort Dodge Regional Airport", 
	"country": "USA", 
	"city": "Fort Dodge, IA"}, 
{
	"citycode": "FOE", 
	"airport": "Topeka Regional Airport", 
	"country": "USA", 
	"city": "Topeka, KS"}, 
{
	"citycode": "FPR", 
	"airport": "St. Lucie County International Airport", 
	"country": "USA", 
	"city": "Fort Pierce, FL"}, 
{
	"citycode": "FRD", 
	"airport": "Friday Harbor Airport", 
	"country": "USA, WA", 
	"city": "Friday Harbor"}, 
{
	"citycode": "FRG", 
	"airport": "Republic Airport", 
	"country": "USA", 
	"city": "Farmingdale, NY"}, 
{
	"citycode": "FRM", 
	"airport": "Fairmont Municipal Airport", 
	"country": "USA", 
	"city": "Fairmont, MN"}, 
{
	"citycode": "FRP", 
	"airport": "Fresh Water Bay Airport", 
	"country": "USA", 
	"city": "Fresh Water Bay, AK"}, 
{
	"citycode": "FSD", 
	"airport": "Sioux Falls Regional Airport", 
	"country": "USA", 
	"city": "Sioux Falls, SD"}, 
{
	"citycode": "FSM", 
	"airport": "Fort Smith Regional Airport", 
	"country": "USA", 
	"city": "Fort Smith, AR"}, 
{
	"citycode": "FTW", 
	"airport": "Fort Worth Meacham International Airport", 
	"country": "USA", 
	"city": "Fort Worth-Dallas, TX"}, 
{
	"citycode": "FTY", 
	"airport": "Fulton County Executive Airport ", 
	"country": "USA", 
	"city": "Atlanta, GA"}, 
{
	"citycode": "FUL", 
	"airport": "Fullerton Municipal Airport", 
	"country": "USA", 
	"city": "Fullerton, CA"}, 
{
	"citycode": "FWA", 
	"airport": "Fort Wayne International Airport", 
	"country": "USA", 
	"city": "Fort Wayne, IN"}, 
{
	"citycode": "FXE", 
	"airport": "Fort Lauderdale Executive Airport", 
	"country": "USA", 
	"city": "Fort Lauderdale, FL"}, 
{
	"citycode": "FYV", 
	"airport": "Drake Field", 
	"country": "USA", 
	"city": "Fayetteville, AR"}, 
{
	"citycode": "GAD", 
	"airport": "Northeast Alabama Regional Airport", 
	"country": "USA", 
	"city": "Gadsden, AL"}, 
{
	"citycode": "GAL", 
	"airport": "Edward G Pitka Sr Airport", 
	"country": "USA", 
	"city": "Galena, AK"}, 
{
	"citycode": "GAM", 
	"airport": "Gambell Airport", 
	"country": "USA", 
	"city": "Gambell, AK"}, 
{
	"citycode": "GBD", 
	"airport": "Great Bend Municipal Airport ", 
	"country": "USA", 
	"city": "Great Bend, KS"}, 
{
	"citycode": "GBO", 
	"airport": "Baltimore Greenbelt T Airport", 
	"country": "USA", 
	"city": "Baltimore, MD"}, 
{
	"citycode": "GCC", 
	"airport": "Gillette–Campbell County Airport", 
	"country": "USA", 
	"city": "Gillette, WY"}, 
{
	"citycode": "GCK", 
	"airport": "Garden City Regional Airport ", 
	"country": "USA", 
	"city": "Garden City, KS"}, 
{
	"citycode": "GCN", 
	"airport": "Grand Canyon National Park Airport", 
	"country": "USA", 
	"city": "Grand Canyon, AZ"}, 
{
	"citycode": "GDV", 
	"airport": "Dawson Community Airport", 
	"country": "USA", 
	"city": "Glendive, MT"}, 
{
	"citycode": "GEG", 
	"airport": "Spokane International Airport", 
	"country": "USA", 
	"city": "Spokane, WA"}, 
{
	"citycode": "GEY", 
	"airport": "South Big Horn County Airport", 
	"country": "USA", 
	"city": "Greybull, WY"}, 
{
	"citycode": "GFK", 
	"airport": "Grand Forks International Airport", 
	"country": "USA", 
	"city": "Grand Forks, ND"}, 
{
	"citycode": "GGG", 
	"airport": "East Texas Regional Airport", 
	"country": "USA", 
	"city": "Longview, TX"}, 
{
	"citycode": "GGW", 
	"airport": "Glasgow Valley County Airport", 
	"country": "USA", 
	"city": "Glasgow, MT"}, 
{
	"citycode": "GJT", 
	"airport": "Grand Junction Regional Airport", 
	"country": "USA", 
	"city": "Grand Junction, CO"}, 
{
	"citycode": "GLD", 
	"airport": "Goodland Municipal Airport", 
	"country": "USA", 
	"city": "Goodland, KS"}, 
{
	"citycode": "GLH", 
	"airport": "Greenville Mid-Delta Airport", 
	"country": "USA", 
	"city": "Greenville, MS"}, 
{
	"citycode": "GLS", 
	"airport": "Scholes International Airport", 
	"country": "USA", 
	"city": "Galveston, TX"}, 
{
	"citycode": "GLV", 
	"airport": "Golovin Airport", 
	"country": "USA", 
	"city": "Golovin, AK"}, 
{
	"citycode": "GNU", 
	"airport": "Goodnews Airport", 
	"country": "USA", 
	"city": "Goodnews Bay, AK"}, 
{
	"citycode": "GNV", 
	"airport": "Gainesville Regional Airport ", 
	"country": "USA", 
	"city": "Gainesville, FL"}, 
{
	"citycode": "GON", 
	"airport": "Groton-New London Airport", 
	"country": "USA", 
	"city": "Groton, CT"}, 
{
	"citycode": "GPT", 
	"airport": "Gulfport-Biloxi International Airport", 
	"country": "USA", 
	"city": "Gulfport, MS"}, 
{
	"citycode": "GPZ", 
	"airport": "Grand Rapids/Itasca County Airport", 
	"country": "USA", 
	"city": "Grand Rapids, MN"}, 
{
	"citycode": "GRB", 
	"airport": "Guarapuava Airport", 
	"country": "USA", 
	"city": "Green Bay, WI"}, 
{
	"citycode": "GRI", 
	"airport": "Central Nebraska Regional Airport", 
	"country": "USA", 
	"city": "Grand Island, NE"}, 
{
	"citycode": "GRR", 
	"airport": "Gerald R. Ford International Airport", 
	"country": "USA", 
	"city": "Grand Rapids, MI"}, 
{
	"citycode": "GSO", 
	"airport": "Piedmont Triad International Airport", 
	"country": "USA", 
	"city": "Greensboro-Winston Salem, NC"}, 
{
	"citycode": "GSP", 
	"airport": "Greenville-Spartanburg International Airport", 
	"country": "USA", 
	"city": "Greer, SC"}, 
{
	"citycode": "GTF", 
	"airport": "Great Falls International Airport", 
	"country": "USA", 
	"city": "Great Falls, MT"}, 
{
	"citycode": "GTR", 
	"airport": "Golden Triangle Regional Airport", 
	"country": "USA", 
	"city": "Columbus, MS"}, 
{
	"citycode": "GUC", 
	"airport": "Gunnison–Crested Butte Regional Airport", 
	"country": "USA", 
	"city": "Gunnison, CO"}, 
{
	"citycode": "GUP", 
	"airport": "Gallup Municipal Airport", 
	"country": "USA", 
	"city": "Gallup, NM"}, 
{
	"citycode": "GYR", 
	"airport": "Phoenix Goodyear Airport", 
	"country": "USA", 
	"city": "Goodyear, AZ"}, 
{
	"citycode": "GYY", 
	"airport": "Gary/Chicago International Airport", 
	"country": "USA", 
	"city": "Chicago, IL"}, 
{
	"citycode": "HAE", 
	"airport": "Lava Falls Heliport", 
	"country": "USA", 
	"city": "Havasupai, AZ"}, 
{
	"citycode": "HAR", 
	"airport": "Capital City Airport", 
	"country": "USA", 
	"city": "Harrisburg, PA"}, 
{
	"citycode": "HCR", 
	"airport": "Holy Cross Airport", 
	"country": "USA", 
	"city": "Holy Cross, AK"}, 
{
	"citycode": "HDN", 
	"airport": "Yampa Valley Regional Airport", 
	"country": "USA", 
	"city": "Hayden, CO"}, 
{
	"citycode": "HFD", 
	"airport": "Hartford–Brainard Airport", 
	"country": "USA", 
	"city": "Hartford, CT"}, 
{
	"citycode": "HGR", 
	"airport": "Hagerstown Regional Airport", 
	"country": "USA", 
	"city": "Hagerstown, MD"}, 
{
	"citycode": "HHH", 
	"airport": "Hilton Head Airport", 
	"country": "USA", 
	"city": "Hilton Head, SC"}, 
{
	"citycode": "HHR", 
	"airport": "Hawthorne Municipal Airport", 
	"country": "USA", 
	"city": "Hawthorne, CA"}, 
{
	"citycode": "HIB", 
	"airport": "Range Regional Airport", 
	"country": "USA", 
	"city": "Hibbing, MN"}, 
{
	"citycode": "HKY", 
	"airport": "Hickory Regional Airport", 
	"country": "USA", 
	"city": "Hickory, NC"}, 
{
	"citycode": "HLN", 
	"airport": "Helena Regional Airport", 
	"country": "USA", 
	"city": "Helena, MT"}, 
{
	"citycode": "HMN", 
	"airport": "Holloman Air Force Base", 
	"country": "USA", 
	"city": "Alamogordo, NM"}, 
{
	"citycode": "HMT", 
	"airport": "Hemet-Ryan Airport", 
	"country": "USA", 
	"city": "Hemet, CA"}, 
{
	"citycode": "HNH", 
	"airport": "Hoonah Airport", 
	"country": "USA", 
	"city": "Hoonah, AK"}, 
{
	"citycode": "HNL", 
	"airport": "Daniel K. Inouye International Airport", 
	"country": "USA", 
	"city": "Honolulu, HI"}, 
{
	"citycode": "HNM", 
	"airport": "Hana Airport", 
	"country": "USA", 
	"city": "Hana, HI"}, 
{
	"citycode": "HNS", 
	"airport": "Haines Airport", 
	"country": "USA", 
	"city": "Haines, AK"}, 
{
	"citycode": "HOB", 
	"airport": "Lea County Regional Airport", 
	"country": "USA", 
	"city": "Hobbs, NM"}, 
{
	"citycode": "HOM", 
	"airport": "Homer Airport", 
	"country": "USA", 
	"city": "Homer, AK"}, 
{
	"citycode": "HON", 
	"airport": "Huron Regional Airport", 
	"country": "USA", 
	"city": "Huron, SD"}, 
{
	"citycode": "HOT", 
	"airport": "Memorial Field Airport", 
	"country": "USA", 
	"city": "Hot Springs, AR"}, 
{
	"citycode": "HOU", 
	"airport": "William P Hobby Airport", 
	"country": "USA", 
	"city": "Houston, TX"}, 
{
	"citycode": "HPB", 
	"airport": "Hooper Bay Airport", 
	"country": "USA", 
	"city": "Hooper Bay, AK"}, 
{
	"citycode": "HPN", 
	"airport": "Westchester County Airport", 
	"country": "USA", 
	"city": "Westchester County, NY"}, 
{
	"citycode": "HPV", 
	"airport": "Princeville Airport", 
	"country": "USA", 
	"city": "Kauai Island, HI"}, 
{
	"citycode": "HRL", 
	"airport": "Valley International Airport", 
	"country": "USA", 
	"city": "Harlingen, TX"}, 
{
	"citycode": "HRO", 
	"airport": "Boone County Airport", 
	"country": "USA", 
	"city": "Harrison, AR"}, 
{
	"citycode": "HSH", 
	"airport": "Henderson Executive Airport", 
	"country": "USA", 
	"city": "Las Vegas, NV"}, 
{
	"citycode": "HSI", 
	"airport": "Hastings Municipal Airport", 
	"country": "USA", 
	"city": "Hastings, NE"}, 
{
	"citycode": "HSL", 
	"airport": "Huslia Airport", 
	"country": "USA", 
	"city": "Huslia, AK"}, 
{
	"citycode": "HST", 
	"airport": "Homestead Air Reserve Base ", 
	"country": "USA", 
	"city": "Homestead, FL"}, 
{
	"citycode": "HSV", 
	"airport": "Huntsville International Airport", 
	"country": "USA", 
	"city": "Huntsville, AL"}, 
{
	"citycode": "HTO", 
	"airport": "East Hampton Airport", 
	"country": "USA", 
	"city": "East Hampton, NY"}, 
{
	"citycode": "HTS", 
	"airport": "Huntington Tri-State Airport", 
	"country": "USA", 
	"city": "Huntington, WV"}, 
{
	"citycode": "HUF", 
	"airport": "Terre Haute Regional Airport", 
	"country": "USA", 
	"city": "Terre Haute, IN"}, 
{
	"citycode": "HUS", 
	"airport": "Hughes Airport", 
	"country": "USA", 
	"city": "Hughes, AK"}, 
{
	"citycode": "HVN", 
	"airport": "Tweed New Haven Airport", 
	"country": "USA", 
	"city": "New Haven, CT"}, 
{
	"citycode": "HVR", 
	"airport": "Havre City–County Airport", 
	"country": "USA", 
	"city": "Havre, MT"}, 
{
	"citycode": "HWO", 
	"airport": "North Perry Airport", 
	"country": "USA", 
	"city": "Hollywood, FL"}, 
{
	"citycode": "HYA", 
	"airport": "Cape Cod Gateway Airport", 
	"country": "USA", 
	"city": "Hyannis, MA"}, 
{
	"citycode": "HYG", 
	"airport": "Hydaburg Seaplane Base", 
	"country": "USA", 
	"city": "Hydaburg, AK"}, 
{
	"citycode": "HYL", 
	"airport": "Hollis Clark Bay Seaplane Base ", 
	"country": "USA", 
	"city": "Hollis, AK"}, 
{
	"citycode": "HYS", 
	"airport": "Hays Regional Airport", 
	"country": "USA", 
	"city": "Hays, KS"}, 
{
	"citycode": "IAB", 
	"airport": "Mcconnell Airforce Base", 
	"country": "USA", 
	"city": "Wichita, KS"}, 
{
	"citycode": "IAD", 
	"airport": "Dulles International Airport", 
	"country": "USA", 
	"city": "Washington, DC"}, 
{
	"citycode": "IAG", 
	"airport": "Niagara Falls International Airport", 
	"country": "USA", 
	"city": "Niagara Falls, NY"}, 
{
	"citycode": "IAH", 
	"airport": "George Bush Intercontinental Airport", 
	"country": "USA", 
	"city": "Houston, TX"}, 
{
	"citycode": "IAN", 
	"airport": "Bob Barker Memorial Airport", 
	"country": "USA", 
	"city": "Kiana, AK"}, 
{
	"citycode": "ICT", 
	"airport": "Wichita Dwight D. Eisenhower National Airport", 
	"country": "USA", 
	"city": "Wichita, KS"}, 
{
	"citycode": "IDA", 
	"airport": "Idaho Falls Regional Airport", 
	"country": "USA", 
	"city": "Idaho Falls, ID"}, 
{
	"citycode": "IGG", 
	"airport": "Igiugig Airport", 
	"country": "USA", 
	"city": "Igiugig, AK"}, 
{
	"citycode": "IGM", 
	"airport": "Kingman Airport", 
	"country": "USA", 
	"city": "Kingman, AZ"}, 
{
	"citycode": "ILE", 
	"airport": "Skylark Field Airport", 
	"country": "USA", 
	"city": "Killeen, TX"}, 
{
	"citycode": "ILG", 
	"airport": "Wilmington Airport", 
	"country": "USA", 
	"city": "Wilmington, DE"}, 
{
	"citycode": "ILI", 
	"airport": "Iliamna Airport", 
	"country": "USA", 
	"city": "Iliamna, AK"}, 
{
	"citycode": "ILM", 
	"airport": "Wilmington International Airport ", 
	"country": "USA", 
	"city": "Wilmington, NC"}, 
{
	"citycode": "IMT", 
	"airport": "Ford Airport", 
	"country": "USA", 
	"city": "Iron Mountain, MI"}, 
{
	"citycode": "IND", 
	"airport": "Indianapolis International Airport", 
	"country": "USA", 
	"city": "Indianapolis, IN"}, 
{
	"citycode": "INL", 
	"airport": "Falls International Airport", 
	"country": "USA", 
	"city": "International Falls, MN"}, 
{
	"citycode": "INT", 
	"airport": "Smith-Reynolds Airport", 
	"country": "USA", 
	"city": "Winston Salem, NC"}, 
{
	"citycode": "IPL", 
	"airport": "Imperial County Airport", 
	"country": "USA", 
	"city": "Imperial, CA"}, 
{
	"citycode": "IPT", 
	"airport": "Williamsport Regional Airport", 
	"country": "USA", 
	"city": "Williamsport, PA"}, 
{
	"citycode": "IRC", 
	"airport": "Circle City Airport", 
	"country": "USA", 
	"city": "Circle, AK"}, 
{
	"citycode": "IRK", 
	"airport": "Kirksville Regional Airport", 
	"country": "USA", 
	"city": "Kirksville, MO"}, 
{
	"citycode": "ISN", 
	"airport": "Sloulin Field International Airport", 
	"country": "USA", 
	"city": "Williston, ND"}, 
{
	"citycode": "ISO", 
	"airport": "Kinston Regional Jetport", 
	"country": "USA", 
	"city": "Kinston, NC"}, 
{
	"citycode": "ISP", 
	"airport": "Long Island MacArthur Airport", 
	"country": "USA", 
	"city": "Islip, NY"}, 
{
	"citycode": "ITH", 
	"airport": "Ithaca Tompkins International Airport", 
	"country": "USA", 
	"city": "Ithaca, NY"}, 
{
	"citycode": "ITO", 
	"airport": "Hilo International Airport", 
	"country": "USA", 
	"city": "Hilo, HI"}, 
{
	"citycode": "IWD", 
	"airport": "Gogebic - Iron County Airport", 
	"country": "USA", 
	"city": "Ironwood, MI"}, 
{
	"citycode": "IYK", 
	"airport": "Inyokern Airport", 
	"country": "USA", 
	"city": "Inyokern, CA"}, 
{
	"citycode": "JAC", 
	"airport": "Jackson Hole Airport", 
	"country": "USA", 
	"city": "Jackson, WY"}, 
{
	"citycode": "JAN", 
	"airport": "Jackson–Medgar Wiley Evers International Airport", 
	"country": "USA", 
	"city": "Jackson, MS"}, 
{
	"citycode": "JAX", 
	"airport": "Jacksonville International Airport", 
	"country": "USA", 
	"city": "Jacksonville, FL"}, 
{
	"citycode": "JBC", 
	"airport": "Boston City Heliport Airport", 
	"country": "USA", 
	"city": "Boston, MA"}, 
{
	"citycode": "JBR", 
	"airport": "Jonesboro Municipal Airport", 
	"country": "USA", 
	"city": "Jonesboro, AR"}, 
{
	"citycode": "JCI", 
	"airport": "New Century AirCenter", 
	"country": "USA", 
	"city": "Kansas City, MO"}, 
{
	"citycode": "JFK", 
	"airport": "John F. Kennedy International Airport", 
	"country": "USA", 
	"city": "New York, NY"}, 
{
	"citycode": "JGC", 
	"airport": "Heliport Airport", 
	"country": "USA", 
	"city": "Grand Canyon, AZ"}, 
{
	"citycode": "JHM", 
	"airport": "Kapalua Airport", 
	"country": "USA", 
	"city": "Kapalua, HI"}, 
{
	"citycode": "JHW", 
	"airport": "Chautauqua County-Jamestown Airport", 
	"country": "USA", 
	"city": "Jamestown, NY"}, 
{
	"citycode": "JLN", 
	"airport": "Joplin Regional Airport", 
	"country": "USA", 
	"city": "Joplin, MO"}, 
{
	"citycode": "JNU", 
	"airport": "Juneau International Airport", 
	"country": "USA", 
	"city": "Juneau, AK"}, 
{
	"citycode": "JRE", 
	"airport": "East 60th Street Heliport", 
	"country": "USA", 
	"city": "New York, NY"}, 
{
	"citycode": "JST", 
	"airport": "Cambria County Airport", 
	"country": "USA", 
	"city": "Johnstown, PA"}, 
{
	"citycode": "KAL", 
	"airport": "Kaltag Airport", 
	"country": "USA", 
	"city": "Kaltag, AK"}, 
{
	"citycode": "KBC", 
	"airport": "Birch Creek Airport", 
	"country": "USA", 
	"city": "Birch Creek, AK"}, 
{
	"citycode": "KCC", 
	"airport": "Coffman Cove Seaplane Base", 
	"country": "USA", 
	"city": "Coffman Cove, AK"}, 
{
	"citycode": "KCG", 
	"airport": "Chignik Fisheries Airport", 
	"country": "USA", 
	"city": "Chignik, AK"}, 
{
	"citycode": "KCK", 
	"airport": "Fairfax Airport", 
	"country": "USA", 
	"city": "Kansas City, KS"}, 
{
	"citycode": "KCL", 
	"airport": "Chignik Lagoon Airport ", 
	"country": "USA", 
	"city": "Chignik, AK"}, 
{
	"citycode": "KCQ", 
	"airport": "Chignik Lake Airport", 
	"country": "USA", 
	"city": "Chignik, AK"}, 
{
	"citycode": "KEH", 
	"airport": "Kenmore Air Harbor", 
	"country": "USA", 
	"city": "Kenmore Air Harbor, WA"}, 
{
	"citycode": "KEK", 
	"airport": "Ekwok Airport", 
	"country": "USA", 
	"city": "Ekwok, AK"}, 
{
	"citycode": "KFP", 
	"airport": "False Pass Airport", 
	"country": "USA", 
	"city": "False Pass, AK"}, 
{
	"citycode": "KGK", 
	"airport": "Koliganek Airport", 
	"country": "USA", 
	"city": "New Koliganek, AK"}, 
{
	"citycode": "KGX", 
	"airport": "Grayling Airport", 
	"country": "USA", 
	"city": "Grayling, AK"}, 
{
	"citycode": "KIB", 
	"airport": "Ivanof Bay Seaplane Base", 
	"country": "USA", 
	"city": "Ivanof Bay, AK"}, 
{
	"citycode": "KKA", 
	"airport": "Koyuk Alfred Adams Airport", 
	"country": "USA", 
	"city": "Koyuk, AK"}, 
{
	"citycode": "KKB", 
	"airport": "Kitoi Bay Seaplane Base", 
	"country": "USA", 
	"city": "Kitoi Bay, AK"}, 
{
	"citycode": "KKH", 
	"airport": "Kongiganak Airport", 
	"country": "USA", 
	"city": "Kongiganak, AK"}, 
{
	"citycode": "KKI", 
	"airport": "Akiachak Airport", 
	"country": "USA", 
	"city": "Akiachak, AK"}, 
{
	"citycode": "KKU", 
	"airport": "Ekuk Airport", 
	"country": "USA", 
	"city": "Ekuk, AK"}, 
{
	"citycode": "KLG", 
	"airport": "Kalskag Airport", 
	"country": "USA", 
	"city": "Kalskag, AK"}, 
{
	"citycode": "KLL", 
	"airport": "Levelock Airport", 
	"country": "USA", 
	"city": "Levelock, AK"}, 
{
	"citycode": "KLN", 
	"airport": "Larsen Bay Airport", 
	"country": "USA", 
	"city": "Larsen Bay, AK"}, 
{
	"citycode": "KLW", 
	"airport": "Klawock Airport", 
	"country": "USA", 
	"city": "Klawock, AK"}, 
{
	"citycode": "KMO", 
	"airport": "Manokotak Airport", 
	"country": "USA", 
	"city": "Manokotak, AK"}, 
{
	"citycode": "KMY", 
	"airport": "Moser Bay Seaplane Base", 
	"country": "USA", 
	"city": "Moser Bay, AK"}, 
{
	"citycode": "KNK", 
	"airport": "Kakhonak Airport", 
	"country": "USA", 
	"city": "Kakhonak, AK"}, 
{
	"citycode": "KNW", 
	"airport": "New Stuyahok Airport", 
	"country": "USA", 
	"city": "New Stuyahok, AK"}, 
{
	"citycode": "KOA", 
	"airport": "Kona International Airport", 
	"country": "USA", 
	"city": "Kona, HI"}, 
{
	"citycode": "KOT", 
	"airport": "Kotlik Airport", 
	"country": "USA", 
	"city": "Kotlik, AK"}, 
{
	"citycode": "KOY", 
	"airport": "Olga Bay Seaplane Base", 
	"country": "USA", 
	"city": "Olga Bay, AK"}, 
{
	"citycode": "KOZ", 
	"airport": "Ouzinkie Airport", 
	"country": "USA", 
	"city": "Ouzinkie, AK"}, 
{
	"citycode": "KPB", 
	"airport": "Point Baker Seaplane Base", 
	"country": "USA", 
	"city": "Point Baker, AK"}, 
{
	"citycode": "KPC", 
	"airport": "Port Clarence Coast Guard Station Airport", 
	"country": "USA", 
	"city": "Port Clarence, AK"}, 
{
	"citycode": "KPK", 
	"airport": "Parks Seaplane Base", 
	"country": "USA", 
	"city": "Parks, AK"}, 
{
	"citycode": "KPN", 
	"airport": "Kipnuk Airport", 
	"country": "USA", 
	"city": "Kipnuk, AK"}, 
{
	"citycode": "KPV", 
	"airport": "Perryville Airport", 
	"country": "USA", 
	"city": "Perryville, AK"}, 
{
	"citycode": "KPW", 
	"airport": "Keperveyem Airport", 
	"country": "USA", 
	"city": "ALASKA"}, 
{
	"citycode": "KPY", 
	"airport": "Port Bailey Seaplane Base", 
	"country": "USA", 
	"city": "Port Bailey, AK"}, 
{
	"citycode": "KQA", 
	"airport": "Akutan Airport", 
	"country": "USA", 
	"city": "Akutan, AK"}, 
{
	"citycode": "KSM", 
	"airport": "St Mary`s-Pitkas Point Airport", 
	"country": "USA", 
	"city": "Saint Marys, AK"}, 
{
	"citycode": "KTB", 
	"airport": "Thorne Bay Seaplane Base", 
	"country": "USA", 
	"city": "Thorne Bay, AK"}, 
{
	"citycode": "KTN", 
	"airport": "Ketchikan International Airport", 
	"country": "USA", 
	"city": "Ketchikan, AK"}, 
{
	"citycode": "KTS", 
	"airport": "Brevig Mission Airport", 
	"country": "USA", 
	"city": "Teller Mission, AK"}, 
{
	"citycode": "KTY", 
	"airport": "Sri Lanka Air Force Station", 
	"country": "USA", 
	"city": "ALASKA"}, 
{
	"citycode": "KUK", 
	"airport": "Kasigluk Airport", 
	"country": "USA", 
	"city": "Kasigluk, AK"}, 
{
	"citycode": "KVC", 
	"airport": "King Cove Airport", 
	"country": "USA", 
	"city": "King Cove, AK"}, 
{
	"citycode": "KVL", 
	"airport": "Kivalina Airport", 
	"country": "USA", 
	"city": "Kivalina, AK"}, 
{
	"citycode": "KWK", 
	"airport": "Kwigillingok Airport", 
	"country": "USA", 
	"city": "Kwigillingok, AK"}, 
{
	"citycode": "KWN", 
	"airport": "Quinhagak Airport", 
	"country": "USA", 
	"city": "Quinhagak, AK"}, 
{
	"citycode": "KWP", 
	"airport": "West Point Village Seaplane Base", 
	"country": "USA", 
	"city": "West Point, AK"}, 
{
	"citycode": "KWT", 
	"airport": "Kwethluk Airport", 
	"country": "USA", 
	"city": "Kwethluk, AK"}, 
{
	"citycode": "KXA", 
	"airport": "Kasaan Seaplane Base", 
	"country": "USA", 
	"city": "Kasaan, AK"}, 
{
	"citycode": "KYK", 
	"airport": "Karluk Airport", 
	"country": "USA", 
	"city": "Karluk, AK"}, 
{
	"citycode": "KYU", 
	"airport": "Koyukuk Airport", 
	"country": "USA", 
	"city": "Koyukuk, AK"}, 
{
	"citycode": "KZB", 
	"airport": "Zachar Bay Seaplane Base", 
	"country": "USA", 
	"city": "Zachar Bay, AK"}, 
{
	"citycode": "LAA", 
	"airport": "Lamar Municipal Airport", 
	"country": "USA", 
	"city": "Lamar, CO"}, 
{
	"citycode": "LAF", 
	"airport": "Purdue University Airport", 
	"country": "USA", 
	"city": "Lafayette, IN"}, 
{
	"citycode": "LAM", 
	"airport": "Los Alamos Airport", 
	"country": "USA", 
	"city": "Los Alamos, NM"}, 
{
	"citycode": "LAN", 
	"airport": "Capital Region International Airport", 
	"country": "USA", 
	"city": "Lansing, MI"}, 
{
	"citycode": "LAR", 
	"airport": "Laramie Regional Airport", 
	"country": "USA", 
	"city": "Laramie, WY"}, 
{
	"citycode": "LAS", 
	"airport": "Harry Reid International Airport", 
	"country": "USA", 
	"city": "Las Vegas, NV"}, 
{
	"citycode": "LAW", 
	"airport": "Lawton–Fort Sill Regional Airport ", 
	"country": "USA", 
	"city": "Lawton, OK"}, 
{
	"citycode": "LAX", 
	"airport": "Los Angeles International Airport", 
	"country": "USA", 
	"city": "Los Angeles, CA"}, 
{
	"citycode": "LBB", 
	"airport": "Lubbock Preston Smith International Airport", 
	"country": "USA", 
	"city": "Lubbock, TX"}, 
{
	"citycode": "LBE", 
	"airport": "Latrobe Airport", 
	"country": "USA", 
	"city": "Latrobe, PA"}, 
{
	"citycode": "LBF", 
	"airport": "North Platte Regional Airport", 
	"country": "USA", 
	"city": "North Platte, NE"}, 
{
	"citycode": "LBL", 
	"airport": "Liberal Airport", 
	"country": "USA", 
	"city": "Liberal, KS"}, 
{
	"citycode": "LCH", 
	"airport": "Lake Charles Regional Airport", 
	"country": "USA", 
	"city": "Lake Charles, LA"}, 
{
	"citycode": "LCI", 
	"airport": "Laconia Municipal Airport", 
	"country": "USA", 
	"city": "Laconia, NH"}, 
{
	"citycode": "LCK", 
	"airport": "Rickenbacker International Airport", 
	"country": "USA", 
	"city": "Columbus, OH"}, 
{
	"citycode": "LEB", 
	"airport": "Lebanon Municipal Airport", 
	"country": "USA", 
	"city": "White River, VT"}, 
{
	"citycode": "LEM", 
	"airport": "Lemmon Municipal Airport", 
	"country": "USA", 
	"city": "Lemmon, SD"}, 
{
	"citycode": "LEX", 
	"airport": "Blue Grass Airport", 
	"country": "USA", 
	"city": "Lexington, KY"}, 
{
	"citycode": "LFT", 
	"airport": "Lafayette Regional Airport", 
	"country": "USA", 
	"city": "Lafayette, LA"}, 
{
	"citycode": "LGA", 
	"airport": "La Guardia Airport", 
	"country": "USA", 
	"city": "New York, NY"}, 
{
	"citycode": "LGB", 
	"airport": "Long Beach Municipal", 
	"country": "USA", 
	"city": "Long Beach, CA"}, 
{
	"citycode": "LHU", 
	"airport": "Lianshulu Airport", 
	"country": "USA", 
	"city": "ARIZONA"}, 
{
	"citycode": "LIH", 
	"airport": "Lihue Airport", 
	"country": "USA", 
	"city": "Kauai Island, HI"}, 
{
	"citycode": "LIJ", 
	"airport": "Long Island Airport", 
	"country": "USA", 
	"city": "Long Island, AK"}, 
{
	"citycode": "LIT", 
	"airport": "Bill and Hillary Clinton National Airport", 
	"country": "USA", 
	"city": "Little Rock, AR"}, 
{
	"citycode": "LKE", 
	"airport": "Kenmore Air Harbor Seaplane Base", 
	"country": "USA", 
	"city": "Seattle, WA"}, 
{
	"citycode": "LMA", 
	"airport": "Minchumina Airport", 
	"country": "USA", 
	"city": "Lake Minchumina, AK"}, 
{
	"citycode": "LMT", 
	"airport": "Crater Lake - Klamath Regional Airport", 
	"country": "USA", 
	"city": "Klamath Falls, OR"}, 
{
	"citycode": "LNA", 
	"airport": "Palm Beach County Park Airport", 
	"country": "USA", 
	"city": "West Palm Beach, FL"}, 
{
	"citycode": "LNK", 
	"airport": "Lincoln Airport", 
	"country": "USA", 
	"city": "Lincoln, NE"}, 
{
	"citycode": "LNS", 
	"airport": "Lancaster Airport", 
	"country": "USA", 
	"city": "Lancaster, PA"}, 
{
	"citycode": "LNY", 
	"airport": "Lanai Airport", 
	"country": "USA", 
	"city": "Lanai City, HI"}, 
{
	"citycode": "LPS", 
	"airport": "Lopez Island Airport", 
	"country": "USA", 
	"city": "Lopez Island, WA"}, 
{
	"citycode": "LPW", 
	"airport": "Little Port Walter Airport", 
	"country": "USA", 
	"city": "Little Port Walter, AK"}, 
{
	"citycode": "LRD", 
	"airport": "Laredo International Airport", 
	"country": "USA", 
	"city": "Laredo, TX"}, 
{
	"citycode": "LRU", 
	"airport": "Las Cruces International Airport", 
	"country": "USA", 
	"city": "Las Cruces, NM"}, 
{
	"citycode": "LSE", 
	"airport": "La Crosse Regional Airport", 
	"country": "USA", 
	"city": "La Crosse, WI"}, 
{
	"citycode": "LUL", 
	"airport": "Hesler-Noble Field Airport", 
	"country": "USA", 
	"city": "Laurel, MS"}, 
{
	"citycode": "LUP", 
	"airport": "Kalaupapa Airport", 
	"country": "USA", 
	"city": "Kalaupapa, HI"}, 
{
	"citycode": "LVD", 
	"airport": "Lime Village Airport", 
	"country": "USA", 
	"city": "Lime Village, AK"}, 
{
	"citycode": "LWB", 
	"airport": "Greenbrier Valley Airport", 
	"country": "USA", 
	"city": "Lewisburg, WV"}, 
{
	"citycode": "LWS", 
	"airport": "Lewiston-Nez Perce County Regional Airport", 
	"country": "USA", 
	"city": "Lewiston, ID"}, 
{
	"citycode": "LWT", 
	"airport": "Lewistown Municipal Airport", 
	"country": "USA", 
	"city": "Lewistown, MT"}, 
{
	"citycode": "LYH", 
	"airport": "Lynchburg Regional Airport", 
	"country": "USA", 
	"city": "Lynchburg, VA"}, 
{
	"citycode": "MAE", 
	"airport": "Madera Muncipal Airport", 
	"country": "USA", 
	"city": "Madera, CA"}, 
{
	"citycode": "MAF", 
	"airport": "Midland International Airport", 
	"country": "USA", 
	"city": "Midland, TX"}, 
{
	"citycode": "MBL", 
	"airport": "Manistee County Blacker Airport", 
	"country": "USA", 
	"city": "Manistee, MI"}, 
{
	"citycode": "MBS", 
	"airport": "MBS International Airport", 
	"country": "USA", 
	"city": "Saginaw, MI"}, 
{
	"citycode": "MCE", 
	"airport": "Merced Regional Airport", 
	"country": "USA", 
	"city": "Merced, CA"}, 
{
	"citycode": "MCG", 
	"airport": "McGrath Airport", 
	"country": "USA", 
	"city": "Mcgrath, AK"}, 
{
	"citycode": "MCI", 
	"airport": "Kansas City International Airport", 
	"country": "USA", 
	"city": "Kansas City, MO"}, 
{
	"citycode": "MCK", 
	"airport": "McCook Ben Nelson Regional Airport", 
	"country": "USA", 
	"city": "Mccook, NE"}, 
{
	"citycode": "MCN", 
	"airport": "Middle Georgia Regional Airport", 
	"country": "USA", 
	"city": "Macon, GA"}, 
{
	"citycode": "MCO", 
	"airport": "Orlando International Airport", 
	"country": "USA", 
	"city": "Orlando, FL"}, 
{
	"citycode": "MCW", 
	"airport": "Mason City Municipal Airport", 
	"country": "USA", 
	"city": "Mason City, IA"}, 
{
	"citycode": "MDF", 
	"airport": "Taylor County Airport ", 
	"country": "USA", 
	"city": "Medford, WI"}, 
{
	"citycode": "MDT", 
	"airport": "Harrisburg International Airport", 
	"country": "USA", 
	"city": "Harrisburg, PA"}, 
{
	"citycode": "MDW", 
	"airport": "Midway International Airport", 
	"country": "USA", 
	"city": "Chicago, IL"}, 
{
	"citycode": "MEM", 
	"airport": "Memphis International Airport", 
	"country": "USA", 
	"city": "Memphis, TN"}, 
{
	"citycode": "MFE", 
	"airport": "McAllen International Airport", 
	"country": "USA", 
	"city": "Mission, TX"}, 
{
	"citycode": "MFR", 
	"airport": "Rogue Valley International Medford Airport", 
	"country": "USA", 
	"city": "Medford, OR"}, 
{
	"citycode": "MGM", 
	"airport": "Montgomery Regional Airport", 
	"country": "USA", 
	"city": "Montgomery, AL"}, 
{
	"citycode": "MGW", 
	"airport": "Morgantown Municipal Airport", 
	"country": "USA", 
	"city": "Morgantown, WV"}, 
{
	"citycode": "MGY", 
	"airport": "Dayton Wright Brothers Airport", 
	"country": "USA", 
	"city": "Dayton, OH"}, 
{
	"citycode": "MHE", 
	"airport": "Mitchell Municipal Airport", 
	"country": "USA", 
	"city": "Mitchell, SD"}, 
{
	"citycode": "MHK", 
	"airport": "Manhattan Regional Airport", 
	"country": "USA", 
	"city": "Manhattan, KS"}, 
{
	"citycode": "MHT", 
	"airport": "Manchester–Boston Regional Airport", 
	"country": "USA", 
	"city": "Manchester, NH"}, 
{
	"citycode": "MHV", 
	"airport": "Mojave Air & Space Port", 
	"country": "USA, CA", 
	"city": "Mojave"}, 
{
	"citycode": "MIA", 
	"airport": "Miami International Airport", 
	"country": "USA", 
	"city": "Miami, FL"}, 
{
	"citycode": "MIE", 
	"airport": "Delaware County Regional Airport", 
	"country": "USA", 
	"city": "Muncie, IN"}, 
{
	"citycode": "MKE", 
	"airport": "Milwaukee Mitchell International Airport", 
	"country": "USA", 
	"city": "Milwaukee, WI"}, 
{
	"citycode": "MKG", 
	"airport": "Muskegon County Airport", 
	"country": "USA", 
	"city": "Muskegon, MI"}, 
{
	"citycode": "MKK", 
	"airport": "Molokai Airport", 
	"country": "USA", 
	"city": "Hoolehua, HI"}, 
{
	"citycode": "MKL", 
	"airport": "McKellar-Sipes Regional Airport", 
	"country": "USA", 
	"city": "Jackson, TN"}, 
{
	"citycode": "MLB", 
	"airport": "Melbourne Orlando International Airport", 
	"country": "USA", 
	"city": "Melbourne, FL"}, 
{
	"citycode": "MLI", 
	"airport": "Quad Cities International Airport", 
	"country": "USA", 
	"city": "Moline, IL"}, 
{
	"citycode": "MLL", 
	"airport": "Marshall Don Hunter Sr. Airport", 
	"country": "USA", 
	"city": "Marshall, AK"}, 
{
	"citycode": "MLS", 
	"airport": "Miles City Airport", 
	"country": "USA", 
	"city": "Miles City, MT"}, 
{
	"citycode": "MLU", 
	"airport": "Monroe Regional Airport", 
	"country": "USA", 
	"city": "Monroe, LA"}, 
{
	"citycode": "MLY", 
	"airport": "Manley Hot Springs Airport", 
	"country": "USA", 
	"city": "Manley Hot Springs, AK"}, 
{
	"citycode": "MMH", 
	"airport": "Mammoth Yosemite Airport", 
	"country": "USA", 
	"city": "Mammoth Lakes, CA"}, 
{
	"citycode": "MML", 
	"airport": "Southwest Minnesota Regional Airport", 
	"country": "USA", 
	"city": "Marshall, MN"}, 
{
	"citycode": "MMU", 
	"airport": "Morristown Municipal Airport", 
	"country": "USA", 
	"city": "Morristown, NJ"}, 
{
	"citycode": "MNM", 
	"airport": "Menominee Regional Airport", 
	"country": "USA", 
	"city": "Menominee, MI"}, 
{
	"citycode": "MNT", 
	"airport": "Minto Al Wright Airport", 
	"country": "USA", 
	"city": "Minto, AK"}, 
{
	"citycode": "MOB", 
	"airport": "Mobile Regional Airport", 
	"country": "USA", 
	"city": "Mobile, AL"}, 
{
	"citycode": "MOD", 
	"airport": "Modesto City–County Airport", 
	"country": "USA", 
	"city": "Modesto, CA"}, 
{
	"citycode": "MOT", 
	"airport": "Minot International Airport", 
	"country": "USA", 
	"city": "Minot, ND"}, 
{
	"citycode": "MOU", 
	"airport": "Mountain Village Airport", 
	"country": "USA", 
	"city": "Mountain Village, AK"}, 
{
	"citycode": "MPB", 
	"airport": "Miami Seaplane Base", 
	"country": "USA", 
	"city": "Miami, FL"}, 
{
	"citycode": "MQT", 
	"airport": "Sawyer International Airport", 
	"country": "USA", 
	"city": "Marquette, MI"}, 
{
	"citycode": "MRI", 
	"airport": "Merrill Field Airport", 
	"country": "USA", 
	"city": "Anchorage, AK"}, 
{
	"citycode": "MRK", 
	"airport": "Marco Island Airport", 
	"country": "USA", 
	"city": "Marco Island, FL"}, 
{
	"citycode": "MRY", 
	"airport": "Monterey Regional Airport", 
	"country": "USA", 
	"city": "Monterey-Carmel, CA"}, 
{
	"citycode": "MSC", 
	"airport": "Falcon Field Airport", 
	"country": "USA", 
	"city": "Mesa, AZ"}, 
{
	"citycode": "MSD", 
	"airport": "Mt Pleasant Airport", 
	"country": "USA", 
	"city": "Mt Pleasant, UT"}, 
{
	"citycode": "MSL", 
	"airport": "Northwest Alabama Regional Airport", 
	"country": "USA", 
	"city": "Sheffield, AL"}, 
{
	"citycode": "MSN", 
	"airport": "Dane County Regional Airport", 
	"country": "USA", 
	"city": "Madison, WI"}, 
{
	"citycode": "MSO", 
	"airport": "Missoula Montana Airport", 
	"country": "USA", 
	"city": "Missoula, MT"}, 
{
	"citycode": "MSP", 
	"airport": "Minneapolis–Saint Paul International Airport", 
	"country": "USA", 
	"city": "Minneapolis, Saint Paul, MN"}, 
{
	"citycode": "MSS", 
	"airport": "Massena International Airport", 
	"country": "USA", 
	"city": "Massena, NY"}, 
{
	"citycode": "MSV", 
	"airport": "Sullivan County International Airport", 
	"country": "USA", 
	"city": "Monticello, NY"}, 
{
	"citycode": "MSY", 
	"airport": "Louis Armstrong New Orleans International Airport", 
	"country": "USA", 
	"city": "New Orleans, LA"}, 
{
	"citycode": "MTH", 
	"airport": "Florida Keys/Marathon International Airport", 
	"country": "USA", 
	"city": "Marathon, FL"}, 
{
	"citycode": "MTJ", 
	"airport": "Montrose County", 
	"country": "USA", 
	"city": "Montrose, CO"}, 
{
	"citycode": "MTM", 
	"airport": "Metlakatla Seaplane Base", 
	"country": "USA", 
	"city": "Metlakatla, AK"}, 
{
	"citycode": "MTN", 
	"airport": "Martin State Airport", 
	"country": "USA", 
	"city": "Baltimore, MD"}, 
{
	"citycode": "MTO", 
	"airport": "Coles County Memorial Airport", 
	"country": "USA", 
	"city": "Mattoon, IL"}, 
{
	"citycode": "MUE", 
	"airport": "Waimea-Kohala Airport", 
	"country": "USA", 
	"city": "Kamuela, HI"}, 
{
	"citycode": "MVN", 
	"airport": "Mount Vernon Outland Airport", 
	"country": "USA", 
	"city": "Mt Vernon, IL"}, 
{
	"citycode": "MVY", 
	"airport": "Martha`s Vineyard Airport", 
	"country": "USA", 
	"city": "Martha`s Vineyard, MA"}, 
{
	"citycode": "MWA", 
	"airport": "Williamson County Regional Airport", 
	"country": "USA", 
	"city": "Marion, IL"}, 
{
	"citycode": "MWH", 
	"airport": "Grant County International Airport", 
	"country": "USA", 
	"city": "Moses Lake, WA"}, 
{
	"citycode": "MYF", 
	"airport": "Montgomery Field", 
	"country": "USA", 
	"city": "San Diego, CA"}, 
{
	"citycode": "MYR", 
	"airport": "Myrtle Beach International Airport", 
	"country": "USA", 
	"city": "Myrtle Beach, SC"}, 
{
	"citycode": "MYU", 
	"airport": "Mekoryuk Airport", 
	"country": "USA", 
	"city": "Mekoryuk, AK"}, 
{
	"citycode": "NIB", 
	"airport": "Nikolai Airport", 
	"country": "USA", 
	"city": "Nikolai, AK"}, 
{
	"citycode": "NKI", 
	"airport": "Naukiti Airport", 
	"country": "USA", 
	"city": "Naukiti, AK"}, 
{
	"citycode": "NLG", 
	"airport": "Nelson Lagoon Airport", 
	"country": "USA", 
	"city": "Nelson Lagoon, AK"}, 
{
	"citycode": "NME", 
	"airport": "Nightmute Airport", 
	"country": "USA", 
	"city": "Nightmute, AK"}, 
{
	"citycode": "NNK", 
	"airport": "Naknek Airport", 
	"country": "USA", 
	"city": "Naknek, AK"}, 
{
	"citycode": "NNL", 
	"airport": "Nondalton Airport", 
	"country": "USA", 
	"city": "Nondalton, AK"}, 
{
	"citycode": "NPH", 
	"airport": "Nephi Municipal Airport", 
	"country": "USA", 
	"city": "Nephi, UT"}, 
{
	"citycode": "NUI", 
	"airport": "Nuiqsut Airport", 
	"country": "USA", 
	"city": "Nuiqsut, AK"}, 
{
	"citycode": "NUL", 
	"airport": "Nulato Airport", 
	"country": "USA", 
	"city": "Nulato, AK"}, 
{
	"citycode": "NUP", 
	"airport": "Nunapitchuk Airport", 
	"country": "USA", 
	"city": "Nunapitchuk, AK"}, 
{
	"citycode": "NYC", 
	"airport": "New York All Airports", 
	"country": "USA", 
	"city": "New York, NY"}, 
{
	"citycode": "OAJ", 
	"airport": "Albert J Ellis Airport", 
	"country": "USA", 
	"city": "Jacksonville, NC"}, 
{
	"citycode": "OAK", 
	"airport": "Oak International Airport", 
	"country": "USA", 
	"city": "Oakland, CA"}, 
{
	"citycode": "OBU", 
	"airport": "Kobuk Airport", 
	"country": "USA", 
	"city": "Kobuk, AK"}, 
{
	"citycode": "OCA", 
	"airport": "Ocean Reef Club Airport", 
	"country": "USA", 
	"city": "Ocean Reef, FL"}, 
{
	"citycode": "OCH", 
	"airport": "A. L. Mangham Jr. Regional Airport", 
	"country": "USA", 
	"city": "Nacogdoches, TX"}, 
{
	"citycode": "ODW", 
	"airport": "A.J. Eisenberg Airport", 
	"country": "USA", 
	"city": "Oak Harbor, WA"}, 
{
	"citycode": "OFK", 
	"airport": "Norfolk Regional Airport", 
	"country": "USA", 
	"city": "Norfolk, NE"}, 
{
	"citycode": "OGG", 
	"airport": "Kahului Airport", 
	"country": "USA", 
	"city": "Kahului, HI"}, 
{
	"citycode": "OGS", 
	"airport": "Ogdensburg International Airport", 
	"country": "USA", 
	"city": "Ogdensburg, NY"}, 
{
	"citycode": "OJC", 
	"airport": "Johnson County Executive Airport", 
	"country": "USA", 
	"city": "Kansas City, MO"}, 
{
	"citycode": "OKC", 
	"airport": "Will Rogers World Airport", 
	"country": "USA", 
	"city": "Oklahoma City, OK"}, 
{
	"citycode": "OLF", 
	"airport": "L.M. Clayton Airport", 
	"country": "USA", 
	"city": "Wolf Point, MT"}, 
{
	"citycode": "OLH", 
	"airport": "Old Harbor Airport", 
	"country": "USA", 
	"city": "Old Harbor, AK"}, 
{
	"citycode": "OLM", 
	"airport": "Olympia Regional Airport", 
	"country": "USA", 
	"city": "Olympia, WA"}, 
{
	"citycode": "OMA", 
	"airport": "Eppley Airfield Airport", 
	"country": "USA", 
	"city": "Omaha, NE"}, 
{
	"citycode": "OME", 
	"airport": "Nome Airport", 
	"country": "USA", 
	"city": "Nome, AK"}, 
{
	"citycode": "ONT", 
	"airport": "Ontario International Airport", 
	"country": "USA", 
	"city": "Ontario, CA"}, 
{
	"citycode": "OOK", 
	"airport": "Toksook Bay Airport", 
	"country": "USA", 
	"city": "Toksook Bay, AK"}, 
{
	"citycode": "OPF", 
	"airport": "Miami-Opa Locka Executive Airport", 
	"country": "USA", 
	"city": "Miami, FL"}, 
{
	"citycode": "ORD", 
	"airport": "O`Hare International Airport", 
	"country": "USA", 
	"city": "Chicago, IL"}, 
{
	"citycode": "ORF", 
	"airport": "Norfolk International Airport", 
	"country": "USA", 
	"city": "Norfolk, VA"}, 
{
	"citycode": "ORH", 
	"airport": "Worcester Regional Airport", 
	"country": "USA", 
	"city": "Worcester, MA"}, 
{
	"citycode": "ORI", 
	"airport": "Port Lions Airport", 
	"country": "USA", 
	"city": "Port Lions, AK"}, 
{
	"citycode": "ORL", 
	"airport": "Orlando Executive Airport", 
	"country": "USA", 
	"city": "Orlando, FL"}, 
{
	"citycode": "ORV", 
	"airport": "Robert (Bob) Curtis Memorial Airport", 
	"country": "USA", 
	"city": "Noorvik, AK"}, 
{
	"citycode": "OSH", 
	"airport": "Osh International Airport", 
	"country": "USA", 
	"city": "Oshkosh, WI"}, 
{
	"citycode": "OSU", 
	"airport": "Ohio State University Airport", 
	"country": "USA", 
	"city": "Columbus, OH"}, 
{
	"citycode": "OTH", 
	"airport": "Southwest Oregon Regional Airport", 
	"country": "USA", 
	"city": "North Bend, OR"}, 
{
	"citycode": "OTM", 
	"airport": "Ottumwa Regional Airport ", 
	"country": "USA", 
	"city": "Ottumwa, IA"}, 
{
	"citycode": "OTS", 
	"airport": "Anacortes Airport", 
	"country": "USA", 
	"city": "Anacortes, WA"}, 
{
	"citycode": "OTZ", 
	"airport": "Ralph Wien Memorial Airport", 
	"country": "USA", 
	"city": "Kotzebue, AK"}, 
{
	"citycode": "OWB", 
	"airport": "Owensboro–Daviess County Airport", 
	"country": "USA", 
	"city": "Owensboro, KY"}, 
{
	"citycode": "OXR", 
	"airport": "Oxnard Airport", 
	"country": "USA", 
	"city": "Ventura, CA"}, 
{
	"citycode": "PAE", 
	"airport": "Seattle Paine Field International Airport", 
	"country": "USA", 
	"city": "Everett, WA"}, 
{
	"citycode": "PAH", 
	"airport": " Barkley Regional Airport", 
	"country": "USA", 
	"city": "Paducah, KY"}, 
{
	"citycode": "PAQ", 
	"airport": "Palmer Municipal Airport", 
	"country": "USA", 
	"city": "Palmer, AK"}, 
{
	"citycode": "PBI", 
	"airport": "Palm Beach International Airport", 
	"country": "USA", 
	"city": "West Palm Beach, FL"}, 
{
	"citycode": "PCA", 
	"airport": "Portage Creek Airport", 
	"country": "USA", 
	"city": "Portage Creek, AK"}, 
{
	"citycode": "PDB", 
	"airport": "Pedro Bay Airport", 
	"country": "USA", 
	"city": "Pedro Bay, AK"}, 
{
	"citycode": "PDK", 
	"airport": "De Kalb-Peachtree Airport", 
	"country": "USA", 
	"city": "Atlanta, GA"}, 
{
	"citycode": "PDT", 
	"airport": "Eastern Oregon Regional Airport", 
	"country": "USA", 
	"city": "Pendleton, OR"}, 
{
	"citycode": "PDX", 
	"airport": "Portland International Airport", 
	"country": "USA", 
	"city": "Portland, OR"}, 
{
	"citycode": "PEC", 
	"airport": "Pelican Seaplane Base", 
	"country": "USA", 
	"city": "Pelican, AK"}, 
{
	"citycode": "PFN", 
	"airport": "Panama City-Bay Co International Airport", 
	"country": "USA", 
	"city": "Panama City, FL"}, 
{
	"citycode": "PGA", 
	"airport": "Page Municipal Airport", 
	"country": "USA", 
	"city": "Page, AZ"}, 
{
	"citycode": "PGM", 
	"airport": "Port Graham Airport", 
	"country": "USA", 
	"city": "Port Graham, AK"}, 
{
	"citycode": "PGV", 
	"airport": "Pitt–Greenville Airport", 
	"country": "USA", 
	"city": "Greenville, NC"}, 
{
	"citycode": "PHF", 
	"airport": "Newport News Williamsburg International Airport", 
	"country": "USA", 
	"city": "Newport News, VA"}, 
{
	"citycode": "PHL", 
	"airport": "Philadelphia International Airport", 
	"country": "USA", 
	"city": "Philadelphia, PA"}, 
{
	"citycode": "PHO", 
	"airport": "Point Hope Airport", 
	"country": "USA", 
	"city": "Point Hope, AK"}, 
{
	"citycode": "PHX", 
	"airport": "Phoenix Sky Harbor International Airport", 
	"country": "USA", 
	"city": "Phoenix, AZ"}, 
{
	"citycode": "PIA", 
	"airport": "General Wayne A. Downing Peoria International Airport", 
	"country": "USA", 
	"city": "Peoria, IL"}, 
{
	"citycode": "PIB", 
	"airport": "Hattiesburg Laurel Regional Airport", 
	"country": "USA", 
	"city": "Laurel, MS"}, 
{
	"citycode": "PIE", 
	"airport": "St. Pete–Clearwater International Airport", 
	"country": "USA", 
	"city": "St. Petersburg, FL"}, 
{
	"citycode": "PIH", 
	"airport": "Pocatello Regional Airport", 
	"country": "USA", 
	"city": "Pocatello, ID"}, 
{
	"citycode": "PIP", 
	"airport": "Pilot Point Airport", 
	"country": "USA", 
	"city": "Pilot Point, AK"}, 
{
	"citycode": "PIR", 
	"airport": "Pierre Regional Airport", 
	"country": "USA", 
	"city": "Pierre, SD"}, 
{
	"citycode": "PIT", 
	"airport": "Pittsburgh International Airport", 
	"country": "USA", 
	"city": "Pittsburgh, PA"}, 
{
	"citycode": "PIZ", 
	"airport": "Point Lay LRRS Airport", 
	"country": "USA", 
	"city": "Point Lay, AK"}, 
{
	"citycode": "PKA", 
	"airport": "Napaskiak Airport", 
	"country": "USA", 
	"city": "Napaskiak, AK"}, 
{
	"citycode": "PKB", 
	"airport": "Mid-Ohio Valley Regional Airport", 
	"country": "USA", 
	"city": "Parkersburg, WV"}, 
{
	"citycode": "PLB", 
	"airport": "Clinton County Airport", 
	"country": "USA", 
	"city": "Plattsburgh, NY"}, 
{
	"citycode": "PLN", 
	"airport": "Pellston Regional Airport", 
	"country": "USA", 
	"city": "Pellston, MI"}, 
{
	"citycode": "PMD", 
	"airport": "Palmdale Regional Airport", 
	"country": "USA", 
	"city": "Palmdale, CA"}, 
{
	"citycode": "PML", 
	"airport": "Port Moller Airport", 
	"country": "USA", 
	"city": "Port Moller, AK"}, 
{
	"citycode": "PNC", 
	"airport": "Ponca City Regional Airport", 
	"country": "USA", 
	"city": "Ponca City, OK"}, 
{
	"citycode": "PNE", 
	"airport": "Northeast Philadelphia Airport", 
	"country": "USA", 
	"city": "Philadelphia, PA"}, 
{
	"citycode": "PNS", 
	"airport": "Pensacola International Airport", 
	"country": "USA", 
	"city": "Pensacola, FL"}, 
{
	"citycode": "POQ", 
	"airport": "Polk Inlet Airport", 
	"country": "USA", 
	"city": "Polk Inlet, AK"}, 
{
	"citycode": "POU", 
	"airport": "Hudson Valley Regional Airport", 
	"country": "USA", 
	"city": "Poughkeepsie, NY"}, 
{
	"citycode": "PPM", 
	"airport": "Pompano Beach Airport", 
	"country": "USA", 
	"city": "Pompano Beach, FL"}, 
{
	"citycode": "PPV", 
	"airport": "Port Protection Seaplane Base", 
	"country": "USA", 
	"city": "Port Protection, AK"}, 
{
	"citycode": "PQI", 
	"airport": "Presque Isle International Airport", 
	"country": "USA", 
	"city": "Presque Isle, ME"}, 
{
	"citycode": "PRC", 
	"airport": "Prescott Regional Airport", 
	"country": "USA", 
	"city": "Prescott, AZ"}, 
{
	"citycode": "PRX", 
	"airport": "Cox Field Airport", 
	"country": "USA", 
	"city": "Paris, TX"}, 
{
	"citycode": "PSC", 
	"airport": "Tri-Cities Airport", 
	"country": "USA", 
	"city": "Pasco, WA"}, 
{
	"citycode": "PSG", 
	"airport": "Petersburg James A. Johnson Airport", 
	"country": "USA", 
	"city": "Petersburg, AK"}, 
{
	"citycode": "PSM", 
	"airport": "Portsmouth International Airport", 
	"country": "USA", 
	"city": "Portsmouth, NH"}, 
{
	"citycode": "PSP", 
	"airport": "Palm Springs International Airport", 
	"country": "USA", 
	"city": "Palm Springs, CA,"}, 
{
	"citycode": "PTA", 
	"airport": "Port Alsworth Airport", 
	"country": "USA", 
	"city": "Port Alsworth, AK"}, 
{
	"citycode": "PTC", 
	"airport": "Port Alice Airport", 
	"country": "USA", 
	"city": "Port Alice, AK"}, 
{
	"citycode": "PTD", 
	"airport": "Potsdam Municipal Airport", 
	"country": "USA", 
	"city": "Port Alexander, AK"}, 
{
	"citycode": "PTH", 
	"airport": "Port Heiden Airport", 
	"country": "USA", 
	"city": "Port Heiden, AK"}, 
{
	"citycode": "PTL", 
	"airport": "Port Armstrong Airport", 
	"country": "USA", 
	"city": "Port Armstrong, AK"}, 
{
	"citycode": "PTU", 
	"airport": "Platinum Airport", 
	"country": "USA", 
	"city": "Platinum, AK"}, 
{
	"citycode": "PUB", 
	"airport": "Pueblo Memorial Airport", 
	"country": "USA", 
	"city": "Pueblo, CO"}, 
{
	"citycode": "PUC", 
	"airport": "Carbon County-Price Regional Airport", 
	"country": "USA", 
	"city": "Price, UT"}, 
{
	"citycode": "PUW", 
	"airport": "Pullman-Moscow Regional Airport", 
	"country": "USA", 
	"city": "Pullman, WA"}, 
{
	"citycode": "PVC", 
	"airport": "Provincetown Municipal Airport", 
	"country": "USA", 
	"city": "Provincetown, MA"}, 
{
	"citycode": "PVD", 
	"airport": "Rhode Island T.F. Green International Airport", 
	"country": "USA", 
	"city": "Providence, RI"}, 
{
	"citycode": "PVU", 
	"airport": "Provo Airport", 
	"country": "USA", 
	"city": "Provo, UT"}, 
{
	"citycode": "PWK", 
	"airport": "Chicago Executive Airport", 
	"country": "USA", 
	"city": "Chicago, IL"}, 
{
	"citycode": "PWM", 
	"airport": "Portland International Jetport", 
	"country": "USA", 
	"city": "Portland, ME"}, 
{
	"citycode": "RAL", 
	"airport": "Riverside Municipal Airport", 
	"country": "USA", 
	"city": "Riverside, CA"}, 
{
	"citycode": "RAP", 
	"airport": "Rapid City Regional Airport", 
	"country": "USA", 
	"city": "Rapid City, SD"}, 
{
	"citycode": "RBD", 
	"airport": "Dallas Executive Airport", 
	"country": "USA", 
	"city": "Dallas-Fort Worth, TX"}, 
{
	"citycode": "RBY", 
	"airport": "Ruby Airport", 
	"country": "USA", 
	"city": "Ruby, AK"}, 
{
	"citycode": "RCE", 
	"airport": "Roche Harbor Airport", 
	"country": "USA", 
	"city": "Roche Harbor, WA"}, 
{
	"citycode": "RDD", 
	"airport": "Redding Municipal Airport", 
	"country": "USA", 
	"city": "Redding, CA"}, 
{
	"citycode": "RDG", 
	"airport": "Reading Regional Airport", 
	"country": "USA", 
	"city": "Reading, PA"}, 
{
	"citycode": "RDM", 
	"airport": "Redmond Municipal Airport", 
	"country": "USA", 
	"city": "Redmond, OR"}, 
{
	"citycode": "RDU", 
	"airport": "Raleigh-Durham International Airport", 
	"country": "USA", 
	"city": "Raleigh-Durham, NC"}, 
{
	"citycode": "RDV", 
	"airport": "Red Devil Airport", 
	"country": "USA", 
	"city": "Red Devil, AK"}, 
{
	"citycode": "RFD", 
	"airport": "Chicago Rockford International Airport", 
	"country": "USA", 
	"city": "Rockford, IL"}, 
{
	"citycode": "RHI", 
	"airport": "Rhinelander–Oneida County Airport", 
	"country": "USA", 
	"city": "Rhinelander, WI"}, 
{
	"citycode": "RIC", 
	"airport": "Richmond International Airport", 
	"country": "USA", 
	"city": "Richmond, VA"}, 
{
	"citycode": "RIF", 
	"airport": "Richfield Municipal Airport", 
	"country": "USA", 
	"city": "Richfield, UT"}, 
{
	"citycode": "RIR", 
	"airport": "Flabob Airport", 
	"country": "USA", 
	"city": "Riverside, CA"}, 
{
	"citycode": "RIW", 
	"airport": "Central Wyoming Regional Airport", 
	"country": "USA", 
	"city": "Riverton, WY"}, 
{
	"citycode": "RKD", 
	"airport": "Knox County Regional Airport", 
	"country": "USA", 
	"city": "Rockland, ME"}, 
{
	"citycode": "RKS", 
	"airport": "Southwest Wyoming Regional Airport", 
	"country": "USA", 
	"city": "Rock Springs, WY"}, 
{
	"citycode": "RNO", 
	"airport": "Reno-Tahoe International Airport", 
	"country": "USA", 
	"city": "Reno, NV"}, 
{
	"citycode": "RNT", 
	"airport": "Renton Municipal Airport", 
	"country": "USA", 
	"city": "Renton, WA"}, 
{
	"citycode": "ROA", 
	"airport": "Roanoke-Blacksburg Regional Airport", 
	"country": "USA", 
	"city": "Roanoke, VA"}, 
{
	"citycode": "ROC", 
	"airport": "Frederick Douglass Greater Rochester International Airport", 
	"country": "USA", 
	"city": "Rochester, NY"}, 
{
	"citycode": "ROW", 
	"airport": "Roswell International Air Center", 
	"country": "USA", 
	"city": "Roswell, NM"}, 
{
	"citycode": "RSH", 
	"airport": "Russian Mission Airport", 
	"country": "USA", 
	"city": "Russian Mission, AK"}, 
{
	"citycode": "RSJ", 
	"airport": "Rosario Airport", 
	"country": "USA", 
	"city": "Rosario, WA"}, 
{
	"citycode": "RST", 
	"airport": "Rochester International Airport", 
	"country": "USA", 
	"city": "Rochester, MN"}, 
{
	"citycode": "RSW", 
	"airport": "Southwest Florida International Airport", 
	"country": "USA", 
	"city": "Fort Myers, FL"}, 
{
	"citycode": "RWB", 
	"airport": "Rowan Bay Airport", 
	"country": "USA", 
	"city": "Rowan Bay, AK"}, 
{
	"citycode": "RWI", 
	"airport": "Rocky Mount-Wilson Regional Airport", 
	"country": "USA", 
	"city": "Rocky Mount, NC"}, 
{
	"citycode": "SAC", 
	"airport": "Sacramento Executive Airport", 
	"country": "USA", 
	"city": "Sacramento, CA"}, 
{
	"citycode": "SAF", 
	"airport": "Santa Fe Regional Airport", 
	"country": "USA", 
	"city": "Santa Fe, NM"}, 
{
	"citycode": "SAN", 
	"airport": "San Diego International Airport", 
	"country": "USA", 
	"city": "San Diego, CA"}, 
{
	"citycode": "SAT", 
	"airport": "San Antonio International Airport", 
	"country": "USA", 
	"city": "San Antonio, TX"}, 
{
	"citycode": "SAV", 
	"airport": "Savannah/Hilton Head International Airport", 
	"country": "USA", 
	"city": "Savannah, GA"}, 
{
	"citycode": "SBA", 
	"airport": "Santa Barbara Airport", 
	"country": "USA", 
	"city": "Santa Barbara, CA"}, 
{
	"citycode": "SBN", 
	"airport": "South Bend International Airport", 
	"country": "USA", 
	"city": "South Bend, IN"}, 
{
	"citycode": "SBO", 
	"airport": "Salina-Gunnison Airport", 
	"country": "USA", 
	"city": "Salina, UT"}, 
{
	"citycode": "SBP", 
	"airport": "San Luis Obispo County Regional Airport", 
	"country": "USA", 
	"city": "San Luis Obispo, CA"}, 
{
	"citycode": "SBS", 
	"airport": "Steamboat Springs Airport", 
	"country": "USA", 
	"city": "Steamboat Springs, CO"}, 
{
	"citycode": "SBY", 
	"airport": "Salisbury Ocean City Wicomico Regional Airport", 
	"country": "USA", 
	"city": "Salisbury-Ocean City, MD"}, 
{
	"citycode": "SCC", 
	"airport": "Deadhorse Airport", 
	"country": "USA", 
	"city": "Prudhoe Bay-Deadhorse, AK"}, 
{
	"citycode": "SCE", 
	"airport": "University Park Airport", 
	"country": "USA", 
	"city": "State College, PA"}, 
{
	"citycode": "SCF", 
	"airport": "Scottsdale Airport", 
	"country": "USA", 
	"city": "Phoenix, AZ"}, 
{
	"citycode": "SCJ", 
	"airport": "Smith Cove Airport", 
	"country": "USA", 
	"city": "Smith Cove, AK"}, 
{
	"citycode": "SCK", 
	"airport": "Stockton Metropolitan Airport", 
	"country": "USA", 
	"city": "Stockton, CA"}, 
{
	"citycode": "SCM", 
	"airport": "Scammon Bay Airport", 
	"country": "USA", 
	"city": "Scammon Bay, AK"}, 
{
	"citycode": "SDF", 
	"airport": "Louisville International Airport", 
	"country": "USA", 
	"city": "Louisville, KY"}, 
{
	"citycode": "SDM", 
	"airport": "Brown Field Municipal Airport", 
	"country": "USA", 
	"city": "San Diego, CA"}, 
{
	"citycode": "SDP", 
	"airport": "Sand Point Airport", 
	"country": "USA", 
	"city": "Sand Point, AK"}, 
{
	"citycode": "SDX", 
	"airport": "Sedona Airport", 
	"country": "USA", 
	"city": "Sedona, AZ"}, 
{
	"citycode": "SDY", 
	"airport": "Sidney–Richland Municipal Airport", 
	"country": "USA", 
	"city": "Sidney, MT"}, 
{
	"citycode": "SEA", 
	"airport": "Seattle-Tacoma International Airport", 
	"country": "USA", 
	"city": "Seattle, WA"}, 
{
	"citycode": "SFB", 
	"airport": "Orlando Sanford International Airport", 
	"country": "USA", 
	"city": "Orlando, FL"}, 
{
	"citycode": "SFF", 
	"airport": "Felts Field Airport", 
	"country": "USA", 
	"city": "Spokane, WA"}, 
{
	"citycode": "SFO", 
	"airport": "San Francisco International Airport", 
	"country": "USA", 
	"city": "San Francisco, CA"}, 
{
	"citycode": "SGF", 
	"airport": "Springfield-Branson National Airport", 
	"country": "USA", 
	"city": "Springfield, MO"}, 
{
	"citycode": "SGU", 
	"airport": "St. George Regional Airport", 
	"country": "USA", 
	"city": "Saint George, UT"}, 
{
	"citycode": "SGY", 
	"airport": "Skagway Airport", 
	"country": "USA", 
	"city": "Skagway, AK"}, 
{
	"citycode": "SHD", 
	"airport": "Shenandoah Valley Airport", 
	"country": "USA", 
	"city": "Staunton, VA"}, 
{
	"citycode": "SHG", 
	"airport": "Shungnak Airport", 
	"country": "USA", 
	"city": "Shungnak, AK"}, 
{
	"citycode": "SHH", 
	"airport": "Shishmaref Airport", 
	"country": "USA", 
	"city": "Shishmaref, AK"}, 
{
	"citycode": "SHR", 
	"airport": "Sheridan County Airport", 
	"country": "USA", 
	"city": "Sheridan, WY"}, 
{
	"citycode": "SHV", 
	"airport": "Shreveport Regional Airport", 
	"country": "USA", 
	"city": "Shreveport, LA"}, 
{
	"citycode": "SHX", 
	"airport": "Shageluk Airport", 
	"country": "USA", 
	"city": "Shageluk, AK"}, 
{
	"citycode": "SIT", 
	"airport": "Sitka Rocky Gutierrez Airport", 
	"country": "USA", 
	"city": "Sitka, AK"}, 
{
	"citycode": "SJC", 
	"airport": "San Jose International Airport", 
	"country": "USA", 
	"city": "San Jose, CA"}, 
{
	"citycode": "SJT", 
	"airport": "San Angelo Regional Airport", 
	"country": "USA", 
	"city": "San Angelo, TX"}, 
{
	"citycode": "SKA", 
	"airport": "Fairchild Airforce Base", 
	"country": "USA", 
	"city": "Spokane, WA"}, 
{
	"citycode": "SKK", 
	"airport": "Shaktoolik Airport", 
	"country": "USA", 
	"city": "Shaktoolik, AK"}, 
{
	"citycode": "SLC", 
	"airport": "Salt Lake City International Airport", 
	"country": "USA", 
	"city": "Salt Lake City, UT"}, 
{
	"citycode": "SLE", 
	"airport": "Salem Municipal Airport", 
	"country": "USA", 
	"city": "Salem, OR"}, 
{
	"citycode": "SLJ", 
	"airport": "Solomon Airport", 
	"country": "USA", 
	"city": "Chandler, AZ"}, 
{
	"citycode": "SLK", 
	"airport": "Adirondack Regional Airport", 
	"country": "USA", 
	"city": "Saranac Lake, NY"}, 
{
	"citycode": "SLN", 
	"airport": "Salina Regional Airport", 
	"country": "USA", 
	"city": "Salina, KS"}, 
{
	"citycode": "SLQ", 
	"airport": "Sleetmute Airport", 
	"country": "USA", 
	"city": "Sleetmute, AK"}, 
{
	"citycode": "SMF", 
	"airport": "Sacramento International Airport", 
	"country": "USA", 
	"city": "Sacramento, CA"}, 
{
	"citycode": "SMK", 
	"airport": "St. Michael International Airport", 
	"country": "USA", 
	"city": "St Michael, AK"}, 
{
	"citycode": "SMO", 
	"airport": "Santa Monica Airport", 
	"country": "USA", 
	"city": "Santa Monica, CA"}, 
{
	"citycode": "SMX", 
	"airport": "Santa Maria Public Airport", 
	"country": "USA", 
	"city": "Santa Maria, CA"}, 
{
	"citycode": "SNA", 
	"airport": "John Wayne International Airport", 
	"country": "USA", 
	"city": "Santa Ana, CA"}, 
{
	"citycode": "SNP", 
	"airport": "Saint Paul Island Airport", 
	"country": "USA", 
	"city": "Saint Paul Island, AK"}, 
{
	"citycode": "SNY", 
	"airport": "Sidney Municipal Airport", 
	"country": "USA", 
	"city": "Sidney, NE"}, 
{
	"citycode": "SOV", 
	"airport": "Seldovia Airport", 
	"country": "USA", 
	"city": "Seldovia, AK"}, 
{
	"citycode": "SPF", 
	"airport": "Black Hills Airport", 
	"country": "USA", 
	"city": "Spearfish, SD"}, 
{
	"citycode": "SPI", 
	"airport": "Abraham Lincoln Capital Airport", 
	"country": "USA", 
	"city": "Springfield, IL"}, 
{
	"citycode": "SPQ", 
	"airport": "Catalina SPB Airport", 
	"country": "USA", 
	"city": "San Pedro, CA"}, 
{
	"citycode": "SPS", 
	"airport": "Wichita Falls Regional Airport", 
	"country": "USA", 
	"city": "Wichita Falls, TX"}, 
{
	"citycode": "SPW", 
	"airport": "Spencer Municipal Airport", 
	"country": "USA", 
	"city": "Spencer, IA"}, 
{
	"citycode": "SQI", 
	"airport": "Whiteside County Airport", 
	"country": "USA", 
	"city": "Sterling Rockfalls, IL"}, 
{
	"citycode": "SRQ", 
	"airport": "Sarasota–Bradenton International Airport", 
	"country": "USA", 
	"city": "Sarasota, FL"}, 
{
	"citycode": "SRV", 
	"airport": "Stony River Airport", 
	"country": "USA", 
	"city": "Stony River, AK"}, 
{
	"citycode": "STG", 
	"airport": "St George Airport", 
	"country": "USA", 
	"city": "St George Island, AK"}, 
{
	"citycode": "STL", 
	"airport": "St. Louis Lambert International Airport", 
	"country": "USA", 
	"city": "St Louis, MO"}, 
{
	"citycode": "STP", 
	"airport": "St. Paul Downtown Airport", 
	"country": "USA", 
	"city": "Minneapolis, MN"}, 
{
	"citycode": "STS", 
	"airport": "Charles M. Schulz–Sonoma County Airport", 
	"country": "USA", 
	"city": "Santa Rosa, CA"}, 
{
	"citycode": "SUA", 
	"airport": "Witham Field Airport", 
	"country": "USA", 
	"city": "Stuart, FL"}, 
{
	"citycode": "SUE", 
	"airport": "Door County Cherryland Airport", 
	"country": "USA", 
	"city": "Sturgeon Bay, WI"}, 
{
	"citycode": "SUN", 
	"airport": "Friedman Memorial Airport", 
	"country": "USA", 
	"city": "Sun Valley, ID"}, 
{
	"citycode": "SUX", 
	"airport": "Sioux Gateway Airport", 
	"country": "USA", 
	"city": "Sioux City, IA"}, 
{
	"citycode": "SVA", 
	"airport": "Savoonga Airport", 
	"country": "USA", 
	"city": "Savoonga, AK"}, 
{
	"citycode": "SVC", 
	"airport": "Grant County Airport", 
	"country": "USA", 
	"city": "Silver City, NM"}, 
{
	"citycode": "SVS", 
	"airport": "Stevens Village Airport", 
	"country": "USA", 
	"city": "Stevens Village, AK"}, 
{
	"citycode": "SWD", 
	"airport": "Seward Airport", 
	"country": "USA", 
	"city": "Seward, AK"}, 
{
	"citycode": "SWF", 
	"airport": "Stewart International Airport", 
	"country": "USA", 
	"city": "Newburgh, NY"}, 
{
	"citycode": "SXP", 
	"airport": "Sheldon Point Airport", 
	"country": "USA", 
	"city": "Sheldon Point, AK"}, 
{
	"citycode": "SYA", 
	"airport": "Eareckson Air Station", 
	"country": "USA", 
	"city": "Shemya, AK"}, 
{
	"citycode": "SYB", 
	"airport": "Seal Bay Seaplane Base", 
	"country": "USA", 
	"city": "Seal Bay, AK"}, 
{
	"citycode": "SYR", 
	"airport": "Syracuse Hancock International Airport", 
	"country": "USA", 
	"city": "Syracuse, NY"}, 
{
	"citycode": "TAL", 
	"airport": "Ralph M. Calhoun Memorial Airport", 
	"country": "USA", 
	"city": "Tanana, AK"}, 
{
	"citycode": "TBN", 
	"airport": "Waynesville - St. Robert Regional Airport", 
	"country": "USA", 
	"city": "Fort Leonard Wood, MO"}, 
{
	"citycode": "TCL", 
	"airport": "Tuscaloosa National Airport", 
	"country": "USA", 
	"city": "Tuscaloosa, AL"}, 
{
	"citycode": "TCT", 
	"airport": "Takotna Airport", 
	"country": "USA", 
	"city": "Takotna, AK"}, 
{
	"citycode": "TEB", 
	"airport": "Teterboro Airport", 
	"country": "USA", 
	"city": "Teterboro, NJ"}, 
{
	"citycode": "TEX", 
	"airport": "Telluride Regional Airport", 
	"country": "USA", 
	"city": "Telluride, CO"}, 
{
	"citycode": "TIX", 
	"airport": "Space Coast Regional Airport", 
	"country": "USA", 
	"city": "Titusville, FL"}, 
{
	"citycode": "TKE", 
	"airport": "Tenakee SPB Airport", 
	"country": "USA", 
	"city": "Tenakee Springs, AK"}, 
{
	"citycode": "TKF", 
	"airport": "Truckee Tahoe Airport", 
	"country": "USA", 
	"city": "Truckee, CA"}, 
{
	"citycode": "TKI", 
	"airport": "McKinney National Airport", 
	"country": "USA", 
	"city": "Tokeen, AK"}, 
{
	"citycode": "TKJ", 
	"airport": "Tok Junction Airport", 
	"country": "USA", 
	"city": "Tok, AK"}, 
{
	"citycode": "TLA", 
	"airport": "Teller Airport", 
	"country": "USA", 
	"city": "Teller, AK"}, 
{
	"citycode": "TLH", 
	"airport": "Tallahassee International Airport", 
	"country": "USA", 
	"city": "Tallahassee, FL"}, 
{
	"citycode": "TLJ", 
	"airport": "Tatalina Airport", 
	"country": "USA", 
	"city": "Tatalina, AK"}, 
{
	"citycode": "TLT", 
	"airport": "Tuluksak Airport", 
	"country": "USA", 
	"city": "Tuluksak, AK"}, 
{
	"citycode": "TMB", 
	"airport": "Miami Executive Airport", 
	"country": "USA", 
	"city": "Miami, FL"}, 
{
	"citycode": "TNC", 
	"airport": "Tin City LRRS Airport", 
	"country": "USA", 
	"city": "Tin City, AK"}, 
{
	"citycode": "TNK", 
	"airport": "Tununak Airport", 
	"country": "USA", 
	"city": "Tununak, AK"}, 
{
	"citycode": "TOA", 
	"airport": "Torrance Municipal Airport", 
	"country": "USA", 
	"city": "Torrance, CA"}, 
{
	"citycode": "TOG", 
	"airport": "Togiak Airport", 
	"country": "USA", 
	"city": "Togiak Village, AK"}, 
{
	"citycode": "TOL", 
	"airport": "Kranz Toledo Express Airport ", 
	"country": "USA", 
	"city": "Toledo, OH"}, 
{
	"citycode": "TOP", 
	"airport": "Philip Billard Airport", 
	"country": "USA", 
	"city": "Topeka, KS"}, 
{
	"citycode": "TPA", 
	"airport": "Tampa International Airport", 
	"country": "USA", 
	"city": "Tampa, FL"}, 
{
	"citycode": "TRI", 
	"airport": "Tri-Cities Airport", 
	"country": "USA", 
	"city": "Bristol, VA"}, 
{
	"citycode": "TSM", 
	"airport": "Taos Regional Airport", 
	"country": "USA", 
	"city": "Taos, NM"}, 
{
	"citycode": "TSS", 
	"airport": "East 34th St Heliport", 
	"country": "USA", 
	"city": "New York, NY"}, 
{
	"citycode": "TTN", 
	"airport": "Trenton-Mercer Airport", 
	"country": "USA", 
	"city": "Trenton-Philadelphia, PA"}, 
{
	"citycode": "TUL", 
	"airport": "Tulsa International Airport", 
	"country": "USA", 
	"city": "Tulsa, OK"}, 
{
	"citycode": "TUP", 
	"airport": "Tupelo Regional Airport", 
	"country": "USA", 
	"city": "Tupelo, MS"}, 
{
	"citycode": "TUS", 
	"airport": "Tucson International Airport", 
	"country": "USA", 
	"city": "Tucson, AZ"}, 
{
	"citycode": "TVC", 
	"airport": "Traverse City", 
	"country": "USA", 
	"city": "Traverse City, MI"}, 
{
	"citycode": "TVF", 
	"airport": "Thief River Falls Regional Airport", 
	"country": "USA", 
	"city": "Thief River Falls, MN"}, 
{
	"citycode": "TVL", 
	"airport": "Lake Tahoe Airport", 
	"country": "USA", 
	"city": "South Lake Tahoe, CA"}, 
{
	"citycode": "TWA", 
	"airport": "Twin Hills Airport", 
	"country": "USA", 
	"city": "Twin Hills, AK"}, 
{
	"citycode": "TWF", 
	"airport": "Magic Valley Regional Airport", 
	"country": "USA", 
	"city": "Twin Falls, ID"}, 
{
	"citycode": "TXK", 
	"airport": "Texarkana Regional Airport", 
	"country": "USA", 
	"city": "Texarkana, AR"}, 
{
	"citycode": "TYR", 
	"airport": "Tyler Pounds Regional Airport", 
	"country": "USA", 
	"city": "Tyler, TX"}, 
{
	"citycode": "TYS", 
	"airport": "Mc Ghee Tyson Airport", 
	"country": "USA", 
	"city": "Knoxville, TN"}, 
{
	"citycode": "UCA", 
	"airport": "Oneida County Airport", 
	"country": "USA", 
	"city": "Utica, NY"}, 
{
	"citycode": "UDD", 
	"airport": "Bermuda Dunes Airport", 
	"country": "USA", 
	"city": "Palm Springs, CA"}, 
{
	"citycode": "UGB", 
	"airport": "Ugashik Bay Airport", 
	"country": "USA", 
	"city": "Pilot Point, AK"}, 
{
	"citycode": "UGI", 
	"airport": "Uganik Airport", 
	"country": "USA", 
	"city": "Uganik, AK"}, 
{
	"citycode": "UGN", 
	"airport": "Waukegan National Airport ", 
	"country": "USA", 
	"city": "Waukegan, IL"}, 
{
	"citycode": "UIN", 
	"airport": "Quincy Regional Airport", 
	"country": "USA", 
	"city": "Quincy, IL"}, 
{
	"citycode": "UNK", 
	"airport": "Unalakleet Airport", 
	"country": "USA", 
	"city": "Unalakleet, AK"}, 
{
	"citycode": "UQE", 
	"airport": "Queen Airport", 
	"country": "USA", 
	"city": "Queen, AK"}, 
{
	"citycode": "UTO", 
	"airport": "Indian Mountain Airport", 
	"country": "USA", 
	"city": "Utopia Creek, AK"}, 
{
	"citycode": "VAK", 
	"airport": "Chevak Airport", 
	"country": "USA", 
	"city": "Chevak, AK"}, 
{
	"citycode": "VCT", 
	"airport": "Victoria Regional Airport", 
	"country": "USA", 
	"city": "Victoria, TX"}, 
{
	"citycode": "VDZ", 
	"airport": "Valdez Airport", 
	"country": "USA", 
	"city": "Valdez, AK"}, 
{
	"citycode": "VEE", 
	"airport": "Venetie Airport", 
	"country": "USA", 
	"city": "Venetie, AK"}, 
{
	"citycode": "VEL", 
	"airport": "Vernal Regional Airport", 
	"country": "USA", 
	"city": "Vernal, UT"}, 
{
	"citycode": "VGT", 
	"airport": "North Las Vegas Airport", 
	"country": "USA", 
	"city": "Las Vegas, NV"}, 
{
	"citycode": "VIS", 
	"airport": "Visalia Municipal Airport", 
	"country": "USA", 
	"city": "Visalia, CA"}, 
{
	"citycode": "VLD", 
	"airport": "Valdosta Regional Airport", 
	"country": "USA", 
	"city": "Valdosta, GA"}, 
{
	"citycode": "VNY", 
	"airport": "Van Nuys Airport", 
	"country": "USA", 
	"city": "Los Angeles, CA"}, 
{
	"citycode": "VPS", 
	"airport": "Destin-Fort Walton Beach Airport", 
	"country": "USA", 
	"city": "Valparaiso, FL"}, 
{
	"citycode": "VRB", 
	"airport": "Vero Beach Regional Airport", 
	"country": "USA", 
	"city": "Vero Beach, FL"}, 
{
	"citycode": "WBB", 
	"airport": "Stebbins Airport", 
	"country": "USA", 
	"city": "Stebbins, AK"}, 
{
	"citycode": "WBQ", 
	"airport": "Beaver Airport", 
	"country": "USA", 
	"city": "Beaver, AK"}, 
{
	"citycode": "WDG", 
	"airport": "Enid-Woodring Airport", 
	"country": "USA", 
	"city": "Enid, OK"}, 
{
	"citycode": "WKK", 
	"airport": "Aleknagik Airport", 
	"country": "USA", 
	"city": "Aleknagik, AK"}, 
{
	"citycode": "WLB", 
	"airport": "Labouchere Bay Airport", 
	"country": "USA", 
	"city": "Labouchere Bay, AK"}, 
{
	"citycode": "WLK", 
	"airport": "Selawik Airport", 
	"country": "USA", 
	"city": "Selawik, AK"}, 
{
	"citycode": "WLM", 
	"airport": "Waltham Airport", 
	"country": "USA", 
	"city": "Waltham, MA"}, 
{
	"citycode": "WMH", 
	"airport": "Ozark Regional Airport", 
	"country": "USA", 
	"city": "Mountain Home, AR"}, 
{
	"citycode": "WMK", 
	"airport": "Meyers Chuck Seaplane Base Airport", 
	"country": "USA", 
	"city": "Meyers Chuck, AK"}, 
{
	"citycode": "WMO", 
	"airport": "White Mountain Airport", 
	"country": "USA", 
	"city": "White Mountain, AK"}, 
{
	"citycode": "WNA", 
	"airport": "Napakiak Airport", 
	"country": "USA", 
	"city": "Napakiak, AK"}, 
{
	"citycode": "WRG", 
	"airport": "Wrangell Airport", 
	"country": "USA", 
	"city": "Wrangell, AK"}, 
{
	"citycode": "WRL", 
	"airport": "Worland Muncipal Airport", 
	"country": "USA", 
	"city": "Worland, WY"}, 
{
	"citycode": "WSN", 
	"airport": "South Naknek Airport", 
	"country": "USA", 
	"city": "South Naknek, AK"}, 
{
	"citycode": "WST", 
	"airport": "Westerly State Airport", 
	"country": "USA", 
	"city": "Westerly, RI"}, 
{
	"citycode": "WSX", 
	"airport": "Westsound Airport", 
	"country": "USA", 
	"city": "Westsound, WA"}, 
{
	"citycode": "WTK", 
	"airport": "Noatak Airport", 
	"country": "USA", 
	"city": "Noatak, AK"}, 
{
	"citycode": "WTL", 
	"airport": "Tuntutuliak Airport", 
	"country": "USA", 
	"city": "Tuntutuliak, AK"}, 
{
	"citycode": "WWA", 
	"airport": "Wasilla Airport", 
	"country": "USA", 
	"city": "Wasilla, AK"}, 
{
	"citycode": "WWD", 
	"airport": "Cape May Airport", 
	"country": "USA", 
	"city": "Wildwood, NJ"}, 
{
	"citycode": "WWP", 
	"airport": "Whale Pass Airport", 
	"country": "USA", 
	"city": "Whale Pass, AK"}, 
{
	"citycode": "WWT", 
	"airport": "Newtok Airport", 
	"country": "USA", 
	"city": "Newtok, AK"}, 
{
	"citycode": "WYS", 
	"airport": "Yellowstone Airport", 
	"country": "USA", 
	"city": "West Yellowstone, MT"}, 
{
	"citycode": "YAK", 
	"airport": "Yakutat Airport", 
	"country": "USA", 
	"city": "Yakutat, AK"}, 
{
	"citycode": "YIP", 
	"airport": "Willow Run Airport", 
	"country": "USA", 
	"city": "Detroit, MI,"}, 
{
	"citycode": "YKM", 
	"airport": "Yakima Airport", 
	"country": "USA", 
	"city": "Yakima, WA"}, 
{
	"citycode": "YKN", 
	"airport": "Chan Gurney Municipal Airport", 
	"country": "USA", 
	"city": "Yankton, SD"}, 
{
	"citycode": "YNG", 
	"airport": "Youngstown-Warren Regional Airport", 
	"country": "USA", 
	"city": "Youngstown, OH"}, 
{
	"citycode": "YUM", 
	"airport": "Yuma International Airport", 
	"country": "USA", 
	"city": "Yuma, AZ"}, 
{
	"citycode": "ZWI", 
	"airport": "Wilmington Railway Station", 
	"country": "USA", 
	"city": "Wilmington"}, 
{
	"citycode": "ABZ", 
	"airport": "Aberdeen International Airport ", 
	"country": "United Kingdom", 
	"city": "Aberdeen"}, 
{
	"citycode": "ACI", 
	"airport": "Alderney Airport", 
	"country": "United Kingdom", 
	"city": "Alderney"}, 
{
	"citycode": "BBS", 
	"airport": "Blackbushe Airport", 
	"country": "United Kingdom", 
	"city": "Blackbush"}, 
{
	"citycode": "BEB", 
	"airport": "Benbecula Airport", 
	"country": "United Kingdom", 
	"city": "Benbecula"}, 
{
	"citycode": "BFS", 
	"airport": "Belfast International Airport", 
	"country": "United Kingdom", 
	"city": "Belfast"}, 
{
	"citycode": "BHD", 
	"airport": "Belfast City Airport", 
	"country": "United Kingdom", 
	"city": "Belfast"}, 
{
	"citycode": "BHX", 
	"airport": "Birmingham Airport", 
	"country": "United Kingdom", 
	"city": "Birmingham"}, 
{
	"citycode": "BLK", 
	"airport": "Blackpool Airport", 
	"country": "United Kingdom", 
	"city": "Blackpool"}, 
{
	"citycode": "BOH", 
	"airport": "Bournemouth International Airport", 
	"country": "United Kingdom", 
	"city": "Bournemouth"}, 
{
	"citycode": "BRR", 
	"airport": "Barra Airport", 
	"country": "United Kingdom", 
	"city": "Barra"}, 
{
	"citycode": "BRS", 
	"airport": "Bristol", 
	"country": "United Kingdom", 
	"city": "Bristol"}, 
{
	"citycode": "BZZ", 
	"airport": "Royal Air Force Brize Norton Station", 
	"country": "United Kingdom", 
	"city": "Brize Norton"}, 
{
	"citycode": "CAL", 
	"airport": "Campbeltown Airport", 
	"country": "United Kingdom", 
	"city": "Campbeltown"}, 
{
	"citycode": "CAX", 
	"airport": "Carlisle Lake District Airport", 
	"country": "United Kingdom", 
	"city": "Carlisle"}, 
{
	"citycode": "CBG", 
	"airport": "Cambridge City Airport", 
	"country": "United Kingdom", 
	"city": "Cambridge"}, 
{
	"citycode": "CVT", 
	"airport": "Coventry Airport", 
	"country": "United Kingdom", 
	"city": "Coventry"}, 
{
	"citycode": "CWL", 
	"airport": "Cardiff-Wales Airport", 
	"country": "United Kingdom", 
	"city": "Cardiff"}, 
{
	"citycode": "DND", 
	"airport": "Dundee Airport", 
	"country": "United Kingdom", 
	"city": "Dundee"}, 
{
	"citycode": "EDI", 
	"airport": "Edinburgh Airport", 
	"country": "United Kingdom", 
	"city": "Edinburgh"}, 
{
	"citycode": "EMA", 
	"airport": "East Midlands Airport", 
	"country": "United Kingdom", 
	"city": "East Midlands Airport"}, 
{
	"citycode": "EOI", 
	"airport": "Eday London Airport", 
	"country": "United Kingdom", 
	"city": "Eday"}, 
{
	"citycode": "ESH", 
	"airport": "Brighton City Airport", 
	"country": "United Kingdom", 
	"city": "Shoreham By Sea"}, 
{
	"citycode": "EXT", 
	"airport": "Exeter Airport", 
	"country": "United Kingdom", 
	"city": "Exeter"}, 
{
	"citycode": "FIE", 
	"airport": "Fair Isle Airport", 
	"country": "United Kingdom", 
	"city": "Fair Isle"}, 
{
	"citycode": "GLA", 
	"airport": "Glasgow Airport", 
	"country": "United Kingdom", 
	"city": "Glasgow"}, 
{
	"citycode": "HUY", 
	"airport": "Humberside Airport", 
	"country": "United Kingdom", 
	"city": "Humberside"}, 
{
	"citycode": "ILY", 
	"airport": "Islay Airport", 
	"country": "United Kingdom", 
	"city": "Islay"}, 
{
	"citycode": "INV", 
	"airport": "Inverness Airport", 
	"country": "United Kingdom", 
	"city": "Inverness"}, 
{
	"citycode": "IOM", 
	"airport": "Ronaldsway Airport", 
	"country": "United Kingdom", 
	"city": "Isle Of Man"}, 
{
	"citycode": "ISC", 
	"airport": "St Marys Airport", 
	"country": "United Kingdom", 
	"city": "Isles Of Scilly"}, 
{
	"citycode": "JER", 
	"airport": "Jersey Airport", 
	"country": "United Kingdom", 
	"city": "Jersey"}, 
{
	"citycode": "KOI", 
	"airport": "Kirkwall Airport", 
	"country": "United Kingdom", 
	"city": "Kirkwall (Orkney Is)"}, 
{
	"citycode": "LBA", 
	"airport": "Leeds-Bradford Airport", 
	"country": "United Kingdom", 
	"city": "Leeds"}, 
{
	"citycode": "LCY", 
	"airport": "London City Airport", 
	"country": "United Kingdom", 
	"city": "LONDON CITY AIRPORT , GB"}, 
{
	"citycode": "LDY", 
	"airport": "City of Derry Airport", 
	"country": "United Kingdom", 
	"city": "Londonderry"}, 
{
	"citycode": "LGW", 
	"airport": "Gatwick Airport", 
	"country": "United Kingdom", 
	"city": "LONDON GATWICK AIRPORT , GB"}, 
{
	"citycode": "LON", 
	"airport": "London All Airports", 
	"country": "United Kingdom", 
	"city": "London"}, 
{
	"citycode": "LPL", 
	"airport": "Liverpool John Lennon Airport", 
	"country": "United Kingdom", 
	"city": "Liverpool"}, 
{
	"citycode": "LSI", 
	"airport": "Sumburgh Airport", 
	"country": "United Kingdom", 
	"city": "Shetland Islands"}, 
{
	"citycode": "LTN", 
	"airport": "Luton Airport", 
	"country": "United Kingdom", 
	"city": "LONDON LUTON AIRPORT , GB"}, 
{
	"citycode": "LWK", 
	"airport": "Tingwall Airport", 
	"country": "United Kingdom", 
	"city": "Shetland Islands"}, 
{
	"citycode": "LYX", 
	"airport": "Lydd International Airport", 
	"country": "United Kingdom", 
	"city": "Lydd"}, 
{
	"citycode": "MAN", 
	"airport": "Manchester Airport", 
	"country": "United Kingdom", 
	"city": "Manchester"}, 
{
	"citycode": "MME", 
	"airport": "Teesside International Airport", 
	"country": "United Kingdom", 
	"city": "Teesside"}, 
{
	"citycode": "MSE", 
	"airport": "Kent International Airport", 
	"country": "United Kingdom", 
	"city": "Manston"}, 
{
	"citycode": "NCL", 
	"airport": "Newcastle International Airport", 
	"country": "United Kingdom", 
	"city": "Newcastle"}, 
{
	"citycode": "NDY", 
	"airport": "Sanday Airport", 
	"country": "United Kingdom", 
	"city": "Sanday"}, 
{
	"citycode": "NQT", 
	"airport": "Nottingham Airport", 
	"country": "United Kingdom", 
	"city": "Nottingham"}, 
{
	"citycode": "NQY", 
	"airport": "Newquay Airport", 
	"country": "United Kingdom", 
	"city": "Newquay"}, 
{
	"citycode": "NRL", 
	"airport": "North Ronaldsay Airport", 
	"country": "United Kingdom", 
	"city": "North Ronaldsay"}, 
{
	"citycode": "NWI", 
	"airport": "Norwich Airport", 
	"country": "United Kingdom", 
	"city": "Norwich"}, 
{
	"citycode": "PIK", 
	"airport": "Glasgow Prestwick Airport", 
	"country": "United Kingdom", 
	"city": "Glasgow"}, 
{
	"citycode": "PLH", 
	"airport": "Plymouth City Airport", 
	"country": "United Kingdom", 
	"city": "Plymouth"}, 
{
	"citycode": "PPW", 
	"airport": "Papa Westray Airport", 
	"country": "United Kingdom", 
	"city": "Papa Westray"}, 
{
	"citycode": "PZE", 
	"airport": "Penzance Airport", 
	"country": "United Kingdom", 
	"city": "Penzance"}, 
{
	"citycode": "SEN", 
	"airport": "London Southend Airport", 
	"country": "United Kingdom", 
	"city": "Southend"}, 
{
	"citycode": "SOU", 
	"airport": "Southampton Airport", 
	"country": "United Kingdom", 
	"city": "Southampton"}, 
{
	"citycode": "SOY", 
	"airport": "Stronsay Airport", 
	"country": "United Kingdom", 
	"city": "Stronsay"}, 
{
	"citycode": "STN", 
	"airport": "London Stansted Airport", 
	"country": "United Kingdom", 
	"city": "LONDON STANSTED AIRPORT , GB"}, 
{
	"citycode": "SYY", 
	"airport": "Stornoway Airport", 
	"country": "United Kingdom", 
	"city": "Stornoway"}, 
{
	"citycode": "TRE", 
	"airport": "Tiree Airport", 
	"country": "United Kingdom", 
	"city": "Tiree"}, 
{
	"citycode": "TSO", 
	"airport": "Carroll County–Tolson Airport", 
	"country": "United Kingdom", 
	"city": "Isles Of Scilly"}, 
{
	"citycode": "UNT", 
	"airport": "Unst Airport", 
	"country": "United Kingdom", 
	"city": "Unst Shetland Is"}, 
{
	"citycode": "WIC", 
	"airport": "Wick John O Groats Airport", 
	"country": "United Kingdom", 
	"city": "Wick"}, 
{
	"citycode": "WRY", 
	"airport": "Westray Airport", 
	"country": "United Kingdom", 
	"city": "Westray"}, 
{
	"citycode": "ABM", 
	"airport": "Northern Peninsula Airport", 
	"country": "Australia", 
	"city": "Bamaga"}, 
{
	"citycode": "ABX", 
	"airport": "Albury Airport", 
	"country": "Australia", 
	"city": "Albury"}, 
{
	"citycode": "ADL", 
	"airport": "Adelaide International Airport", 
	"country": "Australia", 
	"city": "Adelaide"}, 
{
	"citycode": "ARM", 
	"airport": "Armidale Regional Airport", 
	"country": "Australia", 
	"city": "Armidale"}, 
{
	"citycode": "ASP", 
	"airport": "Alice Springs Airport", 
	"country": "Australia", 
	"city": "Alice Springs"}, 
{
	"citycode": "AUU", 
	"airport": "Aurukun Airport", 
	"country": "Australia", 
	"city": "Aurukun Mission"}, 
{
	"citycode": "AVV", 
	"airport": "Avalon Airport", 
	"country": "Australia", 
	"city": "Avalon Airport"}, 
{
	"citycode": "AXL", 
	"airport": "Alexandria Airport", 
	"country": "Australia", 
	"city": "Alexandria"}, 
{
	"citycode": "AYQ", 
	"airport": "Ayers Rock Airport", 
	"country": "Australia", 
	"city": "Ayers Rock"}, 
{
	"citycode": "BCZ", 
	"airport": "Milyakburra Airport", 
	"country": "Australia", 
	"city": "Bickerton Island"}, 
{
	"citycode": "BDB", 
	"airport": "Bundaberg Regional Airport", 
	"country": "Australia", 
	"city": "Bundaberg"}, 
{
	"citycode": "BDD", 
	"airport": "Badu Island Airport", 
	"country": "Australia", 
	"city": "Badu Island"}, 
{
	"citycode": "BEO", 
	"airport": "Belmont Airport", 
	"country": "Australia", 
	"city": "Newcastle"}, 
{
	"citycode": "BHQ", 
	"airport": "Broken Hill", 
	"country": "Australia", 
	"city": "Broken Hill"}, 
{
	"citycode": "BHS", 
	"airport": "Bathurst Airport ", 
	"country": "Australia", 
	"city": "Bathurst"}, 
{
	"citycode": "BKQ", 
	"airport": "Blackall Airport", 
	"country": "Australia", 
	"city": "Blackall"}, 
{
	"citycode": "BLT", 
	"airport": "Blackwater Airport", 
	"country": "Australia", 
	"city": "Blackwater"}, 
{
	"citycode": "BME", 
	"airport": "Broome International Airport", 
	"country": "Australia", 
	"city": "Broome"}, 
{
	"citycode": "BMP", 
	"airport": "Brampton Island Airport", 
	"country": "Australia", 
	"city": "Brampton Island"}, 
{
	"citycode": "BNE", 
	"airport": "Brisbane Airport", 
	"country": "Australia", 
	"city": "Brisbane"}, 
{
	"citycode": "BNK", 
	"airport": "Ballina Byron Gateway Airport", 
	"country": "Australia", 
	"city": "Ballina"}, 
{
	"citycode": "BOX", 
	"airport": "Borroloola Airport", 
	"country": "Australia", 
	"city": "Borroloola"}, 
{
	"citycode": "BRT", 
	"airport": "Bathurst Island Airport", 
	"country": "Australia", 
	"city": "Bathurst Island"}, 
{
	"citycode": "BSJ", 
	"airport": "Bairnsdale Airport", 
	"country": "Australia", 
	"city": "Bairnsdale"}, 
{
	"citycode": "BUC", 
	"airport": "Burketown Airport", 
	"country": "Australia", 
	"city": "Burketown"}, 
{
	"citycode": "BVI", 
	"airport": "Birdsville Airport", 
	"country": "Australia", 
	"city": "Birdsville"}, 
{
	"citycode": "BWT", 
	"airport": "Burnie Wynyard Airport", 
	"country": "Australia", 
	"city": "Burnie"}, 
{
	"citycode": "BYX", 
	"airport": "Baniyala Airport", 
	"country": "Australia", 
	"city": "Baniyala"}, 
{
	"citycode": "CBR", 
	"airport": "Canberra International Airport", 
	"country": "Australia", 
	"city": "Canberra"}, 
{
	"citycode": "CBX", 
	"airport": "Condobolin Aerodrome", 
	"country": "Australia", 
	"city": "Condobolin"}, 
{
	"citycode": "CED", 
	"airport": "Ceduna Airport", 
	"country": "Australia", 
	"city": "Ceduna"}, 
{
	"citycode": "CES", 
	"airport": "Cessnock Airport", 
	"country": "Australia", 
	"city": "Cessnock"}, 
{
	"citycode": "CFS", 
	"airport": "Coffs Harbour Airport", 
	"country": "Australia", 
	"city": "Coffs Harbour"}, 
{
	"citycode": "CMQ", 
	"airport": "Clermont Airport", 
	"country": "Australia", 
	"city": "Clermont"}, 
{
	"citycode": "CNC", 
	"airport": "Coconut Island Airport", 
	"country": "Australia", 
	"city": "Coconut Island"}, 
{
	"citycode": "CNJ", 
	"airport": "Cloncurry Airport", 
	"country": "Australia", 
	"city": "Cloncurry"}, 
{
	"citycode": "CNS", 
	"airport": "Cairns Airport", 
	"country": "Australia", 
	"city": "Cairns"}, 
{
	"citycode": "COJ", 
	"airport": "Coonabarabran Airport", 
	"country": "Australia", 
	"city": "Coonabarabran"}, 
{
	"citycode": "CPD", 
	"airport": "Coober Pedy Airport", 
	"country": "Australia", 
	"city": "Coober Pedy"}, 
{
	"citycode": "CTL", 
	"airport": "Charleville Airport", 
	"country": "Australia", 
	"city": "Charleville"}, 
{
	"citycode": "CTN", 
	"airport": "Cooktown Airport", 
	"country": "Australia", 
	"city": "Cooktown"}, 
{
	"citycode": "CUQ", 
	"airport": "Coen International Airport", 
	"country": "Australia", 
	"city": "Coen"}, 
{
	"citycode": "CUY", 
	"airport": "Cue Airport", 
	"country": "Australia", 
	"city": "Cue"}, 
{
	"citycode": "CVQ", 
	"airport": "Carnarvon Airport", 
	"country": "Australia", 
	"city": "Carnarvon"}, 
{
	"citycode": "CWT", 
	"airport": "Cowra Airport", 
	"country": "Australia", 
	"city": "Cowra"}, 
{
	"citycode": "CXT", 
	"airport": "Charters Towers Airport", 
	"country": "Australia", 
	"city": "Charters Towers"}, 
{
	"citycode": "CYG", 
	"airport": "Corryong Airport", 
	"country": "Australia", 
	"city": "Corryong"}, 
{
	"citycode": "DBO", 
	"airport": "Dubbo City Regional Airport", 
	"country": "Australia", 
	"city": "Dubbo"}, 
{
	"citycode": "DDI", 
	"airport": "Daydream Island Resort Airport", 
	"country": "Australia", 
	"city": "Daydream Is"}, 
{
	"citycode": "DGE", 
	"airport": "Mudgee Airport", 
	"country": "Australia", 
	"city": "Mudgee"}, 
{
	"citycode": "DKI", 
	"airport": "Dunk Island Airport", 
	"country": "Australia", 
	"city": "Dunk Island"}, 
{
	"citycode": "DMD", 
	"airport": "Doomadgee Airport", 
	"country": "Australia", 
	"city": "Doomadgee"}, 
{
	"citycode": "DNQ", 
	"airport": "Deniliquin Airport", 
	"country": "Australia", 
	"city": "Deniliquin"}, 
{
	"citycode": "DPO", 
	"airport": "Devonport Airport", 
	"country": "Australia", 
	"city": "Devonport"}, 
{
	"citycode": "DRW", 
	"airport": "Darwin International Airport", 
	"country": "Australia", 
	"city": "Darwin"}, 
{
	"citycode": "DWR", 
	"airport": "Dwyer Airport", 
	"country": "Australia", 
	"city": "DARWIN"}, 
{
	"citycode": "DYA", 
	"airport": "Dysart Airport", 
	"country": "Australia", 
	"city": "Dysart"}, 
{
	"citycode": "EDR", 
	"airport": "Edward River Airport", 
	"country": "Australia", 
	"city": "Edward River"}, 
{
	"citycode": "ELC", 
	"airport": "Elcho Island Airport", 
	"country": "Australia", 
	"city": "Elcho Island"}, 
{
	"citycode": "EMD", 
	"airport": "Emerald Airport", 
	"country": "Australia", 
	"city": "Emerald"}, 
{
	"citycode": "EPR", 
	"airport": "Esperance Airport", 
	"country": "Australia", 
	"city": "Esperance"}, 
{
	"citycode": "FLS", 
	"airport": "Flinders Island Airport", 
	"country": "Australia", 
	"city": "Flinders Island"}, 
{
	"citycode": "FRB", 
	"airport": "Forbes Airport", 
	"country": "Australia", 
	"city": "Forbes"}, 
{
	"citycode": "GET", 
	"airport": "Geraldton Airport", 
	"country": "Australia", 
	"city": "Geraldton"}, 
{
	"citycode": "GFF", 
	"airport": "Griffith Airport", 
	"country": "Australia", 
	"city": "Griffith"}, 
{
	"citycode": "GFN", 
	"airport": "Clarence Valley Regional Airport", 
	"country": "Australia", 
	"city": "Grafton"}, 
{
	"citycode": "GIC", 
	"airport": "Boigu Island Airport", 
	"country": "Australia", 
	"city": "Boigu Island"}, 
{
	"citycode": "GKL", 
	"airport": "Great Keppel Island Airport", 
	"country": "Australia", 
	"city": "Great Keppel Island"}, 
{
	"citycode": "GLI", 
	"airport": "Glen Innes Airport", 
	"country": "Australia", 
	"city": "Glen Innes"}, 
{
	"citycode": "GLT", 
	"airport": "Gladstone Airport", 
	"country": "Australia", 
	"city": "Gladstone"}, 
{
	"citycode": "GOV", 
	"airport": "Gove-East Arnhem Airport", 
	"country": "Australia", 
	"city": "Gove"}, 
{
	"citycode": "GPN", 
	"airport": "Garden Point Airport", 
	"country": "Australia", 
	"city": "Garden Point"}, 
{
	"citycode": "GTE", 
	"airport": "Groote Eylandt Airport", 
	"country": "Australia", 
	"city": "Groote Eylandt"}, 
{
	"citycode": "GUH", 
	"airport": "Gunnedah Airport", 
	"country": "Australia", 
	"city": "Gunnedah"}, 
{
	"citycode": "HAP", 
	"airport": "Long Island Airport", 
	"country": "Australia", 
	"city": "Long Island"}, 
{
	"citycode": "HBA", 
	"airport": "Hobart Airport", 
	"country": "Australia", 
	"city": "Hobart"}, 
{
	"citycode": "HGD", 
	"airport": "Hughenden Airport", 
	"country": "Australia", 
	"city": "Hughenden"}, 
{
	"citycode": "HIS", 
	"airport": "Hayman Island Resort Airport", 
	"country": "Australia", 
	"city": "Hayman Island"}, 
{
	"citycode": "HOK", 
	"airport": "Hooker Creek Airport", 
	"country": "Australia", 
	"city": "Hooker Creek"}, 
{
	"citycode": "HTI", 
	"airport": "Great Barrier Reef Airport", 
	"country": "Australia", 
	"city": "Hamilton Island"}, 
{
	"citycode": "HVB", 
	"airport": "Hervey Bay Airport", 
	"country": "Australia", 
	"city": "Hervey Bay"}, 
{
	"citycode": "HXX", 
	"airport": "Hay Airport", 
	"country": "Australia", 
	"city": "Hay"}, 
{
	"citycode": "IRG", 
	"airport": "Lockhart River Airport", 
	"country": "Australia", 
	"city": "Lockhart River"}, 
{
	"citycode": "ISA", 
	"airport": "Mount Isa Airport", 
	"country": "Australia", 
	"city": "Mount Isa"}, 
{
	"citycode": "IVR", 
	"airport": "Inverell Airport", 
	"country": "Australia", 
	"city": "Inverell"}, 
{
	"citycode": "JAD", 
	"airport": "Jandakot Airport", 
	"country": "Australia", 
	"city": "Jandakot"}, 
{
	"citycode": "JCK", 
	"airport": "Julia Creek Airport", 
	"country": "Australia", 
	"city": "Julia Creek"}, 
{
	"citycode": "JHQ", 
	"airport": "Whitsunday Airport", 
	"country": "Australia", 
	"city": "Shute Harbour"}, 
{
	"citycode": "KAX", 
	"airport": "Kalbarri Airport", 
	"country": "Australia", 
	"city": "Kalbarri"}, 
{
	"citycode": "KBY", 
	"airport": "Streaky Bay Airport", 
	"country": "Australia", 
	"city": "Streaky Bay"}, 
{
	"citycode": "KFG", 
	"airport": "Kalkurung Airport", 
	"country": "Australia", 
	"city": "Kalkurung"}, 
{
	"citycode": "KGC", 
	"airport": "Kingscote Airport", 
	"country": "Australia", 
	"city": "Kingscote"}, 
{
	"citycode": "KGI", 
	"airport": "Kalgoorlie-Boulder Airport", 
	"country": "Australia", 
	"city": "Kalgoorlie"}, 
{
	"citycode": "KNS", 
	"airport": "King Island Airport", 
	"country": "Australia", 
	"city": "King Island"}, 
{
	"citycode": "KNX", 
	"airport": "East Kimberley Regional Airport", 
	"country": "Australia", 
	"city": "Kununurra"}, 
{
	"citycode": "KPS", 
	"airport": "Kempsey Airport", 
	"country": "Australia", 
	"city": "Kempsey"}, 
{
	"citycode": "KRB", 
	"airport": "Karumba Airport", 
	"country": "Australia", 
	"city": "Karumba"}, 
{
	"citycode": "KTA", 
	"airport": "Karratha Airport", 
	"country": "Australia", 
	"city": "Karratha"}, 
{
	"citycode": "KTR", 
	"airport": "Katherine Airport", 
	"country": "Australia", 
	"city": "Katherine"}, 
{
	"citycode": "KUG", 
	"airport": "Kubin Island", 
	"country": "Australia", 
	"city": "Kubin Island"}, 
{
	"citycode": "KWM", 
	"airport": "Kowanyama Airport", 
	"country": "Australia", 
	"city": "Kowanyama"}, 
{
	"citycode": "LBH", 
	"airport": "Palm Beach Water Airport", 
	"country": "Australia", 
	"city": "Sydney"}, 
{
	"citycode": "LDC", 
	"airport": "Lindeman Island Airport", 
	"country": "Australia", 
	"city": "Lindeman Island"}, 
{
	"citycode": "LDH", 
	"airport": "Lord Howe Island Airport", 
	"country": "Australia", 
	"city": "Lord Howe Island"}, 
{
	"citycode": "LEA", 
	"airport": "Learmonth Airport", 
	"country": "Australia", 
	"city": "Learmonth"}, 
{
	"citycode": "LEL", 
	"airport": "Lake Evella Airport", 
	"country": "Australia", 
	"city": "Lake Evella"}, 
{
	"citycode": "LER", 
	"airport": "Leinster Airport", 
	"country": "Australia", 
	"city": "Leinster"}, 
{
	"citycode": "LGH", 
	"airport": "Leigh Creek Airport", 
	"country": "Australia", 
	"city": "Leigh Creek"}, 
{
	"citycode": "LNO", 
	"airport": "Leonora Airport", 
	"country": "Australia", 
	"city": "Leonora"}, 
{
	"citycode": "LRE", 
	"airport": "Longreach Airport", 
	"country": "Australia", 
	"city": "Longreach"}, 
{
	"citycode": "LST", 
	"airport": "Launceston Airport", 
	"country": "Australia", 
	"city": "Launceston"}, 
{
	"citycode": "LSY", 
	"airport": "Lismore Airport", 
	"country": "Australia", 
	"city": "Lismore"}, 
{
	"citycode": "LVO", 
	"airport": "Laverton Airport", 
	"country": "Australia", 
	"city": "Laverton"}, 
{
	"citycode": "LZR", 
	"airport": "Lizard Island Airport", 
	"country": "Australia", 
	"city": "Lizard Island"}, 
{
	"citycode": "MBB", 
	"airport": "Marble Bar Airport", 
	"country": "Australia", 
	"city": "Marble Bar"}, 
{
	"citycode": "MBH", 
	"airport": "Maryborough Airport", 
	"country": "Australia", 
	"city": "Maryborough"}, 
{
	"citycode": "MBW", 
	"airport": "Moorabbin Airport", 
	"country": "Australia", 
	"city": "Moorabbin"}, 
{
	"citycode": "MCY", 
	"airport": "Sunshine Coast Airport", 
	"country": "Australia", 
	"city": "Sunshine Coast"}, 
{
	"citycode": "MEB", 
	"airport": "Essendon Airport", 
	"country": "Australia", 
	"city": "Melbourne"}, 
{
	"citycode": "MEL", 
	"airport": "Melbourne Airport", 
	"country": "Australia", 
	"city": "Melbourne"}, 
{
	"citycode": "MGB", 
	"airport": "Mount Gambier Airport", 
	"country": "Australia", 
	"city": "Mount Gambier"}, 
{
	"citycode": "MGT", 
	"airport": "Milingimbi Airport", 
	"country": "Australia", 
	"city": "Milingimbi"}, 
{
	"citycode": "MIM", 
	"airport": "Merimbula Airport", 
	"country": "Australia", 
	"city": "Merimbula"}, 
{
	"citycode": "MKR", 
	"airport": "Meekatharra Airport", 
	"country": "Australia", 
	"city": "Meekatharra"}, 
{
	"citycode": "MKY", 
	"airport": "Mackay Airport", 
	"country": "Australia", 
	"city": "Mackay"}, 
{
	"citycode": "MMG", 
	"airport": "Mount Magnet Airport", 
	"country": "Australia", 
	"city": "Mount Magnet"}, 
{
	"citycode": "MMM", 
	"airport": "Middlemount Airport", 
	"country": "Australia", 
	"city": "Middlemount"}, 
{
	"citycode": "MOV", 
	"airport": "Moranbah Airport", 
	"country": "Australia", 
	"city": "Moranbah"}, 
{
	"citycode": "MQL", 
	"airport": "Mildura Airport", 
	"country": "Australia", 
	"city": "Mildura"}, 
{
	"citycode": "MRZ", 
	"airport": "Moree Airport", 
	"country": "Australia", 
	"city": "Moree"}, 
{
	"citycode": "MTL", 
	"airport": "Maitland Airport", 
	"country": "Australia", 
	"city": "Maitland"}, 
{
	"citycode": "MYA", 
	"airport": "Moruya Airport", 
	"country": "Australia", 
	"city": "Moruya"}, 
{
	"citycode": "MYI", 
	"airport": "Murray Island Airport", 
	"country": "Australia", 
	"city": "Murray Island"}, 
{
	"citycode": "NAA", 
	"airport": "Narrabri Airport", 
	"country": "Australia", 
	"city": "Narrabri"}, 
{
	"citycode": "NLF", 
	"airport": "Darnley Island Airport", 
	"country": "Australia", 
	"city": "Darnley Island"}, 
{
	"citycode": "NLL", 
	"airport": "Nullagine Airport", 
	"country": "Australia", 
	"city": "Nullagine"}, 
{
	"citycode": "NOA", 
	"airport": "Nowra Airport", 
	"country": "Australia", 
	"city": "Nowra"}, 
{
	"citycode": "NRA", 
	"airport": "Narrandera Airport", 
	"country": "Australia", 
	"city": "Narrandera"}, 
{
	"citycode": "NSA", 
	"airport": "Noosa Airport", 
	"country": "Australia", 
	"city": "Noosa"}, 
{
	"citycode": "NSM", 
	"airport": "Norseman Airport", 
	"country": "Australia", 
	"city": "Norseman"}, 
{
	"citycode": "NSO", 
	"airport": "Scone Airport", 
	"country": "Australia", 
	"city": "Scone"}, 
{
	"citycode": "NTL", 
	"airport": "Newcastle Airport", 
	"country": "Australia", 
	"city": "Newcastle"}, 
{
	"citycode": "NTN", 
	"airport": "Normanton Airport", 
	"country": "Australia", 
	"city": "Normanton"}, 
{
	"citycode": "NUB", 
	"airport": "Numbulwar Airport", 
	"country": "Australia", 
	"city": "Numbulwar"}, 
{
	"citycode": "OAG", 
	"airport": "Orange Regional Airport", 
	"country": "Australia", 
	"city": "Orange"}, 
{
	"citycode": "OKR", 
	"airport": "Yorke Island Airport", 
	"country": "Australia", 
	"city": "Yorke Island"}, 
{
	"citycode": "OLP", 
	"airport": "Olympic Dam Airport", 
	"country": "Australia", 
	"city": "Olympic Dam"}, 
{
	"citycode": "ONG", 
	"airport": "Mornington Island Airport", 
	"country": "Australia", 
	"city": "Mornington"}, 
{
	"citycode": "ONS", 
	"airport": "Onslow Airport", 
	"country": "Australia", 
	"city": "Onslow"}, 
{
	"citycode": "OOL", 
	"airport": "Gold Coast Airport", 
	"country": "Australia", 
	"city": "Gold Coast"}, 
{
	"citycode": "OOM", 
	"airport": "Cooma–Snowy Mountains Airport", 
	"country": "Australia", 
	"city": "Cooma"}, 
{
	"citycode": "PBO", 
	"airport": "Paraburdoo Airport", 
	"country": "Australia", 
	"city": "Paraburdoo"}, 
{
	"citycode": "PDN", 
	"airport": "Parndana Airport", 
	"country": "Australia", 
	"city": "Parndana"}, 
{
	"citycode": "PEA", 
	"airport": "Penneshaw Airport", 
	"country": "Australia", 
	"city": "Penneshaw"}, 
{
	"citycode": "PER", 
	"airport": "Perth Airport", 
	"country": "Australia", 
	"city": "Perth"}, 
{
	"citycode": "PHE", 
	"airport": "Port Hedland International Airport", 
	"country": "Australia", 
	"city": "Port Hedland"}, 
{
	"citycode": "PHJ", 
	"airport": "Port Hunter Airport", 
	"country": "Australia", 
	"city": "Port Hunter"}, 
{
	"citycode": "PKE", 
	"airport": "Parkes Airport", 
	"country": "Australia", 
	"city": "Parkes"}, 
{
	"citycode": "PLO", 
	"airport": "Port Lincoln Airport", 
	"country": "Australia", 
	"city": "Port Lincoln"}, 
{
	"citycode": "PPP", 
	"airport": "Whitsunday Coast Airport", 
	"country": "Australia", 
	"city": "Proserpine"}, 
{
	"citycode": "PQQ", 
	"airport": "Port Macquarie Airport", 
	"country": "Australia", 
	"city": "Port Macquarie"}, 
{
	"citycode": "PTI", 
	"airport": "Piedmont Triad International Airport", 
	"country": "Australia", 
	"city": "Port Douglas"}, 
{
	"citycode": "PTJ", 
	"airport": "Portland Airport", 
	"country": "Australia", 
	"city": "Portland"}, 
{
	"citycode": "PUG", 
	"airport": "Port Augusta Airport", 
	"country": "Australia", 
	"city": "Port Augusta"}, 
{
	"citycode": "QNA", 
	"airport": "Ballina Byron Airport", 
	"country": "Australia", 
	"city": "BALLINA BYRON"}, 
{
	"citycode": "RAM", 
	"airport": "Ramingining Airport", 
	"country": "Australia", 
	"city": "Ramingining"}, 
{
	"citycode": "RBS", 
	"airport": "Orbost Airport", 
	"country": "Australia", 
	"city": "Orbost"}, 
{
	"citycode": "RCM", 
	"airport": "Richmond Airport", 
	"country": "Australia", 
	"city": "Richmond"}, 
{
	"citycode": "RCN", 
	"airport": "American River", 
	"country": "Australia", 
	"city": "American River"}, 
{
	"citycode": "RMA", 
	"airport": "Roma Airport", 
	"country": "Australia", 
	"city": "Roma"}, 
{
	"citycode": "ROK", 
	"airport": "Rockhampton Airport", 
	"country": "Australia", 
	"city": "Rockhampton"}, 
{
	"citycode": "RPM", 
	"airport": "Ngukurr Airport", 
	"country": "Australia", 
	"city": "Ngukurr"}, 
{
	"citycode": "RSE", 
	"airport": "Rose Bay Water Airport", 
	"country": "Australia", 
	"city": "Sydney"}, 
{
	"citycode": "RTS", 
	"airport": "Rottnest Island Airport", 
	"country": "Australia", 
	"city": "Rottnest Island"}, 
{
	"citycode": "SBR", 
	"airport": "Saibai Island Airport", 
	"country": "Australia", 
	"city": "Saibai Island"}, 
{
	"citycode": "SIO", 
	"airport": "Smithton Airport", 
	"country": "Australia", 
	"city": "Smithton"}, 
{
	"citycode": "SNB", 
	"airport": "Snake Bay Airport", 
	"country": "Australia", 
	"city": "Snake Bay"}, 
{
	"citycode": "SOI", 
	"airport": "South Molle Island Airport", 
	"country": "Australia", 
	"city": "South Molle Island"}, 
{
	"citycode": "SQC", 
	"airport": "Southern Cross Airport", 
	"country": "Australia", 
	"city": "Southern Cross"}, 
{
	"citycode": "SRN", 
	"airport": "Strahan Airport", 
	"country": "Australia", 
	"city": "Strahan"}, 
{
	"citycode": "SYD", 
	"airport": "Sydney Airport", 
	"country": "Australia", 
	"city": "Sydney"}, 
{
	"citycode": "SYU", 
	"airport": "Warraber Island Airport", 
	"country": "Australia", 
	"city": "Sue Island"}, 
{
	"citycode": "TCA", 
	"airport": "Tennant Creek Airport", 
	"country": "Australia", 
	"city": "Tennant Creek"}, 
{
	"citycode": "TEF", 
	"airport": "Telfer Airport", 
	"country": "Australia", 
	"city": "Telfer"}, 
{
	"citycode": "TGN", 
	"airport": "La Trobe Regional Airport", 
	"country": "Australia", 
	"city": "Traralgon"}, 
{
	"citycode": "THG", 
	"airport": "Thangool Airport", 
	"country": "Australia", 
	"city": "Thangool"}, 
{
	"citycode": "TIS", 
	"airport": "Thursday Island Airport", 
	"country": "Australia", 
	"city": "Thursday Island"}, 
{
	"citycode": "TMW", 
	"airport": "Tamworth Regional Airport", 
	"country": "Australia", 
	"city": "Tamworth"}, 
{
	"citycode": "TRO", 
	"airport": "Taree Airport", 
	"country": "Australia", 
	"city": "Taree"}, 
{
	"citycode": "TSV", 
	"airport": "Townsville Airport", 
	"country": "Australia", 
	"city": "Townsville"}, 
{
	"citycode": "TUM", 
	"airport": "Tum Airport", 
	"country": "Australia", 
	"city": "Tumut"}, 
{
	"citycode": "TWB", 
	"airport": "Toowoomba Wellcamp Airport", 
	"country": "Australia", 
	"city": "Toowoomba"}, 
{
	"citycode": "UBB", 
	"airport": "Mabuiag International Airport", 
	"country": "Australia", 
	"city": "Mabuiag Island"}, 
{
	"citycode": "UEE", 
	"airport": "Queenstown Airport", 
	"country": "Australia", 
	"city": "Queenstown"}, 
{
	"citycode": "UIR", 
	"airport": "Quirindi Airport", 
	"country": "Australia", 
	"city": "Quirindi"}, 
{
	"citycode": "ULP", 
	"airport": "Quilpie Airport", 
	"country": "Australia", 
	"city": "Quilpie"}, 
{
	"citycode": "UMR", 
	"airport": "Woomera Airport", 
	"country": "Australia", 
	"city": "Woomera"}, 
{
	"citycode": "USL", 
	"airport": "Useless Loop Airport", 
	"country": "Australia", 
	"city": "Useless Loop"}, 
{
	"citycode": "VCD", 
	"airport": "Victoria River Downs Airport", 
	"country": "Australia", 
	"city": "Victoria River Downs"}, 
{
	"citycode": "WEI", 
	"airport": "Weipa Airport", 
	"country": "Australia", 
	"city": "Weipa"}, 
{
	"citycode": "WGA", 
	"airport": "Wagga Wagga Airport", 
	"country": "Australia", 
	"city": "Wagga Wagga"}, 
{
	"citycode": "WGT", 
	"airport": "Wangaratta Airport", 
	"country": "Australia", 
	"city": "Wangaratta"}, 
{
	"citycode": "WHL", 
	"airport": "Mid Wales Airport", 
	"country": "Australia", 
	"city": "Welshpool"}, 
{
	"citycode": "WIN", 
	"airport": "Winton Airport", 
	"country": "Australia", 
	"city": "Winton"}, 
{
	"citycode": "WNR", 
	"airport": "Windorah Airport", 
	"country": "Australia", 
	"city": "Windorah"}, 
{
	"citycode": "WSY", 
	"airport": "Whitsunday Airport", 
	"country": "Australia", 
	"city": "Airlie Beach"}, 
{
	"citycode": "WUN", 
	"airport": "Wiluna Airport", 
	"country": "Australia", 
	"city": "Wiluna"}, 
{
	"citycode": "WWY", 
	"airport": "West Wyalong Airport", 
	"country": "Australia", 
	"city": "West Wyalong"}, 
{
	"citycode": "WYA", 
	"airport": "Whyalla Airport", 
	"country": "Australia", 
	"city": "Whyalla"}, 
{
	"citycode": "XMC", 
	"airport": "Mallacoota Airport", 
	"country": "Australia", 
	"city": "Mallacoota"}, 
{
	"citycode": "XMY", 
	"airport": "Yam Island Airport", 
	"country": "Australia", 
	"city": "Yam Island"}, 
{
	"citycode": "ZNE", 
	"airport": "Newman Airport", 
	"country": "Australia", 
	"city": "Newman"}, 
{
	"citycode": "BAH", 
	"airport": "Bahrain International Airport", 
	"country": "Bahrain", 
	"city": "Bahrain"}, 
{
	"citycode": "BZL", 
	"airport": "Barisal Airport", 
	"country": "Bangladesh", 
	"city": "Barisal"}, 
{
	"citycode": "CGP", 
	"airport": "Shah Amanat International Airport", 
	"country": "Bangladesh", 
	"city": "Chittagong"}, 
{
	"citycode": "CXB", 
	"airport": "Cox`s Bazar International Airport", 
	"country": "Bangladesh", 
	"city": "Cox`s Bazar"}, 
{
	"citycode": "JSR", 
	"airport": "Jashore Airport", 
	"country": "Bangladesh", 
	"city": "Jessore"}, 
{
	"citycode": "RJH", 
	"airport": "Shah Makhdum Airport", 
	"country": "Bangladesh", 
	"city": "Rajshahi"}, 
{
	"citycode": "SPD", 
	"airport": "Saidpur Airport", 
	"country": "Bangladesh", 
	"city": "Saidpur"}, 
{
	"citycode": "ZYL", 
	"airport": "Osmany International Airport", 
	"country": "Bangladesh", 
	"city": "Sylhet"}, 
{
	"citycode": "ANR", 
	"airport": "Antwerpen International Airport (Deurne)", 
	"country": "Belgium", 
	"city": "Antwerp"}, 
{
	"citycode": "BRU", 
	"airport": "Brussels Airport", 
	"country": "Belgium", 
	"city": "Brussels"}, 
{
	"citycode": "CRL", 
	"airport": "Brussels South Charleroi Airport", 
	"country": "Belgium", 
	"city": "Brussels"}, 
{
	"citycode": "LGG", 
	"airport": "Liege Airport", 
	"country": "Belgium", 
	"city": "Liege"}, 
{
	"citycode": "OST", 
	"airport": "Oostende-Brugge International Airport", 
	"country": "Belgium", 
	"city": "Ostend"}, 
{
	"citycode": "ZYR", 
	"airport": "Brussels Airport", 
	"country": "Belgium", 
	"city": "Brussels"}, 
{
	"citycode": "PBH", 
	"airport": "Paro International Airport", 
	"country": "Bhutan", 
	"city": "Paro"}, 
{
	"citycode": "BJO", 
	"airport": "Bermejo Airport", 
	"country": "Bolivia", 
	"city": "Bermejo"}, 
{
	"citycode": "BYC", 
	"airport": "Yacuiba Airport", 
	"country": "Bolivia", 
	"city": "Yacuiba"}, 
{
	"citycode": "CAM", 
	"airport": "Camiri Airport", 
	"country": "Bolivia", 
	"city": "Camiri"}, 
{
	"citycode": "CBB", 
	"airport": "Jorge Wilstermann International Airport", 
	"country": "Bolivia", 
	"city": "Cochabamba"}, 
{
	"citycode": "CIJ", 
	"airport": "Captain Anibal Arab Airport", 
	"country": "Bolivia", 
	"city": "Cobija"}, 
{
	"citycode": "GYA", 
	"airport": "Guayaramerin Airport", 
	"country": "Bolivia", 
	"city": "Guayaramerin"}, 
{
	"citycode": "LPB", 
	"airport": "El Alto International Airport", 
	"country": "Bolivia", 
	"city": "La Paz"}, 
{
	"citycode": "MGD", 
	"airport": "Magdalena Airport", 
	"country": "Bolivia", 
	"city": "Magdalena"}, 
{
	"citycode": "PSZ", 
	"airport": "Puerto Suarez Airport", 
	"country": "Bolivia", 
	"city": "Puerto Suarez"}, 
{
	"citycode": "RBQ", 
	"airport": "Rurrenabaque Airport", 
	"country": "Bolivia", 
	"city": "Rurrenabaque"}, 
{
	"citycode": "RIB", 
	"airport": "Riberalta Airport", 
	"country": "Bolivia", 
	"city": "Riberalta"}, 
{
	"citycode": "SJB", 
	"airport": "San Joaquin Airport", 
	"country": "Bolivia", 
	"city": "San Joaquin"}, 
{
	"citycode": "SNG", 
	"airport": "San Ignacio De Velasco Airport", 
	"country": "Bolivia", 
	"city": "San Ignacio De Velasco"}, 
{
	"citycode": "SRE", 
	"airport": "Alcantar? International Airport", 
	"country": "Bolivia", 
	"city": "Sucre"}, 
{
	"citycode": "SRJ", 
	"airport": "Capitan German Quiroga Guardia Airport", 
	"country": "Bolivia", 
	"city": "San Borja"}, 
{
	"citycode": "SRZ", 
	"airport": "El Trompillo Airport", 
	"country": "Bolivia", 
	"city": "Santa Cruz"}, 
{
	"citycode": "TDD", 
	"airport": "Teniente Jorge Henrich Arauz Airport", 
	"country": "Bolivia", 
	"city": "Trinidad"}, 
{
	"citycode": "TJA", 
	"airport": "Tarija Airport", 
	"country": "Bolivia", 
	"city": "Tarija"}, 
{
	"citycode": "VVI", 
	"airport": "Viru Viru International Airport", 
	"country": "Bolivia", 
	"city": "Santa Cruz"}, 
{
	"citycode": "AEP", 
	"airport": "Jorge Newbery Airport", 
	"country": "Argentina", 
	"city": "Buenos Aires"}, 
{
	"citycode": "AFA", 
	"airport": "San Rafael Airport", 
	"country": "Argentina", 
	"city": "San Rafael"}, 
{
	"citycode": "AOL", 
	"airport": "Paso De Los Libres Airport", 
	"country": "Argentina", 
	"city": "Paso De Los Libres"}, 
{
	"citycode": "APZ", 
	"airport": "Zapala Airport", 
	"country": "Argentina", 
	"city": "Zapala"}, 
{
	"citycode": "ARR", 
	"airport": "Alto Rio Senguer Airport", 
	"country": "Argentina", 
	"city": "Alto Rio Senguerr"}, 
{
	"citycode": "BHI", 
	"airport": "Comandante Espora Airport", 
	"country": "Argentina", 
	"city": "Bahia Blanca"}, 
{
	"citycode": "BRC", 
	"airport": "San Carlos de Bariloche Airport", 
	"country": "Argentina", 
	"city": "San Carlos DeBariloche"}, 
{
	"citycode": "BUE", 
	"airport": "All Airports Buenos Aires", 
	"country": "Argentina", 
	"city": "Buenos Aires"}, 
{
	"citycode": "CCT", 
	"airport": "Colonia Catriel Airport", 
	"country": "Argentina", 
	"city": "Colonia Catriel"}, 
{
	"citycode": "CNQ", 
	"airport": "Doctor Fernando Piragine Niveyro International Airport", 
	"country": "Argentina", 
	"city": "Corrientes"}, 
{
	"citycode": "COC", 
	"airport": "Concordia Airport", 
	"country": "Argentina", 
	"city": "Concordia"}, 
{
	"citycode": "COR", 
	"airport": "Pajas Blancas Airport", 
	"country": "Argentina", 
	"city": "Cordoba"}, 
{
	"citycode": "CPC", 
	"airport": "Chapelco - Aviador Carlos Campos Airport", 
	"country": "Argentina", 
	"city": "San Martin DeLos Andes"}, 
{
	"citycode": "CRD", 
	"airport": "Comodoro Rivadavia Airport", 
	"country": "Argentina", 
	"city": "Comodoro Rivadavia"}, 
{
	"citycode": "CTC", 
	"airport": "Coronel Felipe Varela Airport", 
	"country": "Argentina", 
	"city": "Catamarca"}, 
{
	"citycode": "CUT", 
	"airport": "Cutral Co Airport", 
	"country": "Argentina", 
	"city": "Cutral"}, 
{
	"citycode": "EHL", 
	"airport": "El Bolson Airport", 
	"country": "Argentina", 
	"city": "El Bolson"}, 
{
	"citycode": "EMX", 
	"airport": "El Maiten Airport", 
	"country": "Argentina", 
	"city": "El Maiten"}, 
{
	"citycode": "EQS", 
	"airport": "Esquel Airport", 
	"country": "Argentina", 
	"city": "Esquel"}, 
{
	"citycode": "EZE", 
	"airport": "Ministro Pistarini International Airport", 
	"country": "Argentina", 
	"city": "Buenos Aires"}, 
{
	"citycode": "FMA", 
	"airport": "Formosa International Airport", 
	"country": "Argentina", 
	"city": "Formosa"}, 
{
	"citycode": "GGS", 
	"airport": "Gobernador Gregores Airport", 
	"country": "Argentina", 
	"city": "Gobernador Gregores"}, 
{
	"citycode": "GNR", 
	"airport": "Dr. Arturo Umberto Illia Airport", 
	"country": "Argentina", 
	"city": "General Roca"}, 
{
	"citycode": "IGR", 
	"airport": "Cataratas of Iguazu International Airport", 
	"country": "Argentina", 
	"city": "Iguazu"}, 
{
	"citycode": "ING", 
	"airport": "Lago Argentino Airport", 
	"country": "Argentina", 
	"city": "Lago Argentino"}, 
{
	"citycode": "IRJ", 
	"airport": "La Rioja Airport", 
	"country": "Argentina", 
	"city": "La Rioja"}, 
{
	"citycode": "JSM", 
	"airport": "Jose De San Martin Airport", 
	"country": "Argentina", 
	"city": "Jose De San Martin"}, 
{
	"citycode": "JUJ", 
	"airport": "Gobernador Horacio Guzman International Airport", 
	"country": "Argentina", 
	"city": "Jujuy"}, 
{
	"citycode": "LPG", 
	"airport": "La Plata Airport", 
	"country": "Argentina", 
	"city": "La Plata"}, 
{
	"citycode": "LUQ", 
	"airport": "San Luis Airport", 
	"country": "Argentina", 
	"city": "San Luis"}, 
{
	"citycode": "MDQ", 
	"airport": "Astor Piazzolla International Airport", 
	"country": "Argentina", 
	"city": "Mar Del Plata"}, 
{
	"citycode": "MDZ", 
	"airport": "Governor Francisco Gabrielli International Airport", 
	"country": "Argentina", 
	"city": "Mendoza"}, 
{
	"citycode": "NQN", 
	"airport": "Juan Domingo Per?n International Airport", 
	"country": "Argentina", 
	"city": "Neuquen"}, 
{
	"citycode": "OES", 
	"airport": "Antoine De St Exupery Airport", 
	"country": "Argentina", 
	"city": "San Antonio Oeste"}, 
{
	"citycode": "PMQ", 
	"airport": "Perito Moreno Airport", 
	"country": "Argentina", 
	"city": "Perito Moreno"}, 
{
	"citycode": "PSS", 
	"airport": "Libertador General Jose de San Mart?n Airport", 
	"country": "Argentina", 
	"city": "Posadas"}, 
{
	"citycode": "PUD", 
	"airport": "Puerto Deseado Airport", 
	"country": "Argentina", 
	"city": "Puerto Deseado"}, 
{
	"citycode": "RCU", 
	"airport": "Rio Cuarto Airport", 
	"country": "Argentina", 
	"city": "Rio Cuarto"}, 
{
	"citycode": "REL", 
	"airport": "Almirante Marcos A. Zar Airport", 
	"country": "Argentina", 
	"city": "Trelew"}, 
{
	"citycode": "RES", 
	"airport": "Resistencia Airport", 
	"country": "Argentina", 
	"city": "Resistencia"}, 
{
	"citycode": "RGA", 
	"airport": "Hermes Quijada International Airport", 
	"country": "Argentina", 
	"city": "Rio Grande"}, 
{
	"citycode": "RGL", 
	"airport": "Piloto Civil Norberto Fernandez International Airport", 
	"country": "Argentina", 
	"city": "Rio Gallegos"}, 
{
	"citycode": "ROS", 
	"airport": "Rosario – Islas Malvinas International Airport", 
	"country": "Argentina", 
	"city": "Rosario"}, 
{
	"citycode": "ROY", 
	"airport": "R?o Mayo Airport", 
	"country": "Argentina", 
	"city": "Rio Mayo"}, 
{
	"citycode": "RSA", 
	"airport": "Santa Rosa Airport", 
	"country": "Argentina", 
	"city": "Santa Rosa"}, 
{
	"citycode": "RYO", 
	"airport": "Rio Turbio Airport", 
	"country": "Argentina", 
	"city": "Rio Turbio"}, 
{
	"citycode": "RZA", 
	"airport": "Santa Cruz Airport", 
	"country": "Argentina", 
	"city": "Santa Cruz"}, 
{
	"citycode": "SDE", 
	"airport": "Vicecomodoro Angel de la Paz Aragones Airport", 
	"country": "Argentina", 
	"city": "Santiago Del Estero"}, 
{
	"citycode": "SGV", 
	"airport": "Sierra Grande Airport", 
	"country": "Argentina", 
	"city": "Sierra Grande"}, 
{
	"citycode": "SLA", 
	"airport": "Mart?n Miguel de Güemes International Airport", 
	"country": "Argentina", 
	"city": "Salta"}, 
{
	"citycode": "TUC", 
	"airport": "Teniente Benjam?n Matienzo International Airport", 
	"country": "Argentina", 
	"city": "Tucuman (Tucum?n)"}, 
{
	"citycode": "UAQ", 
	"airport": "Domingo Faustino Sarmiento Airport", 
	"country": "Argentina", 
	"city": "San Juan"}, 
{
	"citycode": "USH", 
	"airport": "Ushuaia Airport", 
	"country": "Argentina", 
	"city": "Ushuaia"}, 
{
	"citycode": "VDM", 
	"airport": "Gobernador Castello Airport", 
	"country": "Argentina", 
	"city": "Viedma"}, 
{
	"citycode": "VLG", 
	"airport": "Villa Gesell Airport", 
	"country": "Argentina", 
	"city": "Villa Gesell"}, 
{
	"citycode": "GRZ", 
	"airport": "Graz Airport", 
	"country": "Austria", 
	"city": "Graz"}, 
{
	"citycode": "INN", 
	"airport": "Innsbruck Airport", 
	"country": "Austria", 
	"city": "Innsbruck"}, 
{
	"citycode": "KLU", 
	"airport": "Klagenfurt Airport", 
	"country": "Austria", 
	"city": "Klagenfurt"}, 
{
	"citycode": "LNZ", 
	"airport": "Linz Airport", 
	"country": "Austria", 
	"city": "Linz"}, 
{
	"citycode": "SZG", 
	"airport": "Salzburg Airport", 
	"country": "Austria", 
	"city": "Salzburg"}, 
{
	"citycode": "VIE", 
	"airport": "Vienna International Airport", 
	"country": "Austria", 
	"city": "Vienna (Wien)"}, 
{
	"citycode": "AJU", 
	"airport": "Aeropuerto Internacional de Aracaju", 
	"country": "Brazil", 
	"city": "Aracaju"}, 
{
	"citycode": "APQ", 
	"airport": "Arapiraca Airport", 
	"country": "Brazil", 
	"city": "Arapiraca"}, 
{
	"citycode": "ARU", 
	"airport": "Araçatuba–Dario Guarita State Airport", 
	"country": "Brazil", 
	"city": "Aracatuba"}, 
{
	"citycode": "ATM", 
	"airport": "Altamira Airport", 
	"country": "Brazil", 
	"city": "Altamira"}, 
{
	"citycode": "AUX", 
	"airport": "Aragua?na Airport", 
	"country": "Brazil", 
	"city": "Araguaina"}, 
{
	"citycode": "BAU", 
	"airport": "Bauru Airport", 
	"country": "Brazil", 
	"city": "Bauru"}, 
{
	"citycode": "BEL", 
	"airport": "Val De Cans International Airport", 
	"country": "Brazil", 
	"city": "Belem"}, 
{
	"citycode": "BHZ", 
	"airport": "Belo Horizonte - All Airports", 
	"country": "Brazil", 
	"city": "Belo Horizonte"}, 
{
	"citycode": "BPG", 
	"airport": "Barra Do Garcas Airport", 
	"country": "Brazil", 
	"city": "Barra Do Garcas"}, 
{
	"citycode": "BPS", 
	"airport": "Porto Seguro Airport", 
	"country": "Brazil", 
	"city": "Porto Seguro"}, 
{
	"citycode": "BRA", 
	"airport": "Barreiras Airport", 
	"country": "Brazil", 
	"city": "Barreiras"}, 
{
	"citycode": "BSB", 
	"airport": "Brasilia President Juscelino Kubitschek International Airport", 
	"country": "Brazil", 
	"city": "Brasilia"}, 
{
	"citycode": "BVB", 
	"airport": "Boa Vista International Airport", 
	"country": "Brazil", 
	"city": "Boa Vista"}, 
{
	"citycode": "BVH", 
	"airport": "Vilhena Airport", 
	"country": "Brazil", 
	"city": "Vilhena"}, 
{
	"citycode": "BVM", 
	"airport": "Belmonte Airport", 
	"country": "Brazil", 
	"city": "Belmonte"}, 
{
	"citycode": "CAC", 
	"airport": "Cascavel Airport", 
	"country": "Brazil", 
	"city": "Cascavel"}, 
{
	"citycode": "CAW", 
	"airport": "Bartolomeu Lisandro Airport", 
	"country": "Brazil", 
	"city": "Campos"}, 
{
	"citycode": "CCM", 
	"airport": "Diom?cio Freitas Airport", 
	"country": "Brazil", 
	"city": "Criciuma"}, 
{
	"citycode": "CDJ", 
	"airport": "Conceicao Do Araguaia Airport", 
	"country": "Brazil", 
	"city": "Conceicao Do Araguaia"}, 
{
	"citycode": "CFO", 
	"airport": "Confresa Airport", 
	"country": "Brazil", 
	"city": "Confreza"}, 
{
	"citycode": "CGB", 
	"airport": "Marechal Rondon International Airport", 
	"country": "Brazil", 
	"city": "Cuiaba"}, 
{
	"citycode": "CGH", 
	"airport": "Congonhas International Airport", 
	"country": "Brazil", 
	"city": "Sao Paulo"}, 
{
	"citycode": "CGR", 
	"airport": "Campo Grande International Airport", 
	"country": "Brazil", 
	"city": "Campo Grande"}, 
{
	"citycode": "CKS", 
	"airport": "Carajas Airport", 
	"country": "Brazil", 
	"city": "Carajas"}, 
{
	"citycode": "CMG", 
	"airport": "Corumb? International Airport", 
	"country": "Brazil", 
	"city": "Corumba"}, 
{
	"citycode": "CMP", 
	"airport": "Santana do Araguaia Airport", 
	"country": "Brazil", 
	"city": "Santana Do Araguaia"}, 
{
	"citycode": "CNF", 
	"airport": "Tancredo Neves International Airport", 
	"country": "Brazil", 
	"city": "Belo Horizonte"}, 
{
	"citycode": "CPQ", 
	"airport": "Campos dos Amarais Airport", 
	"country": "Brazil", 
	"city": "Campinas"}, 
{
	"citycode": "CPV", 
	"airport": "Campina Grande Airport", 
	"country": "Brazil", 
	"city": "Campina Grande"}, 
{
	"citycode": "CRQ", 
	"airport": "Caravelas Airport", 
	"country": "Brazil", 
	"city": "Caravelas"}, 
{
	"citycode": "CWB", 
	"airport": "Afonso Pena International Airport", 
	"country": "Brazil", 
	"city": "Curitiba"}, 
{
	"citycode": "CZS", 
	"airport": "Cruzeiro do Sul International Airport", 
	"country": "Brazil", 
	"city": "Cruzeiro Do Sul"}, 
{
	"citycode": "DOU", 
	"airport": "Dourados Airport", 
	"country": "Brazil", 
	"city": "Dourados"}, 
{
	"citycode": "FEN", 
	"airport": "Fernando de Noronha Airport", 
	"country": "Brazil", 
	"city": "Fernando De Noronha"}, 
{
	"citycode": "FLN", 
	"airport": "Herc?lio Luz International Airport", 
	"country": "Brazil", 
	"city": "Florianopolis"}, 
{
	"citycode": "FOR", 
	"airport": "Pinto Martins – Fortaleza International Airport", 
	"country": "Brazil", 
	"city": "Fortaleza"}, 
{
	"citycode": "FRC", 
	"airport": "Franca Airport", 
	"country": "Brazil", 
	"city": "Franca"}, 
{
	"citycode": "GEL", 
	"airport": "Sepe Tiaraju Regional Airport", 
	"country": "Brazil", 
	"city": "Santo Angelo"}, 
{
	"citycode": "GIG", 
	"airport": "Rio de Janeiro/Galeao International Airport", 
	"country": "Brazil", 
	"city": "Rio De Janeiro"}, 
{
	"citycode": "GNM", 
	"airport": "Isaac Moura Rocha Airport", 
	"country": "Brazil", 
	"city": "Guanambi"}, 
{
	"citycode": "GRP", 
	"airport": "Gurupi Airport", 
	"country": "Brazil", 
	"city": "Gurupi"}, 
{
	"citycode": "GRU", 
	"airport": "Guarulhos International Airport", 
	"country": "Brazil", 
	"city": "Sao Paulo"}, 
{
	"citycode": "GVR", 
	"airport": "Governador Valadares Airport", 
	"country": "Brazil", 
	"city": "Governador Valadares"}, 
{
	"citycode": "GYN", 
	"airport": "Goiânia/Santa Genoveva International Airport", 
	"country": "Brazil", 
	"city": "Goiania"}, 
{
	"citycode": "IGU", 
	"airport": "Foz do Iguacu/Cataratas International Airport", 
	"country": "Brazil", 
	"city": "Iguassu Falls"}, 
{
	"citycode": "IMP", 
	"airport": "Imperatriz Airport", 
	"country": "Brazil", 
	"city": "Imperatriz"}, 
{
	"citycode": "IOS", 
	"airport": "Jorge Amado Airport", 
	"country": "Brazil", 
	"city": "Ilheus"}, 
{
	"citycode": "IPG", 
	"airport": "Ipiranga Airport", 
	"country": "Brazil", 
	"city": "Ipiranga"}, 
{
	"citycode": "IPN", 
	"airport": "Usiminas Airport", 
	"country": "Brazil", 
	"city": "Ipatinga"}, 
{
	"citycode": "JDF", 
	"airport": "Francisco De Assis Airport", 
	"country": "Brazil", 
	"city": "Juiz De Fora"}, 
{
	"citycode": "JDO", 
	"airport": "Juazeiro do Norte Airport", 
	"country": "Brazil", 
	"city": "Juazeiro Do Norte"}, 
{
	"citycode": "JOI", 
	"airport": "Joinville-Lauro Carneiro de Loyola Airport", 
	"country": "Brazil", 
	"city": "Joinville"}, 
{
	"citycode": "JPA", 
	"airport": "Presidente Castro Pinto International Airport", 
	"country": "Brazil", 
	"city": "Joao Pessoa"}, 
{
	"citycode": "LAJ", 
	"airport": "Lages Airport", 
	"country": "Brazil", 
	"city": "Lages"}, 
{
	"citycode": "LAZ", 
	"airport": "Bom Jesus Da Lapa Airport", 
	"country": "Brazil", 
	"city": "Bom Jesus Da Lapa"}, 
{
	"citycode": "LDB", 
	"airport": "Londrina Airport", 
	"country": "Brazil", 
	"city": "Londrina"}, 
{
	"citycode": "LIP", 
	"airport": "Lins Airport", 
	"country": "Brazil", 
	"city": "Lins"}, 
{
	"citycode": "LVB", 
	"airport": "Dos Galpoes Airport", 
	"country": "Brazil", 
	"city": "Livramento"}, 
{
	"citycode": "MAB", 
	"airport": "Maraba Airport", 
	"country": "Brazil", 
	"city": "Maraba"}, 
{
	"citycode": "TGV", 
	"airport": "Targovishte Airport", 
	"country": "Bulgaria", 
	"city": "Targovishte"}, 
{
	"citycode": "MAO", 
	"airport": "Manaus–Eduardo Gomes International Airport", 
	"country": "Brazil", 
	"city": "Manaus"}, 
{
	"citycode": "MCP", 
	"airport": "Macapa International Airport", 
	"country": "Brazil", 
	"city": "Macapa"}, 
{
	"citycode": "MCZ", 
	"airport": "Zumbi dos Palmares International Airport", 
	"country": "Brazil", 
	"city": "Maceio"}, 
{
	"citycode": "MGF", 
	"airport": "Maringa Regional Airport", 
	"country": "Brazil", 
	"city": "Maringa"}, 
{
	"citycode": "MII", 
	"airport": "Dr Gastao Vidigal Airport", 
	"country": "Brazil", 
	"city": "Marilia"}, 
{
	"citycode": "MOC", 
	"airport": "Montes Claros Airport", 
	"country": "Brazil", 
	"city": "Montes Claros"}, 
{
	"citycode": "NAT", 
	"airport": "Greater Natal International Airport", 
	"country": "Brazil", 
	"city": "Natal"}, 
{
	"citycode": "NTM", 
	"airport": "Miracema Do Norte Airport", 
	"country": "Brazil", 
	"city": "Miracema Do Norte"}, 
{
	"citycode": "NVT", 
	"airport": "Navegantes Airport", 
	"country": "Brazil", 
	"city": "Navegantes"}, 
{
	"citycode": "OUS", 
	"airport": "Ourinhos Airport", 
	"country": "Brazil", 
	"city": "Ourinhos"}, 
{
	"citycode": "PAV", 
	"airport": "Paulo Afonso Airport", 
	"country": "Brazil", 
	"city": "Paulo Afonso"}, 
{
	"citycode": "PET", 
	"airport": "Pelotas International Airport", 
	"country": "Brazil", 
	"city": "Pelotas"}, 
{
	"citycode": "PFB", 
	"airport": "Lauro Kurtz Airport", 
	"country": "Brazil", 
	"city": "Passo Fundo"}, 
{
	"citycode": "PLU", 
	"airport": "Carlos Drummond de Andrade Airport", 
	"country": "Brazil", 
	"city": "Belo Horizonte"}, 
{
	"citycode": "PMG", 
	"airport": "Ponta Pora International Airport", 
	"country": "Brazil", 
	"city": "Ponta Pora"}, 
{
	"citycode": "PNB", 
	"airport": "Porto Nacional Airport", 
	"country": "Brazil", 
	"city": "Porto Nacional"}, 
{
	"citycode": "PNZ", 
	"airport": "Petrolina–Senador Nilo Coelho Airport", 
	"country": "Brazil", 
	"city": "Petrolina"}, 
{
	"citycode": "POA", 
	"airport": "Salgado Filho International Airport", 
	"country": "Brazil", 
	"city": "Porto Alegre"}, 
{
	"citycode": "POO", 
	"airport": "Pocos De Caldas Airport", 
	"country": "Brazil", 
	"city": "Pocos De Caldas"}, 
{
	"citycode": "PPB", 
	"airport": "Presidente Prudente State Airport", 
	"country": "Brazil", 
	"city": "Presidente Prudente"}, 
{
	"citycode": "PVH", 
	"airport": "Belmonte Airport", 
	"country": "Brazil", 
	"city": "Porto Velho"}, 
{
	"citycode": "RAO", 
	"airport": "Leite Lopes Airport", 
	"country": "Brazil", 
	"city": "Ribeirao Preto"}, 
{
	"citycode": "RBR", 
	"airport": "Rio Branco International Airport", 
	"country": "Brazil", 
	"city": "Rio Branco"}, 
{
	"citycode": "RDC", 
	"airport": "Redencao Airport", 
	"country": "Brazil", 
	"city": "Redencao"}, 
{
	"citycode": "REC", 
	"airport": "Guararapes International Airport", 
	"country": "Brazil", 
	"city": "Recife"}, 
{
	"citycode": "RIA", 
	"airport": "Santa Maria Airport", 
	"country": "Brazil", 
	"city": "Santa Maria"}, 
{
	"citycode": "RIG", 
	"airport": "Rio Grande Regional Airport", 
	"country": "Brazil", 
	"city": "Rio Grande"}, 
{
	"citycode": "RIO", 
	"airport": "All Airports Rio de Janerio", 
	"country": "Brazil", 
	"city": "Rio de Jenerio"}, 
{
	"citycode": "ROO", 
	"airport": "Rondon?polis Airport", 
	"country": "Brazil", 
	"city": "Rondonopolis"}, 
{
	"citycode": "SAO", 
	"airport": "All Airports Sao Paulo", 
	"country": "Brazil", 
	"city": "Sao Paulo"}, 
{
	"citycode": "SDU", 
	"airport": "Santos Dumont Airport", 
	"country": "Brazil", 
	"city": "Rio De Janeiro"}, 
{
	"citycode": "SJK", 
	"airport": "Sao Jose Dos Campos Airport", 
	"country": "Brazil", 
	"city": "Sao Jose Dos Campos"}, 
{
	"citycode": "SJP", 
	"airport": "Sao Jose Do Rio Preto Airport", 
	"country": "Brazil", 
	"city": "Sao Jose Do Rio Preto"}, 
{
	"citycode": "SLZ", 
	"airport": "Marechal Cunha Machado International Airport", 
	"country": "Brazil", 
	"city": "Sao Luiz"}, 
{
	"citycode": "SSA", 
	"airport": "Salvador Bahia Airport", 
	"country": "Brazil", 
	"city": "Salvador"}, 
{
	"citycode": "STM", 
	"airport": "Santarem-Maestro Wilson Fonseca Airport", 
	"country": "Brazil", 
	"city": "Santarem (Santar?m)"}, 
{
	"citycode": "STZ", 
	"airport": "Santa Terezinha Airport", 
	"country": "Brazil", 
	"city": "Santa Terezinha"}, 
{
	"citycode": "SXO", 
	"airport": "Sao Felix Do Araguaia Airport", 
	"country": "Brazil", 
	"city": "Sao Felix Do Araguaia"}, 
{
	"citycode": "TBT", 
	"airport": "Tabatinga International Airport", 
	"country": "Brazil", 
	"city": "Tabatinga"}, 
{
	"citycode": "TFF", 
	"airport": "Tefe Airport", 
	"country": "Brazil", 
	"city": "Tefe"}, 
{
	"citycode": "TFL", 
	"airport": "Kemil Kumaira Airport", 
	"country": "Brazil", 
	"city": "Teofilo Otoni"}, 
{
	"citycode": "THE", 
	"airport": "Teresina Airport", 
	"country": "Brazil", 
	"city": "Teresina"}, 
{
	"citycode": "TMT", 
	"airport": "Porto Trombetas Airport", 
	"country": "Brazil", 
	"city": "Trombetas"}, 
{
	"citycode": "TUR", 
	"airport": "Tucurui Airport", 
	"country": "Brazil", 
	"city": "Tucurui"}, 
{
	"citycode": "TUZ", 
	"airport": "Tucuma Airport", 
	"country": "Brazil", 
	"city": "Tucuma"}, 
{
	"citycode": "UBA", 
	"airport": "Uberaba–Mario de Almeida Franco Airport", 
	"country": "Brazil", 
	"city": "Uberaba"}, 
{
	"citycode": "UDI", 
	"airport": "Uberlandia airport", 
	"country": "Brazil", 
	"city": "Uberlandia"}, 
{
	"citycode": "URB", 
	"airport": "Urubupunga Airport", 
	"country": "Brazil", 
	"city": "Urubupunga"}, 
{
	"citycode": "URG", 
	"airport": "Ruben Berta International Airport", 
	"country": "Brazil", 
	"city": "Uruguaiana"}, 
{
	"citycode": "VAG", 
	"airport": "Major-Brigadeiro Trompowsky Airport", 
	"country": "Brazil", 
	"city": "Varginha"}, 
{
	"citycode": "VCP", 
	"airport": "Viracopos International Airport", 
	"country": "Brazil", 
	"city": "Sao Paulo"}, 
{
	"citycode": "VDC", 
	"airport": "Vitoria Da Conquista Airport", 
	"country": "Brazil", 
	"city": "Vitoria Da Conquista"}, 
{
	"citycode": "VIX", 
	"airport": "Eurico de Aguiar Salles International Airport", 
	"country": "Brazil", 
	"city": "Vitoria"}, 
{
	"citycode": "XAP", 
	"airport": "Chapeco Airport", 
	"country": "Brazil", 
	"city": "Chapeco"}, 
{
	"citycode": "BWN", 
	"airport": "Brunei International Airport", 
	"country": "Brunei Darussalam", 
	"city": "Bandar Seri Begawan"}, 
{
	"citycode": "BOJ", 
	"airport": "Burgas Airport", 
	"country": "Bulgaria", 
	"city": "Bourgas"}, 
{
	"citycode": "GOZ", 
	"airport": "Gorna Oryahovitsa Airport", 
	"country": "Bulgaria", 
	"city": "Gorna Orechovitsa"}, 
{
	"citycode": "PDV", 
	"airport": "Plovdiv International Airport", 
	"country": "Bulgaria", 
	"city": "Plovdiv"}, 
{
	"citycode": "ROU", 
	"airport": "Ruse Airport", 
	"country": "Bulgaria", 
	"city": "Rousse"}, 
{
	"citycode": "SLS", 
	"airport": "Silistra Airport", 
	"country": "Bulgaria", 
	"city": "Silistra"}, 
{
	"citycode": "SOF", 
	"airport": "Sofia International Airport", 
	"country": "Bulgaria", 
	"city": "Sofia"}, 
{
	"citycode": "VAR", 
	"airport": "Varna Airport", 
	"country": "Bulgaria", 
	"city": "Varna"}, 
{
	"citycode": "CXH", 
	"airport": "Vancouver Harbour Flight Centre", 
	"country": "Canada", 
	"city": "Vancouver"}, 
{
	"citycode": "CYY", 
	"airport": "Wynyard Airport", 
	"country": "Canada", 
	"city": "CANADA (NW TERRITORIES)"}, 
{
	"citycode": "KIF", 
	"airport": "Kingfisher Lake Airport", 
	"country": "Canada", 
	"city": "Kingfisher Lake"}, 
{
	"citycode": "LAK", 
	"airport": "Aklavik/Freddie Carmichael Airport", 
	"country": "Canada", 
	"city": "Aklavik"}, 
{
	"citycode": "MSA", 
	"airport": "Muskrat Dam Airport", 
	"country": "Canada", 
	"city": "Muskrat Dam"}, 
{
	"citycode": "QBC", 
	"airport": "Bella Coola Airport", 
	"country": "Canada", 
	"city": "Bella Coola"}, 
{
	"citycode": "VPO", 
	"airport": "PEAWANUCK", 
	"country": "Canada", 
	"city": "CANADA (ONTARIO)"}, 
{
	"citycode": "XBE", 
	"airport": "Bearskin Lake Airport", 
	"country": "Canada", 
	"city": "Bearskin Lake"}, 
{
	"citycode": "XGR", 
	"airport": "Kangiqsualujjuaq Airport", 
	"country": "Canada", 
	"city": "Kangiqsualujjuaq"}, 
{
	"citycode": "XKS", 
	"airport": "Kasabonika Airport", 
	"country": "Canada", 
	"city": "Kasabonika"}, 
{
	"citycode": "XLB", 
	"airport": "Lac Brochet Airport", 
	"country": "Canada", 
	"city": "Lac Brochet"}, 
{
	"citycode": "XPK", 
	"airport": "Pukatawagan Airport", 
	"country": "Canada", 
	"city": "Pukatawagan"}, 
{
	"citycode": "XQU", 
	"airport": "Qualicum Beach Airport", 
	"country": "Canada", 
	"city": "Qualicum"}, 
{
	"citycode": "XRR", 
	"airport": "Ross River Airport", 
	"country": "Canada", 
	"city": "Ross River"}, 
{
	"citycode": "XSI", 
	"airport": "South Indian Lake Airport", 
	"country": "Canada", 
	"city": "South Indian Lake"}, 
{
	"citycode": "XTL", 
	"airport": "Tadoule Lake Airport", 
	"country": "Canada", 
	"city": "Tadoule Lake"}, 
{
	"citycode": "YAA", 
	"airport": "Anahim Lake Airport", 
	"country": "Canada", 
	"city": "Anahim Lake"}, 
{
	"citycode": "YAB", 
	"airport": "Arctic Bay Airport", 
	"country": "Canada", 
	"city": "Arctic Bay"}, 
{
	"citycode": "YAC", 
	"airport": "Cat Lake Airport", 
	"country": "Canada", 
	"city": "Cat Lake"}, 
{
	"citycode": "YAG", 
	"airport": "Fort Frances Municipal Airport", 
	"country": "Canada", 
	"city": "Fort Frances"}, 
{
	"citycode": "YAL", 
	"airport": "Alert Bay Airport", 
	"country": "Canada", 
	"city": "Alert Bay"}, 
{
	"citycode": "YAM", 
	"airport": "Sault Ste Marie Airport", 
	"country": "Canada", 
	"city": "Sault Ste Marie"}, 
{
	"citycode": "YAT", 
	"airport": "Attawapiskat Airport", 
	"country": "Canada", 
	"city": "Attawapiskat"}, 
{
	"citycode": "YAW", 
	"airport": "Shearwater Airport", 
	"country": "Canada", 
	"city": "Halifax"}, 
{
	"citycode": "YAY", 
	"airport": "St Anthony Airport", 
	"country": "Canada", 
	"city": "St Anthony"}, 
{
	"citycode": "YBB", 
	"airport": "Kugaaruk Airport", 
	"country": "Canada", 
	"city": "Kugaaruk"}, 
{
	"citycode": "YBC", 
	"airport": "Baie Comeau Airport", 
	"country": "Canada", 
	"city": "Baie Comeau"}, 
{
	"citycode": "YBE", 
	"airport": "Uranium City Airport", 
	"country": "Canada", 
	"city": "Uranium City"}, 
{
	"citycode": "YBG", 
	"airport": "Saguenay-Bagotville Airport", 
	"country": "Canada", 
	"city": "Bagotville"}, 
{
	"citycode": "YBI", 
	"airport": "Black Tickle Airport", 
	"country": "Canada", 
	"city": "Black Tickle"}, 
{
	"citycode": "YBJ", 
	"airport": "Baie Johan Beetz Airport", 
	"country": "Canada", 
	"city": "Baie Johan Beetz"}, 
{
	"citycode": "YBL", 
	"airport": "Campbell River Airport", 
	"country": "Canada", 
	"city": "Campbell River"}, 
{
	"citycode": "YBM", 
	"airport": "Bronson Creek Airport", 
	"country": "Canada", 
	"city": "Bronson Creek"}, 
{
	"citycode": "YBR", 
	"airport": "Brandon Muncipal Airport", 
	"country": "Canada", 
	"city": "Brandon"}, 
{
	"citycode": "YBT", 
	"airport": "Brochet Airport", 
	"country": "Canada", 
	"city": "Brochet"}, 
{
	"citycode": "YBV", 
	"airport": "Berens River Airport", 
	"country": "Canada", 
	"city": "Berens River"}, 
{
	"citycode": "YBX", 
	"airport": "Lourdes-de-Blanc-Sablon Airport", 
	"country": "Canada", 
	"city": "Blanc Sablon"}, 
{
	"citycode": "YCB", 
	"airport": "Cambridge Bay Airport", 
	"country": "Canada", 
	"city": "Cambridge Bay"}, 
{
	"citycode": "YCD", 
	"airport": "Nanaimo Airport", 
	"country": "Canada", 
	"city": "Nanaimo"}, 
{
	"citycode": "YCG", 
	"airport": "Castlegar Airport", 
	"country": "Canada", 
	"city": "Castlegar"}, 
{
	"citycode": "YCH", 
	"airport": "Miramichi Airport", 
	"country": "Canada", 
	"city": "Miramichi"}, 
{
	"citycode": "YCK", 
	"airport": "Colville Lake Airport", 
	"country": "Canada", 
	"city": "Colville Lake"}, 
{
	"citycode": "YCL", 
	"airport": "Charlo Airport", 
	"country": "Canada", 
	"city": "Charlo"}, 
{
	"citycode": "YCN", 
	"airport": "Cochrane Municipal Airport", 
	"country": "Canada", 
	"city": "Cochrane"}, 
{
	"citycode": "YCO", 
	"airport": "Kugluktuk Airport", 
	"country": "Canada", 
	"city": "Kugluktuk-Coppermine"}, 
{
	"citycode": "YCQ", 
	"airport": "Chetwynd Airport", 
	"country": "Canada", 
	"city": "Chetwynd"}, 
{
	"citycode": "YCR", 
	"airport": "Cross Lake Airport", 
	"country": "Canada", 
	"city": "Cross Lake"}, 
{
	"citycode": "YCS", 
	"airport": "Chesterfield Inlet Airport", 
	"country": "Canada", 
	"city": "Chesterfield Inlet"}, 
{
	"citycode": "YCV", 
	"airport": "Cartierville Airport", 
	"country": "Canada", 
	"city": "Cartierville"}, 
{
	"citycode": "YCY", 
	"airport": "Clyde River Airport", 
	"country": "Canada", 
	"city": "Clyde River"}, 
{
	"citycode": "YDA", 
	"airport": "Dawson City Airport", 
	"country": "Canada", 
	"city": "Dawson City"}, 
{
	"citycode": "YDE", 
	"airport": "Paradise River Airport", 
	"country": "Canada", 
	"city": "Paradise River"}, 
{
	"citycode": "YDF", 
	"airport": "Deer Lake Regional Airport", 
	"country": "Canada", 
	"city": "Deer Lake"}, 
{
	"citycode": "YDI", 
	"airport": "Davis Inlet Airport", 
	"country": "Canada", 
	"city": "Davis Inlet"}, 
{
	"citycode": "YDL", 
	"airport": "Dease Lake Airport", 
	"country": "Canada", 
	"city": "Dease Lake"}, 
{
	"citycode": "YDN", 
	"airport": "Dauphin Airport", 
	"country": "Canada", 
	"city": "Dauphin"}, 
{
	"citycode": "YDO", 
	"airport": "Dolbeau-Saint-Felicien Airport", 
	"country": "Canada", 
	"city": "Dolbeau"}, 
{
	"citycode": "YDP", 
	"airport": "Nain Airport", 
	"country": "Canada", 
	"city": "Nain"}, 
{
	"citycode": "YDQ", 
	"airport": "Dawson Creek Airport", 
	"country": "Canada", 
	"city": "Dawson Creek"}, 
{
	"citycode": "YDT", 
	"airport": "Boundary Bay Airport", 
	"country": "Canada", 
	"city": "Vancouver"}, 
{
	"citycode": "YEA", 
	"airport": "All Airports Edmonton", 
	"country": "Canada", 
	"city": "Edmonton"}, 
{
	"citycode": "YEG", 
	"airport": "Edmonton International Airport", 
	"country": "Canada", 
	"city": "Edmonton"}, 
{
	"citycode": "YEK", 
	"airport": "Arviat Airport", 
	"country": "Canada", 
	"city": "Arviat"}, 
{
	"citycode": "YEL", 
	"airport": "Elliot Lake Airport", 
	"country": "Canada", 
	"city": "Elliot Lake"}, 
{
	"citycode": "YER", 
	"airport": "Fort Severn Airport", 
	"country": "Canada", 
	"city": "Fort Severn"}, 
{
	"citycode": "YEV", 
	"airport": "Inuvik-Mike Zubko Airport", 
	"country": "Canada", 
	"city": "Inuvik"}, 
{
	"citycode": "YFA", 
	"airport": "Fort Albany Airport", 
	"country": "Canada", 
	"city": "Fort Albany"}, 
{
	"citycode": "YFB", 
	"airport": "Iqaluit International Airport", 
	"country": "Canada", 
	"city": "Iqaluit"}, 
{
	"citycode": "YFC", 
	"airport": "Fredericton International Airport", 
	"country": "Canada", 
	"city": "Fredericton"}, 
{
	"citycode": "YFH", 
	"airport": "Fort Hope Airport", 
	"country": "Canada", 
	"city": "Fort Hope"}, 
{
	"citycode": "YFO", 
	"airport": "Flin Flon Airport", 
	"country": "Canada", 
	"city": "Flin Flon"}, 
{
	"citycode": "YFR", 
	"airport": "Fort Resolution Airport", 
	"country": "Canada", 
	"city": "Fort Resolution"}, 
{
	"citycode": "YFS", 
	"airport": "Fort Simpson Airport", 
	"country": "Canada", 
	"city": "Fort Simpson"}, 
{
	"citycode": "YFX", 
	"airport": "St. Lewis (Fox Harbour) Airport", 
	"country": "Canada", 
	"city": "Fox Harbour"}, 
{
	"citycode": "YGB", 
	"airport": "Texada-Gillies Bay Airport", 
	"country": "Canada", 
	"city": "Gillies Bay"}, 
{
	"citycode": "YGH", 
	"airport": "Fort Good Hope Airport", 
	"country": "Canada", 
	"city": "Fort Good Hope"}, 
{
	"citycode": "YGK", 
	"airport": "Kingston Norman Rogers Airport", 
	"country": "Canada", 
	"city": "Kingston"}, 
{
	"citycode": "YGL", 
	"airport": "Grand River Airport", 
	"country": "Canada", 
	"city": "La Grande"}, 
{
	"citycode": "YGO", 
	"airport": "Gods Lake Narrows Airport", 
	"country": "Canada", 
	"city": "Gods Narrows"}, 
{
	"citycode": "YGP", 
	"airport": "Michel-Pouliot Gaspe Airport", 
	"country": "Canada", 
	"city": "Gaspe"}, 
{
	"citycode": "YGQ", 
	"airport": "Geraldton (Greenstone Regional) Airport", 
	"country": "Canada", 
	"city": "Geraldton"}, 
{
	"citycode": "YGR", 
	"airport": "Iles De La Madeleine Airport", 
	"country": "Canada", 
	"city": "Iles De La Madeleine"}, 
{
	"citycode": "YGT", 
	"airport": "Igloolik Airport", 
	"country": "Canada", 
	"city": "Igloolik"}, 
{
	"citycode": "YGV", 
	"airport": "Havre St Pierre Airport", 
	"country": "Canada", 
	"city": "Havre St Pierre"}, 
{
	"citycode": "YGW", 
	"airport": "Kuujjuarapik Airport", 
	"country": "Canada", 
	"city": "Kuujjuarapik"}, 
{
	"citycode": "YGX", 
	"airport": "Gillam Airport", 
	"country": "Canada", 
	"city": "Gillam"}, 
{
	"citycode": "YGZ", 
	"airport": "Grise Fiord Airport", 
	"country": "Canada", 
	"city": "Grise Fiord"}, 
{
	"citycode": "YHA", 
	"airport": "Port Hope Simpson Airport", 
	"country": "Canada", 
	"city": "Port Hope Simpson"}, 
{
	"citycode": "YHD", 
	"airport": "Dryden Regional Airport", 
	"country": "Canada", 
	"city": "Dryden"}, 
{
	"citycode": "YHF", 
	"airport": "Hearst/Rene Fontaine Municipal Airport", 
	"country": "Canada", 
	"city": "Hearst"}, 
{
	"citycode": "YHI", 
	"airport": "Holman Airport", 
	"country": "Canada", 
	"city": "Holman"}, 
{
	"citycode": "YHK", 
	"airport": "Gjoa Haven Airport", 
	"country": "Canada", 
	"city": "Gjoa Haven"}, 
{
	"citycode": "YHM", 
	"airport": "John C. Munro Hamilton International Airport", 
	"country": "Canada", 
	"city": "Hamilton"}, 
{
	"citycode": "YHN", 
	"airport": "Hornepayne Municipal Airport", 
	"country": "Canada", 
	"city": "Hornepayne"}, 
{
	"citycode": "YHO", 
	"airport": "Hopedale Airport", 
	"country": "Canada", 
	"city": "Hopedale"}, 
{
	"citycode": "YHP", 
	"airport": "Poplar Hill Airport", 
	"country": "Canada", 
	"city": "Poplar Hill"}, 
{
	"citycode": "YHR", 
	"airport": "Chevery Airport", 
	"country": "Canada", 
	"city": "Chevery"}, 
{
	"citycode": "YHS", 
	"airport": "Sechelt Airport", 
	"country": "Canada", 
	"city": "Sechelt"}, 
{
	"citycode": "YHU", 
	"airport": "Montreal Saint-Hubert Longueuil Airport", 
	"country": "Canada", 
	"city": "Montreal"}, 
{
	"citycode": "YHZ", 
	"airport": "Halifax Stanfield International Airport", 
	"country": "Canada", 
	"city": "Halifax"}, 
{
	"citycode": "YIB", 
	"airport": "Atikokan Municipal Airport", 
	"country": "Canada", 
	"city": "Atikokan"}, 
{
	"citycode": "YIF", 
	"airport": "Saint-Augustin Airport", 
	"country": "Canada", 
	"city": "Pakuashipi"}, 
{
	"citycode": "YIK", 
	"airport": "Ivujivik Airport", 
	"country": "Canada", 
	"city": "Ivujivik"}, 
{
	"citycode": "YIO", 
	"airport": "Pond Inlet Airport", 
	"country": "Canada", 
	"city": "Pond Inlet"}, 
{
	"citycode": "YIV", 
	"airport": "Island Lake Airport", 
	"country": "Canada", 
	"city": "Island Lake -Garden Hill"}, 
{
	"citycode": "YJN", 
	"airport": "Saint-Jean Airport", 
	"country": "Canada", 
	"city": "St Jean"}, 
{
	"citycode": "YJT", 
	"airport": "Stephenville International Airport", 
	"country": "Canada", 
	"city": "Stephenville"}, 
{
	"citycode": "YKA", 
	"airport": "Kamloops Airport", 
	"country": "Canada", 
	"city": "Kamloops"}, 
{
	"citycode": "YKG", 
	"airport": "Kangirsuk Airport", 
	"country": "Canada", 
	"city": "Kangirsuk"}, 
{
	"citycode": "YKL", 
	"airport": "Schefferville Airport", 
	"country": "Canada", 
	"city": "Schefferville"}, 
{
	"citycode": "YKQ", 
	"airport": "Waskaganish Airport", 
	"country": "Canada", 
	"city": "Waskaganish"}, 
{
	"citycode": "YKT", 
	"airport": "Klemtu Airport", 
	"country": "Canada", 
	"city": "Klemtu"}, 
{
	"citycode": "YKU", 
	"airport": "Chisasibi Airport", 
	"country": "Canada", 
	"city": "Chisasibi"}, 
{
	"citycode": "YKX", 
	"airport": "Kirkland Lake Airport", 
	"country": "Canada", 
	"city": "Kirkland Lake"}, 
{
	"citycode": "YKY", 
	"airport": "Kindersley Regional Airport", 
	"country": "Canada", 
	"city": "Kindersley"}, 
{
	"citycode": "YKZ", 
	"airport": "Toronto Buttonville Municipal Airport", 
	"country": "Canada", 
	"city": "Toronto"}, 
{
	"citycode": "YLC", 
	"airport": "Kimmirut Airport", 
	"country": "Canada", 
	"city": "Kimmirut-Lake Harbour"}, 
{
	"citycode": "YLD", 
	"airport": "Chapleau Airport", 
	"country": "Canada", 
	"city": "Chapleau"}, 
{
	"citycode": "YLE", 
	"airport": "Wha Ti Airport", 
	"country": "Canada", 
	"city": "Wha Ti-Lac La Martre"}, 
{
	"citycode": "YLL", 
	"airport": "Lloydminster Minister Airport", 
	"country": "Canada", 
	"city": "Lloydminster"}, 
{
	"citycode": "YLR", 
	"airport": "Leaf Rapids Airport", 
	"country": "Canada", 
	"city": "Leaf Rapids"}, 
{
	"citycode": "YLW", 
	"airport": "Kelowna International Airport", 
	"country": "Canada", 
	"city": "Kelowna"}, 
{
	"citycode": "YMA", 
	"airport": "Mayo Airport", 
	"country": "Canada", 
	"city": "Mayo"}, 
{
	"citycode": "YME", 
	"airport": "Matane Airport", 
	"country": "Canada", 
	"city": "Matane"}, 
{
	"citycode": "YMG", 
	"airport": "Manitouwadge Airport", 
	"country": "Canada", 
	"city": "Manitouwadge"}, 
{
	"citycode": "YMH", 
	"airport": "Mary`s Harbour Airport", 
	"country": "Canada", 
	"city": "Mary`s Harbour"}, 
{
	"citycode": "YMM", 
	"airport": "Fort McMurray International Airport", 
	"country": "Canada", 
	"city": "Fort Mcmurray"}, 
{
	"citycode": "YMN", 
	"airport": "Makkovik Airport", 
	"country": "Canada", 
	"city": "Makkovik"}, 
{
	"citycode": "YMO", 
	"airport": "Moosonee Airport", 
	"country": "Canada", 
	"city": "Moosonee"}, 
{
	"citycode": "YMQ", 
	"airport": "All Airports Montreal", 
	"country": "Canada", 
	"city": "Montreal"}, 
{
	"citycode": "YMT", 
	"airport": "Chibougamau/Chapais Airport", 
	"country": "Canada", 
	"city": "Chibougamau"}, 
{
	"citycode": "YMX", 
	"airport": "Montreal-Mirabel International Airport", 
	"country": "Canada", 
	"city": "Montreal"}, 
{
	"citycode": "YNA", 
	"airport": "Natashquan Airport", 
	"country": "Canada", 
	"city": "Natashquan"}, 
{
	"citycode": "YNC", 
	"airport": "Wemindji Airport", 
	"country": "Canada", 
	"city": "Wemindji"}, 
{
	"citycode": "YND", 
	"airport": "Gatineau-Ottawa Executive Airport", 
	"country": "Canada", 
	"city": "Ottawa"}, 
{
	"citycode": "YNE", 
	"airport": "Norway House Airport", 
	"country": "Canada", 
	"city": "Norway House"}, 
{
	"citycode": "YNL", 
	"airport": "Points North Landing Airport", 
	"country": "Canada", 
	"city": "Points North Landing"}, 
{
	"citycode": "YNM", 
	"airport": "Matagami Airport", 
	"country": "Canada", 
	"city": "Matagami"}, 
{
	"citycode": "YNO", 
	"airport": "North Spirit Lake Airport", 
	"country": "Canada", 
	"city": "North Spirit Lake"}, 
{
	"citycode": "YNS", 
	"airport": "Nemiscau Airport", 
	"country": "Canada", 
	"city": "Nemiscau"}, 
{
	"citycode": "YOC", 
	"airport": "Old Crow Airport", 
	"country": "Canada", 
	"city": "Old Crow"}, 
{
	"citycode": "YOH", 
	"airport": "Oxford House Airport", 
	"country": "Canada", 
	"city": "Oxford House"}, 
{
	"citycode": "YOJ", 
	"airport": "High Level Airport", 
	"country": "Canada", 
	"city": "High Level"}, 
{
	"citycode": "YOO", 
	"airport": "Oshawa Executive Airport", 
	"country": "Canada", 
	"city": "Oshawa"}, 
{
	"citycode": "YOP", 
	"airport": "Rainbow Lake Airport", 
	"country": "Canada", 
	"city": "Rainbow Lake"}, 
{
	"citycode": "YOW", 
	"airport": "Ottawa Macdonald-Cartier International Airport", 
	"country": "Canada", 
	"city": "Ottawa"}, 
{
	"citycode": "YPA", 
	"airport": "Prince Albert Glass Field Airport", 
	"country": "Canada", 
	"city": "Prince Albert"}, 
{
	"citycode": "YPB", 
	"airport": "Alberni Valley Regional Airport", 
	"country": "Canada", 
	"city": "Port Alberni"}, 
{
	"citycode": "YPC", 
	"airport": "Paulatuk Airport", 
	"country": "Canada", 
	"city": "Paulatuk"}, 
{
	"citycode": "YPE", 
	"airport": "Peace River Airport", 
	"country": "Canada", 
	"city": "Peace River"}, 
{
	"citycode": "YPH", 
	"airport": "Inukjuak Airport", 
	"country": "Canada", 
	"city": "Inukjuak"}, 
{
	"citycode": "YPI", 
	"airport": "Port Simpson Airport", 
	"country": "Canada", 
	"city": "Port Simpson"}, 
{
	"citycode": "YPJ", 
	"airport": "Aupaluk Airport", 
	"country": "Canada", 
	"city": "Aupaluk"}, 
{
	"citycode": "YPL", 
	"airport": "Pickle Lake Airport", 
	"country": "Canada", 
	"city": "Pickle Lake"}, 
{
	"citycode": "YPM", 
	"airport": "Pikangikum Airport", 
	"country": "Canada", 
	"city": "Pikangikum"}, 
{
	"citycode": "YPN", 
	"airport": "Port Menier Airport", 
	"country": "Canada", 
	"city": "Port Menier"}, 
{
	"citycode": "YPQ", 
	"airport": "Peterborough Airport", 
	"country": "Canada", 
	"city": "Peterborough"}, 
{
	"citycode": "YPR", 
	"airport": "Prince Rupert Airport", 
	"country": "Canada", 
	"city": "Prince Rupert"}, 
{
	"citycode": "YPW", 
	"airport": "Powell River Airport", 
	"country": "Canada", 
	"city": "Powell River"}, 
{
	"citycode": "YPX", 
	"airport": "Puvirnituq Airport", 
	"country": "Canada", 
	"city": "Povungnituk"}, 
{
	"citycode": "YPY", 
	"airport": "Fort Chipewyan Airport", 
	"country": "Canada", 
	"city": "Fort Chipewyan"}, 
{
	"citycode": "YQB", 
	"airport": "Quebec City Jean Lesage International Airport", 
	"country": "Canada", 
	"city": "Quebec"}, 
{
	"citycode": "YQC", 
	"airport": "Quaqtaq Airport", 
	"country": "Canada", 
	"city": "Quaqtaq"}, 
{
	"citycode": "YQD", 
	"airport": "The Pas Airport", 
	"country": "Canada", 
	"city": "The Pas"}, 
{
	"citycode": "YQG", 
	"airport": "Windsor International Airport", 
	"country": "Canada", 
	"city": "Windsor"}, 
{
	"citycode": "YQH", 
	"airport": "Watson Lake Airport", 
	"country": "Canada", 
	"city": "Watson Lake"}, 
{
	"citycode": "YQI", 
	"airport": "Yarmouth Airport", 
	"country": "Canada", 
	"city": "Yarmouth"}, 
{
	"citycode": "YQK", 
	"airport": "Kenora Airport", 
	"country": "Canada", 
	"city": "Kenora"}, 
{
	"citycode": "YQL", 
	"airport": "Lethbridge Airport", 
	"country": "Canada", 
	"city": "Lethbridge"}, 
{
	"citycode": "YQM", 
	"airport": "Greater Moncton Romeo LeBlanc International Airport", 
	"country": "Canada", 
	"city": "Moncton"}, 
{
	"citycode": "YQQ", 
	"airport": "Comox Airport", 
	"country": "Canada", 
	"city": "Comox"}, 
{
	"citycode": "YQR", 
	"airport": "Regina International Airport", 
	"country": "Canada", 
	"city": "Regina"}, 
{
	"citycode": "YQT", 
	"airport": "Thunder Bay International Airport", 
	"country": "Canada", 
	"city": "Thunder Bay"}, 
{
	"citycode": "YQU", 
	"airport": "Grande Prairie Airport", 
	"country": "Canada", 
	"city": "Grande Prairie"}, 
{
	"citycode": "YQV", 
	"airport": "Yorkton Muncipal Airport", 
	"country": "Canada", 
	"city": "Yorkton"}, 
{
	"citycode": "YQW", 
	"airport": "North Battleford Airport", 
	"country": "Canada", 
	"city": "North Battleford"}, 
{
	"citycode": "YQX", 
	"airport": "Gander International Airport", 
	"country": "Canada", 
	"city": "Gander"}, 
{
	"citycode": "YQY", 
	"airport": "J.A. Douglas McCurdy Sydney Airport", 
	"country": "Canada", 
	"city": "Sydney"}, 
{
	"citycode": "YQZ", 
	"airport": "Quesnel Airport", 
	"country": "Canada", 
	"city": "Quesnel"}, 
{
	"citycode": "YRA", 
	"airport": "Gameti/Rae Lakes Airport", 
	"country": "Canada", 
	"city": "Rae Lakes"}, 
{
	"citycode": "YRB", 
	"airport": "Resolute Bay Airport", 
	"country": "Canada", 
	"city": "Resolute"}, 
{
	"citycode": "YRD", 
	"airport": "Dean River Airport", 
	"country": "Canada", 
	"city": "Dean River"}, 
{
	"citycode": "YRF", 
	"airport": "Cartwright Airport", 
	"country": "Canada", 
	"city": "Cartwright"}, 
{
	"citycode": "YRG", 
	"airport": "Rigolet Airport", 
	"country": "Canada", 
	"city": "Rigolet"}, 
{
	"citycode": "YRJ", 
	"airport": "Roberval Airport", 
	"country": "Canada", 
	"city": "Roberval"}, 
{
	"citycode": "YRL", 
	"airport": "Red Lake Airport", 
	"country": "Canada", 
	"city": "Red Lake"}, 
{
	"citycode": "YRO", 
	"airport": "Rockcliffe Airport", 
	"country": "Canada", 
	"city": "Ottawa"}, 
{
	"citycode": "YRS", 
	"airport": "Red Sucker Lake Airport", 
	"country": "Canada", 
	"city": "Red Sucker Lake"}, 
{
	"citycode": "YRT", 
	"airport": "Rankin Inlet Airport", 
	"country": "Canada", 
	"city": "Rankin Inlet"}, 
{
	"citycode": "YSB", 
	"airport": "Sudbury Airport", 
	"country": "Canada", 
	"city": "Sudbury"}, 
{
	"citycode": "YSE", 
	"airport": "Squamish Airport", 
	"country": "Canada", 
	"city": "Squamish"}, 
{
	"citycode": "YSF", 
	"airport": "Stony Rapids Airport", 
	"country": "Canada", 
	"city": "Stony Rapids"}, 
{
	"citycode": "YSG", 
	"airport": "Lutselke Airport", 
	"country": "Canada", 
	"city": "Lutselke-Snowdrift"}, 
{
	"citycode": "YSJ", 
	"airport": "Saint John Airport", 
	"country": "Canada", 
	"city": "Saint John"}, 
{
	"citycode": "YSK", 
	"airport": "Sanikiluaq Airport", 
	"country": "Canada", 
	"city": "Sanikiluaq"}, 
{
	"citycode": "YSM", 
	"airport": "Fort Smith Airport", 
	"country": "Canada", 
	"city": "Fort Smith"}, 
{
	"citycode": "YSN", 
	"airport": "Salmon Arm Airport", 
	"country": "Canada", 
	"city": "Salmon Arm"}, 
{
	"citycode": "YSO", 
	"airport": "Postville Airport", 
	"country": "Canada", 
	"city": "Postville"}, 
{
	"citycode": "YSP", 
	"airport": "Marathon Airport", 
	"country": "Canada", 
	"city": "Marathon"}, 
{
	"citycode": "YSR", 
	"airport": "Nanisivik Airport", 
	"country": "Canada", 
	"city": "Nanisivik"}, 
{
	"citycode": "YST", 
	"airport": "Ste Therese Point Airport", 
	"country": "Canada", 
	"city": "Ste Therese Point"}, 
{
	"citycode": "YSY", 
	"airport": "Sachs Harbour Airport", 
	"country": "Canada", 
	"city": "Sachs Harbour"}, 
{
	"citycode": "YTA", 
	"airport": "Pembroke and Area Airport", 
	"country": "Canada", 
	"city": "Pembroke"}, 
{
	"citycode": "YTB", 
	"airport": "Hartley Bay Airport", 
	"country": "Canada", 
	"city": "Hartley Bay"}, 
{
	"citycode": "YTC", 
	"airport": "Sturdee Airport", 
	"country": "Canada", 
	"city": "Sturdee"}, 
{
	"citycode": "YTE", 
	"airport": "Cape Dorset Airport", 
	"country": "Canada", 
	"city": "Cape Dorset"}, 
{
	"citycode": "YTF", 
	"airport": "Alma Airport", 
	"country": "Canada", 
	"city": "Alma"}, 
{
	"citycode": "YTH", 
	"airport": "Thompson Airport", 
	"country": "Canada", 
	"city": "Thompson"}, 
{
	"citycode": "YTJ", 
	"airport": "Terrace Bay Airport", 
	"country": "Canada", 
	"city": "Terrace Bay"}, 
{
	"citycode": "YTL", 
	"airport": "Big Trout Lake Airport", 
	"country": "Canada", 
	"city": "Big Trout"}, 
{
	"citycode": "YTO", 
	"airport": "All Airports Toronto", 
	"country": "Canada", 
	"city": "Toronto"}, 
{
	"citycode": "YTQ", 
	"airport": "Tasiujuaq Airport", 
	"country": "Canada", 
	"city": "Tasiujuaq"}, 
{
	"citycode": "YTR", 
	"airport": "Trenton Airport", 
	"country": "Canada", 
	"city": "Trenton"}, 
{
	"citycode": "YTS", 
	"airport": "Timmins/Victor M. Power Airport", 
	"country": "Canada", 
	"city": "Timmins"}, 
{
	"citycode": "YTT", 
	"airport": "Tisdale Airport", 
	"country": "Canada", 
	"city": "Tisdale"}, 
{
	"citycode": "YTX", 
	"airport": "Telegraph Creek Airport", 
	"country": "Canada", 
	"city": "Telegraph Creek"}, 
{
	"citycode": "YTZ", 
	"airport": "Billy Bishop Toronto City Centre Airport", 
	"country": "Canada", 
	"city": "Toronto"}, 
{
	"citycode": "YUB", 
	"airport": "Tuktoyaktuk James Gruben Airport", 
	"country": "Canada", 
	"city": "Tuktoyaktuk"}, 
{
	"citycode": "YUD", 
	"airport": "Umiujaq Airport", 
	"country": "Canada", 
	"city": "Umiujaq"}, 
{
	"citycode": "YUF", 
	"airport": "Dewline Site Airport", 
	"country": "Canada", 
	"city": "CANADA (NW TERRITORIES)"}, 
{
	"citycode": "YUL", 
	"airport": "Montreal–Trudeau International Airport", 
	"country": "Canada", 
	"city": "Montreal"}, 
{
	"citycode": "YUT", 
	"airport": "Naujaat Airport", 
	"country": "Canada", 
	"city": "Repulse Bay"}, 
{
	"citycode": "YUX", 
	"airport": "Hall Beach Airport", 
	"country": "Canada", 
	"city": "Hall Beach"}, 
{
	"citycode": "YUY", 
	"airport": "Rouyn-Noranda Airport", 
	"country": "Canada", 
	"city": "Rouyn"}, 
{
	"citycode": "YVB", 
	"airport": "Bonaventure Airport", 
	"country": "Canada", 
	"city": "Bonaventure"}, 
{
	"citycode": "YVC", 
	"airport": "La Ronge Airport", 
	"country": "Canada", 
	"city": "La Ronge"}, 
{
	"citycode": "YVE", 
	"airport": "Vernon Regional Airport", 
	"country": "Canada", 
	"city": "Vernon"}, 
{
	"citycode": "YVM", 
	"airport": "Qikiqtarjuaq Airport", 
	"country": "Canada", 
	"city": "Qikiqtarjuaq"}, 
{
	"citycode": "YVO", 
	"airport": "Val D`Or Airport", 
	"country": "Canada", 
	"city": "Val D`Or"}, 
{
	"citycode": "YVP", 
	"airport": "Kuujjuaq Airport", 
	"country": "Canada", 
	"city": "Kuujjuaq"}, 
{
	"citycode": "YVQ", 
	"airport": "Norman Wells Airport", 
	"country": "Canada", 
	"city": "Norman Wells"}, 
{
	"citycode": "YVR", 
	"airport": "Vancouver International Airport", 
	"country": "Canada", 
	"city": "Vancouver"}, 
{
	"citycode": "YVT", 
	"airport": "Buffalo Narrows Airport", 
	"country": "Canada", 
	"city": "Buffalo Narrows"}, 
{
	"citycode": "YVZ", 
	"airport": "Deer Lake Airport", 
	"country": "Canada", 
	"city": "Deer Lake"}, 
{
	"citycode": "YWB", 
	"airport": "Kangiqsujuaq Airport", 
	"country": "Canada", 
	"city": "Kangiqsujuaq"}, 
{
	"citycode": "YWF", 
	"airport": "Dwtown Waterfront H-P Airport", 
	"country": "Canada", 
	"city": "Halifax"}, 
{
	"citycode": "YWG", 
	"airport": "Winnipeg Richardson International Airport", 
	"country": "Canada", 
	"city": "Winnipeg"}, 
{
	"citycode": "YWH", 
	"airport": "Victoria Inner Harbor Airport", 
	"country": "Canada", 
	"city": "Victoria"}, 
{
	"citycode": "YWJ", 
	"airport": "Deline Airport", 
	"country": "Canada", 
	"city": "Deline"}, 
{
	"citycode": "YWK", 
	"airport": "Wabush Airport", 
	"country": "Canada", 
	"city": "Wabush"}, 
{
	"citycode": "YWL", 
	"airport": "Williams Lake Airport", 
	"country": "Canada", 
	"city": "Williams Lake"}, 
{
	"citycode": "YWP", 
	"airport": "Webequie Airport", 
	"country": "Canada", 
	"city": "Webequie"}, 
{
	"citycode": "YWS", 
	"airport": "Whistler/Green Lake Water Aerodrome", 
	"country": "Canada", 
	"city": "Whistler"}, 
{
	"citycode": "YWY", 
	"airport": "Wrigley Airport", 
	"country": "Canada", 
	"city": "Wrigley"}, 
{
	"citycode": "YXC", 
	"airport": "Canadian Rockies International Airport", 
	"country": "Canada", 
	"city": "Cranbrook"}, 
{
	"citycode": "YXD", 
	"airport": "Edmonton City Centre Airport", 
	"country": "Canada", 
	"city": "Edmonton"}, 
{
	"citycode": "YXE", 
	"airport": "Saskatoon International Airport", 
	"country": "Canada", 
	"city": "Saskatoon"}, 
{
	"citycode": "YXH", 
	"airport": "Medicine Hat Airport", 
	"country": "Canada", 
	"city": "Medicine Hat"}, 
{
	"citycode": "YXJ", 
	"airport": "North Peace Regional Airport", 
	"country": "Canada", 
	"city": "Fort St John"}, 
{
	"citycode": "YXK", 
	"airport": "Rimouski Airport", 
	"country": "Canada", 
	"city": "Rimouski"}, 
{
	"citycode": "YXL", 
	"airport": "Sioux Lookout Airport", 
	"country": "Canada", 
	"city": "Sioux Lookout"}, 
{
	"citycode": "YXN", 
	"airport": "Whale Cove Airport", 
	"country": "Canada", 
	"city": "Whale Cove"}, 
{
	"citycode": "YXP", 
	"airport": "Pangnirtung Airport", 
	"country": "Canada", 
	"city": "Pangnirtung"}, 
{
	"citycode": "YXR", 
	"airport": "Earlton-Timiskaming Airport", 
	"country": "Canada", 
	"city": "Earlton"}, 
{
	"citycode": "YXS", 
	"airport": "Prince George International Airport", 
	"country": "Canada", 
	"city": "Prince George"}, 
{
	"citycode": "YXT", 
	"airport": "Northwest Terrace Regional Airport", 
	"country": "Canada", 
	"city": "Terrace"}, 
{
	"citycode": "YXU", 
	"airport": "London International Airport", 
	"country": "Canada", 
	"city": "London"}, 
{
	"citycode": "YXX", 
	"airport": "Abbotsford International Airport", 
	"country": "Canada", 
	"city": "Abbotsford"}, 
{
	"citycode": "YXY", 
	"airport": "Erik Nielsen Whitehorse International Airport", 
	"country": "Canada", 
	"city": "Whitehorse"}, 
{
	"citycode": "YXZ", 
	"airport": "Wawa Airport", 
	"country": "Canada", 
	"city": "Wawa"}, 
{
	"citycode": "YYB", 
	"airport": "Jack Garland Airport", 
	"country": "Canada", 
	"city": "North Bay"}, 
{
	"citycode": "YYC", 
	"airport": "Calgary International Airport", 
	"country": "Canada", 
	"city": "Calgary"}, 
{
	"citycode": "YYD", 
	"airport": "Smithers Airport", 
	"country": "Canada", 
	"city": "Smithers"}, 
{
	"citycode": "YYE", 
	"airport": "Fort Nelson Airport", 
	"country": "Canada", 
	"city": "Fort Nelson"}, 
{
	"citycode": "YYG", 
	"airport": "Charlottetown Airport", 
	"country": "Canada", 
	"city": "Charlottetown"}, 
{
	"citycode": "YYH", 
	"airport": "Taloyoak Airport", 
	"country": "Canada", 
	"city": "Taloyoak"}, 
{
	"citycode": "YYJ", 
	"airport": "Victoria International Airport", 
	"country": "Canada", 
	"city": "Victoria"}, 
{
	"citycode": "YYL", 
	"airport": "Lynn Lake Airport", 
	"country": "Canada", 
	"city": "Lynn Lake"}, 
{
	"citycode": "YYN", 
	"airport": "Swift Current Airport", 
	"country": "Canada", 
	"city": "Swift Current"}, 
{
	"citycode": "YYQ", 
	"airport": "Churchill Airport", 
	"country": "Canada", 
	"city": "Churchill"}, 
{
	"citycode": "YYR", 
	"airport": "Goose Bay Airport", 
	"country": "Canada", 
	"city": "Goose Bay"}, 
{
	"citycode": "YYT", 
	"airport": "St. John`s International Airport", 
	"country": "Canada", 
	"city": "St Johns"}, 
{
	"citycode": "YYU", 
	"airport": "Kapuskasing Airport", 
	"country": "Canada", 
	"city": "Kapuskasing"}, 
{
	"citycode": "YYY", 
	"airport": "Mont Joli Airport", 
	"country": "Canada", 
	"city": "Mont Joli"}, 
{
	"citycode": "YYZ", 
	"airport": "Toronto Pearson International Airport", 
	"country": "Canada", 
	"city": "Toronto"}, 
{
	"citycode": "YZD", 
	"airport": "Downsview Airport", 
	"country": "Canada", 
	"city": "CANADA (ONTARIO)"}, 
{
	"citycode": "YZE", 
	"airport": "Gore Bay-Manitoulin Airport", 
	"country": "Canada", 
	"city": "Gore Bay"}, 
{
	"citycode": "YZF", 
	"airport": "Yellowknife Airport", 
	"country": "Canada", 
	"city": "Yellowknife"}, 
{
	"citycode": "YZG", 
	"airport": "Salluit Airport", 
	"country": "Canada", 
	"city": "Salluit"}, 
{
	"citycode": "YZP", 
	"airport": "Sandspit Airport", 
	"country": "Canada", 
	"city": "Sandspit"}, 
{
	"citycode": "YZR", 
	"airport": "Sarnia", 
	"country": "Canada", 
	"city": "Sarnia"}, 
{
	"citycode": "YZS", 
	"airport": "Coral Harbour Airport", 
	"country": "Canada", 
	"city": "Coral Harbour"}, 
{
	"citycode": "YZT", 
	"airport": "Port Hardy Airport", 
	"country": "Canada", 
	"city": "Port Hardy"}, 
{
	"citycode": "YZV", 
	"airport": "Sept-Iles Airport", 
	"country": "Canada", 
	"city": "Sept-Iles"}, 
{
	"citycode": "ZBF", 
	"airport": "Bathurst Airport", 
	"country": "Canada", 
	"city": "Bathurst"}, 
{
	"citycode": "ZEL", 
	"airport": "Bella Bella Airport", 
	"country": "Canada", 
	"city": "Bella Bella"}, 
{
	"citycode": "ZEM", 
	"airport": "East Main River Airport", 
	"country": "Canada", 
	"city": "East Main"}, 
{
	"citycode": "ZFA", 
	"airport": "Faro Airport", 
	"country": "Canada", 
	"city": "Faro"}, 
{
	"citycode": "ZFD", 
	"airport": "Fond Du Lac Airport", 
	"country": "Canada", 
	"city": "CANADA (SASKATCHEWAN)"}, 
{
	"citycode": "ZFM", 
	"airport": "Fort Mcpherson Airport", 
	"country": "Canada", 
	"city": "Fort Mcpherson"}, 
{
	"citycode": "ZFN", 
	"airport": "Tulita Airport", 
	"country": "Canada", 
	"city": "Tulita-Fort Norman"}, 
{
	"citycode": "ZGI", 
	"airport": "Gods River Airport", 
	"country": "Canada", 
	"city": "CANADA (MANITOBA)"}, 
{
	"citycode": "ZGS", 
	"airport": "La Romaine Airport", 
	"country": "Canada", 
	"city": "Gethsemani"}, 
{
	"citycode": "ZJG", 
	"airport": "Jenpeg Airport", 
	"country": "Canada", 
	"city": "Jenpeg"}, 
{
	"citycode": "ZKE", 
	"airport": "Kaschechewan Airport", 
	"country": "Canada", 
	"city": "Kaschechewan"}, 
{
	"citycode": "ZKG", 
	"airport": "Kegaska Airport", 
	"country": "Canada", 
	"city": "Kegaska"}, 
{
	"citycode": "ZLT", 
	"airport": "La Tabatiere Airport", 
	"country": "Canada", 
	"city": "La Tabatiere"}, 
{
	"citycode": "ZMT", 
	"airport": "Masset Airport", 
	"country": "Canada", 
	"city": "Masset"}, 
{
	"citycode": "ZNA", 
	"airport": "Nanaimo Harbour Airport", 
	"country": "Canada", 
	"city": "BR. COLUMBIA"}, 
{
	"citycode": "ZPB", 
	"airport": "Sachigo Lake Airport", 
	"country": "Canada", 
	"city": "CANADA (ONTARIO)"}, 
{
	"citycode": "ZRJ", 
	"airport": "Round Lake Airport", 
	"country": "Canada", 
	"city": "Round Lake"}, 
{
	"citycode": "ZSJ", 
	"airport": "Sandy Lake Airport", 
	"country": "Canada", 
	"city": "CANADA (ONTARIO)"}, 
{
	"citycode": "ZSW", 
	"airport": "Prince Rupert/Seal Cove Water Airport", 
	"country": "Canada", 
	"city": "Prince Rupert"}, 
{
	"citycode": "ZTB", 
	"airport": "Tete-a-La Baleine Airport", 
	"country": "Canada", 
	"city": "Tete-a-La Baleine"}, 
{
	"citycode": "ZTM", 
	"airport": "Shamattawa Airport", 
	"country": "Canada", 
	"city": "Shamattawa"}, 
{
	"citycode": "ZUM", 
	"airport": "Churchill Falls Airport", 
	"country": "Canada", 
	"city": "Churchill Falls"}, 
{
	"citycode": "ZWL", 
	"airport": "Wollaston Lake Airport", 
	"country": "Canada", 
	"city": "Wollaston Lake"}, 
{
	"citycode": "BAV", 
	"airport": "Baotou Erliban Airport", 
	"country": "PR China", 
	"city": "Baotou"}, 
{
	"citycode": "BHY", 
	"airport": "Beihai Fucheng Airport", 
	"country": "PR China", 
	"city": "Beihai"}, 
{
	"citycode": "BJS", 
	"airport": "All Airports Beijing", 
	"country": "PR China", 
	"city": "Beijing"}, 
{
	"citycode": "CAN", 
	"airport": "Guangzhou Baiyun International Airport", 
	"country": "PR China", 
	"city": "Guangzhou"}, 
{
	"citycode": "CGO", 
	"airport": "Zhengzhou Xinzheng International Airport", 
	"country": "PR China", 
	"city": "Zhengzhou"}, 
{
	"citycode": "CGQ", 
	"airport": "Changchun Longjia International Airport", 
	"country": "PR China", 
	"city": "Changchun"}, 
{
	"citycode": "CIF", 
	"airport": "Chifeng Yulong Airport", 
	"country": "PR China", 
	"city": "Chifeng"}, 
{
	"citycode": "CIH", 
	"airport": "Changzhi Wangcun Airport", 
	"country": "PR China", 
	"city": "Changzhi"}, 
{
	"citycode": "CKG", 
	"airport": "Chongqing Jiangbei International Airport", 
	"country": "PR China", 
	"city": "Chongqing"}, 
{
	"citycode": "CSX", 
	"airport": "Changsha Huanghua International Airport", 
	"country": "PR China", 
	"city": "Changsha"}, 
{
	"citycode": "CTU", 
	"airport": "Chengdu Shuangliu International Airport", 
	"country": "PR China", 
	"city": "Chengdu"}, 
{
	"citycode": "CZX", 
	"airport": "Changzhou Benniu International Airport", 
	"country": "PR China", 
	"city": "Changzhou"}, 
{
	"citycode": "DLC", 
	"airport": "Dalian Zhoushuizi International Airport", 
	"country": "PR China", 
	"city": "Dalian"}, 
{
	"citycode": "DNH", 
	"airport": "Dunhuang Mogao International Airport ", 
	"country": "PR China", 
	"city": "Dunhuang"}, 
{
	"citycode": "FOC", 
	"airport": "Fuzhou Changle International Airport", 
	"country": "PR China", 
	"city": "Fuzhou"}, 
{
	"citycode": "HAK", 
	"airport": "Haikou Meilan International Airport", 
	"country": "PR China", 
	"city": "Haikou"}, 
{
	"citycode": "HET", 
	"airport": "Hohhot Baita International Airport", 
	"country": "PR China", 
	"city": "Hohhot"}, 
{
	"citycode": "HFE", 
	"airport": "Hefei Luogang International Airport", 
	"country": "PR China", 
	"city": "Hefei"}, 
{
	"citycode": "HGH", 
	"airport": "Hangzhou International Airport", 
	"country": "PR China", 
	"city": "Hangzhou"}, 
{
	"citycode": "HLD", 
	"airport": "Hulunbuir Hailar Airport", 
	"country": "PR China", 
	"city": "Hailar"}, 
{
	"citycode": "HLH", 
	"airport": "Ulanhot Airport", 
	"country": "PR China", 
	"city": "Ulanhot"}, 
{
	"citycode": "HNY", 
	"airport": "Hengyang Nanyue Airport", 
	"country": "PR China", 
	"city": "Hengyang"}, 
{
	"citycode": "HRB", 
	"airport": "Harbin Taiping International Airport", 
	"country": "PR China", 
	"city": "Harbin"}, 
{
	"citycode": "HYN", 
	"airport": "Taizhou Luqiao Airport", 
	"country": "PR China", 
	"city": "Huangyan"}, 
{
	"citycode": "INC", 
	"airport": "Yinchuan Hedong International Airport", 
	"country": "PR China", 
	"city": "Yinchuan"}, 
{
	"citycode": "JGN", 
	"airport": "Jiayuguan Jiuquan Airport", 
	"country": "PR China", 
	"city": "Jiayuguan"}, 
{
	"citycode": "JJN", 
	"airport": "Jinjiang Airport", 
	"country": "China", 
	"city": "Quanzhou"}, 
{
	"citycode": "KHG", 
	"airport": "Kherson International Airport", 
	"country": "PR China", 
	"city": "Kashi"}, 
{
	"citycode": "KHN", 
	"airport": "Nanchang Changbei International Airport", 
	"country": "PR China", 
	"city": "Nanchang"}, 
{
	"citycode": "KMG", 
	"airport": "Kunming Changshui International Airport", 
	"country": "PR China", 
	"city": "Kunming"}, 
{
	"citycode": "KOW", 
	"airport": "Ganzhou Huangjin Airport", 
	"country": "PR China", 
	"city": "Ganzhou"}, 
{
	"citycode": "KWE", 
	"airport": "Guiyang Longdongbao International Airport", 
	"country": "PR China", 
	"city": "Guiyang"}, 
{
	"citycode": "KWL", 
	"airport": "Guilin Liangjiang International Airport", 
	"country": "PR China", 
	"city": "Guilin"}, 
{
	"citycode": "LHW", 
	"airport": "Lanzhou Zhongchuan International Airport", 
	"country": "Yongdeng", 
	"city": "Lanzhou Zhongchuan International Airport"}, 
{
	"citycode": "LXA", 
	"airport": "Lhasa Gonggar Airport", 
	"country": "PR China", 
	"city": "Lhasa"}, 
{
	"citycode": "LYA", 
	"airport": "Luoyang Beijiao Airport", 
	"country": "PR China", 
	"city": "Luoyang"}, 
{
	"citycode": "LYG", 
	"airport": "Lianyungang Huaguoshan Airport", 
	"country": "PR China", 
	"city": "Lianyungang"}, 
{
	"citycode": "LZH", 
	"airport": "Liuzhou Bailian Airport", 
	"country": "PR China", 
	"city": "Liuzhou"}, 
{
	"citycode": "MXZ", 
	"airport": "Meizhou Meixian Airport", 
	"country": "PR China", 
	"city": "Meixian"}, 
{
	"citycode": "NGB", 
	"airport": "Ningbo Lishe International Airport", 
	"country": "PR China", 
	"city": "Ningbo"}, 
{
	"citycode": "NKG", 
	"airport": "Nanjing Lukou International Airport", 
	"country": "PR China", 
	"city": "Nanking-Nanjing"}, 
{
	"citycode": "NNC", 
	"airport": "NANNING WUXU", 
	"country": "China", 
	"city": "NANNING WUXU"}, 
{
	"citycode": "PEK", 
	"airport": "Beijing Capital International Airport", 
	"country": "PR China", 
	"city": "Beijing"}, 
{
	"citycode": "PKX", 
	"airport": "Beijing Daxing International Airport", 
	"country": "PR China", 
	"city": "beijing"}, 
{
	"citycode": "PVG", 
	"airport": "Shanghai Pudong International Airport", 
	"country": "PR China", 
	"city": "Shanghai"}, 
{
	"citycode": "SHA", 
	"airport": "Shanghai Hongqiao International Airport", 
	"country": "PR China", 
	"city": "Shanghai"}, 
{
	"citycode": "SHE", 
	"airport": "Shenyang Taoxian International Airport", 
	"country": "PR China", 
	"city": "Shenyang"}, 
{
	"citycode": "SHP", 
	"airport": "Qinhuangdao Shanhaiguan Airport", 
	"country": "PR China", 
	"city": "Qinhuangdao"}, 
{
	"citycode": "SHS", 
	"airport": "Shashi Airport", 
	"country": "PR China", 
	"city": "Shashi"}, 
{
	"citycode": "SIA", 
	"airport": "Xi`an Xiguan Airport", 
	"country": "PR China", 
	"city": "Xi An"}, 
{
	"citycode": "SWA", 
	"airport": "Jieyang Chaoshan International Airport", 
	"country": "PR China", 
	"city": "Shantou"}, 
{
	"citycode": "SYX", 
	"airport": "Sanya Phoenix International Airport", 
	"country": "PR China", 
	"city": "Sanya"}, 
{
	"citycode": "SZX", 
	"airport": "Shenzhen Baoan International Airport", 
	"country": "PR China", 
	"city": "Shenzhen"}, 
{
	"citycode": "TAO", 
	"airport": "Qingdao International Airport", 
	"country": "PR China", 
	"city": "Qingdao"}, 
{
	"citycode": "TFU", 
	"airport": "Chengdu Tianfu International Airport", 
	"country": "PR China", 
	"city": "Chengdu"}, 
{
	"citycode": "TGO", 
	"airport": "Tongliao Airport", 
	"country": "PR China", 
	"city": "Tongliao"}, 
{
	"citycode": "TNA", 
	"airport": "Jinan Yaoqiang International Airport", 
	"country": "PR China", 
	"city": "Jinan"}, 
{
	"citycode": "TSN", 
	"airport": "Tianjin Binhai International Airport", 
	"country": "PR China", 
	"city": "Tianjin"}, 
{
	"citycode": "TXN", 
	"airport": "Huangshan Tunxi International Airport", 
	"country": "PR China", 
	"city": "Tunxi"}, 
{
	"citycode": "TYN", 
	"airport": "Taiyuan Wusu International Airport", 
	"country": "PR China", 
	"city": "Taiyuan"}, 
{
	"citycode": "URC", 
	"airport": "Urumqi Diwopu International Airport", 
	"country": "PR China", 
	"city": "Urumqi"}, 
{
	"citycode": "WNZ", 
	"airport": "Wenzhou Longwan International Airport", 
	"country": "PR China", 
	"city": "Wenzhou"}, 
{
	"citycode": "WUH", 
	"airport": "Wuhan Tianhe International Airport", 
	"country": "PR China", 
	"city": "Wuhan"}, 

{
	"citycode": "XIY", 
	"airport": "Xi`an Xianyang International Airport", 
	"country": "PR China", 
	"city": "Xi An"}, 
{
	"citycode": "XMN", 
	"airport": "Xiamen Gaoqi International Airport", 
	"country": "PR China", 
	"city": "Xiamen"}, 
{
	"citycode": "YIH", 
	"airport": "Yichang Sanxia Airport", 
	"country": "PR China", 
	"city": "Yichang"}, 
{
	"citycode": "YIW", 
	"airport": "Yiwu Airport", 
	"country": "China", 
	"city": "Yiwu"}, 
{
	"citycode": "YNT", 
	"airport": "Yantai Penglai International Airport", 
	"country": "PR China", 
	"city": "Yantai"}, 
{
	"citycode": "YNZ", 
	"airport": "Yancheng Nanyang International Airport", 
	"country": "PR China", 
	"city": "Jiangsu"}, 
{
	"citycode": "ZHA", 
	"airport": "Zhanjiang Airport", 
	"country": "PR China", 
	"city": "Zhanjiang"}, 
{
	"citycode": "AVI", 
	"airport": "Maximo Gomez Airport", 
	"country": "Cuba", 
	"city": "Ciego De Avila"}, 
{
	"citycode": "BCA", 
	"airport": "Gustavo Rizo Airport", 
	"country": "Cuba", 
	"city": "Baracoa"}, 
{
	"citycode": "BYM", 
	"airport": "Carlos Manuel de Céspedes Airport", 
	"country": "Cuba", 
	"city": "Bayamo"}, 
{
	"citycode": "CMW", 
	"airport": "Ign Agramonte International Airport", 
	"country": "Cuba", 
	"city": "Camaguey"}, 
{
	"citycode": "GAO", 
	"airport": "Los Canos Airport", 
	"country": "Cuba", 
	"city": "Guantanamo"}, 
{
	"citycode": "GER", 
	"airport": "Rafael Cabrera Airport", 
	"country": "Cuba", 
	"city": "Nueva Gerona"}, 
{
	"citycode": "HAV", 
	"airport": "Jose Marti International Airport", 
	"country": "Cuba", 
	"city": "Havana"}, 
{
	"citycode": "HOG", 
	"airport": "Frank Pais International Airport", 
	"country": "Cuba", 
	"city": "Holguin"}, 
{
	"citycode": "LCL", 
	"airport": "La Coloma Airport", 
	"country": "Cuba", 
	"city": "La Coloma"}, 
{
	"citycode": "MOA", 
	"airport": "Orestes Acosta Airport", 
	"country": "Cuba", 
	"city": "Moa"}, 
{
	"citycode": "MZO", 
	"airport": "Sierra Maestra Airport", 
	"country": "Cuba", 
	"city": "Manzanillo"}, 
{
	"citycode": "SCU", 
	"airport": "Antonio Maceo Airport", 
	"country": "Cuba", 
	"city": "Santiago"}, 
{
	"citycode": "VRA", 
	"airport": "Juan Gualberto Gomez Airport", 
	"country": "Cuba", 
	"city": "Varadero"}, 
{
	"citycode": "VTU", 
	"airport": "Hermanos Ameijeiras Airport", 
	"country": "Cuba", 
	"city": "Las Tunas"}, 
{
	"citycode": "AAL", 
	"airport": "Aalborg Airport", 
	"country": "Denmark", 
	"city": "Aalborg"}, 
{
	"citycode": "AAR", 
	"airport": "Aarhus Airport", 
	"country": "Denmark", 
	"city": "Aarhus"}, 
{
	"citycode": "BLL", 
	"airport": "Billund Airport", 
	"country": "Denmark", 
	"city": "Billund"}, 
{
	"citycode": "CPH", 
	"airport": "Copenhagen Airport", 
	"country": "Denmark", 
	"city": "Copenhagen"}, 
{
	"citycode": "EBJ", 
	"airport": "Esbjerg Airport", 
	"country": "Denmark", 
	"city": "Esbjerg"}, 
{
	"citycode": "KRP", 
	"airport": "Midtjyllands Airport", 
	"country": "Denmark", 
	"city": "Karup"}, 
{
	"citycode": "ODE", 
	"airport": "Hans Christian Andersen Airport", 
	"country": "Denmark", 
	"city": "Odense"}, 
{
	"citycode": "RKE", 
	"airport": "Roskilde Airport", 
	"country": "Denmark", 
	"city": "Copenhagen"}, 
{
	"citycode": "RNN", 
	"airport": "Bornholm Airport", 
	"country": "Denmark", 
	"city": "Bornholm"}, 
{
	"citycode": "SGD", 
	"airport": "Sonderborg Airport", 
	"country": "Denmark", 
	"city": "Sonderborg"}, 
{
	"citycode": "SKS", 
	"airport": "Skrydstrup Airport", 
	"country": "Denmark", 
	"city": "Vojens"}, 
{
	"citycode": "STA", 
	"airport": "Stauning Vestjylland Airport", 
	"country": "Denmark", 
	"city": "Stauning"}, 
{
	"citycode": "TED", 
	"airport": "Thisted Airport", 
	"country": "Denmark", 
	"city": "Thisted"}, 
{
	"citycode": "ABS", 
	"airport": "Abu Simbel Airport", 
	"country": "Egypt", 
	"city": "Abu Simbel"}, 
{
	"citycode": "ALY", 
	"airport": "El Nouzha Airport (Alexandria International Airport)", 
	"country": "Egypt", 
	"city": "Alexandria"}, 
{
	"citycode": "ASW", 
	"airport": "Aswan International Airport", 
	"country": "Egypt", 
	"city": "Aswan"}, 
{
	"citycode": "ATZ", 
	"airport": "Assiut International Airport", 
	"country": "Egypt", 
	"city": "Assiut"}, 
{
	"citycode": "ELT", 
	"airport": "El Tor-Tour Sinai Airport", 
	"country": "Egypt", 
	"city": "Tour Sinai City"}, 
{
	"citycode": "HMB", 
	"airport": "Sohag International Airport", 
	"country": "Egypt", 
	"city": "SOHAG"}, 
{
	"citycode": "HRG", 
	"airport": "Hurghada International Airport", 
	"country": "Egypt", 
	"city": "Hurghada"}, 
{
	"citycode": "LXR", 
	"airport": "Luxor International Airport", 
	"country": "Egypt", 
	"city": "Luxor"}, 
{
	"citycode": "RAF", 
	"airport": "Rafaela Aerodrome", 
	"country": "Egypt", 
	"city": "RAS AN NAQB"}, 
{
	"citycode": "SKV", 
	"airport": "Catherine International Airport", 
	"country": "Egypt", 
	"city": "Santa Katarina"}, 
{
	"citycode": "SSH", 
	"airport": "Sharm El Sheikh International Airport", 
	"country": "Egypt", 
	"city": "Sharm El Sheikh"}, 
{
	"citycode": "UVL", 
	"airport": "El Kharga Airport", 
	"country": "Egypt", 
	"city": "Kharga"}, 
{
	"citycode": "AGF", 
	"airport": "Agen La Garenne Airport", 
	"country": "France", 
	"city": "Agen"}, 
{
	"citycode": "AJA", 
	"airport": "Ajaccio Napoleon Bonaparte Airport", 
	"country": "France", 
	"city": "Ajaccio"}, 
{
	"citycode": "ANG", 
	"airport": "AngoulêmeCognac Airport", 
	"country": "France", 
	"city": "Angouleme"}, 
{
	"citycode": "AUR", 
	"airport": "Aurillac – Tronquières Airport", 
	"country": "France", 
	"city": "Aurillac"}, 
{
	"citycode": "AVN", 
	"airport": "Avignon – Provence Airport", 
	"country": "France", 
	"city": "Avignon"}, 
{
	"citycode": "BES", 
	"airport": "Brest Bretagne Airport", 
	"country": "France", 
	"city": "Brest"}, 
{
	"citycode": "BIA", 
	"airport": "Bastia – Poretta Airport", 
	"country": "France", 
	"city": "Bastia"}, 
{
	"citycode": "BIQ", 
	"airport": "Biarritz Pays Basque Airport", 
	"country": "France", 
	"city": "Biarritz"}, 
{
	"citycode": "BOD", 
	"airport": "Bordeaux Airport", 
	"country": "France", 
	"city": "Bordeaux"}, 
{
	"citycode": "BOR", 
	"airport": "Belfort Fontaine Airport", 
	"country": "France", 
	"city": "Belfort"}, 
{
	"citycode": "BVA", 
	"airport": "Beauvais-Tille Airport", 
	"country": "France", 
	"city": "Paris"}, 
{
	"citycode": "BVE", 
	"airport": "Brive–Souillac Airport", 
	"country": "France", 
	"city": "Brive-La-Gaillarde"}, 
{
	"citycode": "BZR", 
	"airport": "Beziers Vias Airport", 
	"country": "France", 
	"city": "Beziers"}, 
{
	"citycode": "CCF", 
	"airport": "Carcassonne Airport", 
	"country": "France", 
	"city": "Carcassonne"}, 
{
	"citycode": "CDG", 
	"airport": "Charles De Gaulle Airport", 
	"country": "France", 
	"city": "Paris"}, 
{
	"citycode": "CER", 
	"airport": "Cherbourg – Maupertus Airport", 
	"country": "France", 
	"city": "Cherbourg"}, 
{
	"citycode": "CFE", 
	"airport": "Clermont-Ferrand Auvergne Airport", 
	"country": "France", 
	"city": "Clermont-Ferrand"}, 
{
	"citycode": "CFR", 
	"airport": "Caen – Carpiquet Airport", 
	"country": "France", 
	"city": "Caen"}, 

{
	"citycode": "CLY", 
	"airport": "Calvi Sainte-Catherine Airport", 
	"country": "France", 
	"city": "Calvi"}, 
{
	"citycode": "CMF", 
	"airport": "Chambery Airport", 
	"country": "France", 
	"city": "Chambery"}, 
{
	"citycode": "CMR", 
	"airport": "Colmar Airport", 
	"country": "France", 
	"city": "Colmar"}, 
{
	"citycode": "CVF", 
	"airport": "Courchevel Airport", 
	"country": "France", 
	"city": "Courchevel"}, 
{
	"citycode": "DIJ", 
	"airport": "Dijon Airport", 
	"country": "France", 
	"city": "Dijon"}, 
{
	"citycode": "DNR", 
	"airport": "Dinard–Pleurtuit–Saint-Malo Airport", 
	"country": "France", 
	"city": "Dinard"}, 
{
	"citycode": "DOL", 
	"airport": "Deauville – Normandie Airport", 
	"country": "France", 
	"city": "Deauville"}, 
{
	"citycode": "EBU", 
	"airport": "Saint-Etienne–Loire Airport", 
	"country": "France", 
	"city": "St Etienne"}, 
{
	"citycode": "EGC", 
	"airport": "Bergerac Dordogne Périgord Airport", 
	"country": "France", 
	"city": "Bergerac"}, 
{
	"citycode": "EPL", 
	"airport": "Mirecourt Airport", 
	"country": "France", 
	"city": "Epinal"}, 
{
	"citycode": "ETZ", 
	"airport": "Metz-Nancy-Lorraine Airport", 
	"country": "France", 
	"city": "Metz-Nancy"}, 
{
	"citycode": "FNI", 
	"airport": "Nîmes Alès Camargue Cévennes Airport", 
	"country": "France", 
	"city": "Nimes"}, 
{
	"citycode": "FSC", 
	"airport": "Figari–Sud Corse Airport", 
	"country": "France", 
	"city": "Figari"}, 
{
	"citycode": "GNB", 
	"airport": "Grenoble Alpes Isère Airport", 
	"country": "France", 
	"city": "Grenoble"}, 
{
	"citycode": "JCA", 
	"airport": "Croisette Airport", 
	"country": "France", 
	"city": "Cannes"}, 
{
	"citycode": "JDP", 
	"airport": "Heliport De Paris Airport", 
	"country": "France", 
	"city": "Paris"}, 
{
	"citycode": "JPU", 
	"airport": "La Defense Heliport", 
	"country": "France", 
	"city": "Paris"}, 
{
	"citycode": "LAI", 
	"airport": "Lannion Airport", 
	"country": "France", 
	"city": "Lannion"}, 
{
	"citycode": "LBG", 
	"airport": "Paris le Bourget Airport", 
	"country": "France", 
	"city": "Paris"}, 
{
	"citycode": "LBI", 
	"airport": "Le Sequestre Airport", 
	"country": "France", 
	"city": "Albi"}, 
{
	"citycode": "LDE", 
	"airport": "Tarbes Lourdes Airport", 
	"country": "France", 
	"city": "Lourdes-Tarbes"}, 
{
	"citycode": "LEH", 
	"airport": "Le Havre – Octeville Airport", 
	"country": "France", 
	"city": "Le Havre"}, 
{
	"citycode": "LIL", 
	"airport": "Lille Airport", 
	"country": "France", 
	"city": "Lille"}, 
{
	"citycode": "LPY", 
	"airport": "Loudes Airport", 
	"country": "France", 
	"city": "Le Puy"}, 
{
	"citycode": "LRH", 
	"airport": "La Rochelle Airport", 
	"country": "France", 
	"city": "La Rochelle"}, 
{
	"citycode": "LRT", 
	"airport": "Lorient airport", 
	"country": "France", 
	"city": "Lorient"}, 
{
	"citycode": "LTQ", 
	"airport": "Le Touquet Airport", 
	"country": "France", 
	"city": "Le Touquet"}, 
{
	"citycode": "LYN", 
	"airport": "Lyon–Bron Airport", 
	"country": "France", 
	"city": "Lyon"}, 
{
	"citycode": "LYS", 
	"airport": "Lyon-Saint Exupery Airport", 
	"country": "France", 
	"city": "Lyon"}, 
{
	"citycode": "MCU", 
	"airport": "Montlucon – Gueret Airport", 
	"country": "France", 
	"city": "Montlucon"}, 
{
	"citycode": "MPL", 
	"airport": "Montpellier-Mediterranee Airport", 
	"country": "France", 
	"city": "Montpellier"}, 
{
	"citycode": "MRS", 
	"airport": "Marseille Airport", 
	"country": "France", 
	"city": "Marseille"}, 
{
	"citycode": "NCE", 
	"airport": "Nice Cote dAzur Airport", 
	"country": "France", 
	"city": "Nice"}, 
{
	"citycode": "NCY", 
	"airport": "Annecy-Haute-Savoie-Mont Blanc Airport", 
	"country": "France", 
	"city": "Annecy"}, 
{
	"citycode": "NTE", 
	"airport": "Nantes Atlantique Airport", 
	"country": "France", 
	"city": "Nantes"}, 
{
	"citycode": "ORY", 
	"airport": "Paris Orly Airport ", 
	"country": "France", 
	"city": "Paris"}, 
{
	"citycode": "PAR", 
	"airport": "All Airports Paris", 
	"country": "France", 
	"city": "Paris"}, 
{
	"citycode": "PGF", 
	"airport": "Perpignan-Rivesaltes (Llabanère) Airport", 
	"country": "France", 
	"city": "Perpignan"}, 
{
	"citycode": "PGX", 
	"airport": "Périgueux Bassillac Airport", 
	"country": "France", 
	"city": "Perigueux"}, 
{
	"citycode": "PIS", 
	"airport": "Poitiers–Biard Airport", 
	"country": "France", 
	"city": "Poitiers"}, 
{
	"citycode": "POX", 
	"airport": "Paris Cergy Pontoise Airport", 
	"country": "France", 
	"city": "Paris"}, 
{
	"citycode": "PUF", 
	"airport": "Pau-Pyrenees Airport", 
	"country": "France", 
	"city": "Pau"}, 
{
	"citycode": "RDZ", 
	"airport": "Rodez-Marcillac Airport", 
	"country": "France", 
	"city": "Rodez"}, 
{
	"citycode": "RHE", 
	"airport": "Reims Champagne Airport", 
	"country": "France", 
	"city": "Reims"}, 
{
	"citycode": "RNE", 
	"airport": "Roanne-Renaison Airport", 
	"country": "France", 
	"city": "Roanne"}, 
{
	"citycode": "RNS", 
	"airport": "Rennes–Saint-Jacques Airport", 
	"country": "France", 
	"city": "Rennes"}, 
{
	"citycode": "SBK", 
	"airport": "Saint-Brieuc - Armor Airport", 
	"country": "France", 
	"city": "St Brieuc"}, 
{
	"citycode": "SXB", 
	"airport": "Strasbourg Airport", 
	"country": "France", 
	"city": "Strasbourg"}, 
{
	"citycode": "SXD", 
	"airport": "Sophia Antipolis Airport", 
	"country": "France", 
	"city": "Sophia Antipolis"}, 
{
	"citycode": "TLN", 
	"airport": "Toulon–Hyeres Airport", 
	"country": "France", 
	"city": "Toulon"}, 
{
	"citycode": "TLS", 
	"airport": "Toulouse-Blagnac Airport", 
	"country": "France", 
	"city": "Toulouse"}, 
{
	"citycode": "TUF", 
	"airport": "Tours Val de Loire Airport", 
	"country": "France", 
	"city": "Tours"}, 
{
	"citycode": "UIP", 
	"airport": "Quimper–Cornouaille Airport", 
	"country": "France", 
	"city": "Quimper"}, 
{
	"citycode": "URO", 
	"airport": "Rouen Airport", 
	"country": "France", 
	"city": "Rouen"}, 
{
	"citycode": "VAF", 
	"airport": "Valence-Chabeuil Airport", 
	"country": "France", 
	"city": "Valence"}, 
{
	"citycode": "AGB", 
	"airport": "Augsburg Airport", 
	"country": "Germany", 
	"city": "Augsburg"}, 
{
	"citycode": "AGE", 
	"airport": "Wangerooge Airport", 
	"country": "Germany", 
	"city": "Wangerooge"}, 
{
	"citycode": "BER", 
	"airport": "All Airports Berlin", 
	"country": "Germany", 
	"city": "Berlin"}, 
{
	"citycode": "BMK", 
	"airport": "Borkum Airport", 
	"country": "Germany", 
	"city": "Borkum"}, 
{
	"citycode": "BRE", 
	"airport": "Bremen Airport", 
	"country": "Germany", 
	"city": "Bremen"}, 
{
	"citycode": "BRV", 
	"airport": "Bremerhaven Airport", 
	"country": "Germany", 
	"city": "Bremerhaven"}, 
{
	"citycode": "BWE", 
	"airport": "Braunschweig Wolfsburg Airport", 
	"country": "Germany", 
	"city": "Braunschweig"}, 
{
	"citycode": "BYU", 
	"airport": "Bayreuth Airport", 
	"country": "Germany", 
	"city": "Bayreuth"}, 
{
	"citycode": "CGN", 
	"airport": "Cologne Bonn Airport", 
	"country": "Germany", 
	"city": "Cologne"}, 
{
	"citycode": "DRS", 
	"airport": "Dresden Airport", 
	"country": "Germany", 
	"city": "Dresden"}, 
{
	"citycode": "DTM", 
	"airport": "Dortmund Airport", 
	"country": "Germany", 
	"city": "Dortmund"}, 
{
	"citycode": "DUS", 
	"airport": "Flughafen Dusseldorf International Airport", 
	"country": "Germany", 
	"city": "Duesseldorf"}, 
{
	"citycode": "EME", 
	"airport": "Emden Airport ", 
	"country": "Germany", 
	"city": "Emden"}, 
{
	"citycode": "ERF", 
	"airport": "Erfurt-weimar Airport", 
	"country": "Germany", 
	"city": "Erfurt"}, 
{
	"citycode": "ESS", 
	"airport": "Essen/Mülheim Airport", 
	"country": "Germany", 
	"city": "Essen"}, 
{
	"citycode": "FDH", 
	"airport": "Friedrichshafen Airport", 
	"country": "Germany", 
	"city": "Friedrichshafen"}, 
{
	"citycode": "FMO", 
	"airport": "Flughafen M?nster-Osnabr?ck", 
	"country": "Germany", 
	"city": "Muenster-Osnabrueck"}, 
{
	"citycode": "FRA", 
	"airport": "Frankfurt Airport", 
	"country": "Germany", 
	"city": "Frankfurt-Main"}, 
{
	"citycode": "GWT", 
	"airport": "Flughafen Sylt Airport", 
	"country": "Germany", 
	"city": "Westerland"}, 
{
	"citycode": "HAJ", 
	"airport": "Hannover Airport", 
	"country": "Germany", 
	"city": "Hanover"}, 
{
	"citycode": "HAM", 
	"airport": "Hamburg Airport", 
	"country": "Germany", 
	"city": "Hamburg"}, 
{
	"citycode": "HEI", 
	"airport": "Heide-Buesum Airport", 
	"country": "Germany", 
	"city": "Heide-Buesum"}, 
{
	"citycode": "HGL", 
	"airport": "Heligoland Airport", 
	"country": "Germany", 
	"city": "Helgoland"}, 
{
	"citycode": "HOQ", 
	"airport": "Hof–Plauen Airport", 
	"country": "Germany", 
	"city": "Hof"}, 
{
	"citycode": "JUI", 
	"airport": "Juist Airport", 
	"country": "Germany", 
	"city": "Juist"}, 
{
	"citycode": "KEL", 
	"airport": "Kiel Airport", 
	"country": "Germany", 
	"city": "Kiel"}, 
{
	"citycode": "LEJ", 
	"airport": "Leipzig Airport", 
	"country": "Germany", 
	"city": "Leipzig"}, 
{
	"citycode": "MGL", 
	"airport": "Monchengladbach Airport", 
	"country": "Germany", 
	"city": "Dusseldorf"}, 
{
	"citycode": "MUC", 
	"airport": "Munich Airport", 
	"country": "Germany", 
	"city": "Munich"}, 
{
	"citycode": "NRD", 
	"airport": "Norderney Airport", 
	"country": "Germany", 
	"city": "Norderney"}, 
{
	"citycode": "NUE", 
	"airport": "Nuremberg Airport", 
	"country": "Germany", 
	"city": "NUERNBERG"}, 
{
	"citycode": "OBF", 
	"airport": "Oberpfaffenhofen Airport", 
	"country": "Germany", 
	"city": "Oberpfaffenhofen"}, 
{
	"citycode": "OHR", 
	"airport": "O`Hare International Airport", 
	"country": "Germany", 
	"city": "Wyk auf Foehr"}, 
{
	"citycode": "PAD", 
	"airport": "Paderborn Lippstadt Airport", 
	"country": "Germany", 
	"city": "Paderborn"}, 
{
	"citycode": "SCN", 
	"airport": "Saarbrucken Airport", 
	"country": "Germany", 
	"city": "Saarbruecken"}, 
{
	"citycode": "STR", 
	"airport": "Stuttgart Airport", 
	"country": "Germany", 
	"city": "Stuttgart"}, 
{
	"citycode": "SXF", 
	"airport": "Berlin Schonefeld Airport", 
	"country": "Germany", 
	"city": "Berlin"}, 
{
	"citycode": "THF", 
	"airport": "Tempelhof Airport", 
	"country": "Germany", 
	"city": "Berlin"}, 
{
	"citycode": "TXL", 
	"airport": "Berlin Tegel Airport", 
	"country": "Germany", 
	"city": "Berlin"}, 
{
	"citycode": "XFW", 
	"airport": "Hamburg-Finkenwerder Airport", 
	"country": "Germany", 
	"city": "Finkenwerder"}, 
{
	"citycode": "AOK", 
	"airport": "Karpathos Airport", 
	"country": "Greece", 
	"city": "Karpathos"}, 
{
	"citycode": "ATH", 
	"airport": "Athens International Airport", 
	"country": "Greece", 
	"city": "Athens"}, 
{
	"citycode": "AXD", 
	"airport": "Alexandroupolis Airport Democritus", 
	"country": "Greece", 
	"city": "Alexandroupolis"}, 
{
	"citycode": "CFU", 
	"airport": "Corfu International Airport", 
	"country": "Greece", 
	"city": "Kerkyra"}, 
{
	"citycode": "CHQ", 
	"airport": "Chania International Airport", 
	"country": "Greece", 
	"city": "Chania"}, 
{
	"citycode": "EFL", 
	"airport": "Kefalonia International Airport", 
	"country": "Greece", 
	"city": "Kefallinia"}, 
{
	"citycode": "GPA", 
	"airport": "Araxos Airport", 
	"country": "Greece", 
	"city": "Patras"}, 
{
	"citycode": "HER", 
	"airport": "Heraklion International Airport", 
	"country": "Greece", 
	"city": "Heraklion"}, 
{
	"citycode": "IOA", 
	"airport": "Ioannina ?ational Airport", 
	"country": "Greece", 
	"city": "Ioannina"}, 
{
	"citycode": "JKH", 
	"airport": "Chios Island National Airport", 
	"country": "Greece", 
	"city": "Chios"}, 
{
	"citycode": "JMK", 
	"airport": "Mykonos Airport", 
	"country": "Greece", 
	"city": "Mikonos"}, 
{
	"citycode": "JSH", 
	"airport": "Sitia Airport", 
	"country": "Greece", 
	"city": "Sitia"}, 
{
	"citycode": "JSI", 
	"airport": "Skiathos Alexandros Papadiamantis Airport", 
	"country": "Greece", 
	"city": "Skiathos"}, 
{
	"citycode": "JTR", 
	"airport": "Santorini (Thira) International Airport", 
	"country": "Greece", 
	"city": "Thira"}, 
{
	"citycode": "KGS", 
	"airport": "Kos International Airport", 
	"country": "Greece", 
	"city": "Kos"}, 
{
	"citycode": "KIT", 
	"airport": "Kithira Island National Airport", 
	"country": "Greece", 
	"city": "Kithira"}, 
{
	"citycode": "KLX", 
	"airport": "Kalamata International Airport", 
	"country": "Greece", 
	"city": "Kalamata"}, 
{
	"citycode": "KSJ", 
	"airport": "Kasos Island Public Airport", 
	"country": "Greece", 
	"city": "Kasos Island"}, 
{
	"citycode": "KSO", 
	"airport": "Kastoria National Airport", 
	"country": "Greece", 
	"city": "Kastoria"}, 
{
	"citycode": "KVA", 
	"airport": "Kavala Airport Alexander the Great", 
	"country": "Greece", 
	"city": "Kavala"}, 
{
	"citycode": "KZI", 
	"airport": "Philippos Airport", 
	"country": "Greece", 
	"city": "Kozani"}, 
{
	"citycode": "KZS", 
	"airport": "Kastelorizo Airport", 
	"country": "Greece", 
	"city": "Kastelorizo"}, 
{
	"citycode": "LRA", 
	"airport": "Larissa National Airport", 
	"country": "Greece", 
	"city": "Larisa"}, 
{
	"citycode": "LRS", 
	"airport": "Leros Municipal Airport", 
	"country": "Greece", 
	"city": "Leros"}, 
{
	"citycode": "LXS", 
	"airport": "Lemnos International Airport", 
	"country": "Greece", 
	"city": "Lemnos"}, 
{
	"citycode": "MJT", 
	"airport": "Mytilene International Airport", 
	"country": "Greece", 
	"city": "Mytilene"}, 
{
	"citycode": "MLO", 
	"airport": "Milos Island National Airport", 
	"country": "Greece", 
	"city": "Milos"}, 
{
	"citycode": "PAS", 
	"airport": "New Paros Airport", 
	"country": "Greece", 
	"city": "Paros"}, 
{
	"citycode": "PVK", 
	"airport": "Aktion National Airport", 
	"country": "Greece", 
	"city": "Preveza-Lefkas"}, 
{
	"citycode": "PYR", 
	"airport": "Andravida Airport", 
	"country": "Greece", 
	"city": "Pyrgos"}, 
{
	"citycode": "RHO", 
	"airport": "Rhodes Diagoras International Airport", 
	"country": "Greece", 
	"city": "Rhodes"}, 
{
	"citycode": "SKG", 
	"airport": "Thessaloniki Airport", 
	"country": "Greece", 
	"city": "Thessaloniki"}, 
{
	"citycode": "SKU", 
	"airport": "Skyros Island National Airport", 
	"country": "Greece", 
	"city": "Skiros"}, 
{
	"citycode": "SMI", 
	"airport": "Samos Airport", 
	"country": "Greece", 
	"city": "Samos"}, 
{
	"citycode": "VOL", 
	"airport": "Nea Anchialos National Airport", 
	"country": "Greece", 
	"city": "Volos"}, 
{
	"citycode": "ZTH", 
	"airport": "Zakynthos International Airport", 
	"country": "Greece", 
	"city": "Zakinthos Island"}, 
{
	"citycode": "HHP", 
	"airport": "H K Heliport", 
	"country": "Hong Kong, PR China", 
	"city": "Hong Kong"}, 
{
	"citycode": "HKG", 
	"airport": "Hong Kong International Airport", 
	"country": "Hong Kong, PR China", 
	"city": "Hong Kong"}, 
{
	"citycode": "BUD", 
	"airport": "Budapest Ferenc Liszt International Airport", 
	"country": "Hungary", 
	"city": "Budapest"}, 
{
	"citycode": "ABU", 
	"airport": "Atambua", 
	"country": "Indonesia", 
	"city": "Atambua"}, 
{
	"citycode": "AMI", 
	"airport": "Selaparang Airport", 
	"country": "Indonesia", 
	"city": "Mataram"}, 
{
	"citycode": "AMQ", 
	"airport": "Pattimura Airport", 
	"country": "Indonesia", 
	"city": "Ambon"}, 
{
	"citycode": "ARD", 
	"airport": "Alor Island Airport", 
	"country": "Indonesia", 
	"city": "Alor Island"}, 
{
	"citycode": "AYW", 
	"airport": "Ayawasi Airport", 
	"country": "Indonesia", 
	"city": "Ayawasi"}, 
{
	"citycode": "BDJ", 
	"airport": "Syamsudin Noor International Airport", 
	"country": "Indonesia", 
	"city": "Banjarmasin"}, 
{
	"citycode": "BDO", 
	"airport": "Husein Sastranegara International Airport", 
	"country": "Indonesia", 
	"city": "Bandung"}, 
{
	"citycode": "BEJ", 
	"airport": "Raja Alam International Airport ", 
	"country": "Indonesia", 
	"city": "Berau"}, 
{
	"citycode": "BIK", 
	"airport": "Frans Kaisiepo International Airport", 
	"country": "Indonesia", 
	"city": "Biak"}, 
{
	"citycode": "BJW", 
	"airport": "Bajawa Soa Airport", 
	"country": "Indonesia", 
	"city": "Bajawa"}, 
{
	"citycode": "BKS", 
	"airport": "Fatmawati Soekarno Airport", 
	"country": "Indonesia", 
	"city": "Bengkulu"}, 
{
	"citycode": "BMU", 
	"airport": "Sultan Muhammad Salahuddin Airport", 
	"country": "Indonesia", 
	"city": "Bima"}, 
{
	"citycode": "BPN", 
	"airport": "Sultan Aji Muhammad Sulaiman Sepinggan International Airport", 
	"country": "Indonesia", 
	"city": "Balikpapan"}, 
{
	"citycode": "BTH", 
	"airport": "Hang Nadim International Airport", 
	"country": "Indonesia", 
	"city": "Batam"}, 
{
	"citycode": "BTJ", 
	"airport": "Sultan Iskandar Muda International Airport", 
	"country": "Indonesia", 
	"city": "Banda Aceh"}, 
{
	"citycode": "BUI", 
	"airport": "Bokondini Airport", 
	"country": "Indonesia", 
	"city": "Bokondini"}, 
{
	"citycode": "BUW", 
	"airport": "Bandar Udara Betoambari Baubau", 
	"country": "Indonesia", 
	"city": "Baubau"}, 
{
	"citycode": "BWX", 
	"airport": "Banyuwangi Airport", 
	"country": "Indonesia", 
	"city": "Blimbingsari"}, 
{
	"citycode": "BXB", 
	"airport": "Babo Airport", 
	"country": "Indonesia", 
	"city": "Babo"}, 
{
	"citycode": "BXD", 
	"airport": "Bade Airport", 
	"country": "Indonesia", 
	"city": "Bade"}, 
{
	"citycode": "BXM", 
	"airport": "Bandar Udara Batom Airport", 
	"country": "Indonesia", 
	"city": "Batom"}, 
{
	"citycode": "CBN", 
	"airport": "Cakrabhuwana Airport", 
	"country": "Indonesia", 
	"city": "Cirebon"}, 
{
	"citycode": "CGK", 
	"airport": "Soekarno-Hatta International Airport", 
	"country": "Indonesia", 
	"city": "Jakarta"}, 
{
	"citycode": "CXP", 
	"airport": "Tunggul Wulung Airport", 
	"country": "Indonesia", 
	"city": "Cilacap"}, 
{
	"citycode": "DJB", 
	"airport": "Sultan Taha Syarifudn Airport", 
	"country": "Indonesia", 
	"city": "Jambi"}, 
{
	"citycode": "DJJ", 
	"airport": "Dortheys Hiyo Eluay International Airport", 
	"country": "Indonesia", 
	"city": "Jayapura"}, 
{
	"citycode": "DPS", 
	"airport": "I Gusti Ngurah Rai International Airport", 
	"country": "Indonesia", 
	"city": "Denpasar Bali"}, 
{
	"citycode": "DTD", 
	"airport": "Datah Dawai Airport", 
	"country": "Indonesia", 
	"city": "Datadawai"}, 
{
	"citycode": "DUM", 
	"airport": "Pinang Kampai Airport", 
	"country": "Indonesia", 
	"city": "Dumai"}, 
{
	"citycode": "ENE", 
	"airport": "Hasan Aroeboesman Airport ", 
	"country": "Indonesia", 
	"city": "Ende"}, 
{
	"citycode": "EWI", 
	"airport": "Enarotali Airport", 
	"country": "Indonesia", 
	"city": "Enarotali"}, 
{
	"citycode": "FKQ", 
	"airport": "Fakfak Torea Airport", 
	"country": "Indonesia", 
	"city": "Fak Fak"}, 
{
	"citycode": "FOO", 
	"airport": "Numfoor Airport", 
	"country": "Indonesia", 
	"city": "Numfoor"}, 
{
	"citycode": "GEB", 
	"airport": "Gebe Airport", 
	"country": "Indonesia", 
	"city": "Gebe"}, 
{
	"citycode": "GLX", 
	"airport": "Gamar Malamo Airport", 
	"country": "Indonesia", 
	"city": "Galela"}, 
{
	"citycode": "GTO", 
	"airport": "Jalaluddin Airport", 
	"country": "Indonesia", 
	"city": "Gorontalo"}, 
{
	"citycode": "HLP", 
	"airport": "Halim Perdanakusuma International Airport", 
	"country": "Indonesia", 
	"city": "Jakarta"}, 
{
	"citycode": "ILA", 
	"airport": "Illaga Airport", 
	"country": "Indonesia", 
	"city": "Illaga"}, 
{
	"citycode": "INX", 
	"airport": "Inanwatan Airport", 
	"country": "Indonesia", 
	"city": "Inanwatan"}, 
{
	"citycode": "IUL", 
	"airport": "Ilu Airport", 
	"country": "Indonesia", 
	"city": "Ilu"}, 
{
	"citycode": "JKT", 
	"airport": "Jakarta Airport", 
	"country": "Indonesia", 
	"city": "Jakarta"}, 
{
	"citycode": "JOG", 
	"airport": "Adisutjipto International Airport", 
	"country": "Indonesia", 
	"city": "Yogyakarta"}, 
{
	"citycode": "KAZ", 
	"airport": "Kaubang Airport", 
	"country": "Indonesia", 
	"city": "Kau"}, 
{
	"citycode": "KBX", 
	"airport": "Kambuaya Airport", 
	"country": "Indonesia", 
	"city": "Kambuaya"}, 
{
	"citycode": "KDI", 
	"airport": "Haluoleo Airport ", 
	"country": "Indonesia", 
	"city": "Kendari"}, 
{
	"citycode": "KEA", 
	"airport": "Kerki International Airport", 
	"country": "Indonesia", 
	"city": "Keisah"}, 
{
	"citycode": "KEQ", 
	"airport": "Kebar Airport", 
	"country": "Indonesia", 
	"city": "Kebar"}, 
{
	"citycode": "KMM", 
	"airport": "Kimam Airport", 
	"country": "Indonesia", 
	"city": "Kimam"}, 
{
	"citycode": "KNG", 
	"airport": "Kaimana Airport", 
	"country": "Indonesia", 
	"city": "Kaimana"}, 
{
	"citycode": "KNO", 
	"airport": "Kualanamu International Airport", 
	"country": "Indonesia", 
	"city": "Kualanamu International Airport"}, 
{
	"citycode": "KOE", 
	"airport": "El Tari International Airport", 
	"country": "Indonesia", 
	"city": "Kupang"}, 
{
	"citycode": "KTG", 
	"airport": "Rahadi Oesman Airport", 
	"country": "Indonesia", 
	"city": "Ketapang"}, 
{
	"citycode": "LBJ", 
	"airport": "Komodo Airport", 
	"country": "Indonesia", 
	"city": "Labuan Bajo"}, 
{
	"citycode": "LBW", 
	"airport": "Yuvai Semaring Airport", 
	"country": "Indonesia", 
	"city": "Long Bawan"}, 
{
	"citycode": "LHI", 
	"airport": "Lereh Airport", 
	"country": "Indonesia", 
	"city": "Lereh"}, 
{
	"citycode": "LII", 
	"airport": "Mulia Airport", 
	"country": "Indonesia", 
	"city": "Mulia"}, 
{
	"citycode": "LKA", 
	"airport": "Gewayantana Airport", 
	"country": "Indonesia", 
	"city": "Larantuka"}, 
{
	"citycode": "LLN", 
	"airport": "Kelila Airport", 
	"country": "Indonesia", 
	"city": "Kelila"}, 
{
	"citycode": "LOP", 
	"airport": "Lombok International Airport", 
	"country": "Indonesia", 
	"city": "LOMBOK INTERNATIONAL"}, 
{
	"citycode": "LPU", 
	"airport": "Long Ampung Airport", 
	"country": "Indonesia", 
	"city": "Long Apung"}, 
{
	"citycode": "LUW", 
	"airport": "Syukuran Aminuddin Amir Airport", 
	"country": "Indonesia", 
	"city": "Luwuk"}, 
{
	"citycode": "LWE", 
	"airport": "Lewoleba Airport", 
	"country": "Indonesia", 
	"city": "Lewoleba"}, 
{
	"citycode": "MAL", 
	"airport": "Malone-Dufort Airport", 
	"country": "Indonesia", 
	"city": "Mangole"}, 
{
	"citycode": "MDC", 
	"airport": "Sam Ratulangi International Airport", 
	"country": "Indonesia", 
	"city": "Manado"}, 
{
	"citycode": "MDP", 
	"airport": "Mindiptana Airport", 
	"country": "Indonesia", 
	"city": "Mindiptana"}, 
{
	"citycode": "MES", 
	"airport": "Polonia International Airport", 
	"country": "Indonesia", 
	"city": "Medan"}, 
{
	"citycode": "MKQ", 
	"airport": "Mopah International Airport", 
	"country": "Indonesia", 
	"city": "Merauke"}, 
{
	"citycode": "MKW", 
	"airport": "Rendani Airport", 
	"country": "Indonesia", 
	"city": "Manokwari"}, 
{
	"citycode": "MLG", 
	"airport": "Abdul Rachman Saleh Airport", 
	"country": "Indonesia", 
	"city": "Malang"}, 
{
	"citycode": "MNA", 
	"airport": "Melangguane Airport", 
	"country": "Indonesia", 
	"city": "Melangguane"}, 
{
	"citycode": "MPT", 
	"airport": "Maliana Airport", 
	"country": "Indonesia", 
	"city": "Maliana"}, 
{
	"citycode": "MUF", 
	"airport": "Muting Airport", 
	"country": "Indonesia", 
	"city": "Muting"}, 
{
	"citycode": "NBX", 
	"airport": "Douw Aturure Airport", 
	"country": "Indonesia", 
	"city": "Nabire"}, 
{
	"citycode": "NTI", 
	"airport": "Stenkol Airport", 
	"country": "Indonesia", 
	"city": "Bintuni"}, 
{
	"citycode": "OBD", 
	"airport": "Cordoba Airport ", 
	"country": "Indonesia", 
	"city": "Obano"}, 
{
	"citycode": "OEC", 
	"airport": "Oecussi International Airport", 
	"country": "Indonesia", 
	"city": "Ocussi"}, 
{
	"citycode": "OKL", 
	"airport": "Oksibil Airport", 
	"country": "Indonesia", 
	"city": "Oksibil"}, 
{
	"citycode": "OKQ", 
	"airport": "Okaba Airport", 
	"country": "Indonesia", 
	"city": "Okaba"}, 
{
	"citycode": "ONI", 
	"airport": "Moanamani Airport", 
	"country": "Indonesia", 
	"city": "Moanamani"}, 
{
	"citycode": "OTI", 
	"airport": "Morotai Island Airport", 
	"country": "Indonesia", 
	"city": "Morotai Island"}, 
{
	"citycode": "PDG", 
	"airport": "Minangkabau International Airport", 
	"country": "Indonesia", 
	"city": "Padang"}, 
{
	"citycode": "PGK", 
	"airport": "Depati Amir Airport", 
	"country": "Indonesia", 
	"city": "Pangkalpinang"}, 
{
	"citycode": "PKN", 
	"airport": "Iskandar Airport", 
	"country": "Indonesia", 
	"city": "Pangkalanbuun"}, 
{
	"citycode": "PKU", 
	"airport": "Sultan Syarif Kasim II International Airport", 
	"country": "Indonesia", 
	"city": "Pekanbaru"}, 
{
	"citycode": "PKY", 
	"airport": "Tjilik Riwut Airport", 
	"country": "Indonesia", 
	"city": "Palangkaraya"}, 
{
	"citycode": "PLM", 
	"airport": "Sultan Mahmud Badaruddin II International Airport", 
	"country": "Indonesia", 
	"city": "Palembang"}, 
{
	"citycode": "PLW", 
	"airport": "Mutiara SIS Al-Jufrie Airport", 
	"country": "Indonesia", 
	"city": "Palu"}, 
{
	"citycode": "PNK", 
	"airport": "Supadio International Airport", 
	"country": "Indonesia", 
	"city": "Pontianak"}, 
{
	"citycode": "PSJ", 
	"airport": "Kasiguncu Airport", 
	"country": "Indonesia", 
	"city": "Poso"}, 
{
	"citycode": "PUM", 
	"airport": "Pomala Airport", 
	"country": "Indonesia", 
	"city": "Pomala"}, 
{
	"citycode": "RDE", 
	"airport": "Merdei Airport", 
	"country": "Indonesia", 
	"city": "Merdey"}, 
{
	"citycode": "RGT", 
	"airport": "Japura Airport", 
	"country": "Indonesia", 
	"city": "Rengat"}, 
{
	"citycode": "RTG", 
	"airport": "Frans Sales Lega Airport", 
	"country": "Indonesia", 
	"city": "Ruteng"}, 
{
	"citycode": "RTI", 
	"airport": "David Constantijn Saudale Airport", 
	"country": "Indonesia", 
	"city": "Roti"}, 
{
	"citycode": "SAU", 
	"airport": "Sawu Airport", 
	"country": "Indonesia", 
	"city": "Sawu"}, 
{
	"citycode": "SEH", 
	"airport": "Senggeh Airport", 
	"country": "Indonesia", 
	"city": "Senggeh"}, 
{
	"citycode": "SIQ", 
	"airport": "Dabo Airport", 
	"country": "Indonesia", 
	"city": "Singkep"}, 
{
	"citycode": "SOC", 
	"airport": "Adisumarmo International Airport", 
	"country": "Indonesia", 
	"city": "Solo City"}, 
{
	"citycode": "SOQ", 
	"airport": "Domine Eduard Osok Airport", 
	"country": "Indonesia", 
	"city": "Sorong"}, 
{
	"citycode": "SRG", 
	"airport": "Jenderal Ahmad Yani International Airport", 
	"country": "Indonesia", 
	"city": "Semarang"}, 
{
	"citycode": "SRI", 
	"airport": "Samarinda Airport", 
	"country": "Indonesia", 
	"city": "Samarinda"}, 
{
	"citycode": "SUB", 
	"airport": "Juanda International Airport", 
	"country": "Indonesia", 
	"city": "Surabaya"}, 
{
	"citycode": "SWQ", 
	"airport": "Sultan Muhammad Kaharuddin III Airport", 
	"country": "Indonesia", 
	"city": "Sumbawa"}, 
{
	"citycode": "TIM", 
	"airport": "Mozes Kilangin International Airport", 
	"country": "Indonesia", 
	"city": "Tembagapura"}, 
{
	"citycode": "TJQ", 
	"airport": "Hanandjoeddin International Airport", 
	"country": "Indonesia", 
	"city": "Tanjung Pandan"}, 
{
	"citycode": "TJS", 
	"airport": "Tanjung Harapan Airport", 
	"country": "Indonesia", 
	"city": "Tanjung Selor"}, 
{
	"citycode": "TKG", 
	"airport": "Radin Inten II Airport", 
	"country": "Indonesia", 
	"city": "Bandar Lampung"}, 
{
	"citycode": "TLI", 
	"airport": "Sultan Bantilan Airport", 
	"country": "Indonesia", 
	"city": "Tolitoli"}, 
{
	"citycode": "TMC", 
	"airport": "Tambolaka Airport", 
	"country": "Indonesia", 
	"city": "Tambolaka"}, 
{
	"citycode": "TMH", 
	"airport": "Tanah Merah Airport", 
	"country": "Indonesia", 
	"city": "Tanahmerah"}, 
{
	"citycode": "TMY", 
	"airport": "Tiom Airport", 
	"country": "Indonesia", 
	"city": "Tiom"}, 
{
	"citycode": "TNJ", 
	"airport": "Raja Haji Fisabilillah International Airport", 
	"country": "Indonesia", 
	"city": "Tanjung Pinang"}, 
{
	"citycode": "TRK", 
	"airport": "Juwata International Airport", 
	"country": "Indonesia", 
	"city": "Tarakan"}, 
{
	"citycode": "TTE", 
	"airport": "Sultan Babullah Airport", 
	"country": "Indonesia", 
	"city": "Ternate"}, 
{
	"citycode": "TTR", 
	"airport": "Tana Toraja Airport", 
	"country": "Indonesia", 
	"city": "Tana Toraja"}, 
{
	"citycode": "TXM", 
	"airport": "Teminabuan Airport", 
	"country": "Indonesia", 
	"city": "Teminabuan"}, 
{
	"citycode": "UOL", 
	"airport": "Pogogul Airport", 
	"country": "Indonesia", 
	"city": "Buol"}, 
{
	"citycode": "UPG", 
	"airport": "Sultan Hasanuddin International Airport", 
	"country": "Indonesia", 
	"city": "Ujung Pandang"}, 
{
	"citycode": "WET", 
	"airport": "Wagethe Airport", 
	"country": "Indonesia", 
	"city": "Wagethe"}, 
{
	"citycode": "WGP", 
	"airport": "Umbu Mehang Kunda Airport", 
	"country": "Indonesia", 
	"city": "Waingapu"}, 
{
	"citycode": "WMX", 
	"airport": "Wamena Airport", 
	"country": "Indonesia", 
	"city": "Wamena"}, 
{
	"citycode": "ZRI", 
	"airport": "Stevanus Rumbewas Airport ", 
	"country": "Indonesia", 
	"city": "Serui"}, 
{
	"citycode": "ZRM", 
	"airport": "Sarmi Airport", 
	"country": "Indonesia", 
	"city": "Sarmi"}, 
{
	"citycode": "ABD", 
	"airport": "Abadan International Airport", 
	"country": "Iran", 
	"city": "Abadan"}, 
{
	"citycode": "AWZ", 
	"airport": "Ahvaz International Airport", 
	"country": "Iran", 
	"city": "Ahwaz"}, 
{
	"citycode": "AZD", 
	"airport": "Yazd Sadooghi International Airport", 
	"country": "Iran", 
	"city": "Yazd"}, 
{
	"citycode": "BDH", 
	"airport": "Bandar Lengeh International Airport", 
	"country": "Iran", 
	"city": "Bandar Lengeh"}, 
{
	"citycode": "BND", 
	"airport": "Bandar Abbas International Airport", 
	"country": "Iran", 
	"city": "Bandar Abbas"}, 
{
	"citycode": "BUZ", 
	"airport": "Bushehr International Airport", 
	"country": "Iran", 
	"city": "Bushehr"}, 
{
	"citycode": "IFN", 
	"airport": "Isfahan International Airport ", 
	"country": "Iran", 
	"city": "Isfahan"}, 
{
	"citycode": "IKA", 
	"airport": "Imam Khomeini International Airport", 
	"country": "Iran", 
	"city": "Tehran"}, 
{
	"citycode": "KER", 
	"airport": "Kerman International Airport", 
	"country": "Iran", 
	"city": "Kerman"}, 
{
	"citycode": "KIH", 
	"airport": "Kish International Airport", 
	"country": "Iran", 
	"city": "Kish Island"}, 
{
	"citycode": "KSH", 
	"airport": "Kermanshah Airport", 
	"country": "Iran", 
	"city": "Kermanshah"}, 
{
	"citycode": "LRR", 
	"airport": "Larestan International Airport", 
	"country": "Iran", 
	"city": "Lar"}, 
{
	"citycode": "MHD", 
	"airport": "Mashhad Shahid Hasheminejad International Airport", 
	"country": "Iran", 
	"city": "Mashad"}, 
{
	"citycode": "OMH", 
	"airport": "Urmia International Airport", 
	"country": "Iran", 
	"city": "Urmieh"}, 
{
	"citycode": "RAS", 
	"airport": "Sardar Jangal Rasht International Airport", 
	"country": "Iran", 
	"city": "Rasht"}, 
{
	"citycode": "SYZ", 
	"airport": "Shiraz International Airport", 
	"country": "Iran", 
	"city": "Shiraz"}, 
{
	"citycode": "TBZ", 
	"airport": "Tabriz Shahid Madani International Airport", 
	"country": "Iran", 
	"city": "Tabriz"}, 
{
	"citycode": "THR", 
	"airport": "Mehrabad International Airport", 
	"country": "Iran", 
	"city": "Tehran"}, 
{
	"citycode": "ZAH", 
	"airport": "Zahedan Airport", 
	"country": "Iran", 
	"city": "Zahedan"}, 
{
	"citycode": "ZBR", 
	"airport": "Chabahar Konarak Airport", 
	"country": "Iran", 
	"city": "Chah-Bahar"}, 
{
	"citycode": "BGW", 
	"airport": "Baghdad International Airport", 
	"country": "Iraq", 
	"city": "Baghdad"}, 
{
	"citycode": "BSR", 
	"airport": "Basrah International Airport", 
	"country": "Iraq", 
	"city": "Basra"}, 
{
	"citycode": "EBL", 
	"airport": "Erbil International Airport", 
	"country": "Iraq", 
	"city": "Erbil"}, 
{
	"citycode": "ISU", 
	"airport": "Sulaimaniyah International Airport", 
	"country": "Iraq", 
	"city": "SULAYMANIYAH INTERNATIONAL"}, 
{
	"citycode": "NJF", 
	"airport": "Najaf International Airport", 
	"country": "Iraq", 
	"city": "NAJAF"}, 
{
	"citycode": "CFN", 
	"airport": "Donegal Airport", 
	"country": "Ireland", 
	"city": "Donegal"}, 
{
	"citycode": "DUB", 
	"airport": "Dublin Airport", 
	"country": "Ireland", 
	"city": "Dublin"}, 
{
	"citycode": "GWY", 
	"airport": "Galway Airport", 
	"country": "Ireland", 
	"city": "Galway"}, 
{
	"citycode": "IIA", 
	"airport": "Inishmaan Aerodrome", 
	"country": "Ireland", 
	"city": "Inishmaan"}, 
{
	"citycode": "INQ", 
	"airport": "Inisheer Airport", 
	"country": "Ireland", 
	"city": "Inisheer"}, 
{
	"citycode": "IOR", 
	"airport": "Inishmore Airport", 
	"country": "Ireland", 
	"city": "Inishmore"}, 
{
	"citycode": "KIR", 
	"airport": "Kerry Airport", 
	"country": "Ireland", 
	"city": "Kerry County"}, 
{
	"citycode": "NOC", 
	"airport": "Ireland West Airport", 
	"country": "Ireland", 
	"city": "Knock"}, 
{
	"citycode": "ORK", 
	"airport": "Cork Airport", 
	"country": "Ireland", 
	"city": "Cork"}, 
{
	"citycode": "SNN", 
	"airport": "Shannon Airport", 
	"country": "Ireland", 
	"city": "Shannon"}, 
{
	"citycode": "SXL", 
	"airport": "Sligo Airport", 
	"country": "Ireland", 
	"city": "Sligo"}, 
{
	"citycode": "WAT", 
	"airport": "Waterford Airport", 
	"country": "Ireland", 
	"city": "Waterford"}, 
{
	"citycode": "AEY", 
	"airport": "Akureyri International Airport", 
	"country": "Iceland", 
	"city": "Akureyri"}, 
{
	"citycode": "BGJ", 
	"airport": "Borgarfjordur Airport", 
	"country": "Iceland", 
	"city": "Borgarfjordur Eystri"}, 
{
	"citycode": "BJD", 
	"airport": "Bakkafjordur Airport", 
	"country": "Iceland", 
	"city": "Bakkafjordur"}, 
{
	"citycode": "BXV", 
	"airport": "Breiddalsvik Airport", 
	"country": "Iceland", 
	"city": "Breiddalsvik"}, 
{
	"citycode": "EGS", 
	"airport": "Egilsstadir Airport", 
	"country": "Iceland", 
	"city": "Egilsstadir"}, 
{
	"citycode": "ETH", 
	"airport": "Elat Airport", 
	"country": "Israel", 
	"city": "Elat"}, 
{
	"citycode": "GRY", 
	"airport": "Grimsey Airport", 
	"country": "Iceland", 
	"city": "Grimsey"}, 
{
	"citycode": "HFA", 
	"airport": "Haifa Airport", 
	"country": "Israel", 
	"city": "Haifa"}, 
{
	"citycode": "HFN", 
	"airport": "Hornafjordur Airport", 
	"country": "Iceland", 
	"city": "Hornafjordur"}, 
{
	"citycode": "HZK", 
	"airport": "Husavik Airport", 
	"country": "Iceland", 
	"city": "Husavik"}, 
{
	"citycode": "IFJ", 
	"airport": "Isafjordur Airport", 
	"country": "Iceland", 
	"city": "Isafjordur"}, 
{
	"citycode": "JRS", 
	"airport": "Jerusalem International Airport", 
	"country": "Israel", 
	"city": "Jerusalem"}, 
{
	"citycode": "KEF", 
	"airport": "Keflavik International Airport", 
	"country": "Iceland", 
	"city": "Reykjavik"}, 
{
	"citycode": "MTZ", 
	"airport": "Bar Yehuda Airfield", 
	"country": "Israel", 
	"city": "Masada"}, 
{
	"citycode": "NOR", 
	"airport": "Nordfjordur Airport", 
	"country": "Iceland", 
	"city": "Nordfjordur"}, 
{
	"citycode": "OFJ", 
	"airport": "Olafsfjordur Airport", 
	"country": "Iceland", 
	"city": "Olafsfjordur"}, 
{
	"citycode": "OPA", 
	"airport": "Kopasker Airport", 
	"country": "Iceland", 
	"city": "Kopasker"}, 
{
	"citycode": "PFJ", 
	"airport": "Patreksfjordur Airport", 
	"country": "Iceland", 
	"city": "Patreksfjordur"}, 
{
	"citycode": "REK", 
	"airport": "Reykjav?k - All Airports", 
	"country": "Iceland", 
	"city": "Reykjavik"}, 
{
	"citycode": "RFN", 
	"airport": "Raufarhofn Airport", 
	"country": "Iceland", 
	"city": "Raufarhofn"}, 
{
	"citycode": "RPN", 
	"airport": "Rosh Pina Airport", 
	"country": "Israel", 
	"city": "Rosh Pina"}, 
{
	"citycode": "SAK", 
	"airport": "Saudarkrokur Airport", 
	"country": "Iceland", 
	"city": "Saudarkrokur"}, 
{
	"citycode": "SDV", 
	"airport": "Sde Dov Airport", 
	"country": "Israel", 
	"city": "Tel Aviv Yafo"}, 
{
	"citycode": "SIJ", 
	"airport": "Siglufjordur Airport", 
	"country": "Iceland", 
	"city": "Siglufjordur"}, 
{
	"citycode": "TEY", 
	"airport": "Thingeyri Airport", 
	"country": "Iceland", 
	"city": "Thingeyri"}, 
{
	"citycode": "THO", 
	"airport": "Thorshofn Airport", 
	"country": "Iceland", 
	"city": "Thorshofn"}, 
{
	"citycode": "TLV", 
	"airport": "Ben Gurion International Airport", 
	"country": "Israel", 
	"city": "Tel Aviv Yafo"}, 
{
	"citycode": "VDA", 
	"airport": "Ovda Airport", 
	"country": "Israel", 
	"city": "Ovda"}, 
{
	"citycode": "VEY", 
	"airport": "Vestmannaeyjar Airport", 
	"country": "Iceland", 
	"city": "Vestmannaeyjar"}, 
{
	"citycode": "VPN", 
	"airport": "Vopnafjordur Airport", 
	"country": "Iceland", 
	"city": "Vopnafjordur"}, 
{
	"citycode": "AHO", 
	"airport": "Alghero Airport", 
	"country": "Italy", 
	"city": "Alghero"}, 
{
	"citycode": "AOI", 
	"airport": "Ancona Airport Raffaello Sanzio", 
	"country": "Italy", 
	"city": "Ancona"}, 
{
	"citycode": "BDS", 
	"airport": "Salento Airport", 
	"country": "Italy", 
	"city": "Brindisi"}, 
{
	"citycode": "BGY", 
	"airport": "Milan Bergamo Airport", 
	"country": "Italy", 
	"city": "Milan"}, 
{
	"citycode": "BLQ", 
	"airport": "Bologna Guglielmo Marconi Airport", 
	"country": "Italy", 
	"city": "Bologna"}, 
{
	"citycode": "BRI", 
	"airport": "Bari International Airport-Karol Wojtyla", 
	"country": "Italy", 
	"city": "Bari"}, 
{
	"citycode": "CAG", 
	"airport": "Cagliari Elmas Airport", 
	"country": "Italy", 
	"city": "Cagliari"}, 
{
	"citycode": "CIA", 
	"airport": "Giovan Battista Pastine International Airport", 
	"country": "Italy", 
	"city": "Rome"}, 
{
	"citycode": "CTA", 
	"airport": "Vincenzo Bellini Catania Airport", 
	"country": "Italy", 
	"city": "Catania"}, 
{
	"citycode": "CUF", 
	"airport": "Cuneo International Airport", 
	"country": "Italy", 
	"city": "Cuneo"}, 
{
	"citycode": "FCO", 
	"airport": "Leonardo da Vinci–Fiumicino Airport", 
	"country": "Italy", 
	"city": "Rome"}, 
{
	"citycode": "FLR", 
	"airport": "Amerigo Vespucci Airport", 
	"country": "Italy", 
	"city": "Florence"}, 
{
	"citycode": "GOA", 
	"airport": "Genoa Cristoforo Colombo Airport", 
	"country": "Italy", 
	"city": "Genoa"}, 
{
	"citycode": "LIN", 
	"airport": "Milan Linate Airport", 
	"country": "Italy", 
	"city": "Milan"}, 
{
	"citycode": "LMP", 
	"airport": "Lampedusa Airport", 
	"country": "Italy", 
	"city": "Lampedusa"}, 
{
	"citycode": "MIL", 
	"airport": "All Airports Milan", 
	"country": "Italy", 
	"city": "Milan"}, 
{
	"citycode": "MXP", 
	"airport": "Milan Malpensa Airport", 
	"country": "Italy", 
	"city": "Milan"}, 
{
	"citycode": "NAP", 
	"airport": "Naples International Airport", 
	"country": "Italy", 
	"city": "Naples"}, 
{
	"citycode": "OLB", 
	"airport": "Olbia Costa Smeralda Airport", 
	"country": "Italy", 
	"city": "Olbia"}, 
{
	"citycode": "PEG", 
	"airport": "Perugia San Francesco Dassisi - Umbria International Airport", 
	"country": "Italy", 
	"city": "Perugia"}, 
{
	"citycode": "PMF", 
	"airport": "Parma Airport", 
	"country": "Italy", 
	"city": "Milan"}, 
{
	"citycode": "PMO", 
	"airport": "Palermo Airport", 
	"country": "Italy", 
	"city": "Palermo"}, 
{
	"citycode": "PNL", 
	"airport": "Pantelleria Airport", 
	"country": "Italy", 
	"city": "Pantelleria"}, 
{
	"citycode": "PSA", 
	"airport": "Pisa International Airport", 
	"country": "Italy", 
	"city": "Florence"}, 
{
	"citycode": "PSR", 
	"airport": "Abruzzo Airport", 
	"country": "Italy", 
	"city": "Pescara"}, 
{
	"citycode": "REG", 
	"airport": "Reggio Calabria Airport", 
	"country": "Italy", 
	"city": "Reggio Calabria"}, 
{
	"citycode": "RMI", 
	"airport": "Federico Fellini International Airport", 
	"country": "Italy", 
	"city": "Rimini"}, 
{
	"citycode": "ROM", 
	"airport": "All Airports Rome", 
	"country": "Italy", 
	"city": "Rome"}, 
{
	"citycode": "SUF", 
	"airport": "Lamezia Terme International Airport", 
	"country": "Italy", 
	"city": "Lamezia-Terme"}, 
{
	"citycode": "TPS", 
	"airport": "Trapani–Birgi Airport", 
	"country": "Italy", 
	"city": "Trapani"}, 
{
	"citycode": "TRN", 
	"airport": "Torino Airport", 
	"country": "Italy", 
	"city": "Turin"}, 
{
	"citycode": "TRS", 
	"airport": "Trieste Airport", 
	"country": "Italy", 
	"city": "Trieste"}, 
{
	"citycode": "TSF", 
	"airport": "Treviso Airport", 
	"country": "Italy", 
	"city": "Venice"}, 
{
	"citycode": "TTB", 
	"airport": "Tortol? Airport", 
	"country": "Italy", 
	"city": "Tortoli"}, 
{
	"citycode": "VCE", 
	"airport": "Venice Marco Polo Airport", 
	"country": "Italy", 
	"city": "Venice"}, 
{
	"citycode": "VRN", 
	"airport": "Verona Villafranca Airport", 
	"country": "Italy", 
	"city": "Verona"}, 
{
	"citycode": "AGJ", 
	"airport": "Aguni Airport", 
	"country": "Japan", 
	"city": "Aguni"}, 
{
	"citycode": "AKJ", 
	"airport": "Asahikawa Airport", 
	"country": "Japan", 
	"city": "Asahikawa"}, 
{
	"citycode": "AOJ", 
	"airport": "Aomori Airport", 
	"country": "Japan", 
	"city": "Aomori"}, 
{
	"citycode": "ASJ", 
	"airport": "Amami-Oshima Airport", 
	"country": "Japan", 
	"city": "Amami Oshima Is"}, 
{
	"citycode": "AXT", 
	"airport": "Akita Airport", 
	"country": "Japan", 
	"city": "Akita"}, 
{
	"citycode": "CTS", 
	"airport": "New Chitose Airport", 
	"country": "Japan", 
	"city": "Sapporo"}, 
{
	"citycode": "FUJ", 
	"airport": "Fukue Airport", 
	"country": "Japan", 
	"city": "Fukue"}, 
{
	"citycode": "FUK", 
	"airport": "Goto Tsubaki Airport", 
	"country": "Japan", 
	"city": "Fukuoka"}, 
{
	"citycode": "GAJ", 
	"airport": "Yamagata Airport", 
	"country": "Japan", 
	"city": "Yamagata"}, 
{
	"citycode": "HAC", 
	"airport": "HachijoJima Airport", 
	"country": "Japan", 
	"city": "Hachijo Jima"}, 
{
	"citycode": "HIJ", 
	"airport": "Hiroshima Airport", 
	"country": "Japan", 
	"city": "Hiroshima"}, 
{
	"citycode": "HKD", 
	"airport": "Hakodate Airport", 
	"country": "Japan", 
	"city": "Hakodate"}, 
{
	"citycode": "HNA", 
	"airport": "Hanamaki Airport", 
	"country": "Japan", 
	"city": "Morioka"}, 
{
	"citycode": "HND", 
	"airport": "Haneda Airport", 
	"country": "Japan", 
	"city": "Tokyo"}, 
{
	"citycode": "HTR", 
	"airport": "Hateruma Airport", 
	"country": "Japan", 
	"city": "Hateruma"}, 
{
	"citycode": "IKI", 
	"airport": "Iki Airport", 
	"country": "Japan", 
	"city": "Iki"}, 
{
	"citycode": "ISG", 
	"airport": "Ishigaki Airport", 
	"country": "Japan", 
	"city": "Ishigaki"}, 
{
	"citycode": "IZO", 
	"airport": "Izumo Airport", 
	"country": "Japan", 
	"city": "Izumo"}, 
{
	"citycode": "KCZ", 
	"airport": "Ryoma Airport", 
	"country": "Japan", 
	"city": "Kochi"}, 
{
	"citycode": "KIJ", 
	"airport": "Niigata Airport", 
	"country": "Japan", 
	"city": "Niigata"}, 
{
	"citycode": "KIX", 
	"airport": "Kansai International Airport", 
	"country": "Japan", 
	"city": "Osaka"}, 
{
	"citycode": "KKX", 
	"airport": "Kikai Airport", 
	"country": "Japan", 
	"city": "Kikaiga Shima"}, 
{
	"citycode": "KMI", 
	"airport": "Miyazaki Airport", 
	"country": "Japan", 
	"city": "Miyazaki"}, 
{
	"citycode": "KMJ", 
	"airport": "Kumamoto Airport", 
	"country": "Japan", 
	"city": "Kumamoto"}, 
{
	"citycode": "KMQ", 
	"airport": "Komatsu Airport", 
	"country": "Japan", 
	"city": "Komatsu"}, 
{
	"citycode": "KOJ", 
	"airport": "Kagoshima Airport", 
	"country": "Japan", 
	"city": "Kagoshima"}, 
{
	"citycode": "KTD", 
	"airport": "Kitadaito Airport", 
	"country": "Japan", 
	"city": "Kitadaito"}, 
{
	"citycode": "KUH", 
	"airport": "Kushiro Airport", 
	"country": "Japan", 
	"city": "Kushiro"}, 
{
	"citycode": "KUM", 
	"airport": "Yakushima Airport", 
	"country": "Japan", 
	"city": "Yakushima"}, 
{
	"citycode": "MBE", 
	"airport": "Monbetsu Airport", 
	"country": "Japan", 
	"city": "Monbetsu"}, 
{
	"citycode": "MMB", 
	"airport": "Memanbetsu Airport", 
	"country": "Japan", 
	"city": "Memanbetsu"}, 
{
	"citycode": "MMD", 
	"airport": "Minamidaito Airport", 
	"country": "Japan", 
	"city": "Minami Daito"}, 
{
	"citycode": "MMJ", 
	"airport": "Shinshu-Matsumoto Airport", 
	"country": "Japan", 
	"city": "Matsumoto"}, 
{
	"citycode": "MMY", 
	"airport": "Miyako Airport", 
	"country": "Japan", 
	"city": "Miyako Jima"}, 
{
	"citycode": "MSJ", 
	"airport": "Misawa Airport", 
	"country": "Japan", 
	"city": "Misawa"}, 
{
	"citycode": "MYE", 
	"airport": "MiyakeJima Airport", 
	"country": "Japan", 
	"city": "Miyake Jima"}, 
{
	"citycode": "MYJ", 
	"airport": "Matsuyama Airport", 
	"country": "Japan", 
	"city": "Matsuyama"}, 
{
	"citycode": "NGO", 
	"airport": "Chubu Centrair International Airport", 
	"country": "Japan", 
	"city": "Nagoya"}, 
{
	"citycode": "NGS", 
	"airport": "Nagasaki Airport", 
	"country": "Japan", 
	"city": "Nagasaki"}, 
{
	"citycode": "NRT", 
	"airport": "Narita International Airport", 
	"country": "Japan", 
	"city": "Tokyo"}, 
{
	"citycode": "OBO", 
	"airport": "Obihiro Airport", 
	"country": "Japan", 
	"city": "Obihiro"}, 
{
	"citycode": "OGN", 
	"airport": "Yonaguni Airport", 
	"country": "Japan", 
	"city": "Yonaguni Jima"}, 
{
	"citycode": "OIM", 
	"airport": "Oshima Airport", 
	"country": "Japan", 
	"city": "Oshima"}, 
{
	"citycode": "OIR", 
	"airport": "Okushiri Airport", 
	"country": "Japan", 
	"city": "Okushiri"}, 
{
	"citycode": "OIT", 
	"airport": "Oita Airport", 
	"country": "Japan", 
	"city": "Oita"}, 
{
	"citycode": "OKA", 
	"airport": "Naha Airport", 
	"country": "Japan", 
	"city": "Okinawa"}, 
{
	"citycode": "OKD", 
	"airport": "Sapporo Okadama Airport", 
	"country": "Japan", 
	"city": "Sapporo"}, 
{
	"citycode": "OKE", 
	"airport": "Okinoerabu Airports", 
	"country": "Japan", 
	"city": "Okino Erabu"}, 
{
	"citycode": "OKI", 
	"airport": "Oki Airport", 
	"country": "Japan", 
	"city": "Oki Island"}, 
{
	"citycode": "OKJ", 
	"airport": "Okayama Momotaro Airport", 
	"country": "Japan", 
	"city": "Okayama"}, 
{
	"citycode": "OSA", 
	"airport": "All Airports Osaka", 
	"country": "Japan", 
	"city": "Osaka"}, 
{
	"citycode": "RBJ", 
	"airport": "Rebun Airport", 
	"country": "Japan", 
	"city": "Rebun"}, 
{
	"citycode": "RIS", 
	"airport": "Rishiri Airport", 
	"country": "Japan", 
	"city": "Rishiri"}, 
{
	"citycode": "RNJ", 
	"airport": "Yoron Airport", 
	"country": "Japan", 
	"city": "Yoronjima"}, 
{
	"citycode": "SDJ", 
	"airport": "Sendai Airport", 
	"country": "Japan", 
	"city": "Sendai"}, 
{
	"citycode": "SHB", 
	"airport": "Nakashibetsu Airport", 
	"country": "Japan", 
	"city": "Nakashibetsu"}, 
{
	"citycode": "SHI", 
	"airport": "Shimojishima Airport", 
	"country": "Japan", 
	"city": "Shimojishima"}, 
{
	"citycode": "SHM", 
	"airport": "Nanki Shirahama Airport", 
	"country": "Japan", 
	"city": "Shirahama"}, 
{
	"citycode": "SPK", 
	"airport": "Sapporo All Airports", 
	"country": "Japan", 
	"city": "Sapporo"}, 
{
	"citycode": "TAK", 
	"airport": "Takamatsu Airport", 
	"country": "Japan", 
	"city": "Takamatsu"}, 
{
	"citycode": "TKN", 
	"airport": "Tokunoshima Airport", 
	"country": "Japan", 
	"city": "Tokunoshima"}, 
{
	"citycode": "TKS", 
	"airport": "Tokushima Awaodori Airport", 
	"country": "Japan", 
	"city": "Tokushima"}, 
{
	"citycode": "TNE", 
	"airport": "Tanegashima Airport", 
	"country": "Japan", 
	"city": "Tanegashima"}, 
{
	"citycode": "TOY", 
	"airport": "Toyama Airport", 
	"country": "Japan", 
	"city": "Toyama"}, 
{
	"citycode": "TSJ", 
	"airport": "Tsushima Airport", 
	"country": "Japan", 
	"city": "Tsushima"}, 
{
	"citycode": "TTJ", 
	"airport": "Tottori Airport", 
	"country": "Japan", 
	"city": "Tottori"}, 
{
	"citycode": "TYO", 
	"airport": "All Airports Tokyo", 
	"country": "Japan", 
	"city": "Tokyo"}, 
{
	"citycode": "UBJ", 
	"airport": "Yamaguchi Ube Airport", 
	"country": "Japan", 
	"city": "Ube"}, 
{
	"citycode": "UEO", 
	"airport": "Kumejima Airport", 
	"country": "Japan", 
	"city": "Kumejima"}, 
{
	"citycode": "WKJ", 
	"airport": "Wakkanai Airport", 
	"country": "Japan", 
	"city": "Wakkanai"}, 
{
	"citycode": "YGJ", 
	"airport": "Miho-Yonago Airport", 
	"country": "Japan", 
	"city": "Yonago"}, 
{
	"citycode": "ADJ", 
	"airport": "Amman Civil Airport (Marka International Airport)", 
	"country": "Jordan", 
	"city": "Amman"}, 
{
	"citycode": "AMM", 
	"airport": "Queen Alia International Airport", 
	"country": "Jordan", 
	"city": "Amman"}, 
{
	"citycode": "AQJ", 
	"airport": "Aqaba Airport", 
	"country": "Jordan", 
	"city": "Aqaba"}, 
{
	"citycode": "ASV", 
	"airport": "Amboseli Airstrip", 
	"country": "Kenya", 
	"city": "Amboseli"}, 
{
	"citycode": "BMQ", 
	"airport": "Bamburi Airport", 
	"country": "Kenya", 
	"city": "Bamburi"}, 
{
	"citycode": "EDL", 
	"airport": "Eldoret Airport", 
	"country": "Kenya", 
	"city": "Eldoret"}, 
{
	"citycode": "FER", 
	"airport": "Fergusons Gulf Airport", 
	"country": "Kenya", 
	"city": "Fergusons Gulf"}, 
{
	"citycode": "GAS", 
	"airport": "Garissa Airport", 
	"country": "Kenya", 
	"city": "Garissa"}, 
{
	"citycode": "ILU", 
	"airport": "Kilaguni Airport", 
	"country": "Kenya", 
	"city": "Kilaguni"}, 
{
	"citycode": "KEY", 
	"airport": "Kericho Airport", 
	"country": "Kenya", 
	"city": "Kericho"}, 
{
	"citycode": "KIS", 
	"airport": "Kisumu International Airport", 
	"country": "Kenya", 
	"city": "Kisumu"}, 
{
	"citycode": "KRV", 
	"airport": "Kimwarer Airport", 
	"country": "Kenya", 
	"city": "Kerio Valley"}, 
{
	"citycode": "KTL", 
	"airport": "Kitale Airport", 
	"country": "Kenya", 
	"city": "Kitale"}, 
{
	"citycode": "KWY", 
	"airport": "Kiwayu Airport", 
	"country": "Kenya", 
	"city": "Kiwayu"}, 
{
	"citycode": "LAU", 
	"airport": "Manda Airport", 
	"country": "Kenya", 
	"city": "Lamu"}, 
{
	"citycode": "LOK", 
	"airport": "Lodwar Airport", 
	"country": "Kenya", 
	"city": "Lodwar"}, 
{
	"citycode": "LOY", 
	"airport": "Loyengalani Airport", 
	"country": "Kenya", 
	"city": "Loyangalani"}, 
{
	"citycode": "MBA", 
	"airport": "Moi International Airport", 
	"country": "Kenya", 
	"city": "Mombasa"}, 
{
	"citycode": "MRE", 
	"airport": "Mara Serena Airport", 
	"country": "Kenya", 
	"city": "Mara Lodges"}, 
{
	"citycode": "MYD", 
	"airport": "Malindi Airport", 
	"country": "Kenya", 
	"city": "Malindi"}, 
{
	"citycode": "NBO", 
	"airport": "Jomo Kenyatta International Airport", 
	"country": "Kenya", 
	"city": "Nairobi"}, 
{
	"citycode": "NDE", 
	"airport": "Mandera Airport", 
	"country": "Kenya", 
	"city": "Mandera"}, 
{
	"citycode": "NUU", 
	"airport": "Nakuru Airport", 
	"country": "Kenya", 
	"city": "Nakuru"}, 
{
	"citycode": "NYE", 
	"airport": "Nyeri Airport", 
	"country": "Kenya", 
	"city": "Nyeri"}, 
{
	"citycode": "NYK", 
	"airport": "Nanyuki Airport", 
	"country": "Kenya", 
	"city": "Nanyuki"}, 
{
	"citycode": "OYL", 
	"airport": "Moyale Airport", 
	"country": "Kenya", 
	"city": "Moyale"}, 
{
	"citycode": "RBT", 
	"airport": "Marsabit Airport", 
	"country": "Kenya", 
	"city": "Marsabit"}, 
{
	"citycode": "UAS", 
	"airport": "Samburu Airport", 
	"country": "Kenya", 
	"city": "Samburu"}, 
{
	"citycode": "WIL", 
	"airport": "Wilson Airport", 
	"country": "Kenya", 
	"city": "Nairobi"}, 
{
	"citycode": "WJR", 
	"airport": "Wajir Airport", 
	"country": "Kenya", 
	"city": "Wajir"}, 
{
	"citycode": "CJU", 
	"airport": "Jeju International Airport", 
	"country": "South Korea", 
	"city": "Cheju"}, 
{
	"citycode": "GMP", 
	"airport": "Gimpo International Airport", 
	"country": "South Korea", 
	"city": "Seoul"}, 
{
	"citycode": "HIN", 
	"airport": "Sacheon Airport", 
	"country": "South Korea", 
	"city": "Chinju"}, 
{
	"citycode": "ICN", 
	"airport": "Incheon International Airport", 
	"country": "South Korea", 
	"city": "Seoul"}, 
{
	"citycode": "KAG", 
	"airport": "Gangneung Airport", 
	"country": "South Korea", 
	"city": "Kangnung"}, 
{
	"citycode": "KPO", 
	"airport": "Pohang-Gyeongju Airport", 
	"country": "South Korea", 
	"city": "Pohang"}, 
{
	"citycode": "KWJ", 
	"airport": "Gwangju Airport", 
	"country": "South Korea", 
	"city": "Kwangju"}, 
{
	"citycode": "PUS", 
	"airport": "Gimhae International Airport", 
	"country": "South Korea", 
	"city": "Pusan"}, 
{
	"citycode": "RSU", 
	"airport": "Yeosu Airport", 
	"country": "South Korea", 
	"city": "Yeosu"}, 
{
	"citycode": "SEL", 
	"airport": "Seoul All Airports", 
	"country": "South Korea", 
	"city": "Seoul"}, 
{
	"citycode": "SHO", 
	"airport": "King Mswati III International Airport", 
	"country": "South Korea", 
	"city": "Sokcho"}, 
{
	"citycode": "TAE", 
	"airport": "Daegu International Airport", 
	"country": "South Korea", 
	"city": "Daegu"}, 
{
	"citycode": "USN", 
	"airport": "Ulsan Airport", 
	"country": "South Korea", 
	"city": "Ulsan"}, 
{
	"citycode": "YEC", 
	"airport": "Yecheon Airport", 
	"country": "South Korea", 
	"city": "Yechon"}, 
{
	"citycode": "KWI", 
	"airport": "Kuwait International Airport", 
	"country": "Kuwait", 
	"city": "Kuwait"}, 
{
	"citycode": "RIX", 
	"airport": "Riga International Airport", 
	"country": "Latvia", 
	"city": "Riga"}, 
{
	"citycode": "BEY", 
	"airport": "Beirut International Airport", 
	"country": "Lebanon", 
	"city": "Beirut"}, 
{
	"citycode": "KYE", 
	"airport": "Kleyate Airport", 
	"country": "Lebanon", 
	"city": "Tripoli"}, 
{
	"citycode": "CPA", 
	"airport": "Cape Palmas Airport", 
	"country": "Liberia", 
	"city": "Cape Palmas"}, 
{
	"citycode": "MLW", 
	"airport": "James Spriggs Payne Airport", 
	"country": "Liberia", 
	"city": "Monrovia"}, 
{
	"citycode": "NIA", 
	"airport": "Nimba Airport", 
	"country": "Liberia", 
	"city": "Nimba"}, 
{
	"citycode": "ROB", 
	"airport": "Roberts International Airport", 
	"country": "Liberia", 
	"city": "Monrovia"}, 
{
	"citycode": "SNI", 
	"airport": "Greenville/Sinoe Airport", 
	"country": "Liberia", 
	"city": "Sinoe"}, 
{
	"citycode": "THC", 
	"airport": "Tchien Airport", 
	"country": "Liberia", 
	"city": "Tchien"}, 
{
	"citycode": "UCN", 
	"airport": "Buchanan Airport", 
	"country": "Liberia", 
	"city": "Buchanan"}, 
{
	"citycode": "AOR", 
	"airport": "Sultan Abdul Halim Airport", 
	"country": "Malaysia", 
	"city": "Alor Setar"}, 
{
	"citycode": "BBN", 
	"airport": "Bario Airport ", 
	"country": "Malaysia", 
	"city": "Bario"}, 
{
	"citycode": "BKI", 
	"airport": "Kota Kinabalu International Airport", 
	"country": "Malaysia", 
	"city": "Kota Kinabalu"}, 
{
	"citycode": "BKM", 
	"airport": "Bakalalan Airport", 
	"country": "Malaysia", 
	"city": "Bakalalan"}, 
{
	"citycode": "BLG", 
	"airport": "Belaga Airport", 
	"country": "Malaysia", 
	"city": "Belaga"}, 
{
	"citycode": "BTU", 
	"airport": "Bintulu Airport", 
	"country": "Malaysia", 
	"city": "Bintulu"}, 
{
	"citycode": "GSA", 
	"airport": "Long Pasia Airport", 
	"country": "Malaysia", 
	"city": "Long Pasia"}, 
{
	"citycode": "IPH", 
	"airport": "Sultan Azlan Shah Airport", 
	"country": "Malaysia", 
	"city": "Ipoh"}, 
{
	"citycode": "JHB", 
	"airport": "Johor Bahru Senai International Airport", 
	"country": "Malaysia", 
	"city": "Johor Bahru"}, 
{
	"citycode": "KBR", 
	"airport": "Kota Bharu Sultan Ismail Petra Airport ", 
	"country": "Malaysia", 
	"city": "Kota Bharu"}, 
{
	"citycode": "KCH", 
	"airport": "Kuching International Airport", 
	"country": "Malaysia", 
	"city": "Kuching"}, 
{
	"citycode": "KPI", 
	"airport": "Kapit Airport", 
	"country": "Malaysia", 
	"city": "Kapit"}, 
{
	"citycode": "KTE", 
	"airport": "Kerteh Airport", 
	"country": "Malaysia", 
	"city": "Kerteh"}, 
{
	"citycode": "KUA", 
	"airport": "Sultan Ahmad Shah Airport", 
	"country": "Malaysia", 
	"city": "Kuantan"}, 
{
	"citycode": "KUD", 
	"airport": "Kudat Airport", 
	"country": "Malaysia", 
	"city": "Kudat"}, 
{
	"citycode": "KUL", 
	"airport": "Kuala Lumpur International Airport", 
	"country": "Malaysia", 
	"city": "Kuala Lumpur"}, 
{
	"citycode": "LBU", 
	"airport": "Labuan Airport", 
	"country": "Malaysia", 
	"city": "Labuan"}, 
{
	"citycode": "LDU", 
	"airport": "Lahad Datu Airport", 
	"country": "Malaysia", 
	"city": "Lahad Datu"}, 
{
	"citycode": "LGK", 
	"airport": "Langkawi International Airport ", 
	"country": "Malaysia", 
	"city": "Langkawi"}, 
{
	"citycode": "LGL", 
	"airport": "Long Lellang Airport", 
	"country": "Malaysia", 
	"city": "Long Lellang"}, 
{
	"citycode": "LMN", 
	"airport": "Limbang Airport", 
	"country": "Malaysia", 
	"city": "Limbang"}, 
{
	"citycode": "LSM", 
	"airport": "Long Semado Airport", 
	"country": "Malaysia", 
	"city": "Long Semado"}, 
{
	"citycode": "MKM", 
	"airport": "Mukah Airport", 
	"country": "Malaysia", 
	"city": "Mukah"}, 
{
	"citycode": "MKZ", 
	"airport": "Malacca International Airport", 
	"country": "Malaysia", 
	"city": "Malacca"}, 
{
	"citycode": "MUR", 
	"airport": "Marudi Airport", 
	"country": "Malaysia", 
	"city": "Marudi"}, 
{
	"citycode": "MYY", 
	"airport": "Miri Airport", 
	"country": "Malaysia", 
	"city": "Miri"}, 
{
	"citycode": "ODN", 
	"airport": "Long Seridan Airport", 
	"country": "Malaysia", 
	"city": "Long Seridan"}, 
{
	"citycode": "PAY", 
	"airport": "Pamol Airport", 
	"country": "Malaysia", 
	"city": "Pamol"}, 
{
	"citycode": "PEN", 
	"airport": "Penang International Airport", 
	"country": "Malaysia", 
	"city": "Penang"}, 
{
	"citycode": "SBW", 
	"airport": "Sibu Airport", 
	"country": "Malaysia", 
	"city": "Sibu"}, 
{
	"citycode": "SDK", 
	"airport": "Sandakan Airport", 
	"country": "Malaysia", 
	"city": "Sandakan"}, 
{
	"citycode": "SMM", 
	"airport": "Semporna Airport", 
	"country": "Malaysia", 
	"city": "Semporna"}, 
{
	"citycode": "SWY", 
	"airport": "Sitiawan Airport", 
	"country": "Malaysia", 
	"city": "Sitiawan"}, 
{
	"citycode": "SXS", 
	"airport": "Sahabat Airport", 
	"country": "Malaysia", 
	"city": "Sahabat 16"}, 
{
	"citycode": "SXT", 
	"airport": "Sungai Tiang Airport", 
	"country": "Malaysia", 
	"city": "Taman Negara"}, 
{
	"citycode": "SZB", 
	"airport": "Sultan Abdul Aziz Shah Airport", 
	"country": "Malaysia", 
	"city": "Kuala Lumpur"}, 
{
	"citycode": "TGG", 
	"airport": "Sultan Mahmood Airport", 
	"country": "Malaysia", 
	"city": "Kuala Terengganu"}, 
{
	"citycode": "TMG", 
	"airport": "Tomanggong Airport", 
	"country": "Malaysia", 
	"city": "Tomanggong"}, 
{
	"citycode": "TOD", 
	"airport": "Tioman Airport", 
	"country": "Malaysia", 
	"city": "Tioman"}, 
{
	"citycode": "TWU", 
	"airport": "Tawau Airport", 
	"country": "Malaysia", 
	"city": "Tawau"}, 
{
	"citycode": "GAN", 
	"airport": "Gan International Airport", 
	"country": "Maldives", 
	"city": "Gan Addu Atoll"}, 
{
	"citycode": "MLE", 
	"airport": "Velana International Airport", 
	"country": "Maldives", 
	"city": "Male"}, 
{
	"citycode": "BKO", 
	"airport": "Modibo Keita International Airport", 
	"country": "Mali", 
	"city": "Bamako"}, 
{
	"citycode": "EYL", 
	"airport": "Yelimane Airport", 
	"country": "Mali", 
	"city": "Yelimane"}, 
{
	"citycode": "GAQ", 
	"airport": "Gao International Airport", 
	"country": "Mali", 
	"city": "Gao"}, 
{
	"citycode": "GUD", 
	"airport": "Goundam Airport", 
	"country": "Mali", 
	"city": "Goundam"}, 
{
	"citycode": "KSS", 
	"airport": "Sikasso Airport", 
	"country": "Mali", 
	"city": "Sikasso"}, 
{
	"citycode": "KTX", 
	"airport": "Koutiala Airport", 
	"country": "Mali", 
	"city": "Koutiala"}, 
{
	"citycode": "KYS", 
	"airport": "Kayes Airport", 
	"country": "Mali", 
	"city": "Kayes"}, 
{
	"citycode": "MZI", 
	"airport": "Mopti Airport", 
	"country": "Mali", 
	"city": "Mopti"}, 
{
	"citycode": "NIX", 
	"airport": "Nioro Airport", 
	"country": "Mali", 
	"city": "Nioro"}, 
{
	"citycode": "NRM", 
	"airport": "Keibane Airport", 
	"country": "Mali", 
	"city": "Nara"}, 
{
	"citycode": "TOM", 
	"airport": "Timbuktu Airport", 
	"country": "Mali", 
	"city": "Tombouctou"}, 
{
	"citycode": "MRU", 
	"airport": "Seewoosagur Ramgoolam International Airport", 
	"country": "Mauritius", 
	"city": "Mauritius"}, 
{
	"citycode": "RRG", 
	"airport": "Plaine Corail Airport", 
	"country": "Mauritius", 
	"city": "Rodrigues Island"}, 
{
	"citycode": "ACA", 
	"airport": "Acapulco International Airport", 
	"country": "Mexico", 
	"city": "Acapulco"}, 
{
	"citycode": "AGU", 
	"airport": "Aguascalientes International Airport", 
	"country": "Mexico", 
	"city": "Aguascalientes"}, 
{
	"citycode": "AZP", 
	"airport": "Atizapan Airport", 
	"country": "Mexico", 
	"city": "Mexico City"}, 
{
	"citycode": "BJX", 
	"airport": "Guanajuato International Airport", 
	"country": "Mexico", 
	"city": "Leon-Guanajuato"}, 
{
	"citycode": "CEN", 
	"airport": "Ciudad Obregon International Airport", 
	"country": "Mexico", 
	"city": "Ciudad Obregon"}, 
{
	"citycode": "CJS", 
	"airport": "Ciudad Ju?rez International Airport", 
	"country": "Mexico", 
	"city": "Ciudad Juarez"}, 
{
	"citycode": "CLQ", 
	"airport": "Colima Airport", 
	"country": "Mexico", 
	"city": "Colima"}, 
{
	"citycode": "CME", 
	"airport": "Ciudad Del Carmen Airport", 
	"country": "Mexico", 
	"city": "Ciudad Del Carmen"}, 
{
	"citycode": "CPE", 
	"airport": "Campeche International Airport", 
	"country": "Mexico", 
	"city": "Campeche"}, 
{
	"citycode": "CTM", 
	"airport": "Chetumal International Airport", 
	"country": "Mexico", 
	"city": "Chetumal"}, 
{
	"citycode": "CUL", 
	"airport": "Culiac?n International Airport", 
	"country": "Mexico", 
	"city": "Culiacan"}, 
{
	"citycode": "CUN", 
	"airport": "Cancun International Airport", 
	"country": "Mexico", 
	"city": "Cancun"}, 
{
	"citycode": "CUU", 
	"airport": "Chihuahua International Airport", 
	"country": "Mexico", 
	"city": "Chihuahua"}, 
{
	"citycode": "CVM", 
	"airport": "General Pedro José Méndez International Airport", 
	"country": "Mexico", 
	"city": "Ciudad Victoria"}, 
{
	"citycode": "CZM", 
	"airport": "Cozumel International Airport", 
	"country": "Mexico", 
	"city": "Cozumel"}, 
{
	"citycode": "DGO", 
	"airport": "Durango International Airport", 
	"country": "Mexico", 
	"city": "Durango"}, 
{
	"citycode": "GDL", 
	"airport": "Miguel Hidalgo y Costilla International Airport", 
	"country": "Mexico", 
	"city": "Guadalajara"}, 
{
	"citycode": "GYM", 
	"airport": "Guaymas International Airport", 
	"country": "Mexico", 
	"city": "Guaymas"}, 
{
	"citycode": "HMO", 
	"airport": "Hermosillo Airport", 
	"country": "Mexico", 
	"city": "Hermosillo"}, 
{
	"citycode": "HUX", 
	"airport": "Huatulco International Airport", 
	"country": "Mexico", 
	"city": "Huatulco"}, 
{
	"citycode": "LAP", 
	"airport": "La Paz International Airport", 
	"country": "Mexico", 
	"city": "La Paz"}, 
{
	"citycode": "LMM", 
	"airport": "Los Mochis International Airport ", 
	"country": "Mexico", 
	"city": "Los Mochis"}, 
{
	"citycode": "LTO", 
	"airport": "Loreto International Airport", 
	"country": "Mexico", 
	"city": "Loreto"}, 
{
	"citycode": "LZC", 
	"airport": "Lazaro Cardenas Airport", 
	"country": "Mexico", 
	"city": "Lazaro Cardenas"}, 
{
	"citycode": "MEX", 
	"airport": "Mexico City International Airport", 
	"country": "Mexico", 
	"city": "Mexico City"}, 
{
	"citycode": "MID", 
	"airport": "Merida International Airport", 
	"country": "Mexico", 
	"city": "Merida"}, 
{
	"citycode": "MLM", 
	"airport": "Morelia Airport", 
	"country": "Mexico", 
	"city": "Morelia"}, 
{
	"citycode": "MTT", 
	"airport": "Minatitlan International Airport", 
	"country": "Mexico", 
	"city": "Minatitlan"}, 
{
	"citycode": "MTY", 
	"airport": "Monterrey International Airport", 
	"country": "Mexico", 
	"city": "Monterrey"}, 
{
	"citycode": "MXL", 
	"airport": "Mexicali International Airport", 
	"country": "Mexico", 
	"city": "Mexicali"}, 
{
	"citycode": "MZT", 
	"airport": "Mazatlan International Airport", 
	"country": "Mexico", 
	"city": "Mazatlan"}, 
{
	"citycode": "NLD", 
	"airport": "Nuevo Laredo International Airport", 
	"country": "Mexico", 
	"city": "Nuevo Laredo"}, 
{
	"citycode": "OAX", 
	"airport": "Oaxaca International Airport", 
	"country": "Mexico", 
	"city": "Oaxaca"}, 
{
	"citycode": "PAZ", 
	"airport": "El Taj?n National Airport", 
	"country": "Mexico", 
	"city": "Poza Rica"}, 
{
	"citycode": "PBC", 
	"airport": "Puebla International Airport", 
	"country": "Mexico", 
	"city": "Puebla"}, 
{
	"citycode": "PPE", 
	"airport": "Mar de Cortés International Airport", 
	"country": "Mexico", 
	"city": "Puerto Penasco"}, 
{
	"citycode": "PVR", 
	"airport": "Gustavo Diaz Ordaz International Airport", 
	"country": "Mexico", 
	"city": "Puerto Vallarta"}, 
{
	"citycode": "PXM", 
	"airport": "Puerto Escondido International Airport", 
	"country": "Mexico", 
	"city": "Puerto Escondido"}, 
{
	"citycode": "REX", 
	"airport": "Gen. Lucio Blanco International Airport", 
	"country": "Mexico", 
	"city": "Reynosa"}, 
{
	"citycode": "SFH", 
	"airport": "San Felipe International Airport", 
	"country": "Mexico", 
	"city": "San Felipe"}, 
{
	"citycode": "SLP", 
	"airport": "San Luis Potosi International Airport", 
	"country": "Mexico", 
	"city": "San Luis Potosi"}, 
{
	"citycode": "TAM", 
	"airport": "Tampico International Airport", 
	"country": "Mexico", 
	"city": "Tampico"}, 
{
	"citycode": "TAP", 
	"airport": "Tapachula International Airport", 
	"country": "Mexico", 
	"city": "Tapachula"}, 
{
	"citycode": "TGZ", 
	"airport": "Tuxtla Gutiérrez International Airport", 
	"country": "Mexico", 
	"city": "Tuxtla Gutierrez"}, 
{
	"citycode": "TIJ", 
	"airport": "Tijuana International Airport", 
	"country": "Mexico", 
	"city": "Tijuana"}, 
{
	"citycode": "TPQ", 
	"airport": "Amado Nervo National Airport", 
	"country": "Mexico", 
	"city": "Tepic"}, 
{
	"citycode": "TRC", 
	"airport": "Torreon Airport", 
	"country": "Mexico", 
	"city": "Torreon"}, 
{
	"citycode": "UAC", 
	"airport": "San Luis Rio Colorado Airport", 
	"country": "Mexico", 
	"city": "San Luis Rio Colorado"}, 
{
	"citycode": "UPN", 
	"airport": "Uruapan International Airport", 
	"country": "Mexico", 
	"city": "Uruapan"}, 
{
	"citycode": "VER", 
	"airport": "Veracruz International Airport", 
	"country": "Mexico", 
	"city": "Veracruz"}, 
{
	"citycode": "VIB", 
	"airport": "Villa Constitucion Airport", 
	"country": "Mexico", 
	"city": "Villa Constitucion"}, 
{
	"citycode": "VSA", 
	"airport": "Carlos Rovirosa Perez International Airport", 
	"country": "Mexico", 
	"city": "Villahermosa"}, 
{
	"citycode": "ZCL", 
	"airport": "Zacatecas International Airport (La Calera)", 
	"country": "Mexico", 
	"city": "Zacatecas"}, 
{
	"citycode": "ZIH", 
	"airport": "Ixtapa-Zihuatanejo International Airport", 
	"country": "Mexico", 
	"city": "Ixtapa-Zihuatanejo"}, 
{
	"citycode": "ZLO", 
	"airport": "The Manzanillo International Airport", 
	"country": "Mexico", 
	"city": "Manzanillo"}, 
{
	"citycode": "ZMM", 
	"airport": "Zamora Airport", 
	"country": "Mexico", 
	"city": "Zamora"}, 
{
	"citycode": "AGA", 
	"airport": "Agadir Al-Massira International Airport", 
	"country": "Morocco", 
	"city": "Agadir"}, 
{
	"citycode": "AHU", 
	"airport": "Aeropuerto Cherif Al Idrissi", 
	"country": "Morocco", 
	"city": "Al Hoceima"}, 
{
	"citycode": "CAS", 
	"airport": "Casablanca–Anfa Airport", 
	"country": "Morocco", 
	"city": "Casablanca"}, 
{
	"citycode": "CMN", 
	"airport": "Mohammed V International Airport", 
	"country": "Morocco", 
	"city": "Casablanca"}, 
{
	"citycode": "ERH", 
	"airport": "Moulay Ali Cherif Airport", 
	"country": "Morocco", 
	"city": "Errachidia"}, 
{
	"citycode": "EUN", 
	"airport": "Hassan I Airport", 
	"country": "Morocco", 
	"city": "Laayoune"}, 
{
	"citycode": "FEZ", 
	"airport": "Fes Sais International Airport", 
	"country": "Morocco", 
	"city": "Fez"}, 
{
	"citycode": "OUD", 
	"airport": "Oujda Angads Airport", 
	"country": "Morocco", 
	"city": "Oujda"}, 
{
	"citycode": "OZZ", 
	"airport": "Ouarzazate International Airport", 
	"country": "Morocco", 
	"city": "Ouarzazate"}, 
{
	"citycode": "RAK", 
	"airport": "Marrakesh Menara Airport", 
	"country": "Morocco", 
	"city": "Marrakech"}, 
{
	"citycode": "RBA", 
	"airport": "Rabat Sale Intl airport", 
	"country": "Morocco", 
	"city": "Rabat"}, 
{
	"citycode": "SFI", 
	"airport": "Safi Airport", 
	"country": "Morocco", 
	"city": "Safi"}, 
{
	"citycode": "SMW", 
	"airport": "Smara Airport", 
	"country": "Morocco", 
	"city": "Smara"}, 
{
	"citycode": "TNG", 
	"airport": "Tangier Ibn Battuta Airport", 
	"country": "Morocco", 
	"city": "Tangier"}, 
{
	"citycode": "TTA", 
	"airport": "Tan Tan Airport", 
	"country": "Morocco", 
	"city": "Tan Tan"}, 
{
	"citycode": "TTU", 
	"airport": "Sania Ramel Airport", 
	"country": "Morocco", 
	"city": "Tetuan"}, 
{
	"citycode": "VIL", 
	"airport": "Dakhla Airport", 
	"country": "Morocco", 
	"city": "Dakhla"}, 
{
	"citycode": "ADI", 
	"airport": "Arandis Airport", 
	"country": "Namibia", 
	"city": "Arandis"}, 
{
	"citycode": "GFY", 
	"airport": "Grootfontein Air Force Base", 
	"country": "Namibia", 
	"city": "Grootfontein"}, 
{
	"citycode": "KMP", 
	"airport": "Keetmanshoop Airport", 
	"country": "Namibia", 
	"city": "Keetmanshoop"}, 
{
	"citycode": "LUD", 
	"airport": "Luderitz Airport", 
	"country": "Namibia", 
	"city": "Luderitz"}, 
{
	"citycode": "MPA", 
	"airport": "Katima Mulilo Airport", 
	"country": "Namibia", 
	"city": "Mpacha"}, 
{
	"citycode": "NDU", 
	"airport": "Rundu Airport", 
	"country": "Namibia", 
	"city": "Rundu"}, 
{
	"citycode": "NNI", 
	"airport": "Namutoni Airport", 
	"country": "Namibia", 
	"city": "Namutoni"}, 
{
	"citycode": "OHI", 
	"airport": "Flugplatz Oshakati Airport", 
	"country": "Namibia", 
	"city": "Oshakati"}, 
{
	"citycode": "OKF", 
	"airport": "Okaukuejo Airport", 
	"country": "Namibia", 
	"city": "Okaukuejo"}, 
{
	"citycode": "OMD", 
	"airport": "Oranjemund Airport", 
	"country": "Namibia", 
	"city": "Oranjemund"}, 
{
	"citycode": "OND", 
	"airport": "Andimba Toivo ya Toivo Airport", 
	"country": "Namibia", 
	"city": "Ondangwa"}, 
{
	"citycode": "SWP", 
	"airport": "Swakopmund Airport", 
	"country": "Namibia", 
	"city": "Swakopmund"}, 
{
	"citycode": "TSB", 
	"airport": "Tsumeb Airport", 
	"country": "Namibia", 
	"city": "Tsumeb"}, 
{
	"citycode": "WDH", 
	"airport": "Hosea Kutako International Airport", 
	"country": "Namibia", 
	"city": "Windhoek"}, 
{
	"citycode": "WVB", 
	"airport": "Walvis Bay International Airport", 
	"country": "Namibia", 
	"city": "Walvis Bay"}, 
{
	"citycode": "BDP", 
	"airport": "Chandragadi Airport", 
	"country": "Nepal", 
	"city": "Bhadrapur"}, 
{
	"citycode": "BIR", 
	"airport": "Biratnagar Airport", 
	"country": "Nepal", 
	"city": "Biratnagar"}, 
{
	"citycode": "BWA", 
	"airport": "Gautam Buddha International Airport", 
	"country": "Nepal", 
	"city": "Bhairahawa"}, 
{
	"citycode": "LUA", 
	"airport": "Tenzing-Hillary Airport", 
	"country": "Nepal", 
	"city": "Lukla"}, 
{
	"citycode": "MEY", 
	"airport": "Meghauli Airport", 
	"country": "Nepal", 
	"city": "Meghauli"}, 
{
	"citycode": "PKR", 
	"airport": "Pokhara Domestic Airport", 
	"country": "Nepal", 
	"city": "Pokhara"}, 
{
	"citycode": "AMS", 
	"airport": "Amsterdam Airport Schiphol", 
	"country": "Netherlands", 
	"city": "Amsterdam"}, 
{
	"citycode": "BZM", 
	"airport": "Bemolanga Airport", 
	"country": "Netherlands", 
	"city": "Bergen Op Zoom"}, 
{
	"citycode": "EIN", 
	"airport": "Eindhoven Airport", 
	"country": "Netherlands", 
	"city": "Eindhoven"}, 
{
	"citycode": "ENS", 
	"airport": "Twente Airport", 
	"country": "Netherlands", 
	"city": "Enschede"}, 
{
	"citycode": "GRQ", 
	"airport": "Groningen Airport Eelde", 
	"country": "Netherlands", 
	"city": "Groningen"}, 
{
	"citycode": "MST", 
	"airport": "Maastricht-Aachen Airport", 
	"country": "Netherlands", 
	"city": "Maastricht"}, 
{
	"citycode": "RTM", 
	"airport": "Rotterdam The Hague Airport", 
	"country": "Netherlands", 
	"city": "Rotterdam"}, 
{
	"citycode": "AKL", 
	"airport": "Auckland International Airport", 
	"country": "New Zealand", 
	"city": "Auckland"}, 
{
	"citycode": "ALR", 
	"airport": "Alexandra Aerodrome", 
	"country": "New Zealand", 
	"city": "Alexandra"}, 
{
	"citycode": "BHE", 
	"airport": "Woodbourne Airport", 
	"country": "New Zealand", 
	"city": "Blenheim"}, 
{
	"citycode": "CHC", 
	"airport": "Christchurch Airport", 
	"country": "New Zealand", 
	"city": "Christchurch"}, 
{
	"citycode": "DUD", 
	"airport": "Dunedin Airport", 
	"country": "New Zealand", 
	"city": "Dunedin"}, 
{
	"citycode": "GIS", 
	"airport": "Gisborne Airport", 
	"country": "New Zealand", 
	"city": "Gisborne"}, 
{
	"citycode": "GTN", 
	"airport": "Glentanner Aerodrome", 
	"country": "New Zealand", 
	"city": "Mount Cook"}, 
{
	"citycode": "HKK", 
	"airport": "Hokitika Airport", 
	"country": "New Zealand", 
	"city": "Hokitika"}, 
{
	"citycode": "HLZ", 
	"airport": "Hamilton Airport", 
	"country": "New Zealand", 
	"city": "Hamilton"}, 
{
	"citycode": "IVC", 
	"airport": "Invercargill Airport", 
	"country": "New Zealand", 
	"city": "Invercargill"}, 
{
	"citycode": "KAT", 
	"airport": "Kaitaia Airport", 
	"country": "New Zealand", 
	"city": "Kaitaia"}, 
{
	"citycode": "KKE", 
	"airport": "Kerikeri Airport", 
	"country": "New Zealand", 
	"city": "Kerikeri"}, 
{
	"citycode": "MFN", 
	"airport": "Milford Sound Airport", 
	"country": "New Zealand", 
	"city": "Milford Sound"}, 
{
	"citycode": "MON", 
	"airport": "Mount Cook Airport", 
	"country": "New Zealand", 
	"city": "Mount Cook"}, 
{
	"citycode": "MRO", 
	"airport": "Base Marambio Island´s Airport", 
	"country": "New Zealand", 
	"city": "Masterton"}, 
{
	"citycode": "MZP", 
	"airport": "Motueka Aerodrome", 
	"country": "New Zealand", 
	"city": "Motueka"}, 
{
	"citycode": "NPE", 
	"airport": "Hawkes Bay Airport", 
	"country": "New Zealand", 
	"city": "Napier-Hastings"}, 
{
	"citycode": "NPL", 
	"airport": "New Plymouth Airport", 
	"country": "New Zealand", 
	"city": "New Plymouth"}, 
{
	"citycode": "NSN", 
	"airport": "Nelson Airport", 
	"country": "New Zealand", 
	"city": "Nelson"}, 
{
	"citycode": "OAM", 
	"airport": "Oamaru Airport", 
	"country": "New Zealand", 
	"city": "Oamaru"}, 
{
	"citycode": "PCN", 
	"airport": "Picton Aerodrome", 
	"country": "New Zealand", 
	"city": "Picton"}, 
{
	"citycode": "PMR", 
	"airport": "Palmerston North Airport", 
	"country": "New Zealand", 
	"city": "Palmerston North"}, 
{
	"citycode": "PPQ", 
	"airport": "Kapiti Coast Airport", 
	"country": "New Zealand", 
	"city": "Paraparaumu"}, 
{
	"citycode": "ROT", 
	"airport": "Rotorua Regional Airport", 
	"country": "New Zealand", 
	"city": "Rotorua"}, 
{
	"citycode": "SZS", 
	"airport": "Ryan`s Creek Airport", 
	"country": "New Zealand", 
	"city": "Stewart Island"}, 
{
	"citycode": "TEU", 
	"airport": "Te Anau-Manapouri Airport", 
	"country": "New Zealand", 
	"city": "Te Anau"}, 
{
	"citycode": "TIU", 
	"airport": "Richard Pearse-Timaru-Levels Airport", 
	"country": "New Zealand", 
	"city": "Timaru"}, 
{
	"citycode": "TRG", 
	"airport": "Tauranga Airport", 
	"country": "New Zealand", 
	"city": "Tauranga"}, 
{
	"citycode": "TUO", 
	"airport": "Taupo Airport", 
	"country": "New Zealand", 
	"city": "Taupo"}, 
{
	"citycode": "WAG", 
	"airport": "Whanganui Airport", 
	"country": "New Zealand", 
	"city": "Wanganui"}, 
{
	"citycode": "WHK", 
	"airport": "Whakatane Airport", 
	"country": "New Zealand", 
	"city": "Whakatane"}, 
{
	"citycode": "WKA", 
	"airport": "Wanaka Airport", 
	"country": "New Zealand", 
	"city": "Wanaka"}, 
{
	"citycode": "WLG", 
	"airport": "Wellington International Airport", 
	"country": "New Zealand", 
	"city": "Wellington"}, 
{
	"citycode": "WRE", 
	"airport": "Whangarei Airport", 
	"country": "New Zealand", 
	"city": "Whangarei"}, 
{
	"citycode": "WSZ", 
	"airport": "Westport Airport", 
	"country": "New Zealand", 
	"city": "Westport"}, 
{
	"citycode": "ZQN", 
	"airport": "Queenstown International Airport", 
	"country": "New Zealand", 
	"city": "Queenstown"}, 
{
	"citycode": "ABB", 
	"airport": "Asaba International Airport", 
	"country": "Nigeria", 
	"city": "Asaba"}, 
{
	"citycode": "ABV", 
	"airport": "Nnamdi Azikiwe International Airport", 
	"country": "Nigeria", 
	"city": "Nnamdi Azikiwe International Airport"}, 
{
	"citycode": "AKR", 
	"airport": "Akron Airport", 
	"country": "Nigeria", 
	"city": "Akure"}, 
{
	"citycode": "BCU", 
	"airport": "Sir Abubakar Tafawa Balewa International Airport", 
	"country": "Nigeria", 
	"city": "Bauchi"}, 
{
	"citycode": "BNI", 
	"airport": "Benin City Airport", 
	"country": "Nigeria", 
	"city": "Benin City"}, 
{
	"citycode": "CBQ", 
	"airport": "Margaret Ekpo International Airport", 
	"country": "Nigeria", 
	"city": "Calabar"}, 
{
	"citycode": "ENU", 
	"airport": "Akanu Ibiam International Airport", 
	"country": "Nigeria", 
	"city": "Enugu"}, 
{
	"citycode": "IBA", 
	"airport": "Ibadan Airport", 
	"country": "Nigeria", 
	"city": "Ibadan"}, 
{
	"citycode": "ILR", 
	"airport": "Ilorin International Airport", 
	"country": "Nigeria", 
	"city": "Ilorin"}, 
{
	"citycode": "JOS", 
	"airport": "Yakubu Gowon Airport", 
	"country": "Nigeria", 
	"city": "Jos"}, 
{
	"citycode": "KAD", 
	"airport": "Kaduna Airport", 
	"country": "Nigeria", 
	"city": "Kaduna"}, 
{
	"citycode": "KAN", 
	"airport": "Aminu Kano International Airport", 
	"country": "Nigeria", 
	"city": "Kano"}, 
{
	"citycode": "LOS", 
	"airport": "Murtala Muhammed International Airport", 
	"country": "Nigeria", 
	"city": "Lagos"}, 
{
	"citycode": "MDI", 
	"airport": "Makurdi Airport", 
	"country": "Nigeria", 
	"city": "Makurdi"}, 
{
	"citycode": "MIU", 
	"airport": "Maiduguri International Airport", 
	"country": "Nigeria", 
	"city": "Maiduguri"}, 
{
	"citycode": "MXJ", 
	"airport": "Minna Airport", 
	"country": "Nigeria", 
	"city": "Minna"}, 
{
	"citycode": "PHC", 
	"airport": "Port Harcourt International Airport", 
	"country": "Nigeria", 
	"city": "Port Harcourt"}, 
{
	"citycode": "QOW", 
	"airport": "Sam Mbakwe Intl", 
	"country": "Nigeria", 
	"city": "Sam Mbakwe Intl"}, 
{
	"citycode": "SKO", 
	"airport": "Sultan Abubakar III International Airport", 
	"country": "Nigeria", 
	"city": "Sokoto"}, 
{
	"citycode": "YOL", 
	"airport": "Yola International Airport", 
	"country": "Nigeria", 
	"city": "Yola"}, 
{
	"citycode": "ZAR", 
	"airport": "Zaria Airport", 
	"country": "Nigeria", 
	"city": "Zaria"}, 
{
	"citycode": "AES", 
	"airport": "Alesund Airport", 
	"country": "Norway", 
	"city": "Aalesund"}, 
{
	"citycode": "ALF", 
	"airport": "Alta Airport", 
	"country": "Norway", 
	"city": "Alta"}, 
{
	"citycode": "ANX", 
	"airport": "Andoya Airport", 
	"country": "Norway", 
	"city": "Andenes"}, 
{
	"citycode": "BDU", 
	"airport": "Bardufoss Airport", 
	"country": "Norway", 
	"city": "Bardufoss"}, 
{
	"citycode": "BGO", 
	"airport": "Bergen Airport", 
	"country": "Norway", 
	"city": "Bergen"}, 
{
	"citycode": "BJF", 
	"airport": "Batsfjord Airport", 
	"country": "Norway", 
	"city": "Batsfjord"}, 
{
	"citycode": "BNN", 
	"airport": "Bronnoysund Airport", 
	"country": "Norway", 
	"city": "Bronnoysund"}, 
{
	"citycode": "BOO", 
	"airport": "Bodo Airport", 
	"country": "Norway", 
	"city": "Bodo"}, 
{
	"citycode": "BVG", 
	"airport": "Berlevag Airport", 
	"country": "Norway", 
	"city": "Berlevag"}, 
{
	"citycode": "EVE", 
	"airport": "Harstad/Narvik Airport", 
	"country": "Norway", 
	"city": "Harstad-Narvik"}, 
{
	"citycode": "FBU", 
	"airport": "Oslo Airport", 
	"country": "Norway", 
	"city": "OSLO FORNEBU"}, 
{
	"citycode": "FDE", 
	"airport": "Forde Airport ", 
	"country": "Norway", 
	"city": "Forde"}, 
{
	"citycode": "FRO", 
	"airport": "Flora Airport", 
	"country": "Norway", 
	"city": "Floro"}, 
{
	"citycode": "GEN", 
	"airport": "Gardermoen Airport", 
	"country": "Norway", 
	"city": "OSLO GARDERMOEN"}, 
{
	"citycode": "HAA", 
	"airport": "Hasvik Airport", 
	"country": "Norway", 
	"city": "Hasvik"}, 
{
	"citycode": "HAU", 
	"airport": "Haugesund Airport", 
	"country": "Norway", 
	"city": "Haugesund"}, 
{
	"citycode": "HFT", 
	"airport": "Hammerfest Airport", 
	"country": "Norway", 
	"city": "Hammerfest"}, 
{
	"citycode": "HOV", 
	"airport": "Orsta-Volda Airport", 
	"country": "Norway", 
	"city": "Orsta-Volda"}, 
{
	"citycode": "HVG", 
	"airport": "Honningsvag Airport", 
	"country": "Norway", 
	"city": "Honningsvag"}, 
{
	"citycode": "KKN", 
	"airport": "Kirkenes Airport", 
	"country": "Norway", 
	"city": "Kirkenes"}, 
{
	"citycode": "KRS", 
	"airport": "Kristiansand Airport", 
	"country": "Norway", 
	"city": "Kristiansand"}, 
{
	"citycode": "KSU", 
	"airport": "Kristiansund Airport", 
	"country": "Norway", 
	"city": "Kristiansund"}, 
{
	"citycode": "LKL", 
	"airport": "Lakselv Airport", 
	"country": "Norway", 
	"city": "Lakselv"}, 
{
	"citycode": "LKN", 
	"airport": "Leknes (LKN)", 
	"country": "Norway", 
	"city": "Leknes"}, 
{
	"citycode": "MEH", 
	"airport": "Mehamn Airport", 
	"country": "Norway", 
	"city": "Mehamn"}, 
{
	"citycode": "MJF", 
	"airport": "Mosjoen Airport ", 
	"country": "Norway", 
	"city": "Mosjoen"}, 
{
	"citycode": "MOL", 
	"airport": "Molde Airport", 
	"country": "Norway", 
	"city": "Molde"}, 
{
	"citycode": "MQN", 
	"airport": "Mo i Rana Airport", 
	"country": "Norway", 
	"city": "Mo I Rana"}, 
{
	"citycode": "NVK", 
	"airport": "Narvik Airport", 
	"country": "Norway", 
	"city": "Narvik"}, 
{
	"citycode": "OSL", 
	"airport": "Oslo Gardermoen Airport", 
	"country": "Norway", 
	"city": "Oslo"}, 
{
	"citycode": "OSY", 
	"airport": "Namsos Airport", 
	"country": "Norway", 
	"city": "Namsos"}, 
{
	"citycode": "RET", 
	"airport": "Rost Airport", 
	"country": "Norway", 
	"city": "Rost"}, 
{
	"citycode": "RRS", 
	"airport": "Roros Airport", 
	"country": "Norway", 
	"city": "Roros"}, 
{
	"citycode": "RVK", 
	"airport": "Rorvik Airport", 
	"country": "Norway", 
	"city": "Roervik"}, 
{
	"citycode": "SDN", 
	"airport": "Sandane Airport", 
	"country": "Norway", 
	"city": "Sandane"}, 
{
	"citycode": "SKE", 
	"airport": "Skien Airport", 
	"country": "Norway", 
	"city": "Skien"}, 
{
	"citycode": "SKN", 
	"airport": "Stokmarknes Airport", 
	"country": "Norway", 
	"city": "Stokmarknes"}, 
{
	"citycode": "SOG", 
	"airport": "Sogndal Airport", 
	"country": "Norway", 
	"city": "Sogndal"}, 
{
	"citycode": "SOJ", 
	"airport": "Sorkjosen Airport", 
	"country": "Norway", 
	"city": "Sorkjosen"}, 
{
	"citycode": "SSJ", 
	"airport": "Sandnessjoen Airport", 
	"country": "Norway", 
	"city": "Sandnessjoen"}, 
{
	"citycode": "SVG", 
	"airport": "Stavanger Airport", 
	"country": "Norway", 
	"city": "Stavanger"}, 
{
	"citycode": "SVJ", 
	"airport": "Svolv?r Airport", 
	"country": "Norway", 
	"city": "Svolvaer"}, 
{
	"citycode": "TOS", 
	"airport": "Tromso Airport", 
	"country": "Norway", 
	"city": "Tromso"}, 
{
	"citycode": "TRD", 
	"airport": "Trondheim Airport", 
	"country": "Norway", 
	"city": "Trondheim"}, 
{
	"citycode": "TRF", 
	"airport": "Sandefjord Airport", 
	"country": "Norway", 
	"city": "Oslo"}, 
{
	"citycode": "VAW", 
	"airport": "Vardoe Airport", 
	"country": "Norway", 
	"city": "Vardoe"}, 
{
	"citycode": "VDB", 
	"airport": "Fagernes Airport", 
	"country": "Norway", 
	"city": "Fagernes"}, 
{
	"citycode": "VDS", 
	"airport": "Vadso Airport", 
	"country": "Norway", 
	"city": "Vadso"}, 
{
	"citycode": "BYB", 
	"airport": "Dibaa Airport", 
	"country": "Oman", 
	"city": "Dibaa"}, 
{
	"citycode": "DQM", 
	"airport": "DQM", 
	"country": "Oman", 
	"city": "Al Wusta Region"}, 
{
	"citycode": "KHS", 
	"airport": "Khasab Airport", 
	"country": "Oman", 
	"city": "Khasab"}, 
{
	"citycode": "MSH", 
	"airport": "Masirah Airport", 
	"country": "Oman", 
	"city": "Masirah"}, 
{
	"citycode": "OHS", 
	"airport": "Sohar International Airport", 
	"country": "Oman", 
	"city": "Sohar"}, 
{
	"citycode": "SLL", 
	"airport": "Salalah International Airport", 
	"country": "Oman", 
	"city": "Salalah"}, 
{
	"citycode": "SUH", 
	"airport": "Sur Airport", 
	"country": "Oman", 
	"city": "Sur"}, 
{
	"citycode": "BHC", 
	"airport": "Bhurban Airport", 
	"country": "Pakistan", 
	"city": "Bhurban"}, 
{
	"citycode": "BHV", 
	"airport": "BAHAWALPUR", 
	"country": "Pakistan", 
	"city": "BAHAWALPUR"}, 
{
	"citycode": "DEA", 
	"airport": "DERA GHAZI KHAN INTERNATIONAL", 
	"country": "Pakistan", 
	"city": "DERA GHAZI KHAN"}, 
{
	"citycode": "KDU", 
	"airport": "Skardu International Airport", 
	"country": "Pakistan", 
	"city": "Skardu"}, 
{
	"citycode": "KHI", 
	"airport": "Jinnah International Airport", 
	"country": "Pakistan", 
	"city": "Karachi"}, 
{
	"citycode": "LYP", 
	"airport": "Faisalabad International Airport", 
	"country": "Pakistan", 
	"city": "Faisalabad"}, 
{
	"citycode": "MFG", 
	"airport": "Muzaffarabad Airport", 
	"country": "Pakistan", 
	"city": "Muzaffarabad"}, 
{
	"citycode": "MJD", 
	"airport": "Mohenjodaro Airport", 
	"country": "Pakistan", 
	"city": "Mohenjodaro"}, 
{
	"citycode": "MPD", 
	"airport": "Mirpur Khas Airport", 
	"country": "Pakistan", 
	"city": "Mirpur Khas"}, 
{
	"citycode": "MUX", 
	"airport": "Multan International Airport", 
	"country": "Pakistan", 
	"city": "Multan"}, 
{
	"citycode": "MWD", 
	"airport": "Mianwali Airport", 
	"country": "Pakistan", 
	"city": "Mianwali"}, 
{
	"citycode": "OHT", 
	"airport": "Kohat Airport", 
	"country": "Pakistan", 
	"city": "Kohat"}, 
{
	"citycode": "ORW", 
	"airport": "Ormara Airport", 
	"country": "Pakistan", 
	"city": "Ormara"}, 
{
	"citycode": "PEW", 
	"airport": "Bacha Khan International Airport Peshawar", 
	"country": "Pakistan", 
	"city": "Peshawar"}, 
{
	"citycode": "PJG", 
	"airport": "Panjgur Airport", 
	"country": "Pakistan", 
	"city": "Panjgur"}, 
{
	"citycode": "PSI", 
	"airport": "Pasni Airport", 
	"country": "Pakistan", 
	"city": "Pasni"}, 
{
	"citycode": "PZH", 
	"airport": "Zhob Airport", 
	"country": "Pakistan", 
	"city": "Zhob"}, 
{
	"citycode": "RAZ", 
	"airport": "Rawalakot Airport", 
	"country": "Pakistan", 
	"city": "Rawala Kot"}, 
{
	"citycode": "RYK", 
	"airport": "Shaikh Zayed International Airport", 
	"country": "Pakistan", 
	"city": "Rahim Yar Khan"}, 
{
	"citycode": "SDT", 
	"airport": "Saidu Sharif Airport", 
	"country": "Pakistan", 
	"city": "Saidu Sharif"}, 
{
	"citycode": "SKT", 
	"airport": "SIALKOT", 
	"country": "Pakistan", 
	"city": "Sialkot"}, 
{
	"citycode": "SKZ", 
	"airport": "Sukkur Airport", 
	"country": "Pakistan", 
	"city": "Sukkur"}, 
{
	"citycode": "SUL", 
	"airport": "Sui Airport", 
	"country": "Pakistan", 
	"city": "Sui"}, 
{
	"citycode": "TUK", 
	"airport": "Turbat International Airport", 
	"country": "Pakistan", 
	"city": "Turbat"}, 
{
	"citycode": "UET", 
	"airport": "Quetta International Airport", 
	"country": "Pakistan", 
	"city": "Quetta"}, 
{
	"citycode": "WNS", 
	"airport": "Nawabshah Airport", 
	"country": "Pakistan", 
	"city": "Nawabshah"}, 
{
	"citycode": "BAG", 
	"airport": "Baguio Loakan Airport", 
	"country": "Philippines", 
	"city": "Baguio"}, 
{
	"citycode": "BCD", 
	"airport": "Bacolod–Silay Airport", 
	"country": "Philippines", 
	"city": "Bacolod"}, 
{
	"citycode": "BXU", 
	"airport": "Butuan-Bancasi Airport", 
	"country": "Philippines", 
	"city": "Butuan"}, 
{
	"citycode": "CBO", 
	"airport": "Cotabato Airport", 
	"country": "Philippines", 
	"city": "Cotabato"}, 
{
	"citycode": "CEB", 
	"airport": "Mactan-Cebu International Airport", 
	"country": "Philippines", 
	"city": "Cebu"}, 
{
	"citycode": "CGY", 
	"airport": "Laguindingan International Airport", 
	"country": "Philippines", 
	"city": "Cagayan De Oro"}, 
{
	"citycode": "CRK", 
	"airport": "Clark International Airport", 
	"country": "Philippines", 
	"city": "Luzon Island"}, 
{
	"citycode": "CYZ", 
	"airport": "Cauayan", 
	"country": "Philippines", 
	"city": "Philippines"}, 
{
	"citycode": "DGT", 
	"airport": "Dumaguete–Sibulan Airport", 
	"country": "Philippines", 
	"city": "Dumaguete"}, 
{
	"citycode": "DPL", 
	"airport": "Dipolog", 
	"country": "Philippines", 
	"city": "Dipolog"}, 
{
	"citycode": "DRP", 
	"airport": "Bicol International Airport", 
	"country": "Philippines", 
	"city": "Bicol"}, 
{
	"citycode": "DVO", 
	"airport": "Davao International Airport (Francisco Bangoy International Airport)", 
	"country": "Philippines", 
	"city": "Davao"}, 
{
	"citycode": "GES", 
	"airport": "General Santos International Airport", 
	"country": "Philippines", 
	"city": "General Santos"}, 
{
	"citycode": "ILO", 
	"airport": "Iloilo International Airport", 
	"country": "Philippines", 
	"city": "Iloilo"}, 
{
	"citycode": "KLO", 
	"airport": "Kalibo International Airport", 
	"country": "Philippines", 
	"city": "Kalibo"}, 
{
	"citycode": "LGP", 
	"airport": "Legazpi Airport", 
	"country": "Philippines", 
	"city": "Legaspi"}, 
{
	"citycode": "MPH", 
	"airport": "Godofredo P. Ramos Airport", 
	"country": "Philippines", 
	"city": "CATICLAN"}, 
{
	"citycode": "OZC", 
	"airport": "Ozamiz", 
	"country": "Philippines", 
	"city": "Ozamiz"}, 
{
	"citycode": "PAG", 
	"airport": "Pagadian", 
	"country": "Philippines", 
	"city": "Pagadian"}, 
{
	"citycode": "PPS", 
	"airport": "Puerto Princesa International Airport", 
	"country": "Philippines", 
	"city": "Puerto Princesa"}, 
{
	"citycode": "RXS", 
	"airport": "Roxas", 
	"country": "Philippines", 
	"city": "Roxas"}, 
{
	"citycode": "SFS", 
	"airport": "Subic Bay International Airport", 
	"country": "Philippines", 
	"city": "Subic Bay"}, 
{
	"citycode": "SJI", 
	"airport": "San Jose Airport", 
	"country": "Philippines", 
	"city": "San Jose"}, 
{
	"citycode": "TAC", 
	"airport": "Daniel Z. Romualdez Airport", 
	"country": "Philippines", 
	"city": "Tacloban"}, 
{
	"citycode": "TAG", 
	"airport": "Tagbilaran", 
	"country": "Philippines", 
	"city": "Tagbilaran"}, 
{
	"citycode": "TUG", 
	"airport": "Tuguegarao Airport", 
	"country": "Philippines", 
	"city": "Tuguegarao"}, 
{
	"citycode": "WNP", 
	"airport": "Naga", 
	"country": "Philippines", 
	"city": "Naga"}, 
{
	"citycode": "ZAM", 
	"airport": "Zamboanga International Airport", 
	"country": "Philippines", 
	"city": "Zamboanga"}, 
{
	"citycode": "CZW", 
	"airport": "Czestochowa-Rudniki Airport", 
	"country": "Poland", 
	"city": "Czestochowa"}, 
{
	"citycode": "GDN", 
	"airport": "Gdansk Lech Walesa Airport", 
	"country": "Poland", 
	"city": "Gdansk"}, 
{
	"citycode": "KRK", 
	"airport": "J. Paul II Balice International Airport", 
	"country": "Poland", 
	"city": "Krakow"}, 
{
	"citycode": "KTW", 
	"airport": "Katowice International Airport", 
	"country": "Poland", 
	"city": "Katowice"}, 
{
	"citycode": "POZ", 
	"airport": "Poznan Airport", 
	"country": "Poland", 
	"city": "Poznan"}, 
{
	"citycode": "RZE", 
	"airport": "Rzeszow-Jasionka Airport", 
	"country": "Poland", 
	"city": "Rzeszow"}, 
{
	"citycode": "SZZ", 
	"airport": "Solidarity Szczecin-Goleniow Airport", 
	"country": "Poland", 
	"city": "Szczecin"}, 
{
	"citycode": "WAW", 
	"airport": "Warsaw Chopin Airport", 
	"country": "Poland", 
	"city": "Warsaw"}, 
{
	"citycode": "WRO", 
	"airport": "Wroclaw Nicolaus Copernicus Airport", 
	"country": "Poland", 
	"city": "Wroclaw"}, 
{
	"citycode": "BGC", 
	"airport": "Aérodrome de Bragance Airport", 
	"country": "Portugal", 
	"city": "Braganca"}, 
{
	"citycode": "FAO", 
	"airport": "Faro International Airport", 
	"country": "Portugal", 
	"city": "Faro"}, 
{
	"citycode": "FLW", 
	"airport": "Flores Airport", 
	"country": "Portugal", 
	"city": "Flores Island"}, 
{
	"citycode": "FNC", 
	"airport": "Madeira Airport International Cristiano Ronaldo", 
	"country": "Portugal", 
	"city": "Funchal"}, 
{
	"citycode": "GRW", 
	"airport": "Graciosa Airport", 
	"country": "Portugal", 
	"city": "Graciosa Island"}, 
{
	"citycode": "HOR", 
	"airport": "Horta Airport", 
	"country": "Portugal", 
	"city": "Horta"}, 
{
	"citycode": "LIS", 
	"airport": "Lisbon Airport", 
	"country": "Portugal", 
	"city": "Lisbon"}, 
{
	"citycode": "OPO", 
	"airport": "Porto Airport", 
	"country": "Portugal", 
	"city": "Porto"}, 
{
	"citycode": "PDL", 
	"airport": "Ponta Delgada - Joao Paulo II Airport", 
	"country": "Portugal", 
	"city": "Ponta Delgada"}, 
{
	"citycode": "PIX", 
	"airport": "Pico Airport", 
	"country": "Portugal", 
	"city": "Pico Island"}, 
{
	"citycode": "PXO", 
	"airport": "Porto Santo Airport", 
	"country": "Portugal", 
	"city": "Porto Santo"}, 
{
	"citycode": "SJZ", 
	"airport": "Sao Jorge Airport", 
	"country": "Portugal", 
	"city": "Sao Jorge Island"}, 
{
	"citycode": "SMA", 
	"airport": "Santa Maria Airport ", 
	"country": "Portugal", 
	"city": "Santa Maria"}, 
{
	"citycode": "TER", 
	"airport": "Lajes Terceira Island", 
	"country": "Portugal", 
	"city": "Terceira Island"}, 
{
	"citycode": "VRL", 
	"airport": "Vila Real Airport", 
	"country": "Portugal", 
	"city": "Vila Real"}, 
{
	"citycode": "DIA", 
	"airport": "Doha International Airport", 
	"country": "Qatar", 
	"city": "Doha"}, 
{
	"citycode": "DOH", 
	"airport": "Hamad International Airport", 
	"country": "Qatar", 
	"city": "Doha"}, 
{
	"citycode": "AAQ", 
	"airport": "Anapa International Airport", 
	"country": "Russia", 
	"city": "Anapa"}, 
{
	"citycode": "ABA", 
	"airport": "Abakan International Airport", 
	"country": "Russia", 
	"city": "Abakan"}, 
{
	"citycode": "AER", 
	"airport": "Sochi International Airport", 
	"country": "Russia", 
	"city": "Adler-Sochi"}, 
{
	"citycode": "ARH", 
	"airport": "Talagi Airport", 
	"country": "Russia", 
	"city": "Arkhangelsk"}, 
{
	"citycode": "ASF", 
	"airport": "Astrakhan International Airport", 
	"country": "Russia", 
	"city": "Astrakhan"}, 
{
	"citycode": "BAX", 
	"airport": "Barnaul Airport", 
	"country": "Russia", 
	"city": "Barnaul"}, 
{
	"citycode": "BKA", 
	"airport": "Bykovo Airport", 
	"country": "Russia", 
	"city": "Moscow"}, 
{
	"citycode": "BQS", 
	"airport": "Ignatyevo Airport", 
	"country": "Russia", 
	"city": "Ignatyevo"}, 
{
	"citycode": "BTK", 
	"airport": "Bratsk Airport", 
	"country": "Russia", 
	"city": "Bratsk"}, 
{
	"citycode": "CEK", 
	"airport": "Chelyabinsk airport", 
	"country": "Russia", 
	"city": "Chelyabinsk"}, 
{
	"citycode": "DME", 
	"airport": "Moscow Domodedovo Mikhail Lomonosov Airport", 
	"country": "Russia", 
	"city": "Moscow"}, 
{
	"citycode": "GDX", 
	"airport": "Magadan Airport", 
	"country": "Russia", 
	"city": "Magadan"}, 
{
	"citycode": "GOJ", 
	"airport": "Strigino Airport", 
	"country": "Russia", 
	"city": "Nizhniy Novgorod"}, 
{
	"citycode": "GRV", 
	"airport": "Grozny Airport", 
	"country": "Russia", 
	"city": "Groznyj"}, 
{
	"citycode": "HTA", 
	"airport": "Chita-kadala Airport", 
	"country": "Russia", 
	"city": "Chita"}, 
{
	"citycode": "IAA", 
	"airport": "Igarka Airport", 
	"country": "Russia", 
	"city": "Igarka"}, 
{
	"citycode": "IKS", 
	"airport": "Tiksi Aerodrome", 
	"country": "Russia", 
	"city": "Tiksi"}, 
{
	"citycode": "IKT", 
	"airport": "Irkutsk International Airport", 
	"country": "Russia", 
	"city": "Irkutsk"}, 
{
	"citycode": "KEJ", 
	"airport": "Kemerovo Airport", 
	"country": "Russia", 
	"city": "Kemerovo"}, 
{
	"citycode": "KGD", 
	"airport": "Khrabrovo Airport", 
	"country": "Russia", 
	"city": "Kaliningrad"}, 
{
	"citycode": "KHV", 
	"airport": "Khabarovsk Novy Airport", 
	"country": "Russia", 
	"city": "Khabarovsk"}, 
{
	"citycode": "KJA", 
	"airport": "Krasnoyarsk International Airport", 
	"country": "Russia", 
	"city": "Krasnojarsk"}, 
{
	"citycode": "KRO", 
	"airport": "Kurgan Airport", 
	"country": "Russia", 
	"city": "Kurgan"}, 
{
	"citycode": "KRR", 
	"airport": "Krasnodar International Airport", 
	"country": "Russia", 
	"city": "Krasnodar"}, 
{
	"citycode": "KUF", 
	"airport": "Kurumoch International Airport", 
	"country": "Russia", 
	"city": "Samara"}, 
{
	"citycode": "KVX", 
	"airport": "Pobedilovo Airport", 
	"country": "Russia", 
	"city": "Kirov"}, 
{
	"citycode": "KYZ", 
	"airport": "Kyzyl Airport", 
	"country": "Russia", 
	"city": "Kyzyl"}, 
{
	"citycode": "KZN", 
	"airport": "Kazan International Airport", 
	"country": "Russia", 
	"city": "Kazan"}, 
{
	"citycode": "LED", 
	"airport": "Pulkovo Airport", 
	"country": "Russia", 
	"city": "St Petersburg"}, 
{
	"citycode": "MCX", 
	"airport": "Makhachkala Uytash Airport ", 
	"country": "Russia", 
	"city": "Makhachkala"}, 
{
	"citycode": "MJZ", 
	"airport": "Mirny Airport", 
	"country": "Russia", 
	"city": "Mirnyj"}, 
{
	"citycode": "MMK", 
	"airport": "Murmansk Airport", 
	"country": "Russia", 
	"city": "Murmansk"}, 
{
	"citycode": "MOW", 
	"airport": "All Airports Moscow", 
	"country": "Russia", 
	"city": "Moscow"}, 
{
	"citycode": "MQF", 
	"airport": "Magnitogorsk International Airport", 
	"country": "Russia", 
	"city": "Magnitogorsk"}, 
{
	"citycode": "MRV", 
	"airport": "Mineralnye Vody Airport", 
	"country": "Russia", 
	"city": "Mineralnye Vody"}, 
{
	"citycode": "NAL", 
	"airport": "Nal Air Force Station", 
	"country": "Russia", 
	"city": "Nalchik"}, 
{
	"citycode": "NBC", 
	"airport": "Begishevo Airport", 
	"country": "Russia", 
	"city": "Naberevnye Chelny"}, 
{
	"citycode": "NER", 
	"airport": "Neryungri Airport", 
	"country": "Russia", 
	"city": "Neryungri"}, 
{
	"citycode": "NOZ", 
	"airport": "Novokuznetsk Airport", 
	"country": "Russia", 
	"city": "Novokuznetsk"}, 
{
	"citycode": "NSK", 
	"airport": "Norilsk Airport", 
	"country": "Russia", 
	"city": "Noril`sk"}, 
{
	"citycode": "OGZ", 
	"airport": "Vladikavkaz International Airport", 
	"country": "Russia", 
	"city": "Vladikavkaz"}, 
{
	"citycode": "OMS", 
	"airport": "Central Airport", 
	"country": "Russia", 
	"city": "Omsk"}, 
{
	"citycode": "OVB", 
	"airport": "Novosibirsk International Airport", 
	"country": "Russia", 
	"city": "Novosibirsk"}, 
{
	"citycode": "PEE", 
	"airport": "Perm International Airport", 
	"country": "Russia", 
	"city": "Perm"}, 
{
	"citycode": "PKC", 
	"airport": "Petropavlovsk-Kamchatsky Airport", 
	"country": "Russia", 
	"city": "Petropavlovsk-Kamchats"}, 
{
	"citycode": "REN", 
	"airport": "Orenburg Airport", 
	"country": "Russia", 
	"city": "Orenburg"}, 
{
	"citycode": "ROV", 
	"airport": "Platov International Airport", 
	"country": "Russia", 
	"city": "Rostov"}, 
{
	"citycode": "RTW", 
	"airport": "Saratov Central Airport", 
	"country": "Russia", 
	"city": "Saratov"}, 
{
	"citycode": "SCW", 
	"airport": "Syktyvkar Airport", 
	"country": "Russia", 
	"city": "Syktyvkar"}, 
{
	"citycode": "SGC", 
	"airport": "Surgut International Airport", 
	"country": "Russia", 
	"city": "Surgut"}, 
{
	"citycode": "STW", 
	"airport": "Stavropol Shpakovskoye Airport", 
	"country": "Russia", 
	"city": "Stavropol"}, 
{
	"citycode": "SVO", 
	"airport": "Sheremetyevo - A.S. Pushkin international airport", 
	"country": "Russia", 
	"city": "Moscow"}, 
{
	"citycode": "SVX", 
	"airport": "Koltsovo International Airport", 
	"country": "Russia", 
	"city": "Ekaterinburg"}, 
{
	"citycode": "TJM", 
	"airport": "Roshchino International Airport", 
	"country": "Russia", 
	"city": "Tyumen"}, 
{
	"citycode": "TOF", 
	"airport": "Bogashevo Airport", 
	"country": "Russia", 
	"city": "Tomsk"}, 
{
	"citycode": "UCT", 
	"airport": "Ukhta Airport", 
	"country": "Russia", 
	"city": "Ukhta"}, 
{
	"citycode": "UFA", 
	"airport": "Ufa International Airport", 
	"country": "Russia", 
	"city": "Ufa"}, 
{
	"citycode": "ULY", 
	"airport": "Ulyanovsk Vostochny Airport", 
	"country": "Russia", 
	"city": "Ulyanovsk"}, 
{
	"citycode": "UUD", 
	"airport": "Baikal International Airport", 
	"country": "Russia", 
	"city": "Ulan-Ude"}, 
{
	"citycode": "UUS", 
	"airport": "Yuzhno-Sakhalinsk International Airport", 
	"country": "Russia", 
	"city": "Yuzhno-Sakhalinsk"}, 
{
	"citycode": "VKO", 
	"airport": "Vnukovo International Airport", 
	"country": "Russia", 
	"city": "Moscow"}, 
{
	"citycode": "VKT", 
	"airport": "Vorkuta Airport", 
	"country": "Russia", 
	"city": "Vorkuta"}, 
{
	"citycode": "VOG", 
	"airport": "Volgograd International Airport", 
	"country": "Russia", 
	"city": "Volgograd"}, 
{
	"citycode": "VOZ", 
	"airport": "Voronezh Peter the Great Airport", 
	"country": "Russia", 
	"city": "Voronezh"}, 
{
	"citycode": "VVO", 
	"airport": "Vladivostok International Airport", 
	"country": "Russia", 
	"city": "Vladivostok"}, 
{
	"citycode": "YKS", 
	"airport": "Yakutsk Airport", 
	"country": "Russia", 
	"city": "Yakutsk"}, 
{
	"citycode": "ABT", 
	"airport": "King Saud Bin Abdulaziz Airport", 
	"country": "Saudi Arabia", 
	"city": "Al-Baha"}, 
{
	"citycode": "AHB", 
	"airport": "Abha International Airport", 
	"country": "Saudi Arabia", 
	"city": "Abha"}, 
{
	"citycode": "AJF", 
	"airport": "Al Jouf Domestic Airport", 
	"country": "Saudi Arabia", 
	"city": "Jouf"}, 
{
	"citycode": "AQI", 
	"airport": "Al Qaisumah-Hafar Al Batin Airport", 
	"country": "Saudi Arabia", 
	"city": "Qaisumah"}, 
{
	"citycode": "BHH", 
	"airport": "Bisha Domestic Airport", 
	"country": "Saudi Arabia", 
	"city": "Bisha"}, 
{
	"citycode": "DHA", 
	"airport": "King Abdulaziz Air Base", 
	"country": "Saudi Arabia", 
	"city": "Dhahran"}, 
{
	"citycode": "DMS", 
	"airport": "Sabtco Bus Station", 
	"country": "Saudi Arabia", 
	"city": "DAMMAM"}, 
{
	"citycode": "DWD", 
	"airport": "DWD", 
	"country": "Saudi Arabia", 
	"city": "Dawadmi Domestic Airport"}, 
{
	"citycode": "EAM", 
	"airport": "Najran Domestic Airport", 
	"country": "Saudi Arabia", 
	"city": "Najran"}, 
{
	"citycode": "EJH", 
	"airport": "Al Wajh Domestic Airport", 
	"country": "Saudi Arabia", 
	"city": "Al Wajh"}, 
{
	"citycode": "ELQ", 
	"airport": "Prince Naif Bin Abdulaziz International Airport", 
	"country": "Saudi Arabia", 
	"city": "Gassim"}, 
{
	"citycode": "GIZ", 
	"airport": "King Abdullah bin Abdulaziz International Airport", 
	"country": "Saudi Arabia", 
	"city": "Gizan"}, 
{
	"citycode": "HAS", 
	"airport": "Hail International Airport", 
	"country": "Saudi Arabia", 
	"city": "Hail"}, 
{
	"citycode": "HOF", 
	"airport": "Al-Ahsa International Airport", 
	"country": "Saudi Arabia", 
	"city": "Hofuf Airport"}, 
{
	"citycode": "MED", 
	"airport": "Prince Mohammed Bin Abdulaziz International Airport", 
	"country": "Saudi Arabia", 
	"city": "Madinah"}, 
{
	"citycode": "NUM", 
	"airport": "Neom Bay Airport", 
	"country": "Saudi Arabia", 
	"city": "Neom"}, 
{
	"citycode": "RAE", 
	"airport": "Arar Domestic Airport", 
	"country": "Saudi Arabia", 
	"city": "Arar"}, 
{
	"citycode": "RAH", 
	"airport": "Rafha Domestic Airport", 
	"country": "Saudi Arabia", 
	"city": "Rafha"}, 
{
	"citycode": "RSI", 
	"airport": "Red Sea International Airport", 
	"country": "Saudi Arabia", 
	"city": "Hanak"}, 
{
	"citycode": "RUJ", 
	"airport": "Saptco Olaya Bus Station", 
	"country": "Saudi Arabia", 
	"city": "Saptco BUS STATION"}, 
{
	"citycode": "SHW", 
	"airport": "Sharurah Domestic Airport", 
	"country": "Saudi Arabia", 
	"city": "Sharurah"}, 
{
	"citycode": "TIF", 
	"airport": "Taif International Airport", 
	"country": "Saudi Arabia", 
	"city": "Taif"}, 
{
	"citycode": "TUI", 
	"airport": "Turaif Domestic Airport", 
	"country": "Saudi Arabia", 
	"city": "Turaif"}, 
{
	"citycode": "TUU", 
	"airport": "Tabuk Regional Airport", 
	"country": "Saudi Arabia", 
	"city": "Tabuk"}, 
{
	"citycode": "ULH", 
	"airport": "Prince Abdul Majeed bin Abdulaziz International Airport", 
	"country": "Saudi Arabia", 
	"city": "Prince Abdul Majeed bin Abdulaziz"}, 
{
	"citycode": "URY", 
	"airport": "Gurayat Domestic Airport", 
	"country": "Saudi Arabia", 
	"city": "Gurayat"}, 
{
	"citycode": "WAE", 
	"airport": "Wadi Al Dawasir Airport", 
	"country": "Saudi Arabia", 
	"city": "Wadi Ad Dawasir"}, 
{
	"citycode": "YNB", 
	"airport": "Yanbu Airport", 
	"country": "Saudi Arabia", 
	"city": "Yanbu"}, 
{
	"citycode": "QPG", 
	"airport": "Paya Lebar Airbase", 
	"country": "Singapore", 
	"city": "Singapore"}, 
{
	"citycode": "XSP", 
	"airport": "Seletar Airport", 
	"country": "Singapore", 
	"city": "Singapore"}, 
{
	"citycode": "AGZ", 
	"airport": "Aggeneys Airport", 
	"country": "South Africa", 
	"city": "Aggeneys"}, 
{
	"citycode": "BFN", 
	"airport": "Bram Fischer International Airport", 
	"country": "South Africa", 
	"city": "Bloemfontein"}, 
{
	"citycode": "BIY", 
	"airport": "Bhisho Airport", 
	"country": "South Africa", 
	"city": "Bisho"}, 
{
	"citycode": "CPT", 
	"airport": "Cape Town International Airport", 
	"country": "South Africa", 
	"city": "Cape Town"}, 
{
	"citycode": "DUR", 
	"airport": "Durban International Airport", 
	"country": "South Africa", 
	"city": "Durban"}, 
{
	"citycode": "ELL", 
	"airport": "Ellisras Airport", 
	"country": "South Africa", 
	"city": "Ellisras"}, 
{
	"citycode": "ELS", 
	"airport": "King Phalo Airport", 
	"country": "South Africa", 
	"city": "East London"}, 
{
	"citycode": "GCJ", 
	"airport": "Grand Central Airport", 
	"country": "South Africa", 
	"city": "Johannesburg"}, 
{
	"citycode": "GRJ", 
	"airport": "George Airport", 
	"country": "South Africa", 
	"city": "George"}, 
{
	"citycode": "HLA", 
	"airport": "Lanseria International Airport", 
	"country": "South Africa", 
	"city": "Lanseria"}, 
{
	"citycode": "JNB", 
	"airport": "O.R. Tambo International Airport", 
	"country": "South Africa", 
	"city": "Johannesburg"}, 
{
	"citycode": "KIM", 
	"airport": "Kimberley Airport", 
	"country": "South Africa", 
	"city": "Kimberley"}, 
{
	"citycode": "KLZ", 
	"airport": "Kleinzee Airport", 
	"country": "South Africa", 
	"city": "Kleinzee"}, 
{
	"citycode": "LAY", 
	"airport": "Ladysmith Airport", 
	"country": "South Africa", 
	"city": "Ladysmith"}, 
{
	"citycode": "LCD", 
	"airport": "Louis Trichardt Airport", 
	"country": "South Africa", 
	"city": "Louis Trichardt"}, 
{
	"citycode": "MBD", 
	"airport": "Mahikeng Airport", 
	"country": "South Africa", 
	"city": "Mmabatho"}, 
{
	"citycode": "MEZ", 
	"airport": "Mena Intermountain Municipal Airport", 
	"country": "South Africa", 
	"city": "Messina"}, 
{
	"citycode": "MGH", 
	"airport": "Margate Airport", 
	"country": "South Africa", 
	"city": "Margate"}, 
{
	"citycode": "MZF", 
	"airport": "Mzamba Airport", 
	"country": "South Africa", 
	"city": "Mzamba"}, 
{
	"citycode": "NCS", 
	"airport": "Newcastle Airport", 
	"country": "South Africa", 
	"city": "Newcastle"}, 
{
	"citycode": "NLP", 
	"airport": "Nelspruit Airport", 
	"country": "South Africa", 
	"city": "Nelspruit (Mbombela)"}, 
{
	"citycode": "NTY", 
	"airport": "Pilanesberg International Airport", 
	"country": "South Africa", 
	"city": "Sun City"}, 
{
	"citycode": "PHW", 
	"airport": "Hendrik Van Eck Airport", 
	"country": "South Africa", 
	"city": "Phalaborwa"}, 
{
	"citycode": "PLZ", 
	"airport": "Port Elizabeth International Airport", 
	"country": "South Africa", 
	"city": "Port Elizabeth"}, 
{
	"citycode": "PRY", 
	"airport": "Wonderboom National Airport", 
	"country": "South Africa", 
	"city": "Pretoria"}, 
{
	"citycode": "PTG", 
	"airport": "Polokwane International Airport", 
	"country": "South Africa", 
	"city": "Pietersburg"}, 
{
	"citycode": "PZB", 
	"airport": "Pietermaritzburg Airport", 
	"country": "South Africa", 
	"city": "Pietermaritzburg"}, 
{
	"citycode": "RCB", 
	"airport": "Richards Bay Airport", 
	"country": "South Africa", 
	"city": "Richards Bay"}, 
{
	"citycode": "SBU", 
	"airport": "Springbok Airport", 
	"country": "South Africa", 
	"city": "Springbok"}, 
{
	"citycode": "SIS", 
	"airport": "Sishen Airport", 
	"country": "South Africa", 
	"city": "Sishen"}, 
{
	"citycode": "SZK", 
	"airport": "Skukuza Airport", 
	"country": "South Africa", 
	"city": "Skukuza"}, 
{
	"citycode": "TCU", 
	"airport": "Thaba Nchu Tar Airport", 
	"country": "South Africa", 
	"city": "Thaba Nchu"}, 
{
	"citycode": "THY", 
	"airport": "Thohoyandou Airport", 
	"country": "South Africa", 
	"city": "Thohoyandou"}, 
{
	"citycode": "TSD", 
	"airport": "Tshipise Airport", 
	"country": "South Africa", 
	"city": "Tshipise"}, 
{
	"citycode": "UTN", 
	"airport": "Upington Airport", 
	"country": "South Africa", 
	"city": "Upington"}, 
{
	"citycode": "UTT", 
	"airport": "Mthatha Airport", 
	"country": "South Africa", 
	"city": "Umtata"}, 
{
	"citycode": "VIR", 
	"airport": "Virginia Airport", 
	"country": "South Africa", 
	"city": "Durban"}, 
{
	"citycode": "VYD", 
	"airport": "Vryheid Airport", 
	"country": "South Africa", 
	"city": "Vryheid"}, 
{
	"citycode": "WEL", 
	"airport": "Welkom Airport", 
	"country": "South Africa", 
	"city": "Welkom"}, 
{
	"citycode": "AGP", 
	"airport": "Malaga Airport", 
	"country": "Spain", 
	"city": "Malaga"}, 
{
	"citycode": "ALC", 
	"airport": "Alicante Airport", 
	"country": "Spain", 
	"city": "Alicante"}, 
{
	"citycode": "BCN", 
	"airport": "Josep Tarradellas Barcelona-El Prat Airport", 
	"country": "Spain", 
	"city": "Barcelona"}, 
{
	"citycode": "BIO", 
	"airport": "Bilbao Airport", 
	"country": "Spain", 
	"city": "Bilbao"}, 
{
	"citycode": "EAS", 
	"airport": "San Sebastian Airport", 
	"country": "Spain", 
	"city": "San Sebastian"}, 
{
	"citycode": "GRO", 
	"airport": "Girona–Costa Brava Airport", 
	"country": "Spain", 
	"city": "Gerona"}, 
{
	"citycode": "GRX", 
	"airport": "Federico Garc?a Lorca Granada Airport", 
	"country": "Spain", 
	"city": "Granada"}, 
{
	"citycode": "IBZ", 
	"airport": "Ibiza Airport", 
	"country": "Spain", 
	"city": "Ibiza"}, 
{
	"citycode": "LCG", 
	"airport": "A Coruna Airport", 
	"country": "Spain", 
	"city": "La Coruna"}, 
{
	"citycode": "LEI", 
	"airport": "Almeria Airport", 
	"country": "Spain", 
	"city": "Almeria"}, 
{
	"citycode": "MAD", 
	"airport": "Adolfo Suarez Madrid–Barajas Airport", 
	"country": "Spain", 
	"city": "Madrid"}, 
{
	"citycode": "MJV", 
	"airport": "Murcia–San Javier Airport", 
	"country": "Spain", 
	"city": "Murcia"}, 
{
	"citycode": "MLN", 
	"airport": "Melilla Airport", 
	"country": "Spain", 
	"city": "Melilla"}, 
{
	"citycode": "OVD", 
	"airport": "Asturias Airport", 
	"country": "Spain", 
	"city": "Asturias"}, 
{
	"citycode": "PMI", 
	"airport": "Palma de Mallorca Airport", 
	"country": "Spain", 
	"city": "Palma"}, 
{
	"citycode": "PNA", 
	"airport": "Pamplona Airport", 
	"country": "Spain", 
	"city": "Pamplona"}, 
{
	"citycode": "REU", 
	"airport": "Reus Airport", 
	"country": "Spain", 
	"city": "Reus"}, 
{
	"citycode": "SCQ", 
	"airport": "Santiago-Rosal?a de Castro Airport", 
	"country": "Spain", 
	"city": "Santiago De Compostela"}, 
{
	"citycode": "SDR", 
	"airport": "Seve Ballesteros-Santander Airport", 
	"country": "Spain", 
	"city": "Santander"}, 
{
	"citycode": "SVQ", 
	"airport": "Seville Airport", 
	"country": "Spain", 
	"city": "Sevilla"}, 
{
	"citycode": "TCI", 
	"airport": "All Airports Tenerife", 
	"country": "Spain", 
	"city": "Tenerife"}, 
{
	"citycode": "VGO", 
	"airport": "Vigo Airport", 
	"country": "Spain", 
	"city": "Vigo"}, 
{
	"citycode": "VIT", 
	"airport": "Vitoria Airport", 
	"country": "Spain", 
	"city": "Vitoria"}, 
{
	"citycode": "VLC", 
	"airport": "Valencia Airport", 
	"country": "Spain", 
	"city": "Valencia"}, 
{
	"citycode": "VLL", 
	"airport": "Valladolid Airport", 
	"country": "Spain", 
	"city": "Valladolid"}, 
{
	"citycode": "XRY", 
	"airport": "Jerez Airport", 
	"country": "Spain", 
	"city": "Jerez de la Frontera"}, 
{
	"citycode": "ZAZ", 
	"airport": "Zaragoza Airport", 
	"country": "Spain", 
	"city": "Zaragoza"}, 
{
	"citycode": "CMB", 
	"airport": "Bandaranayake International Airport", 
	"country": "Sri Lanka", 
	"city": "Colombo"}, 
{
	"citycode": "HRI", 
	"airport": "Mattala Rajapaksa International Airport", 
	"country": "Sri Lanka", 
	"city": "Hambantota"}, 
{
	"citycode": "JAF", 
	"airport": "Jaffna International Airport", 
	"country": "Sri Lanka", 
	"city": "Palaly"}, 
{
	"citycode": "AGH", 
	"airport": "Angelholm/Helsingborg Airport", 
	"country": "Sweden", 
	"city": "Angelholm-Helsingborg"}, 
{
	"citycode": "AJR", 
	"airport": "Arvidsjaur Airport", 
	"country": "Sweden", 
	"city": "Arvidsjaur"}, 
{
	"citycode": "ARN", 
	"airport": "Stockholm Arlanda Airport", 
	"country": "Sweden", 
	"city": "Stockholm"}, 
{
	"citycode": "BLE", 
	"airport": "Dala Airport", 
	"country": "Sweden", 
	"city": "Borlange-Falun"}, 
{
	"citycode": "BMA", 
	"airport": "Bromma Stockholm Airport", 
	"country": "Sweden", 
	"city": "Stockholm"}, 
{
	"citycode": "EVG", 
	"airport": "Sveg Airport", 
	"country": "Sweden", 
	"city": "Sveg"}, 
{
	"citycode": "GEV", 
	"airport": "G?llivare Airport", 
	"country": "Sweden", 
	"city": "Gallivare"}, 
{
	"citycode": "GOT", 
	"airport": "Goteborg Landvetter Airport", 
	"country": "Sweden", 
	"city": "Gothenburg"}, 
{
	"citycode": "GSE", 
	"airport": "Save-Goteborg City Airport", 
	"country": "Sweden", 
	"city": "Gothenburg"}, 
{
	"citycode": "GVX", 
	"airport": "Gavle–Sandviken Airport", 
	"country": "Sweden", 
	"city": "Gavle"}, 
{
	"citycode": "HAD", 
	"airport": "Halmstad Airport", 
	"country": "Sweden", 
	"city": "Halmstad"}, 
{
	"citycode": "HLF", 
	"airport": "Hultsfred Airport", 
	"country": "Sweden", 
	"city": "Hultsfred"}, 
{
	"citycode": "HMA", 
	"airport": "Khanty Mansiysk Airport", 
	"country": "Sweden", 
	"city": "MALMOE CITY HOVERCRAFT APT."}, 
{
	"citycode": "HUV", 
	"airport": "Hudiksvall Airport", 
	"country": "Sweden", 
	"city": "Hudiksvall"}, 
{
	"citycode": "JHE", 
	"airport": "Helsingborg Airport", 
	"country": "Sweden", 
	"city": "Angelholm-Helsingborg"}, 
{
	"citycode": "JKG", 
	"airport": "Jonkoping Airport", 
	"country": "Sweden", 
	"city": "Jonkoping"}, 
{
	"citycode": "JLD", 
	"airport": "Landskrona Heliport", 
	"country": "Sweden", 
	"city": "Landskrona"}, 
{
	"citycode": "JMM", 
	"airport": "Malmo Harbour Heliport", 
	"country": "Sweden", 
	"city": "Malmo"}, 
{
	"citycode": "KID", 
	"airport": "Kristianstad Airport", 
	"country": "Sweden", 
	"city": "Kristianstad"}, 
{
	"citycode": "KLR", 
	"airport": "Kalmar Airport", 
	"country": "Sweden", 
	"city": "Kalmar"}, 
{
	"citycode": "KRF", 
	"airport": "High Coast Airport", 
	"country": "Sweden", 
	"city": "Kramfors"}, 
{
	"citycode": "KRN", 
	"airport": "Kiruna Airport", 
	"country": "Sweden", 
	"city": "Kiruna"}, 
{
	"citycode": "KSD", 
	"airport": "Karlstad Airport", 
	"country": "Sweden", 
	"city": "Karlstad"}, 
{
	"citycode": "KVB", 
	"airport": "Skovde Airport", 
	"country": "Sweden", 
	"city": "Skovde"}, 
{
	"citycode": "LDK", 
	"airport": "Lidkoping Airport", 
	"country": "Sweden", 
	"city": "Lidkoping"}, 
{
	"citycode": "LLA", 
	"airport": "Lule? Airport", 
	"country": "Sweden", 
	"city": "Lulea"}, 
{
	"citycode": "LPI", 
	"airport": "Link?ping City Airport", 
	"country": "Sweden", 
	"city": "Linkoping"}, 
{
	"citycode": "LYC", 
	"airport": "Lycksele Airport", 
	"country": "Sweden", 
	"city": "Lycksele"}, 
{
	"citycode": "MMA", 
	"airport": "Malmo Bulltofta Airport", 
	"country": "Sweden", 
	"city": "Malmo"}, 
{
	"citycode": "MMX", 
	"airport": "Malmo Airport", 
	"country": "Sweden", 
	"city": "Malmo"}, 
{
	"citycode": "MXX", 
	"airport": "Mora–Siljan Airport", 
	"country": "Sweden", 
	"city": "Mora"}, 
{
	"citycode": "NRK", 
	"airport": "Norrkoping Airport", 
	"country": "Sweden", 
	"city": "Norrkoping"}, 
{
	"citycode": "NYO", 
	"airport": "Stockholm Skavsta Airport", 
	"country": "Sweden", 
	"city": "Stockholm"}, 
{
	"citycode": "OER", 
	"airport": "Ornskoldsvik Airport", 
	"country": "Sweden", 
	"city": "Ornskoldsvik"}, 
{
	"citycode": "ORB", 
	"airport": "Orebro Airport", 
	"country": "Sweden", 
	"city": "Orebro"}, 
{
	"citycode": "OSD", 
	"airport": "Are Ostersund Airport", 
	"country": "Sweden", 
	"city": "Ostersund"}, 
{
	"citycode": "OSK", 
	"airport": "Oskarshamn Airport", 
	"country": "Sweden", 
	"city": "Oskarshamn"}, 
{
	"citycode": "RNB", 
	"airport": "Ronneby Airport", 
	"country": "Sweden", 
	"city": "Ronneby"}, 
{
	"citycode": "SDL", 
	"airport": "Sundsvall-Harnosand Airport", 
	"country": "Sweden", 
	"city": "Sundsvall"}, 
{
	"citycode": "SFT", 
	"airport": "Skelleftea Airport", 
	"country": "Sweden", 
	"city": "Skelleftea"}, 
{
	"citycode": "SOO", 
	"airport": "Soderhamn Airport", 
	"country": "Sweden", 
	"city": "Soderhamn"}, 
{
	"citycode": "STO", 
	"airport": "Stockholm airport", 
	"country": "Sweden", 
	"city": "Stockholm"}, 
{
	"citycode": "THN", 
	"airport": "Trollh?ttan–V?nersborg Airport", 
	"country": "Sweden", 
	"city": "Trollhattan"}, 
{
	"citycode": "UME", 
	"airport": "Umea Airport", 
	"country": "Sweden", 
	"city": "Umea"}, 
{
	"citycode": "VBY", 
	"airport": "Visby Airport", 
	"country": "Sweden", 
	"city": "Visby"}, 
{
	"citycode": "VHM", 
	"airport": "Vilhelmina Airport", 
	"country": "Sweden", 
	"city": "Vilhelmina"}, 
{
	"citycode": "VST", 
	"airport": "Stockholm Vasteras Airport", 
	"country": "Sweden", 
	"city": "Vasteras"}, 
{
	"citycode": "VXO", 
	"airport": "Vaxjo Kronoberg Airport", 
	"country": "Sweden", 
	"city": "Vaxjo"}, 
{
	"citycode": "ALP", 
	"airport": "Aleppo International Airport (Nejrab Airport)", 
	"country": "Syria", 
	"city": "Aleppo"}, 
{
	"citycode": "DAM", 
	"airport": "Damascus International Airport", 
	"country": "Syria", 
	"city": "Damascus"}, 
{
	"citycode": "DEZ", 
	"airport": "Deir ez-Zor Airport", 
	"country": "Syria", 
	"city": "Deirezzor"}, 
{
	"citycode": "KAC", 
	"airport": "Qamishli International Airport", 
	"country": "Syria", 
	"city": "Kameshli"}, 
{
	"citycode": "LTK", 
	"airport": "Bassel Al-Assad International Airport", 
	"country": "Syria", 
	"city": "Latakia"}, 
{
	"citycode": "CMJ", 
	"airport": "Qimei Airport", 
	"country": "Taiwan", 
	"city": "Chi Mei"}, 
{
	"citycode": "GNI", 
	"airport": "Lyudao Airport", 
	"country": "Taiwan", 
	"city": "Green Island"}, 
{
	"citycode": "HUN", 
	"airport": "Hualien Airport", 
	"country": "Taiwan", 
	"city": "Hualien"}, 
{
	"citycode": "KHH", 
	"airport": "Kaohsiung International Airport ", 
	"country": "Taiwan", 
	"city": "Kaohsiung"}, 
{
	"citycode": "KNH", 
	"airport": "Kinmen Airport", 
	"country": "Taiwan", 
	"city": "Kinmen"}, 
{
	"citycode": "KYD", 
	"airport": "Lanyu Airport", 
	"country": "Taiwan", 
	"city": "Orchid Island"}, 
{
	"citycode": "MZG", 
	"airport": "Penghu Airport", 
	"country": "Taiwan", 
	"city": "Makung"}, 
{
	"citycode": "RMQ", 
	"airport": "Taichung International Airport", 
	"country": "CHINESE TAIPEI", 
	"city": "Taichung"}, 
{
	"citycode": "TNN", 
	"airport": "Tainan Airport", 
	"country": "Taiwan", 
	"city": "Tainan"}, 
{
	"citycode": "TPE", 
	"airport": "Taiwan Taoyuan International Airport", 
	"country": "Taiwan", 
	"city": "Taipei"}, 
{
	"citycode": "TSA", 
	"airport": "Taipei Songshan Airport", 
	"country": "Taiwan", 
	"city": "Taipei"}, 
{
	"citycode": "TTT", 
	"airport": "Taitung Airport", 
	"country": "Taiwan", 
	"city": "Taitung"}, 
{
	"citycode": "TXG", 
	"airport": "Taichung International Airport", 
	"country": "Taiwan", 
	"city": "Taichung"}, 
{
	"citycode": "WOT", 
	"airport": "Wangan Airport", 
	"country": "Taiwan", 
	"city": "Wonan"}, 
{
	"citycode": "BKK", 
	"airport": "Suvarnabhumi International Airport", 
	"country": "Thailand", 
	"city": "Bangkok"}, 
{
	"citycode": "CEI", 
	"airport": "Chiang Rai International Airport", 
	"country": "Thailand", 
	"city": "Chiang Rai"}, 
{
	"citycode": "CJM", 
	"airport": "Chumphon Airport", 
	"country": "Thailand", 
	"city": "Chiang Rai"}, 
{
	"citycode": "CNX", 
	"airport": "Chiang Mai International Airport", 
	"country": "Thailand", 
	"city": "Chiang Mai"}, 
{
	"citycode": "DMK", 
	"airport": "Don Mueang International Airport", 
	"country": "Thailand", 
	"city": "Bangkok"}, 
{
	"citycode": "HDY", 
	"airport": "Hat Yai International Airport", 
	"country": "Thailand", 
	"city": "Hat Yai"}, 
{
	"citycode": "HHQ", 
	"airport": "Hua Hin Airport", 
	"country": "Thailand", 
	"city": "Hua Hin"}, 
{
	"citycode": "HKT", 
	"airport": "Phuket International Airport", 
	"country": "Thailand", 
	"city": "Phuket"}, 
{
	"citycode": "KBV", 
	"airport": "Krabi International Airport", 
	"country": "Thailand", 
	"city": "Krabi"}, 
{
	"citycode": "KKC", 
	"airport": "Khon Kaen Airport", 
	"country": "Thailand", 
	"city": "Khon Kaen"}, 
{
	"citycode": "LOE", 
	"airport": "Loei Airport", 
	"country": "Thailand", 
	"city": "Loei"}, 
{
	"citycode": "LPT", 
	"airport": "Lampang Airport", 
	"country": "Thailand", 
	"city": "Lampang"}, 
{
	"citycode": "MAQ", 
	"airport": "Mae Sot Airport", 
	"country": "Thailand", 
	"city": "Mae Sot"}, 
{
	"citycode": "NAK", 
	"airport": "Nakhon Ratchasima Airport", 
	"country": "Thailand", 
	"city": "Nakhon Ratchasima"}, 
{
	"citycode": "NAW", 
	"airport": "Narathiwat Airport", 
	"country": "Thailand", 
	"city": "Narathiwat"}, 
{
	"citycode": "NST", 
	"airport": "Nakhon Si Thammarat Airport", 
	"country": "Thailand", 
	"city": "Nakhon Si Thammarat"}, 
{
	"citycode": "PAN", 
	"airport": "Pattani Airport", 
	"country": "Thailand", 
	"city": "Pattani"}, 
{
	"citycode": "PHS", 
	"airport": "Phitsanulok Airport", 
	"country": "Thailand", 
	"city": "Phitsanulok"}, 
{
	"citycode": "PRH", 
	"airport": "Phrae Airport", 
	"country": "Thailand", 
	"city": "Phrae"}, 
{
	"citycode": "PYX", 
	"airport": "Pattaya Airport", 
	"country": "Thailand", 
	"city": "Pattaya"}, 
{
	"citycode": "SNO", 
	"airport": "Sakon Nakhon Airport", 
	"country": "Thailand", 
	"city": "Sakon Nakhon"}, 
{
	"citycode": "TST", 
	"airport": "Trang Airport", 
	"country": "Thailand", 
	"city": "Trang"}, 
{
	"citycode": "UBP", 
	"airport": "Ubon Ratchathani International Airport", 
	"country": "Thailand", 
	"city": "Ubon Ratchathani"}, 
{
	"citycode": "UNN", 
	"airport": "Ranong Airport", 
	"country": "Thailand", 
	"city": "Ranong"}, 
{
	"citycode": "URT", 
	"airport": "Surat Thani International Airport", 
	"country": "Thailand", 
	"city": "Surat Thani"}, 
{
	"citycode": "USM", 
	"airport": "Samui International Airport", 
	"country": "Thailand", 
	"city": "Koh Samui"}, 
{
	"citycode": "UTH", 
	"airport": "Udon Thani International Airport", 
	"country": "Thailand", 
	"city": "Udon Thani"}, 
{
	"citycode": "UTP", 
	"airport": "U-Tapao–Rayong–Pattaya International Airport", 
	"country": "Thailand", 
	"city": "Utapao"}, 
{
	"citycode": "DJE", 
	"airport": "Djerba–Zarzis International Airport", 
	"country": "Tunisia", 
	"city": "Djerba"}, 
{
	"citycode": "MIR", 
	"airport": "Monastir Habib Bourguiba International Airport", 
	"country": "Tunisia", 
	"city": "Monastir"}, 
{
	"citycode": "SFA", 
	"airport": "Sfax–Thyna International Airport", 
	"country": "Tunisia", 
	"city": "Sfax"}, 
{
	"citycode": "TOE", 
	"airport": "Tozeur–Nefta International Airport", 
	"country": "Tunisia", 
	"city": "Tozeur"}, 
{
	"citycode": "TUN", 
	"airport": "Tunis-Carthage International Airport", 
	"country": "Tunisia", 
	"city": "Tunis"}, 
{
	"citycode": "AAB", 
	"airport": "Arrabury Airport", 
	"country": "United Arab Emirates", 
	"city": "AI Ain Bus Service"}, 
{
	"citycode": "AAN", 
	"airport": "Al Ain International Airport", 
	"country": "United Arab Emirates", 
	"city": "Al Ain"}, 
{
	"citycode": "AUB", 
	"airport": "Abu Dhabi Bus Station", 
	"country": "United Arab Emirates", 
	"city": "Abudhabi Bus Service"}, 
{
	"citycode": "AUH", 
	"airport": "Zayed International Airport", 
	"country": "United Arab Emirates", 
	"city": "Abu Dhabi"}, 
{
	"citycode": "DBS", 
	"airport": "Dubai Bus Service", 
	"country": "United Arab Emirates", 
	"city": "Dubai Bus Service"}, 
{
	"citycode": "DWC", 
	"airport": "Al Maktoum International Airport", 
	"country": "United Arab Emirates", 
	"city": "Dubai Al Maktoum"}, 
{
	"citycode": "FJR", 
	"airport": "Fujairah International Airport", 
	"country": "United Arab Emirates", 
	"city": "Al-Fujairah"}, 
{
	"citycode": "RKT", 
	"airport": "Ras Al Khaimah Airport", 
	"country": "United Arab Emirates", 
	"city": "Ras Al Khaimah"}, 
{
	"citycode": "SHJ", 
	"airport": "Sharjah International Airport", 
	"country": "United Arab Emirates", 
	"city": "Sharjah"}, 
{
	"citycode": "XNB", 
	"airport": "Dubai Bus Terminal", 
	"country": "United Arab Emirates", 
	"city": "Dubai Bus Terminal"}, 
{
	"citycode": "ZVH", 
	"airport": "Al Ain Bus Station", 
	"country": "United Arab Emirates", 
	"city": "Al Ain"}, 
{
	"citycode": "ZVJ", 
	"airport": "Abu Dhabi Bus Station", 
	"country": "United Arab Emirates", 
	"city": "Abu Dhabi"}, 
{
	"citycode": "AAY", 
	"airport": "Al Ghaydah Airport", 
	"country": "Yemen", 
	"city": "Al Ghaydah"}, 
{
	"citycode": "ADE", 
	"airport": "Aden International Airport", 
	"country": "Yemen", 
	"city": "Aden"}, 
{
	"citycode": "AJO", 
	"airport": "Aljouf Airport", 
	"country": "Yemen", 
	"city": "Aljouf"}, 
{
	"citycode": "AXK", 
	"airport": "Ataq Airport", 
	"country": "Yemen", 
	"city": "Ataq"}, 
{
	"citycode": "BHN", 
	"airport": "Beihan Airport", 
	"country": "Yemen", 
	"city": "Beihan"}, 
{
	"citycode": "BUK", 
	"airport": "Albuq Airport", 
	"country": "Yemen", 
	"city": "Albuq"}, 
{
	"citycode": "GXF", 
	"airport": "Seyoun Airport", 
	"country": "Yemen", 
	"city": "Seiyun"}, 
{
	"citycode": "HOD", 
	"airport": "Hodeidah International Airport", 
	"country": "Yemen", 
	"city": "Hodeidah"}, 
{
	"citycode": "IHN", 
	"airport": "Qishn Airport", 
	"country": "Yemen", 
	"city": "Qishn"}, 
{
	"citycode": "RIY", 
	"airport": "Riyan Mukalla Airport", 
	"country": "Yemen", 
	"city": "Riyan Mukalla"}, 
{
	"citycode": "SAH", 
	"airport": "Sana`a International Airport", 
	"country": "Yemen", 
	"city": "Sana`a"}, 
{
	"citycode": "SCT", 
	"airport": "Socotra Airport", 
	"country": "Yemen", 
	"city": "Socotra"}, 
{
	"citycode": "TAI", 
	"airport": "Ta`izz International Airport", 
	"country": "Yemen", 
	"city": "Taiz"}, 
{
	"citycode": "UKR", 
	"airport": "Mukeiras Airport", 
	"country": "Yemen", 
	"city": "Mukeiras"}, 
{
	"citycode": "BFO", 
	"airport": "Aeroportul Buffalo Range Airport", 
	"country": "Zimbabwe", 
	"city": "Buffalo Range"}, 
{
	"citycode": "BUQ", 
	"airport": "Joshua Mqabuko Nkomo International Airport", 
	"country": "Zimbabwe", 
	"city": "Bulawayo"}, 
{
	"citycode": "GWE", 
	"airport": "Gweru-Thornhill Air Base", 
	"country": "Zimbabwe", 
	"city": "Gweru"}, 
{
	"citycode": "HRE", 
	"airport": "Harare International Airport", 
	"country": "Zimbabwe", 
	"city": "Harare"}, 
{
	"citycode": "HWN", 
	"airport": "Hwange National Park Airport", 
	"country": "Zimbabwe", 
	"city": "Hwange Nat Park"}, 
{
	"citycode": "KAB", 
	"airport": "Kariba Airport", 
	"country": "Zimbabwe", 
	"city": "Kariba"}, 
{
	"citycode": "MVZ", 
	"airport": "Masvingo Airport", 
	"country": "Zimbabwe", 
	"city": "Masvingo"}, 
{
	"citycode": "VFA", 
	"airport": "Victoria Falls Airport", 
	"country": "Zimbabwe", 
	"city": "Victoria Falls"}, 
{
	"citycode": "BDT", 
	"airport": "Gbadolite Airport", 
	"country": "Congo (DRC)", 
	"city": "Gbadolite"}, 
{
	"citycode": "BKY", 
	"airport": "Kavumu Airport", 
	"country": "Congo (DRC)", 
	"city": "Bukavu"}, 
{
	"citycode": "BMB", 
	"airport": "Bumba Airport", 
	"country": "Congo (DRC)", 
	"city": "Bumba"}, 
{
	"citycode": "BNB", 
	"airport": "Boende Airport", 
	"country": "Congo (DRC)", 
	"city": "Boende"}, 
{
	"citycode": "BNC", 
	"airport": "Beni Airport", 
	"country": "Congo (DRC)", 
	"city": "Beni"}, 
{
	"citycode": "BSU", 
	"airport": "Basankusu Airstrip", 
	"country": "Congo (DRC)", 
	"city": "Basankusu"}, 
{
	"citycode": "BUX", 
	"airport": "Bunia Airport", 
	"country": "Congo (DRC)", 
	"city": "Bunia"}, 
{
	"citycode": "BZV", 
	"airport": "Maya Maya International Airport", 
	"country": "Congo (DRC)", 
	"city": "BRAZZAVILLE"}, 
{
	"citycode": "FBM", 
	"airport": "Lubumbashi International Airport", 
	"country": "Congo (DRC)", 
	"city": "LUBUMBASHI"}, 
{
	"citycode": "FDU", 
	"airport": "Bandundu Airport", 
	"country": "Congo (DRC)", 
	"city": "Bandundu"}, 
{
	"citycode": "FIH", 
	"airport": "N’djili International Airport", 
	"country": "Congo (DRC)", 
	"city": "Kinshasa"}, 
{
	"citycode": "FKI", 
	"airport": "Kisangani Bangoka International Airport", 
	"country": "Congo (DRC)", 
	"city": "Kisangani"}, 
{
	"citycode": "FMI", 
	"airport": "Kalemie Airport", 
	"country": "Congo (DRC)", 
	"city": "Kalemie"}, 
{
	"citycode": "GMA", 
	"airport": "Gemena Airport", 
	"country": "Congo (DRC)", 
	"city": "Gemena"}, 
{
	"citycode": "GOM", 
	"airport": "Goma International Airport", 
	"country": "Congo (DRC)", 
	"city": "Goma"}, 
{
	"citycode": "IKL", 
	"airport": "Ikela Airport", 
	"country": "Congo (DRC)", 
	"city": "Ikela"}, 
{
	"citycode": "INO", 
	"airport": "Inongo Airport", 
	"country": "Congo (DRC)", 
	"city": "Inongo"}, 
{
	"citycode": "IRP", 
	"airport": "Matari Airport", 
	"country": "Congo (DRC)", 
	"city": "Isiro"}, 
{
	"citycode": "KGA", 
	"airport": "Kananga Airport", 
	"country": "Congo (DRC)", 
	"city": "Kananga"}, 
{
	"citycode": "KND", 
	"airport": "Kindu Airport", 
	"country": "Congo (DRC)", 
	"city": "Kindu"}, 
{
	"citycode": "KOO", 
	"airport": "Kongolo Airport", 
	"country": "Congo (DRC)", 
	"city": "Kongolo"}, 
{
	"citycode": "LIQ", 
	"airport": "Lisala Airport", 
	"country": "Congo (DRC)", 
	"city": "Lisala"}, 
{
	"citycode": "LJA", 
	"airport": "Lodja Airport", 
	"country": "Congo (DRC)", 
	"city": "Lodja"}, 
{
	"citycode": "MDK", 
	"airport": "Mbandaka Airport", 
	"country": "Congo (DRC)", 
	"city": "Mbandaka"}, 
{
	"citycode": "MJM", 
	"airport": "Mbuji Mayi international Airport", 
	"country": "Congo (DRC)", 
	"city": "Mbuji Mayi"}, 
{
	"citycode": "PNR", 
	"airport": "Antonio-Agostinho-Neto International Airport", 
	"country": "Congo (DRC)", 
	"city": "POINTE NOIRE"}, 
{
	"citycode": "TSH", 
	"airport": "Tshikapa Airport", 
	"country": "Congo (DRC)", 
	"city": "Tshikapa"}, 
{
	"citycode": "AGR", 
	"airport": "Agra Airport", 
	"country": "India", 
	"city": "Agra"}, 
{
	"citycode": "AGX", 
	"airport": "Agatti Airport", 
	"country": "India", 
	"city": "Agatti Island"}, 
{
	"citycode": "AJL", 
	"airport": "Lengpui Airport", 
	"country": "India", 
	"city": "Aizawl"}, 
{
	"citycode": "AKD", 
	"airport": "Shioni Airport", 
	"country": "India", 
	"city": "Akola"}, 
{
	"citycode": "AMD", 
	"airport": "Sardar Vallabhbhai Patel International Airport", 
	"country": "India", 
	"city": "Ahmedabad"}, 
{
	"citycode": "ATQ", 
	"airport": "Sri Guru Ram Das Ji International Airport", 
	"country": "India", 
	"city": "Amritsar"}, 
{
	"citycode": "AYJ", 
	"airport": "Ayodhya International Airport", 
	"country": "India", 
	"city": "Ayodhya"}, 
{
	"citycode": "BBI", 
	"airport": "Biju Patnaik International Airport", 
	"country": "India", 
	"city": "Bhubaneswar"}, 
{
	"citycode": "BDQ", 
	"airport": "Vadodara Airport", 
	"country": "India", 
	"city": "Vadodara"}, 
{
	"citycode": "BEK", 
	"airport": "Bareilly Airport", 
	"country": "India", 
	"city": "Uttar Pradesh"}, 
{
	"citycode": "BEP", 
	"airport": "Bellary Airport", 
	"country": "India", 
	"city": "Bellary"}, 
{
	"citycode": "BHJ", 
	"airport": "Bhuj Airport", 
	"country": "India", 
	"city": "Bhuj"}, 
{
	"citycode": "BHO", 
	"airport": "Bhopal Airport", 
	"country": "India", 
	"city": "Bhopal"}, 
{
	"citycode": "BHU", 
	"airport": "Bhavnagar Airport", 
	"country": "India", 
	"city": "Bhavnagar"}, 
{
	"citycode": "BLR", 
	"airport": "Kempegowda International Airport Bengaluru", 
	"country": "India", 
	"city": "Bangalore"}, 
{
	"citycode": "CBD", 
	"airport": "Car Nicobar Airport", 
	"country": "India", 
	"city": "Car Nicobar"}, 
{
	"citycode": "CCU", 
	"airport": "Netaji Subhash Chandra Bose International Airport", 
	"country": "India", 
	"city": "Kolkata"}, 
{
	"citycode": "CDP", 
	"airport": "Kadapa Airport", 
	"country": "India", 
	"city": "Kamalapuram"}, 
{
	"citycode": "CJB", 
	"airport": "Coimbatore International Airport", 
	"country": "India", 
	"city": "Coimbatore"}, 
{
	"citycode": "CNN", 
	"airport": "Kannur International Airport", 
	"country": "India", 
	"city": "Kannur"}, 
{
	"citycode": "COH", 
	"airport": "Cooch Behar Airport", 
	"country": "India", 
	"city": "Cooch Behar"}, 
{
	"citycode": "DBR", 
	"airport": "Darbhanga Airport", 
	"country": "India", 
	"city": "Aerodrome Darbhanga"}, 
{
	"citycode": "DED", 
	"airport": "Dehradun Airport", 
	"country": "India", 
	"city": "Dehra Dun"}, 
{
	"citycode": "DEL", 
	"airport": "Indira Gandhi International Airport", 
	"country": "India", 
	"city": "New Delhi"}, 
{
	"citycode": "DGH", 
	"airport": "Deoghar Airport", 
	"country": "Jharkhand", 
	"city": "Deoghar"}, 
{
	"citycode": "DHM", 
	"airport": "Kangra-Gaggal Airport", 
	"country": "India", 
	"city": "Dharamsala"}, 
{
	"citycode": "DIB", 
	"airport": "Dibrugarh Airport", 
	"country": "India", 
	"city": "Dibrugarh"}, 
{
	"citycode": "DIU", 
	"airport": "Diu Airport", 
	"country": "India", 
	"city": "Diu"}, 
{
	"citycode": "DMU", 
	"airport": "Dimapur Airport", 
	"country": "India", 
	"city": "Dimapur"}, 
{
	"citycode": "GAU", 
	"airport": "Lokpriya Gopinath Bordoloi International Airport", 
	"country": "India", 
	"city": "Guwahati"}, 
{
	"citycode": "GAY", 
	"airport": "Gaya Airport", 
	"country": "India", 
	"city": "Gaya"}, 
{
	"citycode": "GOI", 
	"airport": "Dabolim Airport", 
	"country": "India", 
	"city": "Goa"}, 
{
	"citycode": "GOP", 
	"airport": "Gorakhpur Airport", 
	"country": "India", 
	"city": "Gorakhpur"}, 
{
	"citycode": "GOX", 
	"airport": "Mopa International Airport,Goa", 
	"country": "India", 
	"city": "Mopa"}, 
{
	"citycode": "GWL", 
	"airport": "Gwalior Airport", 
	"country": "India", 
	"city": "Gwalior"}, 
{
	"citycode": "HBX", 
	"airport": "Hubli Airport", 
	"country": "India", 
	"city": "Hubli"}, 
{
	"citycode": "HJR", 
	"airport": "Khajuraho Airport", 
	"country": "India", 
	"city": "Khajuraho"}, 
{
	"citycode": "HSR", 
	"airport": "Rajkot International Airport", 
	"country": "India", 
	"city": "Rajkot"}, 
{
	"citycode": "HYD", 
	"airport": "Rajiv Gandhi International Airport", 
	"country": "India", 
	"city": "Hyderabad"}, 
{
	"citycode": "IDR", 
	"airport": "Devi Ahilyabai Holkar International Airport", 
	"country": "India", 
	"city": "Indore"}, 
{
	"citycode": "IHX", 
	"airport": "KAILASHAHAR", 
	"country": "India", 
	"city": "KAILASHAHAR"}, 
{
	"citycode": "IMF", 
	"airport": "Bir Tikendrajit International Airport", 
	"country": "India", 
	"city": "Imphal"}, 
{
	"citycode": "ISK", 
	"airport": "Nashik International Airport", 
	"country": "India", 
	"city": "Nasik"}, 
{
	"citycode": "IXA", 
	"airport": "Maharaja Bir Bikram Airport", 
	"country": "India", 
	"city": "Agartala"}, 
{
	"citycode": "IXB", 
	"airport": "Bagdogra International Airport", 
	"country": "India", 
	"city": "Bagdogra"}, 
{
	"citycode": "IXC", 
	"airport": "Chandigarh Airport", 
	"country": "India", 
	"city": "Chandigarh"}, 
{
	"citycode": "IXD", 
	"airport": "Prayagraj Airport", 
	"country": "India", 
	"city": "Allahabad"}, 
{
	"citycode": "IXE", 
	"airport": "Mangaluru International Airport", 
	"country": "India", 
	"city": "Mangalore"}, 
{
	"citycode": "IXG", 
	"airport": "Belgaum Airport", 
	"country": "India", 
	"city": "Belgaum"}, 
{
	"citycode": "IXH", 
	"airport": "Kailashahar Airport", 
	"country": "India", 
	"city": "Kailashahar"}, 
{
	"citycode": "IXI", 
	"airport": "Lilabari Airport", 
	"country": "India", 
	"city": "Lilabari"}, 
{
	"citycode": "IXJ", 
	"airport": "Jammu Airport", 
	"country": "India", 
	"city": "Jammu"}, 
{
	"citycode": "IXK", 
	"airport": "Keshod Airport", 
	"country": "India", 
	"city": "Keshod"}, 
{
	"citycode": "IXL", 
	"airport": "Kushok Bakula Rimpochee Airport", 
	"country": "India", 
	"city": "Leh"}, 
{
	"citycode": "IXM", 
	"airport": "Madurai Airport", 
	"country": "India", 
	"city": "Madurai"}, 
{
	"citycode": "IXP", 
	"airport": "Pathankot Airport", 
	"country": "India", 
	"city": "Pathankot"}, 
{
	"citycode": "IXR", 
	"airport": "Birsa Munda Airport", 
	"country": "India", 
	"city": "Ranchi"}, 
{
	"citycode": "IXS", 
	"airport": "Silchar Airport", 
	"country": "India", 
	"city": "Silchar"}, 
{
	"citycode": "IXU", 
	"airport": "Aurangabad Airport", 
	"country": "India", 
	"city": "Aurangabad"}, 
{
	"citycode": "IXW", 
	"airport": "Sonari Airport", 
	"country": "India", 
	"city": "Jamshedpur"}, 
{
	"citycode": "IXY", 
	"airport": "Kandla Airport", 
	"country": "India", 
	"city": "Kandla"}, 
{
	"citycode": "IXZ", 
	"airport": "Veer Savarkar International Airport", 
	"country": "India", 
	"city": "Port Blair"}, 
{
	"citycode": "JAI", 
	"airport": "Jaipur International Airport", 
	"country": "India", 
	"city": "Jaipur"}, 
{
	"citycode": "JDH", 
	"airport": "Jodhpur Airport", 
	"country": "India", 
	"city": "Jodhpur"}, 
{
	"citycode": "JGA", 
	"airport": "Jamnagar Airport", 
	"country": "India", 
	"city": "Jamnagar"}, 
{
	"citycode": "JGB", 
	"airport": "Jagdalpur Airport", 
	"country": "India", 
	"city": "Jagdalpur"}, 
{
	"citycode": "JLR", 
	"airport": "Jabalpur Airport", 
	"country": "India", 
	"city": "Jabalpur"}, 
{
	"citycode": "JRG", 
	"airport": "Veer Surendra Sai Airport", 
	"country": "India", 
	"city": "Odisha"}, 
{
	"citycode": "JRH", 
	"airport": "Jorhat Airport", 
	"country": "India", 
	"city": "Jorhat"}, 
{
	"citycode": "JSA", 
	"airport": "Jaisalmer Airport", 
	"country": "India", 
	"city": "Jaisalmer"}, 
{
	"citycode": "KBK", 
	"airport": "Kushinagar International Airport", 
	"country": "India", 
	"city": "Kushinagar"}, 
{
	"citycode": "KLH", 
	"airport": "Kolhapur Airport", 
	"country": "India", 
	"city": "Kolhapur"}, 
{
	"citycode": "KNU", 
	"airport": "Kanpur Airport", 
	"country": "India", 
	"city": "Kanpur"}, 
{
	"citycode": "KQH", 
	"airport": "Kishangarh Airport", 
	"country": "India", 
	"city": "Ajmer"}, 
{
	"citycode": "KTU", 
	"airport": "Kota Airport", 
	"country": "India", 
	"city": "Kota"}, 
{
	"citycode": "KUU", 
	"airport": "Bhuntar Airport", 
	"country": "India", 
	"city": "Kulu"}, 
{
	"citycode": "LDA", 
	"airport": "Malda Airport", 
	"country": "India", 
	"city": "Malda"}, 
{
	"citycode": "LKO", 
	"airport": "Chaudhary Charan Singh International Airport", 
	"country": "India", 
	"city": "Lucknow"}, 
{
	"citycode": "LTU", 
	"airport": "Latur Airport", 
	"country": "India", 
	"city": "LATUR"}, 
{
	"citycode": "LUH", 
	"airport": "Ludhiana Airport", 
	"country": "India", 
	"city": "Ludhiana"}, 
{
	"citycode": "MAA", 
	"airport": "Chennai International Airport", 
	"country": "India", 
	"city": "Chennai"}, 
{
	"citycode": "MYQ", 
	"airport": "Mysore Airport", 
	"country": "India", 
	"city": "Mysore"}, 
{
	"citycode": "NAG", 
	"airport": "Dr Babasaheb Ambedkar International Airport", 
	"country": "India", 
	"city": "Nagpur"}, 
{
	"citycode": "NDC", 
	"airport": "Shri Guru Gobind Singh Ji Airport", 
	"country": "India", 
	"city": "Nanded"}, 
{
	"citycode": "NMB", 
	"airport": "Daman Airport", 
	"country": "India", 
	"city": "Daman"}, 
{
	"citycode": "NVY", 
	"airport": "Neyveli Airport", 
	"country": "India", 
	"city": "Neyveli"}, 
{
	"citycode": "PAB", 
	"airport": "Bilaspur Airport", 
	"country": "India", 
	"city": "Bilaspur"}, 
{
	"citycode": "PAT", 
	"airport": "Jayprakash Narayan International Airport", 
	"country": "India", 
	"city": "Patna"}, 
{
	"citycode": "PBD", 
	"airport": "Porbandar Airport", 
	"country": "India", 
	"city": "Porbandar"}, 
{
	"citycode": "PGH", 
	"airport": "Pantnagar Airport", 
	"country": "India", 
	"city": "Pantnagar"}, 
{
	"citycode": "PNQ", 
	"airport": "Pune Airport", 
	"country": "India", 
	"city": "Pune (Poona)"}, 
{
	"citycode": "PNY", 
	"airport": "Puducherry Airport", 
	"country": "India", 
	"city": "Pondicherry"}, 
{
	"citycode": "PUT", 
	"airport": "Sri Sathya Sai Airport", 
	"country": "India", 
	"city": "Puttaparthi"}, 
{
	"citycode": "RAJ", 
	"airport": "Rajkot Civil Airport", 
	"country": "India", 
	"city": "Rajkot"}, 
{
	"citycode": "RDP", 
	"airport": "Kazi Nazrul Islam Airport", 
	"country": "India", 
	"city": "Durgapur"}, 
{
	"citycode": "REW", 
	"airport": "Rewa Airport", 
	"country": "India", 
	"city": "Rewa"}, 
{
	"citycode": "RJA", 
	"airport": "Rajahmundry Airport", 
	"country": "India", 
	"city": "Rajahmundry"}, 
{
	"citycode": "RJI", 
	"airport": "Rajouri Airport", 
	"country": "India", 
	"city": "Rajouri"}, 
{
	"citycode": "RPR", 
	"airport": "Swami Vivekananda International Airport", 
	"country": "India", 
	"city": "Raipur"}, 
{
	"citycode": "RQY", 
	"airport": "Kuvempu Airport", 
	"country": "India", 
	"city": "Shivamogga"}, 
{
	"citycode": "RRK", 
	"airport": "Rourkela Airport", 
	"country": "India", 
	"city": "Rourkela"}, 
{
	"citycode": "SAG", 
	"airport": "Shirdi Airport", 
	"country": "India", 
	"city": "Shirdi"}, 
{
	"citycode": "SHL", 
	"airport": "Shillong Airport", 
	"country": "India", 
	"city": "Shillong"}, 
{
	"citycode": "SLV", 
	"airport": "Shimla Airport", 
	"country": "India", 
	"city": "Simla"}, 
{
	"citycode": "SSE", 
	"airport": "Solapur Airport", 
	"country": "India", 
	"city": "Sholapur"}, 
{
	"citycode": "STV", 
	"airport": "Surat International Airport", 
	"country": "India", 
	"city": "Surat"}, 
{
	"citycode": "SXR", 
	"airport": "Sheikh-Ul Alam International Airport", 
	"country": "India", 
	"city": "Srinagar"}, 
{
	"citycode": "SXV", 
	"airport": "Salem Airport", 
	"country": "India", 
	"city": "Salem"}, 
{
	"citycode": "TCR", 
	"airport": "Tuticorin Airport", 
	"country": "India", 
	"city": "Tuticorin"}, 
{
	"citycode": "TEI", 
	"airport": "Tezu Airport", 
	"country": "India", 
	"city": "Tezu"}, 
{
	"citycode": "TEZ", 
	"airport": "Tezpur Airport", 
	"country": "India", 
	"city": "Tezpur"}, 
{
	"citycode": "TIR", 
	"airport": "Tirupati Airport", 
	"country": "India", 
	"city": "Tirupati"}, 
{
	"citycode": "TNI", 
	"airport": "Tinian International Airport", 
	"country": "India", 
	"city": "Satna"}, 
{
	"citycode": "TRV", 
	"airport": "Thiruvananthapuram International Airport", 
	"country": "India", 
	"city": "Thiruvananthapuram"}, 
{
	"citycode": "TRZ", 
	"airport": "Tiruchirappalli International Airport", 
	"country": "India", 
	"city": "Tiruchirapally"}, 
{
	"citycode": "UDR", 
	"airport": "Maharana Partap Dabok Airport", 
	"country": "India", 
	"city": "Udaipur"}, 
{
	"citycode": "VDY", 
	"airport": "Jindal Vijaynagar Airport", 
	"country": "India", 
	"city": "VIDAYNAGAR"}, 
{
	"citycode": "VGA", 
	"airport": "Vijayawada International Airport", 
	"country": "India", 
	"city": "Vijayawada"}, 
{
	"citycode": "VNS", 
	"airport": "Lal Bahadur Shastri Airport", 
	"country": "India", 
	"city": "Varanasi"}, 
{
	"citycode": "VTZ", 
	"airport": "Vishakhapatnam Airport", 
	"country": "India", 
	"city": "Vishakhapatnam"}, 
{
	"citycode": "WGC", 
	"airport": "Waca Airport", 
	"country": "India", 
	"city": "Warrangal"}, 
{
	"citycode": "MFM", 
	"airport": "Macau International Airport", 
	"country": "Macau (SAR), PR China", 
	"city": "Macau"}, 
{
	"citycode": "BST", 
	"airport": "Bost Airport", 
	"country": "Afghanistan", 
	"city": "Bost"}, 
{
	"citycode": "CCN", 
	"airport": "Chakcharan", 
	"country": "Afghanistan", 
	"city": "Chakcharan"}, 
{
	"citycode": "FAH", 
	"airport": "Farah Airport", 
	"country": "Afghanistan", 
	"city": "Farah"}, 
{
	"citycode": "FBD", 
	"airport": "Fayzabad Airport", 
	"country": "Afghanistan", 
	"city": "Faizabad"}, 
{
	"citycode": "GRG", 
	"airport": "Gardez Airport", 
	"country": "Afghanistan", 
	"city": "Gardez"}, 
{
	"citycode": "HEA", 
	"airport": "Herat International Airport", 
	"country": "Afghanistan", 
	"city": "Herat"}, 
{
	"citycode": "JAA", 
	"airport": "Jalalabad Airport", 
	"country": "Afghanistan", 
	"city": "Jalalabad"}, 
{
	"citycode": "KBL", 
	"airport": "Kabul International Airport", 
	"country": "Afghanistan", 
	"city": "Kabul"}, 
{
	"citycode": "KDH", 
	"airport": "Kandahar International Airport", 
	"country": "Afghanistan", 
	"city": "Kandahar"}, 
{
	"citycode": "KHT", 
	"airport": "Khost Airport", 
	"country": "Afghanistan", 
	"city": "Khost"}, 
{
	"citycode": "KWH", 
	"airport": "Khwahan Airport", 
	"country": "Afghanistan", 
	"city": "Khwahan"}, 
{
	"citycode": "LQN", 
	"airport": "Qalah-ye Now Airport", 
	"country": "Afghanistan", 
	"city": "Qala Nau"}, 
{
	"citycode": "MMZ", 
	"airport": "Maymana Airport", 
	"country": "Afghanistan", 
	"city": "Maimana"}, 
{
	"citycode": "MZR", 
	"airport": "Mazar-I-Sharif International Airport", 
	"country": "Afghanistan", 
	"city": "Mazar I Sharif"}, 
{
	"citycode": "SGA", 
	"airport": "Sheghnan Airport", 
	"country": "Afghanistan", 
	"city": "Sheghnan"}, 
{
	"citycode": "TII", 
	"airport": "Tirinkot Airport", 
	"country": "Afghanistan", 
	"city": "Tirinkot"}, 
{
	"citycode": "UND", 
	"airport": "Kunduz Airport", 
	"country": "Afghanistan", 
	"city": "Kunduz"}, 
{
	"citycode": "ZAJ", 
	"airport": "Zaranj Airport", 
	"country": "Afghanistan", 
	"city": "Zaranj"}, 
{
	"citycode": "BHK", 
	"airport": "Bukhara International Airport", 
	"country": "Uzbekistan", 
	"city": "Bukhara"}, 
{
	"citycode": "FEG", 
	"airport": "Fergana International Airport", 
	"country": "Uzbekistan", 
	"city": "Fergana"}, 
{
	"citycode": "KSQ", 
	"airport": "Karshi Airport", 
	"country": "Uzbekistan", 
	"city": "Karshi"}, 
{
	"citycode": "NCU", 
	"airport": "Nukus International Airport", 
	"country": "Uzbekistan", 
	"city": "Nukus"}, 
{
	"citycode": "NMA", 
	"airport": "Namangan Airport", 
	"country": "Uzbekistan", 
	"city": "Namangan"}, 
{
	"citycode": "SKD", 
	"airport": "Samarkand International Airport", 
	"country": "Uzbekistan", 
	"city": "Samarkand"}, 
{
	"citycode": "TAS", 
	"airport": "Tashkent International Airport", 
	"country": "Uzbekistan", 
	"city": "Tashkent"}, 
{
	"citycode": "UGC", 
	"airport": "Urgench International Airport", 
	"country": "Uzbekistan", 
	"city": "Urgench"}, 
{
	"citycode": "TIA", 
	"airport": "Tirana International Airport", 
	"country": "Albania", 
	"city": "Tirana"}, 
{
	"citycode": "AAE", 
	"airport": "Annaba Rabah Bitat Airport", 
	"country": "Algeria", 
	"city": "Annaba"}, 
{
	"citycode": "ALG", 
	"airport": "Algiers-Houari-Boumediene International Airport", 
	"country": "Algeria", 
	"city": "Algiers"}, 
{
	"citycode": "AZR", 
	"airport": "Touat-Cheikh Sidi Mohamed Belkebir Airport", 
	"country": "Algeria", 
	"city": "Adrar"}, 
{
	"citycode": "BJA", 
	"airport": "Bejaia International Airport Abane Ramdane", 
	"country": "Algeria", 
	"city": "Bejaia"}, 
{
	"citycode": "BMW", 
	"airport": "Bordj Badji Mokhtar Airport", 
	"country": "Algeria", 
	"city": "Bordj Badji Mokhtar"}, 
{
	"citycode": "BSK", 
	"airport": "Biskra International Airport", 
	"country": "Algeria", 
	"city": "Biskra"}, 
{
	"citycode": "CBH", 
	"airport": "Boudghene Ben Ali Lotfi Airport", 
	"country": "Algeria", 
	"city": "Bechar"}, 
{
	"citycode": "CZL", 
	"airport": "Ain El Bey", 
	"country": "Algeria", 
	"city": "Constantine"}, 
{
	"citycode": "DJG", 
	"airport": "Tiska Djanet Airport", 
	"country": "Algeria", 
	"city": "Djanet"}, 
{
	"citycode": "ELG", 
	"airport": "El Meniaa airport", 
	"country": "Algeria", 
	"city": "El Golea"}, 
{
	"citycode": "ELU", 
	"airport": "Guemar Airport", 
	"country": "Algeria", 
	"city": "El Oued"}, 
{
	"citycode": "GHA", 
	"airport": "Noumérat – Moufdi Zakaria Airport", 
	"country": "Algeria", 
	"city": "Ghardaia"}, 
{
	"citycode": "GJL", 
	"airport": "Jijel Ferhat Abbas Airport", 
	"country": "Algeria", 
	"city": "Jijel"}, 
{
	"citycode": "HME", 
	"airport": "Oued Irara - Krim Belkacem Airport", 
	"country": "Algeria", 
	"city": "Hassi Messaoud"}, 
{
	"citycode": "IAM", 
	"airport": "In Amenas Airport", 
	"country": "Algeria", 
	"city": "In Amenas"}, 
{
	"citycode": "INF", 
	"airport": "In Guezzam Airport", 
	"country": "Algeria", 
	"city": "In Guezzam"}, 
{
	"citycode": "INZ", 
	"airport": "In Salah Airport", 
	"country": "Algeria", 
	"city": "In Salah"}, 
{
	"citycode": "OGX", 
	"airport": "Ain Beida Airport", 
	"country": "Algeria", 
	"city": "Ouargla"}, 
{
	"citycode": "ORN", 
	"airport": "Oran Ahmed Ben Bella Airport", 
	"country": "Algeria", 
	"city": "Oran"}, 
{
	"citycode": "TEE", 
	"airport": "Cheikh Larbi Tebessa Airport", 
	"country": "Algeria", 
	"city": "Tbessa"}, 
{
	"citycode": "TGR", 
	"airport": "Touggourt Airport", 
	"country": "Algeria", 
	"city": "Touggourt"}, 
{
	"citycode": "TID", 
	"airport": "Abdelhafid Boussouf Bou Chekif Airport", 
	"country": "Algeria", 
	"city": "Tiaret"}, 
{
	"citycode": "TIN", 
	"airport": "Tindouf Airport", 
	"country": "Algeria", 
	"city": "Tindouf"}, 
{
	"citycode": "TLM", 
	"airport": "Zenata – Messali El Hadj Airport", 
	"country": "Algeria", 
	"city": "Tlemcen"}, 
{
	"citycode": "TMR", 
	"airport": "Tamanrasset – Hadj Bey Akhamok Airport", 
	"country": "Algeria", 
	"city": "Tamanrasset"}, 
{
	"citycode": "VVZ", 
	"airport": "Takhamalt Airport", 
	"country": "Algeria", 
	"city": "Illizi"}, 
{
	"citycode": "OFU", 
	"airport": "Ofu Airport", 
	"country": "American Samoa", 
	"city": "Ofu"}, 
{
	"citycode": "PPG", 
	"airport": "Pago Pago International Airport", 
	"country": "American Samoa", 
	"city": "Pago Pago"}, 
{
	"citycode": "TAV", 
	"airport": "Tau Airport", 
	"country": "American Samoa", 
	"city": "Tau"}, 
{
	"citycode": "ARZ", 
	"airport": "N`zeto Airport", 
	"country": "Angola", 
	"city": "N`Zeto"}, 
{
	"citycode": "AZZ", 
	"airport": "Ambriz Airport", 
	"country": "Angola", 
	"city": "Ambriz"}, 
{
	"citycode": "BUG", 
	"airport": "Benguela Airport Terminal", 
	"country": "Angola", 
	"city": "Benguela"}, 
{
	"citycode": "CAB", 
	"airport": "Cabinda Airport", 
	"country": "Angola", 
	"city": "Cabinda"}, 
{
	"citycode": "CAV", 
	"airport": "Cazombo Airport", 
	"country": "Angola", 
	"city": "Cazombo"}, 
{
	"citycode": "CBT", 
	"airport": "Catumbela Airport", 
	"country": "Angola", 
	"city": "Catumbela"}, 
{
	"citycode": "CEO", 
	"airport": "Waco Kungo Airport", 
	"country": "Angola", 
	"city": "Waco Kungo"}, 
{
	"citycode": "DUE", 
	"airport": "Lapangan Terbang Dundo Airport", 
	"country": "Angola", 
	"city": "Dundo"}, 
{
	"citycode": "GXG", 
	"airport": "Negage Airport", 
	"country": "Angola", 
	"city": "Negage"}, 
{
	"citycode": "LAD", 
	"airport": "Luanda International Airport", 
	"country": "Angola", 
	"city": "Luanda"}, 
{
	"citycode": "LUO", 
	"airport": "Luena Airport", 
	"country": "Angola", 
	"city": "Luena"}, 
{
	"citycode": "MEG", 
	"airport": "Malanje Airport", 
	"country": "Angola", 
	"city": "Malange"}, 
{
	"citycode": "MSZ", 
	"airport": "Welwitschia Mirabilis International Airport", 
	"country": "Angola", 
	"city": "Namibe"}, 
{
	"citycode": "NGV", 
	"airport": "Ngiva Airport", 
	"country": "Angola", 
	"city": "Ngiva"}, 
{
	"citycode": "NOV", 
	"airport": "Albano Machado Airport", 
	"country": "Angola", 
	"city": "Huambo"}, 
{
	"citycode": "PBN", 
	"airport": "Porto Amboim Airport", 
	"country": "Angola", 
	"city": "Porto Amboim"}, 
{
	"citycode": "PGI", 
	"airport": "Chitato Airport", 
	"country": "Angola", 
	"city": "Chitato"}, 
{
	"citycode": "SDD", 
	"airport": "Lubango Airport", 
	"country": "Angola", 
	"city": "Lubango"}, 
{
	"citycode": "SPP", 
	"airport": "Menongue Airport", 
	"country": "Angola", 
	"city": "Menongue"}, 
{
	"citycode": "SSY", 
	"airport": "M`Banza Congo Airport", 
	"country": "Angola", 
	"city": "M`Banza Congo"}, 
{
	"citycode": "SVP", 
	"airport": "Kuito Airport", 
	"country": "Angola", 
	"city": "Kuito"}, 
{
	"citycode": "SZA", 
	"airport": "Soyo Airport", 
	"country": "Angola", 
	"city": "Soyo"}, 
{
	"citycode": "UAL", 
	"airport": "Luau Airport", 
	"country": "Angola", 
	"city": "Luau"}, 
{
	"citycode": "UGO", 
	"airport": "Uige Airport", 
	"country": "Angola", 
	"city": "Uige"}, 
{
	"citycode": "VHC", 
	"airport": "Saurimo Airport", 
	"country": "Angola", 
	"city": "Saurimo"}, 
{
	"citycode": "XGN", 
	"airport": "Xangongo Airport", 
	"country": "Angola", 
	"city": "Xangongo"}, 
{
	"citycode": "AXA", 
	"airport": "Lloyd International Airport", 
	"country": "Anguilla", 
	"city": "Anguilla"}, 
{
	"citycode": "ANU", 
	"airport": "V.C. Bird International Airport", 
	"country": "Antigua and Barbuda", 
	"city": "St. John`s"}, 
{
	"citycode": "BBQ", 
	"airport": "Barbuda Codrington Airport", 
	"country": "Antigua and Barbuda", 
	"city": "Barbuda"}, 
{
	"citycode": "EVN", 
	"airport": "Zvartnots International Airport", 
	"country": "Armenia", 
	"city": "Yerevan"}, 
{
	"citycode": "LWN", 
	"airport": "Gyumri Shirak International Airport", 
	"country": "Armenia", 
	"city": "Gyoumri"}, 
{
	"citycode": "AUA", 
	"airport": "Queen Beatrix International Airport", 
	"country": "Aruba", 
	"city": "Aruba"}, 
{
	"citycode": "GBB", 
	"airport": "Qabala International Airport", 
	"country": "Azerbaijan", 
	"city": "Qabala"}, 
{
	"citycode": "GYD", 
	"airport": "Heydar Aliyev International Airport", 
	"country": "Azerbaijan", 
	"city": "Baku"}, 
{
	"citycode": "ASD", 
	"airport": "Andros Town International Airport", 
	"country": "Bahamas", 
	"city": "Andros Town"}, 
{
	"citycode": "ATC", 
	"airport": "Arthur`s Town Airport", 
	"country": "Bahamas", 
	"city": "Arthur`s Town"}, 
{
	"citycode": "AXP", 
	"airport": "Springpoint Airport", 
	"country": "Bahamas", 
	"city": "Spring Point"}, 
{
	"citycode": "BIM", 
	"airport": "South Bimini Airport", 
	"country": "Bahamas", 
	"city": "Bimini"}, 
{
	"citycode": "CCZ", 
	"airport": "Chub Cay International Airport", 
	"country": "Bahamas", 
	"city": "Chub Cay"}, 
{
	"citycode": "CRI", 
	"airport": "Colonel Hill Airport", 
	"country": "Bahamas", 
	"city": "Crooked Island"}, 
{
	"citycode": "ELH", 
	"airport": "North Eleuthera Airport", 
	"country": "Bahamas", 
	"city": "North Eleuthera"}, 
{
	"citycode": "FPO", 
	"airport": "Grand Bahama International Airport", 
	"country": "Bahamas", 
	"city": "Freeport"}, 
{
	"citycode": "GGT", 
	"airport": "Exuma International Airport", 
	"country": "Bahamas", 
	"city": "George Town"}, 
{
	"citycode": "GHB", 
	"airport": "Governor`s Harbour Airport", 
	"country": "Bahamas", 
	"city": "Governors Harbour"}, 
{
	"citycode": "GHC", 
	"airport": "Great Harbour Cay Airport", 
	"country": "Bahamas", 
	"city": "Great Harbour"}, 
{
	"citycode": "IGA", 
	"airport": "Inagua International Airport", 
	"country": "Bahamas", 
	"city": "Inagua"}, 
{
	"citycode": "LGI", 
	"airport": "Deadmans Cay Airport", 
	"country": "Bahamas", 
	"city": "Long Island"}, 
{
	"citycode": "MAY", 
	"airport": "Clarence A. Bain Airport", 
	"country": "Bahamas", 
	"city": "Mangrove Cay"}, 
{
	"citycode": "MHH", 
	"airport": "Leonard M. Thompson International Airport", 
	"country": "Bahamas", 
	"city": "Marsh Harbour"}, 
{
	"citycode": "MYG", 
	"airport": "Mayaguana Airport", 
	"country": "Bahamas", 
	"city": "Mayaguana"}, 
{
	"citycode": "NAS", 
	"airport": "Lynden Pindling International Airport", 
	"country": "Bahamas", 
	"city": "Nassau"}, 
{
	"citycode": "NSB", 
	"airport": "North Bimini Airport", 
	"country": "Bahamas", 
	"city": "Bimini"}, 
{
	"citycode": "PID", 
	"airport": "New Providence Airport", 
	"country": "Bahamas", 
	"city": "Nassau"}, 
{
	"citycode": "RSD", 
	"airport": "Rock Sound International Airport", 
	"country": "Bahamas", 
	"city": "Rock Sound"}, 
{
	"citycode": "SAQ", 
	"airport": "San Andros Airport", 
	"country": "Bahamas", 
	"city": "San Andros"}, 
{
	"citycode": "SML", 
	"airport": "Stella Maris Airport", 
	"country": "Bahamas", 
	"city": "Stella Maris"}, 
{
	"citycode": "TCB", 
	"airport": "Treasure Cay Airport", 
	"country": "Bahamas", 
	"city": "Treasure Cay"}, 
{
	"citycode": "TZN", 
	"airport": "South Andros Airport", 
	"country": "Bahamas", 
	"city": "South Andros"}, 
{
	"citycode": "WKR", 
	"airport": "Walker`s Cay Airport", 
	"country": "Bahamas", 
	"city": "Walker`s Cay"}, 
{
	"citycode": "ZSA", 
	"airport": "San Salvador Airport", 
	"country": "Bahamas", 
	"city": "San Salvador"}, 
{
	"citycode": "BGI", 
	"airport": "Grantley Adams International Airport", 
	"country": "Barbados", 
	"city": "Bridgetown"}, 
{
	"citycode": "BQT", 
	"airport": "Brest Airport", 
	"country": "Belarus", 
	"city": "Brest"}, 
{
	"citycode": "GME", 
	"airport": "Gomel Airport", 
	"country": "Belarus", 
	"city": "Gomel"}, 
{
	"citycode": "MSQ", 
	"airport": "Minsk National Airport", 
	"country": "Belarus", 
	"city": "Minsk"}, 
{
	"citycode": "MVQ", 
	"airport": "Mahilyow Airport", 
	"country": "Belarus", 
	"city": "Mogilev"}, 
{
	"citycode": "BGK", 
	"airport": "Big Creek Airport", 
	"country": "Belize", 
	"city": "Big Creek"}, 
{
	"citycode": "BZE", 
	"airport": "Philip S.W.Goldson International Airport", 
	"country": "Belize", 
	"city": "Belize City"}, 
{
	"citycode": "CYC", 
	"airport": "Caye Chapel Airport", 
	"country": "Belize", 
	"city": "Caye Chapel"}, 
{
	"citycode": "CZH", 
	"airport": "Corozal Airport", 
	"country": "Belize", 
	"city": "Corozal"}, 
{
	"citycode": "DGA", 
	"airport": "Dangriga Airport", 
	"country": "Belize", 
	"city": "Dangriga"}, 
{
	"citycode": "PND", 
	"airport": "Punta Gorda Airport", 
	"country": "Belize", 
	"city": "Punta Gorda"}, 
{
	"citycode": "SPR", 
	"airport": "John Greif II Airport", 
	"country": "Belize", 
	"city": "San Pedro"}, 
{
	"citycode": "COO", 
	"airport": "Cotonou Cadjehoun International Airport", 
	"country": "Benin", 
	"city": "Cotonou"}, 
{
	"citycode": "KDC", 
	"airport": "Kandi Airport", 
	"country": "Benin", 
	"city": "Kandi"}, 
{
	"citycode": "NAE", 
	"airport": "Boundetingou Airport", 
	"country": "Benin", 
	"city": "Natitingou"}, 
{
	"citycode": "PKO", 
	"airport": "Parakou Airport", 
	"country": "Benin", 
	"city": "Parakou"}, 
{
	"citycode": "BDA", 
	"airport": "L.F. Wade International Airport", 
	"country": "Bermuda", 
	"city": "Bermuda"}, 
{
	"citycode": "OMO", 
	"airport": "Mostar International Airport", 
	"country": "Bosnia and Herzegovina", 
	"city": "Mostar"}, 
{
	"citycode": "SJJ", 
	"airport": "Sarajevo International Airport", 
	"country": "Bosnia and Herzegovina", 
	"city": "Sarajevo"}, 
{
	"citycode": "BBK", 
	"airport": "Suvarnabhumi Airport", 
	"country": "Botswana", 
	"city": "Kasane"}, 
{
	"citycode": "FRW", 
	"airport": "Phillip Gaonwe Matante International Airport", 
	"country": "Botswana", 
	"city": "Francistown"}, 
{
	"citycode": "GBE", 
	"airport": "Sir Seretse Khama International Airport", 
	"country": "Botswana", 
	"city": "Gaborone"}, 
{
	"citycode": "GNZ", 
	"airport": "Ghanzi Airport", 
	"country": "Botswana", 
	"city": "Ghanzi"}, 
{
	"citycode": "HUK", 
	"airport": "Hukuntsi Airport", 
	"country": "Botswana", 
	"city": "Hukuntsi"}, 
{
	"citycode": "JWA", 
	"airport": "Jwaneng Airport", 
	"country": "Botswana", 
	"city": "Jwaneng"}, 
{
	"citycode": "KHW", 
	"airport": "Khwai River Airport", 
	"country": "Botswana", 
	"city": "Khwai River Lodge"}, 
{
	"citycode": "MUB", 
	"airport": "Maun International Airport", 
	"country": "Botswana", 
	"city": "Maun"}, 
{
	"citycode": "ORP", 
	"airport": "Orapa Airport", 
	"country": "Botswana", 
	"city": "Orapa"}, 
{
	"citycode": "PKW", 
	"airport": "Selebi-Phikwe Airport", 
	"country": "Botswana", 
	"city": "Selebi-Phikwe"}, 
{
	"citycode": "SWX", 
	"airport": "Shakawe Airport", 
	"country": "Botswana", 
	"city": "Shakawe"}, 
{
	"citycode": "TBY", 
	"airport": "Tshabong Airport", 
	"country": "Botswana", 
	"city": "Tsabong"}, 
{
	"citycode": "TLD", 
	"airport": "Tuli Lodge Airport", 
	"country": "Botswana", 
	"city": "Tuli Lodge"}, 
{
	"citycode": "BNR", 
	"airport": "Banfora Airport", 
	"country": "Burkina Faso", 
	"city": "Banfora"}, 
{
	"citycode": "BOY", 
	"airport": "Bobo Dioulasso Airport", 
	"country": "Burkina Faso", 
	"city": "Bobo Dioulasso"}, 
{
	"citycode": "DGU", 
	"airport": "Dedougou Airport", 
	"country": "Burkina Faso", 
	"city": "Dedougou"}, 
{
	"citycode": "DOR", 
	"airport": "Dori Airport", 
	"country": "Burkina Faso", 
	"city": "Dori"}, 
{
	"citycode": "FNG", 
	"airport": "Fada N`gourma Airport", 
	"country": "Burkina Faso", 
	"city": "Fada Ngourma"}, 
{
	"citycode": "OUA", 
	"airport": "Ouagadougou Airport", 
	"country": "Burkina Faso", 
	"city": "Ouagadougou"}, 
{
	"citycode": "OUG", 
	"airport": "Ouahigouya Airport", 
	"country": "Burkina Faso", 
	"city": "Ouahigouya"}, 
{
	"citycode": "TEG", 
	"airport": "Tenkodogo Airport", 
	"country": "Burkina Faso", 
	"city": "Tenkodogo"}, 
{
	"citycode": "XGA", 
	"airport": "Gaoua Airport", 
	"country": "Burkina Faso", 
	"city": "Gaoua"}, 
{
	"citycode": "XGG", 
	"airport": "Gorom-Gorom Airport", 
	"country": "Burkina Faso", 
	"city": "Gorom-Gorom"}, 
{
	"citycode": "XKA", 
	"airport": "Kantchari Airport", 
	"country": "Burkina Faso", 
	"city": "Kantchari"}, 
{
	"citycode": "XNU", 
	"airport": "Nouna Airport", 
	"country": "Burkina Faso", 
	"city": "Nouna"}, 
{
	"citycode": "BJM", 
	"airport": "Melchior Ndadaye International Airport", 
	"country": "Burundi", 
	"city": "Bujumbura"}, 
{
	"citycode": "GID", 
	"airport": "Gitega Airport", 
	"country": "Burundi", 
	"city": "Gitega"}, 
{
	"citycode": "KRE", 
	"airport": "Kirundo Airport", 
	"country": "Burundi", 
	"city": "Kirundo"}, 
{
	"citycode": "PNH", 
	"airport": "Phnom Penh International Airport", 
	"country": "Cambodia", 
	"city": "Phnom Penh"}, 
{
	"citycode": "REP", 
	"airport": "Siem Reap International Airport", 
	"country": "Cambodia", 
	"city": "Siem Reap"}, 
{
	"citycode": "BFX", 
	"airport": "Bafoussam Airport", 
	"country": "Cameroon", 
	"city": "Bafoussam"}, 
{
	"citycode": "BLC", 
	"airport": "Bali", 
	"country": "Cameroon", 
	"city": "Bali"}, 
{
	"citycode": "BPC", 
	"airport": "Bamenda Universal Airport", 
	"country": "Cameroon", 
	"city": "Bamenda"}, 
{
	"citycode": "BTA", 
	"airport": "Bertoua Airport", 
	"country": "Cameroon", 
	"city": "Bertoua"}, 
{
	"citycode": "DLA", 
	"airport": "Douala International Airport", 
	"country": "Cameroon", 
	"city": "Douala"}, 
{
	"citycode": "DSC", 
	"airport": "Dschang Airport", 
	"country": "Cameroon", 
	"city": "Dschang"}, 
{
	"citycode": "EBW", 
	"airport": "Ebolowa Airport", 
	"country": "Cameroon", 
	"city": "Ebolowa"}, 
{
	"citycode": "FOM", 
	"airport": "Foumban Nkounja Airport", 
	"country": "Cameroon", 
	"city": "Foumban"}, 
{
	"citycode": "GOU", 
	"airport": "Garouan Airport", 
	"country": "Cameroon", 
	"city": "Garoua"}, 
{
	"citycode": "GXX", 
	"airport": "Yagoua Airport", 
	"country": "Cameroon", 
	"city": "Yagoua"}, 
{
	"citycode": "KBI", 
	"airport": "Kribi Airport", 
	"country": "Cameroon", 
	"city": "Kribi"}, 
{
	"citycode": "KLE", 
	"airport": "Kaele Airport", 
	"country": "Cameroon", 
	"city": "Kaele"}, 
{
	"citycode": "KOB", 
	"airport": "Koutaba Airport", 
	"country": "Cameroon", 
	"city": "Koutaba"}, 
{
	"citycode": "MMF", 
	"airport": "Mamfe Airport", 
	"country": "Cameroon", 
	"city": "Mamfe"}, 
{
	"citycode": "MVR", 
	"airport": "Maroua Salak Airport", 
	"country": "Cameroon", 
	"city": "Maroua"}, 
{
	"citycode": "NGE", 
	"airport": "Ngaoundere Airport", 
	"country": "Cameroon", 
	"city": "Ngaoundere"}, 
{
	"citycode": "NSI", 
	"airport": "Yaounde Nsimalen International Airport", 
	"country": "Cameroon", 
	"city": "Yaounde"}, 
{
	"citycode": "OUR", 
	"airport": "Batouri Airport", 
	"country": "Cameroon", 
	"city": "Batouri"}, 
{
	"citycode": "TKC", 
	"airport": "Tiko Airport", 
	"country": "Cameroon", 
	"city": "Tiko"}, 
{
	"citycode": "YAO", 
	"airport": "Yaounde Airport", 
	"country": "Cameroon", 
	"city": "Yaounde"}, 
{
	"citycode": "BVC", 
	"airport": "Aristides Pereira International Airport", 
	"country": "Cape Verde", 
	"city": "Boa Vista"}, 
{
	"citycode": "MMO", 
	"airport": "Maio Airport", 
	"country": "Cape Verde", 
	"city": "Maio"}, 
{
	"citycode": "RAI", 
	"airport": "Nelson Mandela Praia International Airpor", 
	"country": "Cape Verde", 
	"city": "Praia"}, 
{
	"citycode": "SID", 
	"airport": "Amilcar Cabral International Airport", 
	"country": "Cape Verde", 
	"city": "Sal"}, 
{
	"citycode": "SNE", 
	"airport": "Sao Nicolau Airport", 
	"country": "Cape Verde", 
	"city": "Sao Nicolau"}, 
{
	"citycode": "VXE", 
	"airport": "Cesaria Evora Airport", 
	"country": "Cape Verde", 
	"city": "Sao Vicente"}, 
{
	"citycode": "CYB", 
	"airport": "Captain Charles Kirkconnell International Airport", 
	"country": "Cayman Islands", 
	"city": "Cayman Brac Island"}, 
{
	"citycode": "GCM", 
	"airport": "Owen Roberts International Airport", 
	"country": "Cayman Islands", 
	"city": "Grand Cayman Island"}, 
{
	"citycode": "LYB", 
	"airport": "Little Cayman Airport", 
	"country": "Cayman Islands", 
	"city": "Little Cayman"}, 
{
	"citycode": "ANF", 
	"airport": "Cerro Moreno International Airport", 
	"country": "Chile", 
	"city": "Antofagasta"}, 
{
	"citycode": "ARI", 
	"airport": "Chacalluta International Airport", 
	"country": "Chile", 
	"city": "Arica"}, 
{
	"citycode": "CCP", 
	"airport": "Carriel Sur International Airport", 
	"country": "Chile", 
	"city": "Concepcion"}, 
{
	"citycode": "CJC", 
	"airport": "El Loa Airport", 
	"country": "Chile", 
	"city": "Calama"}, 
{
	"citycode": "CPO", 
	"airport": "Desierto de Atacama Airport", 
	"country": "Chile", 
	"city": "Copiapo"}, 
{
	"citycode": "ESR", 
	"airport": "El Salvador Airport", 
	"country": "Chile", 
	"city": "El Salvador"}, 
{
	"citycode": "GXQ", 
	"airport": "Teniente Vidal Airport", 
	"country": "Chile", 
	"city": "Coyhaique"}, 
{
	"citycode": "IPC", 
	"airport": "Mataveri International Airport", 
	"country": "Chile", 
	"city": "Easter Island"}, 
{
	"citycode": "IQQ", 
	"airport": "Diego Aracena International Airport", 
	"country": "Chile", 
	"city": "Iquique"}, 
{
	"citycode": "LSC", 
	"airport": "La Florida Airport", 
	"country": "Chile", 
	"city": "La Serena"}, 
{
	"citycode": "LSQ", 
	"airport": "Mar?a Dolores Airport", 
	"country": "Chile", 
	"city": "Los Angeles"}, 
{
	"citycode": "PMC", 
	"airport": "El Tepual International Airport", 
	"country": "Chile", 
	"city": "Puerto Montt"}, 
{
	"citycode": "PUQ", 
	"airport": "Presidente Carlos Ibanez International Airport", 
	"country": "Chile", 
	"city": "Punta Arenas"}, 
{
	"citycode": "SCL", 
	"airport": "Arturo Merino Benitez International Airport", 
	"country": "Chile", 
	"city": "Santiago"}, 
{
	"citycode": "ZAL", 
	"airport": "Pichoy Airport", 
	"country": "Chile", 
	"city": "Valdivia"}, 
{
	"citycode": "ZCO", 
	"airport": "La Araucan?a International Airport", 
	"country": "Chile", 
	"city": "Temuco"}, 
{
	"citycode": "ZOS", 
	"airport": "Canal Bajo Carlos Hott Siebert Airport", 
	"country": "Chile", 
	"city": "Osorno"}, 
{
	"citycode": "ACD", 
	"airport": "Alcides Fern?ndez Airport", 
	"country": "Colombia", 
	"city": "Acandi"}, 
{
	"citycode": "ACR", 
	"airport": "Araracuara Airport", 
	"country": "Colombia", 
	"city": "Araracuara"}, 
{
	"citycode": "ADZ", 
	"airport": "Gustavo Rojas Pinilla - San Andrés International Airport", 
	"country": "Colombia", 
	"city": "San Andres Island"}, 
{
	"citycode": "APO", 
	"airport": "Antonio Rold?n Betancur Airport", 
	"country": "Colombia", 
	"city": "Apartado"}, 
{
	"citycode": "AUC", 
	"airport": "Santiago Perez Quiroz Airport", 
	"country": "Colombia", 
	"city": "Arauca"}, 
{
	"citycode": "AXM", 
	"airport": "El Edén International Airport", 
	"country": "Colombia", 
	"city": "Armenia"}, 
{
	"citycode": "AYG", 
	"airport": "Yaguara Airport", 
	"country": "Colombia", 
	"city": "Yaguara"}, 
{
	"citycode": "BAQ", 
	"airport": "Ernesto Cortissoz International Airport", 
	"country": "Colombia", 
	"city": "Barranquilla"}, 
{
	"citycode": "BGA", 
	"airport": "Palonegro Airport", 
	"country": "Colombia", 
	"city": "Bucaramanga"}, 
{
	"citycode": "BOG", 
	"airport": "El Dorado International Airport", 
	"country": "Colombia", 
	"city": "Bogota"}, 
{
	"citycode": "BSC", 
	"airport": "José Celestino Mutis Airport", 
	"country": "Colombia", 
	"city": "Bahia Solano"}, 
{
	"citycode": "BUN", 
	"airport": "Gerardo Tovar L?pez airport", 
	"country": "Colombia", 
	"city": "Buenaventura"}, 
{
	"citycode": "CAQ", 
	"airport": "Juan H. White Airport", 
	"country": "Colombia", 
	"city": "Caucasia"}, 
{
	"citycode": "CCO", 
	"airport": "Newnan Coweta County Airport", 
	"country": "Colombia", 
	"city": "Carimagua"}, 
{
	"citycode": "CIM", 
	"airport": "Cimitarra Airport", 
	"country": "Colombia", 
	"city": "Cimitarra"}, 
{
	"citycode": "CJD", 
	"airport": "Candilejas Airport", 
	"country": "Colombia", 
	"city": "Candilejas"}, 
{
	"citycode": "CLO", 
	"airport": "Alfonso Bonilla Arag?n International Airport", 
	"country": "Colombia", 
	"city": "Cali"}, 
{
	"citycode": "COG", 
	"airport": "Mandinga Airport", 
	"country": "Colombia", 
	"city": "Condoto"}, 
{
	"citycode": "CPB", 
	"airport": "Capurgana Airport", 
	"country": "Colombia", 
	"city": "Capurgana"}, 
{
	"citycode": "CQT", 
	"airport": "Caquetania Airport", 
	"country": "Colombia", 
	"city": "Caquetania"}, 
{
	"citycode": "CTG", 
	"airport": "Rafael Nunez International Airport", 
	"country": "Colombia", 
	"city": "Cartagena"}, 
{
	"citycode": "CUC", 
	"airport": "Camilo Daza International Airport", 
	"country": "Colombia", 
	"city": "Cucuta"}, 
{
	"citycode": "CZU", 
	"airport": "Las Brujas Airport", 
	"country": "Colombia", 
	"city": "Corozal"}, 
{
	"citycode": "EBG", 
	"airport": "El Bagre Airport", 
	"country": "Colombia", 
	"city": "El Bagre"}, 
{
	"citycode": "EJA", 
	"airport": "Yarigu?es Regional Airport", 
	"country": "Colombia", 
	"city": "Barrancabermeja"}, 
{
	"citycode": "ELB", 
	"airport": "Las Flores Airport", 
	"country": "Colombia", 
	"city": "El Banco"}, 
{
	"citycode": "ELJ", 
	"airport": "El Recreo Airport", 
	"country": "Colombia", 
	"city": "El Recreo"}, 
{
	"citycode": "EYP", 
	"airport": "El Alcaravan International Airport", 
	"country": "Colombia", 
	"city": "El Yopal"}, 
{
	"citycode": "FLA", 
	"airport": "Gustavo Artunduaga Paredes Airport", 
	"country": "Colombia", 
	"city": "Florencia"}, 
{
	"citycode": "GCA", 
	"airport": "Guacamaya Airport", 
	"country": "Colombia", 
	"city": "Guacamaya"}, 
{
	"citycode": "GPI", 
	"airport": "Guapi Airport", 
	"country": "Colombia", 
	"city": "Guapi"}, 
{
	"citycode": "IBE", 
	"airport": "Perales National Airport", 
	"country": "Colombia", 
	"city": "Ibague"}, 
{
	"citycode": "IGO", 
	"airport": "Chigorodo Airport", 
	"country": "Colombia", 
	"city": "Chigorodo"}, 
{
	"citycode": "IPI", 
	"airport": "San Luis Airport", 
	"country": "Colombia", 
	"city": "Ipiales"}, 
{
	"citycode": "LAT", 
	"airport": "La Uribe Airport", 
	"country": "Colombia", 
	"city": "La Uribe"}, 
{
	"citycode": "LCR", 
	"airport": "La Chorrera Airport", 
	"country": "Colombia", 
	"city": "La Chorrera"}, 
{
	"citycode": "LET", 
	"airport": "Alfredo Vasquez Cobo International Airport", 
	"country": "Colombia", 
	"city": "Leticia"}, 
{
	"citycode": "LGZ", 
	"airport": "Leguizamo Airport", 
	"country": "Colombia", 
	"city": "Leguizamo"}, 
{
	"citycode": "LMC", 
	"airport": "La macarena Airport", 
	"country": "Colombia", 
	"city": "Lamacarena"}, 
{
	"citycode": "LMX", 
	"airport": "Lopez De Micay Airport", 
	"country": "Colombia", 
	"city": "Lopez De Micay"}, 
{
	"citycode": "LPD", 
	"airport": "La Pedrera Airport", 
	"country": "Colombia", 
	"city": "La Pedrera"}, 
{
	"citycode": "LPE", 
	"airport": "La Primavera Airport", 
	"country": "Colombia", 
	"city": "La Primavera"}, 
{
	"citycode": "MDE", 
	"airport": "Jose Marie Cordova International Airport", 
	"country": "Colombia", 
	"city": "Medellin"}, 
{
	"citycode": "MMP", 
	"airport": "San Bernardo Airport", 
	"country": "Colombia", 
	"city": "Mompos"}, 
{
	"citycode": "MTR", 
	"airport": "Los Garzones-Monteria International Airport", 
	"country": "Colombia", 
	"city": "Monteria"}, 
{
	"citycode": "MVP", 
	"airport": "Fabio Alberto Leon Bentley Airport", 
	"country": "Colombia", 
	"city": "Mitu"}, 
{
	"citycode": "MZL", 
	"airport": "La Nubia Airport", 
	"country": "Colombia", 
	"city": "Manizales"}, 
{
	"citycode": "NAR", 
	"airport": "Narita International Airport", 
	"country": "Colombia", 
	"city": "Nare"}, 
{
	"citycode": "NBB", 
	"airport": "Barranco Minas Airport", 
	"country": "Colombia", 
	"city": "Barrancominas"}, 
{
	"citycode": "NCI", 
	"airport": "Necocli Airport", 
	"country": "Colombia", 
	"city": "Necocli"}, 
{
	"citycode": "NQU", 
	"airport": "Reyes Murillo Airport", 
	"country": "Colombia", 
	"city": "Nuqui"}, 
{
	"citycode": "NVA", 
	"airport": "Benito Salas Airport", 
	"country": "Colombia", 
	"city": "Neiva"}, 
{
	"citycode": "OCV", 
	"airport": "Aguas claras Airport", 
	"country": "Colombia", 
	"city": "Ocana"}, 
{
	"citycode": "ORC", 
	"airport": "Orange City Municipal Airport", 
	"country": "Colombia", 
	"city": "Orocue"}, 
{
	"citycode": "OTU", 
	"airport": "Out Airport", 
	"country": "Colombia", 
	"city": "Otu"}, 
{
	"citycode": "PBE", 
	"airport": "Puerto Berrio Airport", 
	"country": "Colombia", 
	"city": "Puerto Berrio"}, 
{
	"citycode": "PCR", 
	"airport": "German Olano Airport", 
	"country": "Colombia", 
	"city": "Puerto Carreno"}, 
{
	"citycode": "PDA", 
	"airport": "Cesar Gaviria Trujillo Airport", 
	"country": "Colombia", 
	"city": "Puerto Inirida"}, 
{
	"citycode": "PEI", 
	"airport": "Mateca?a International Airport", 
	"country": "Colombia", 
	"city": "Pereira"}, 
{
	"citycode": "PPN", 
	"airport": "Guillermo Leon Valencia Airport", 
	"country": "Colombia", 
	"city": "Popayan"}, 
{
	"citycode": "PUU", 
	"airport": "Tres de Mayo Airport", 
	"country": "Colombia", 
	"city": "Puerto Asis"}, 
{
	"citycode": "PVA", 
	"airport": "El Embrujo Airport", 
	"country": "Colombia", 
	"city": "Providencia"}, 
{
	"citycode": "PZA", 
	"airport": "Paz de Ariporo Airport", 
	"country": "Colombia", 
	"city": "Paz De Ariporo"}, 
{
	"citycode": "RAV", 
	"airport": "Cravo Norte Airport", 
	"country": "Colombia", 
	"city": "Cravo Norte"}, 
{
	"citycode": "RCH", 
	"airport": "Almirante Padilla Airport", 
	"country": "Colombia", 
	"city": "Riohacha"}, 
{
	"citycode": "RON", 
	"airport": "Juan Jose Rondon Airport", 
	"country": "Colombia", 
	"city": "Rondon"}, 
{
	"citycode": "RVE", 
	"airport": "Los Colonizadores Airport", 
	"country": "Colombia", 
	"city": "Saravena"}, 
{
	"citycode": "SJE", 
	"airport": "Jorge Enrique Gonz?lez Torres Airport", 
	"country": "Colombia", 
	"city": "San Jose Del Gua"}, 
{
	"citycode": "SMR", 
	"airport": "Simon Bolivar International Airport", 
	"country": "Colombia", 
	"city": "Santa Marta"}, 
{
	"citycode": "SQF", 
	"airport": "Solano Airport", 
	"country": "Colombia", 
	"city": "Solano"}, 
{
	"citycode": "SRO", 
	"airport": "Santana Ramos Airport", 
	"country": "Colombia", 
	"city": "Santana Ramos"}, 
{
	"citycode": "SVI", 
	"airport": "San Vicente Airport", 
	"country": "Colombia", 
	"city": "San Vicente"}, 
{
	"citycode": "TCO", 
	"airport": "La Florida Airport", 
	"country": "Colombia", 
	"city": "Tumaco"}, 
{
	"citycode": "TDA", 
	"airport": "Trinidad Airport", 
	"country": "Colombia", 
	"city": "Trinidad"}, 
{
	"citycode": "TME", 
	"airport": "Gabriel Vargas Santos Airport", 
	"country": "Colombia", 
	"city": "Tame"}, 
{
	"citycode": "TRB", 
	"airport": "Gonzalo Mejia Airport", 
	"country": "Colombia", 
	"city": "Turbo"}, 
{
	"citycode": "UIB", 
	"airport": "Quibdo Airport", 
	"country": "Colombia", 
	"city": "Quibdo"}, 
{
	"citycode": "URR", 
	"airport": "Urrao Airport", 
	"country": "Colombia", 
	"city": "Urrao"}, 
{
	"citycode": "VGZ", 
	"airport": "Villa Garzon Airport", 
	"country": "Colombia", 
	"city": "Villagarzon"}, 
{
	"citycode": "VUP", 
	"airport": "Alfonso Lopez Airport", 
	"country": "Colombia", 
	"city": "Valledupar"}, 
{
	"citycode": "VVC", 
	"airport": "La Vanguardia Airport", 
	"country": "Colombia", 
	"city": "Villavicencio"}, 
{
	"citycode": "AJN", 
	"airport": "Ouani Airport", 
	"country": "Comoros", 
	"city": "Anjouan, Nzwani Island"}, 
{
	"citycode": "HAH", 
	"airport": "Prince Said Ibrahim International Airport", 
	"country": "Comoros", 
	"city": "Moroni"}, 
{
	"citycode": "NWA", 
	"airport": "Moheli Bandar Es Eslam Airport", 
	"country": "Comoros", 
	"city": "Moheli"}, 
{
	"citycode": "YVA", 
	"airport": "Iconi Airport", 
	"country": "Comoros", 
	"city": "Moroni"}, 
{
	"citycode": "AIT", 
	"airport": "Aitutaki Airport", 
	"country": "Cook Islands", 
	"city": "Aitutaki"}, 
{
	"citycode": "AIU", 
	"airport": "Enua Airport", 
	"country": "Cook Islands", 
	"city": "Atiu Island"}, 
{
	"citycode": "MGS", 
	"airport": "Mangaia Airport", 
	"country": "Cook Islands", 
	"city": "Mangaia Island"}, 
{
	"citycode": "MHX", 
	"airport": "Manihiki Island Airport", 
	"country": "Cook Islands", 
	"city": "Manihiki Island"}, 
{
	"citycode": "MOI", 
	"airport": "Moi International Airport", 
	"country": "Cook Islands", 
	"city": "Mitiaro Island"}, 
{
	"citycode": "MUK", 
	"airport": "Mauke Airport", 
	"country": "Cook Islands", 
	"city": "Mauke Island"}, 
{
	"citycode": "PYE", 
	"airport": "Tongareva Airport", 
	"country": "Cook Islands", 
	"city": "Penrhyn Island"}, 
{
	"citycode": "RAR", 
	"airport": "Rarotonga International Airport", 
	"country": "Cook Islands", 
	"city": "Rarotonga"}, 
{
	"citycode": "GLF", 
	"airport": "Golfito Airport", 
	"country": "Costa Rica", 
	"city": "Golfito"}, 
{
	"citycode": "NOB", 
	"airport": "Nosara Airport", 
	"country": "Costa Rica", 
	"city": "Nosara Beach"}, 
{
	"citycode": "OTR", 
	"airport": "Coto 47 Airport", 
	"country": "Costa Rica", 
	"city": "Coto 47"}, 
{
	"citycode": "PLD", 
	"airport": "Playa Samara Airport", 
	"country": "Costa Rica", 
	"city": "Playa Samara"}, 
{
	"citycode": "PMZ", 
	"airport": "Palmar Sur Airport", 
	"country": "Costa Rica", 
	"city": "Palmar"}, 
{
	"citycode": "SJO", 
	"airport": "Juan Santamaria International Airport", 
	"country": "Costa Rica", 
	"city": "San Jose"}, 
{
	"citycode": "XQP", 
	"airport": "La Managua Airport", 
	"country": "Costa Rica", 
	"city": "Quepos"}, 
{
	"citycode": "DBV", 
	"airport": "Roger Boscovich Airport", 
	"country": "Croatia", 
	"city": "Dubrovnik"}, 
{
	"citycode": "PUY", 
	"airport": "Pula Airport", 
	"country": "Croatia", 
	"city": "Pula"}, 
{
	"citycode": "RJK", 
	"airport": "Rijeka International Airport", 
	"country": "Croatia", 
	"city": "Rijeka"}, 
{
	"citycode": "SPU", 
	"airport": "Split Airport", 
	"country": "Croatia", 
	"city": "Split"}, 
{
	"citycode": "ZAD", 
	"airport": "Zadar Airport", 
	"country": "Croatia", 
	"city": "Zadar"}, 
{
	"citycode": "ZAG", 
	"airport": "Zagreb Franjo Tudman Airport", 
	"country": "Croatia", 
	"city": "Zagreb"}, 
{
	"citycode": "AKT", 
	"airport": "Akrotiri RAF Airport", 
	"country": "Cyprus", 
	"city": "Akrotiri"}, 
{
	"citycode": "ECN", 
	"airport": "Ercan International Airport", 
	"country": "Cyprus", 
	"city": "Ercan"}, 
{
	"citycode": "GEC", 
	"airport": "Gecitkale Airport", 
	"country": "Cyprus", 
	"city": "Gecitkale"}, 
{
	"citycode": "LCA", 
	"airport": "Larnaca International Airport", 
	"country": "Cyprus", 
	"city": "Larnaca"}, 
{
	"citycode": "PFO", 
	"airport": "Paphos International Airport", 
	"country": "Cyprus", 
	"city": "Paphos"}, 
{
	"citycode": "PRG", 
	"airport": "Vaclav Havel Airport", 
	"country": "Czech Republic", 
	"city": "Prague"}, 
{
	"citycode": "TDG", 
	"airport": "Podgorica Airport", 
	"country": "Czech Republic", 
	"city": "Podgorica"}, 
{
	"citycode": "JIB", 
	"airport": "Djibouti–Ambouli International Airport", 
	"country": "Djibouti", 
	"city": "Djibouti"}, 
{
	"citycode": "OBC", 
	"airport": "Obock Airport", 
	"country": "Djibouti", 
	"city": "Obock"}, 
{
	"citycode": "TDJ", 
	"airport": "Tadjoura Airport", 
	"country": "Djibouti", 
	"city": "Tadjoura"}, 
{
	"citycode": "DCF", 
	"airport": "Roseau-Canefield Airport", 
	"country": "Dominica", 
	"city": "Roseau"}, 
{
	"citycode": "DOM", 
	"airport": "Douglas–Charles Airport", 
	"country": "Dominica", 
	"city": "Dominica"}, 
{
	"citycode": "HEX", 
	"airport": "Herrera International Airport", 
	"country": "Dominican Republic", 
	"city": "Santo Domingo"}, 
{
	"citycode": "LRM", 
	"airport": "La Romana International Airport", 
	"country": "Dominican Republic", 
	"city": "La Romana"}, 
{
	"citycode": "POP", 
	"airport": "Puerto Plata International Airport", 
	"country": "Dominican Republic", 
	"city": "Puerto Plata"}, 
{
	"citycode": "PUJ", 
	"airport": "Punta Cana International Airport", 
	"country": "Dominican Republic", 
	"city": "Punta Cana"}, 
{
	"citycode": "SDQ", 
	"airport": "Las Americas international Airport", 
	"country": "Dominican Republic", 
	"city": "Santo Domingo"}, 
{
	"citycode": "STI", 
	"airport": "Cibao International Airport", 
	"country": "Dominican Republic", 
	"city": "Santiago"}, 
{
	"citycode": "CUE", 
	"airport": "Mariscal Lamar International Airport", 
	"country": "Ecuador", 
	"city": "Cuenca"}, 
{
	"citycode": "ESM", 
	"airport": "Colonel Carlos Concha Torres Airport", 
	"country": "Ecuador", 
	"city": "Esmeraldas"}, 
{
	"citycode": "GPS", 
	"airport": "Seymour Airport", 
	"country": "Ecuador", 
	"city": "Galapagos Is"}, 
{
	"citycode": "GYE", 
	"airport": "Guayaquil Airport", 
	"country": "Ecuador", 
	"city": "Guayaquil"}, 
{
	"citycode": "LGQ", 
	"airport": "Lago Agrio Airport", 
	"country": "Ecuador", 
	"city": "Lago Agrio"}, 
{
	"citycode": "LOH", 
	"airport": "Ciudad de Catamayo Airport", 
	"country": "Ecuador", 
	"city": "Loja"}, 
{
	"citycode": "MCH", 
	"airport": "General Manuel Serrano Airport", 
	"country": "Ecuador", 
	"city": "Machala"}, 
{
	"citycode": "MEC", 
	"airport": "Eloy Alfaro International Airport", 
	"country": "Ecuador", 
	"city": "Manta"}, 
{
	"citycode": "OCC", 
	"airport": "Francisco de Orellana Airport", 
	"country": "Ecuador", 
	"city": "Coca"}, 
{
	"citycode": "PVO", 
	"airport": "Reales Tamarindos Airport", 
	"country": "Ecuador", 
	"city": "Portoviejo"}, 
{
	"citycode": "TPC", 
	"airport": "Tarapoa Airport", 
	"country": "Ecuador", 
	"city": "Tarapoa"}, 
{
	"citycode": "TUA", 
	"airport": "Teniente Coronel Luis A. Mantilla International Airport", 
	"country": "Ecuador", 
	"city": "Tulcan"}, 
{
	"citycode": "UIO", 
	"airport": "Mariscal Sucre Quito International Airport", 
	"country": "Ecuador", 
	"city": "Quito"}, 
{
	"citycode": "XMS", 
	"airport": "Coronel Edmundo Carvajal Airport", 
	"country": "Ecuador", 
	"city": "Macas"}, 
{
	"citycode": "SAL", 
	"airport": "El Salvador International Airport", 
	"country": "El Salvador", 
	"city": "San Salvador"}, 
{
	"citycode": "BSG", 
	"airport": "Bata Airport", 
	"country": "Equatorial Guinea", 
	"city": "Bata"}, 
{
	"citycode": "SSG", 
	"airport": "Malabo International Airport", 
	"country": "Equatorial Guinea", 
	"city": "Malabo"}, 
{
	"citycode": "TLL", 
	"airport": "Tallinn Airport", 
	"country": "Estonia", 
	"city": "Tallinn"}, 
{
	"citycode": "ABK", 
	"airport": "Kabri Dar Airport", 
	"country": "Ethiopia", 
	"city": "Kabri Dar"}, 
{
	"citycode": "ADD", 
	"airport": "Bole Addis Ababa International Airport", 
	"country": "Ethiopia", 
	"city": "Addis Ababa"}, 
{
	"citycode": "AMH", 
	"airport": "Arba Minch Airport", 
	"country": "Ethiopia", 
	"city": "Arba Mintch"}, 
{
	"citycode": "ASO", 
	"airport": "Asosa Airport", 
	"country": "Ethiopia", 
	"city": "Asosa"}, 
{
	"citycode": "AWA", 
	"airport": "Hawassa Airport", 
	"country": "Ethiopia", 
	"city": "Awassa"}, 
{
	"citycode": "AWH", 
	"airport": "Awareh Airport ", 
	"country": "Ethiopia", 
	"city": "Awareh"}, 
{
	"citycode": "AXU", 
	"airport": "Axum Airport", 
	"country": "Ethiopia", 
	"city": "Axum"}, 
{
	"citycode": "BCO", 
	"airport": "Jinka international airport", 
	"country": "Ethiopia", 
	"city": "Jinka"}, 
{
	"citycode": "BCY", 
	"airport": "Bulchi Airport", 
	"country": "Ethiopia", 
	"city": "Bulchi"}, 
{
	"citycode": "BEI", 
	"airport": "Beica Airport", 
	"country": "Ethiopia", 
	"city": "Beica"}, 
{
	"citycode": "BJR", 
	"airport": "Bahir Dar Belay Zeleke International Airport", 
	"country": "Ethiopia", 
	"city": "Bahar Dar"}, 
{
	"citycode": "DBM", 
	"airport": "Debre Marqos Airport", 
	"country": "Ethiopia", 
	"city": "Debra Marcos"}, 
{
	"citycode": "DBT", 
	"airport": "Debre Tabor Airport", 
	"country": "Ethiopia", 
	"city": "Debra Tabor"}, 
{
	"citycode": "DEM", 
	"airport": "Dembidollo Airport", 
	"country": "Ethiopia", 
	"city": "Dembidollo"}, 
{
	"citycode": "DIR", 
	"airport": "Dire Dawa International Airport", 
	"country": "Ethiopia", 
	"city": "Dire Dawa"}, 
{
	"citycode": "DSE", 
	"airport": "Kombolcha Airport", 
	"country": "Ethiopia", 
	"city": "Dessie"}, 
{
	"citycode": "ETE", 
	"airport": "Genda Wuha Airport", 
	"country": "Ethiopia", 
	"city": "Genda Wuha"}, 
{
	"citycode": "GCE", 
	"airport": "GODE", 
	"country": "Ethiopia", 
	"city": "GODE"}, 
{
	"citycode": "GDE", 
	"airport": "Gode Airport", 
	"country": "Ethiopia", 
	"city": "Gode"}, 
{
	"citycode": "GDQ", 
	"airport": "Gondar Airport", 
	"country": "Ethiopia", 
	"city": "Gondar"}, 
{
	"citycode": "GMB", 
	"airport": "Gambela Airport", 
	"country": "Ethiopia", 
	"city": "Gambela"}, 
{
	"citycode": "GNN", 
	"airport": "Ghinnir Airport", 
	"country": "Ethiopia", 
	"city": "Ghinnir"}, 
{
	"citycode": "GOB", 
	"airport": "Robe Airport", 
	"country": "Ethiopia", 
	"city": "Goba"}, 
{
	"citycode": "GOR", 
	"airport": "Gore Airport", 
	"country": "Ethiopia", 
	"city": "Gore"}, 
{
	"citycode": "HUE", 
	"airport": "Humera Airport", 
	"country": "Ethiopia", 
	"city": "Humera"}, 
{
	"citycode": "JIJ", 
	"airport": "Jigjiga Garad Wilwal Airport", 
	"country": "Ethiopia", 
	"city": "Jijiga"}, 
{
	"citycode": "JIM", 
	"airport": "Aba Segud Airport", 
	"country": "Ethiopia", 
	"city": "Jimma"}, 
{
	"citycode": "LLI", 
	"airport": "Lissadell Airport", 
	"country": "Ethiopia", 
	"city": "Lalibela"}, 
{
	"citycode": "MKS", 
	"airport": "Mekane Selam Airport", 
	"country": "Ethiopia", 
	"city": "Mekane Selam"}, 
{
	"citycode": "MQX", 
	"airport": "Alula Aba Nega Airport", 
	"country": "Ethiopia", 
	"city": "Makale"}, 
{
	"citycode": "MTF", 
	"airport": "Mizan Teferi Airport", 
	"country": "Ethiopia", 
	"city": "Mizan Teferi"}, 
{
	"citycode": "MUJ", 
	"airport": "Mui Airport", 
	"country": "Ethiopia", 
	"city": "Mui"}, 
{
	"citycode": "MZX", 
	"airport": "Mena Airport", 
	"country": "Ethiopia", 
	"city": "Mena"}, 
{
	"citycode": "NDM", 
	"airport": "Mendi Airport", 
	"country": "Ethiopia", 
	"city": "Mendi"}, 
{
	"citycode": "NEK", 
	"airport": "Nekemt Airport", 
	"country": "Ethiopia", 
	"city": "Nekemt"}, 
{
	"citycode": "OTA", 
	"airport": "Mota Airport", 
	"country": "Ethiopia", 
	"city": "Mota"}, 
{
	"citycode": "PWI", 
	"airport": "Beles Airport", 
	"country": "Ethiopia", 
	"city": "Pawi"}, 
{
	"citycode": "SHC", 
	"airport": "Shire Airport", 
	"country": "Ethiopia", 
	"city": "Indaselassie"}, 
{
	"citycode": "SKR", 
	"airport": "Shakiso Airport", 
	"country": "Ethiopia", 
	"city": "Shakiso"}, 
{
	"citycode": "SXU", 
	"airport": "Soddu Airport", 
	"country": "Ethiopia", 
	"city": "Soddu"}, 
{
	"citycode": "SZE", 
	"airport": "Samara Airport", 
	"country": "Ethiopia", 
	"city": "Semera"}, 
{
	"citycode": "TIE", 
	"airport": "Tippi Airport", 
	"country": "Ethiopia", 
	"city": "Tippi"}, 
{
	"citycode": "TUJ", 
	"airport": "Tum Airport", 
	"country": "Ethiopia", 
	"city": "Tum"}, 
{
	"citycode": "WAC", 
	"airport": "Waca Airport", 
	"country": "Ethiopia", 
	"city": "Waca"}, 
{
	"citycode": "WRA", 
	"airport": "Warder Airport", 
	"country": "Ethiopia", 
	"city": "Warder"}, 
{
	"citycode": "XBL", 
	"airport": "Buno Bedelle Airport", 
	"country": "Ethiopia", 
	"city": "Buno Bedelle"}, 
{
	"citycode": "CST", 
	"airport": "Castaway Island Airport", 
	"country": "Fiji", 
	"city": "Castaway"}, 
{
	"citycode": "ICI", 
	"airport": "Cicia Airport", 
	"country": "Fiji", 
	"city": "Cicia"}, 
{
	"citycode": "KDV", 
	"airport": "Vunisea Airport ", 
	"country": "Fiji", 
	"city": "Kandavu"}, 
{
	"citycode": "LBS", 
	"airport": "Labasa Airport", 
	"country": "Fiji", 
	"city": "Labasa"}, 
{
	"citycode": "LEV", 
	"airport": "Levuka Airfield", 
	"country": "Fiji", 
	"city": "Bureta"}, 
{
	"citycode": "LKB", 
	"airport": "Lakeba Airport", 
	"country": "Fiji", 
	"city": "Lakeba"}, 
{
	"citycode": "MFJ", 
	"airport": "Moala Airport", 
	"country": "Fiji", 
	"city": "Moala"}, 
{
	"citycode": "MNF", 
	"airport": "Mana Island Airport", 
	"country": "Fiji", 
	"city": "Mana Island"}, 
{
	"citycode": "NAN", 
	"airport": "Nadi International Airport", 
	"country": "Fiji", 
	"city": "Nadi, Suva"}, 
{
	"citycode": "PHR", 
	"airport": "Pacific Harbor Airport", 
	"country": "Fiji", 
	"city": "Pacific Harbor"}, 
{
	"citycode": "PTF", 
	"airport": "Malolo Lailai Airport", 
	"country": "Fiji", 
	"city": "Malololailai"}, 
{
	"citycode": "RTA", 
	"airport": "Rotuma Airport", 
	"country": "Fiji", 
	"city": "Rotuma Island"}, 
{
	"citycode": "SUV", 
	"airport": "Suva-Nausori Airport", 
	"country": "Fiji", 
	"city": "Suva"}, 
{
	"citycode": "SVU", 
	"airport": "Savusavu Airport", 
	"country": "Fiji", 
	"city": "Savusavu"}, 
{
	"citycode": "TVU", 
	"airport": "Matei Airport", 
	"country": "Fiji", 
	"city": "Taveuni"}, 
{
	"citycode": "ENF", 
	"airport": "Enontekio Airport", 
	"country": "Finland", 
	"city": "Enontekio"}, 
{
	"citycode": "HEL", 
	"airport": "Helsinki-Vantaa Airport", 
	"country": "Finland", 
	"city": "Helsinki"}, 
{
	"citycode": "HEM", 
	"airport": "Helsinki-Malmi Airport", 
	"country": "Finland", 
	"city": "Helsinki"}, 
{
	"citycode": "IVL", 
	"airport": "Ivalo Airport", 
	"country": "Finland", 
	"city": "Ivalo"}, 
{
	"citycode": "JOE", 
	"airport": "Joensuu Airport", 
	"country": "Finland", 
	"city": "Joensuu"}, 
{
	"citycode": "JYV", 
	"airport": "Jyvaskyla Airport", 
	"country": "Finland", 
	"city": "Jyvaskyla"}, 
{
	"citycode": "KAJ", 
	"airport": "Kajaani Airport", 
	"country": "Finland", 
	"city": "Kajaani"}, 
{
	"citycode": "KAO", 
	"airport": "Kuusamo Airport", 
	"country": "Finland", 
	"city": "Kuusamo"}, 
{
	"citycode": "KEM", 
	"airport": "Kemi-Tornio Airport", 
	"country": "Finland", 
	"city": "Kemi-Tornio"}, 
{
	"citycode": "KOK", 
	"airport": "Kokkola-Jakobstad Airport", 
	"country": "Finland", 
	"city": "Kokkola-Pietarsaari"}, 
{
	"citycode": "KTT", 
	"airport": "Kittila Airport", 
	"country": "Finland", 
	"city": "Kittila"}, 
{
	"citycode": "KUO", 
	"airport": "Kuopio Airport", 
	"country": "Finland", 
	"city": "Kuopio"}, 
{
	"citycode": "LPP", 
	"airport": "Lappeenranta Airport", 
	"country": "Finland", 
	"city": "Lappeenranta"}, 
{
	"citycode": "MHQ", 
	"airport": "Mariehamn Airport", 
	"country": "Finland", 
	"city": "Mariehamn"}, 
{
	"citycode": "MIK", 
	"airport": "Mikkeli Airport", 
	"country": "Finland", 
	"city": "Mikkeli"}, 
{
	"citycode": "OUL", 
	"airport": "Oulu Airport", 
	"country": "Finland", 
	"city": "Oulu"}, 
{
	"citycode": "POR", 
	"airport": "Pori Airport", 
	"country": "Finland", 
	"city": "Pori"}, 
{
	"citycode": "RVN", 
	"airport": "Rovaniemi Airport", 
	"country": "Finland", 
	"city": "Rovaniemi"}, 
{
	"citycode": "SOT", 
	"airport": "Mae Sot Airport", 
	"country": "Finland", 
	"city": "Sodankyla"}, 
{
	"citycode": "SVL", 
	"airport": "Savonlinna Airport", 
	"country": "Finland", 
	"city": "Savonlinna"}, 
{
	"citycode": "TKU", 
	"airport": "Turku Airport", 
	"country": "Finland", 
	"city": "Turku"}, 
{
	"citycode": "TMP", 
	"airport": "Tampere-Pirkkala Airport", 
	"country": "Finland", 
	"city": "Tampere"}, 
{
	"citycode": "VAA", 
	"airport": "Vaasa Airport", 
	"country": "Finland", 
	"city": "Vaasa"}, 
{
	"citycode": "VRK", 
	"airport": "Varkaus Airport", 
	"country": "Finland", 
	"city": "Varkaus"}, 
{
	"citycode": "CAY", 
	"airport": "Aeropuerto Internacional de Cayenne-Rochambeau Airport", 
	"country": "French Guiana", 
	"city": "Cayenne"}, 
{
	"citycode": "AAA", 
	"airport": "Anaa Airport", 
	"country": "French Polynesia", 
	"city": "Anaa"}, 
{
	"citycode": "APK", 
	"airport": "Apataki Airport", 
	"country": "French Polynesia", 
	"city": "Apataki"}, 
{
	"citycode": "AUQ", 
	"airport": "Atuona Airport", 
	"country": "French Polynesia", 
	"city": "Atuona"}, 
{
	"citycode": "AXR", 
	"airport": "Arutua Airport", 
	"country": "French Polynesia", 
	"city": "Arutua"}, 
{
	"citycode": "BOB", 
	"airport": "Bora Bora Airport", 
	"country": "French Polynesia", 
	"city": "Bora Bora"}, 
{
	"citycode": "FAV", 
	"airport": "Fakarava Airport", 
	"country": "French Polynesia", 
	"city": "Fakarava"}, 
{
	"citycode": "FGU", 
	"airport": "Fangatau Airport", 
	"country": "French Polynesia", 
	"city": "Fangatau"}, 
{
	"citycode": "FHZ", 
	"airport": "Fakahina Airfield", 
	"country": "French Polynesia", 
	"city": "Fakahina"}, 
{
	"citycode": "GMR", 
	"airport": "Totegegie Airport", 
	"country": "French Polynesia", 
	"city": "Gambier Is"}, 
{
	"citycode": "HOI", 
	"airport": "Hao Airport", 
	"country": "French Polynesia", 
	"city": "Hao Island"}, 
{
	"citycode": "HUH", 
	"airport": "Huahine – Fare Airport", 
	"country": "French Polynesia", 
	"city": "Huahine"}, 
{
	"citycode": "KKR", 
	"airport": "Kaukura Airport", 
	"country": "French Polynesia", 
	"city": "Kaukura Atoll"}, 
{
	"citycode": "MAU", 
	"airport": "Maupiti Airport", 
	"country": "French Polynesia", 
	"city": "Maupiti"}, 
{
	"citycode": "MKP", 
	"airport": "Makemo Airport", 
	"country": "French Polynesia", 
	"city": "Makemo"}, 
{
	"citycode": "MOZ", 
	"airport": "Moorea Airport", 
	"country": "French Polynesia", 
	"city": "Moorea"}, 
{
	"citycode": "MVT", 
	"airport": "Mataiva Airport", 
	"country": "French Polynesia", 
	"city": "Mataiva"}, 
{
	"citycode": "NAU", 
	"airport": "Napuka Airport", 
	"country": "French Polynesia", 
	"city": "Napuka Island"}, 
{
	"citycode": "NHV", 
	"airport": "Nuku Hiva Airport", 
	"country": "French Polynesia", 
	"city": "Nuku Hiva"}, 
{
	"citycode": "NUK", 
	"airport": "Nukutavake Airport", 
	"country": "French Polynesia", 
	"city": "Nukutavake"}, 
{
	"citycode": "PKP", 
	"airport": "Puka Puka Airport", 
	"country": "French Polynesia", 
	"city": "Puka Puka"}, 
{
	"citycode": "PPT", 
	"airport": "Faa`a International Airport", 
	"country": "French Polynesia", 
	"city": "Papeete"}, 
{
	"citycode": "PUK", 
	"airport": "Pukarua Airport", 
	"country": "French Polynesia", 
	"city": "Pukarua"}, 
{
	"citycode": "REA", 
	"airport": "Reao Airport", 
	"country": "French Polynesia", 
	"city": "Reao"}, 
{
	"citycode": "RFP", 
	"airport": "Raiatea Airport", 
	"country": "French Polynesia", 
	"city": "Raiatea"}, 
{
	"citycode": "RGI", 
	"airport": "Rangiroa Airport", 
	"country": "French Polynesia", 
	"city": "Rangiroa"}, 
{
	"citycode": "RUR", 
	"airport": "Rurutu Airport", 
	"country": "French Polynesia", 
	"city": "Rurutu"}, 
{
	"citycode": "TIH", 
	"airport": "Tikehau Airport", 
	"country": "French Polynesia", 
	"city": "Tikehau Atoll"}, 
{
	"citycode": "TKP", 
	"airport": "Takapoto Airport", 
	"country": "French Polynesia", 
	"city": "Takapoto"}, 
{
	"citycode": "TKV", 
	"airport": "Tatakoto Airport", 
	"country": "French Polynesia", 
	"city": "Tatakoto"}, 
{
	"citycode": "TKX", 
	"airport": "Takaroa Airport", 
	"country": "French Polynesia", 
	"city": "Takaroa"}, 
{
	"citycode": "TUB", 
	"airport": "Tubuai – Mataura Airport", 
	"country": "French Polynesia", 
	"city": "Tubuai"}, 
{
	"citycode": "UAH", 
	"airport": "Ua Huka Airport", 
	"country": "French Polynesia", 
	"city": "Ua Huka"}, 
{
	"citycode": "UAP", 
	"airport": "Ua Pou Airport", 
	"country": "French Polynesia", 
	"city": "Ua Pou"}, 
{
	"citycode": "VHZ", 
	"airport": "Vahitahi Airport", 
	"country": "French Polynesia", 
	"city": "Vahitahi"}, 
{
	"citycode": "XMH", 
	"airport": "Manihi Airport", 
	"country": "French Polynesia", 
	"city": "Manihi"}, 
{
	"citycode": "BGB", 
	"airport": "Booué Airport", 
	"country": "Gabon", 
	"city": "Booue"}, 
{
	"citycode": "BMM", 
	"airport": "Bitam Airport", 
	"country": "Gabon", 
	"city": "Bitam"}, 
{
	"citycode": "FOU", 
	"airport": "Fougamou Airport", 
	"country": "Gabon", 
	"city": "Fougamou"}, 
{
	"citycode": "GAX", 
	"airport": "Gamba Airport", 
	"country": "Gabon", 
	"city": "Gamba"}, 
{
	"citycode": "KDN", 
	"airport": "Ndende Airport", 
	"country": "Gabon", 
	"city": "Ndende"}, 
{
	"citycode": "KOU", 
	"airport": "Koulamoutou Airport", 
	"country": "Gabon", 
	"city": "Koulamoutou"}, 
{
	"citycode": "LBQ", 
	"airport": "Lambarene Airport", 
	"country": "Gabon", 
	"city": "Lambarene"}, 
{
	"citycode": "LBV", 
	"airport": "Léon-Mba International Airport", 
	"country": "Gabon", 
	"city": "Libreville"}, 
{
	"citycode": "LTL", 
	"airport": "Lastoursville Airport", 
	"country": "Gabon", 
	"city": "Lastourville"}, 
{
	"citycode": "MBC", 
	"airport": "Mbigou Airport", 
	"country": "Gabon", 
	"city": "Mbigou"}, 
{
	"citycode": "MDV", 
	"airport": "Medouneu Airport", 
	"country": "Gabon", 
	"city": "Medouneu"}, 
{
	"citycode": "MFF", 
	"airport": "Moanda Airport", 
	"country": "Gabon", 
	"city": "Moanda"}, 
{
	"citycode": "MGX", 
	"airport": "Moabi Airport", 
	"country": "Gabon", 
	"city": "Moabi"}, 
{
	"citycode": "MJL", 
	"airport": "Mouila Ville Airport ", 
	"country": "Gabon", 
	"city": "Mouila"}, 
{
	"citycode": "MKB", 
	"airport": "Mekambo Airport", 
	"country": "Gabon", 
	"city": "Mekambo"}, 
{
	"citycode": "MKU", 
	"airport": "Makokou Airport", 
	"country": "Gabon", 
	"city": "Makokou"}, 
{
	"citycode": "MVB", 
	"airport": "M`Vengue El Hadj Omar Bongo Ondimba International Airport", 
	"country": "Gabon", 
	"city": "Franceville"}, 
{
	"citycode": "MVX", 
	"airport": "Minvoul Airport", 
	"country": "Gabon", 
	"city": "Minvoul"}, 
{
	"citycode": "MYB", 
	"airport": "Mayumba Airport", 
	"country": "Gabon", 
	"city": "Mayoumba"}, 
{
	"citycode": "MZC", 
	"airport": "Mitzic Airport", 
	"country": "Gabon", 
	"city": "Mitzic"}, 
{
	"citycode": "OKN", 
	"airport": "Okondja Airport", 
	"country": "Gabon", 
	"city": "Okondja"}, 
{
	"citycode": "OMB", 
	"airport": "Omboue Airport", 
	"country": "Gabon", 
	"city": "Omboue"}, 
{
	"citycode": "OYE", 
	"airport": "Oyem Airport", 
	"country": "Gabon", 
	"city": "Oyem"}, 
{
	"citycode": "POG", 
	"airport": "Port Gentil Airport", 
	"country": "Gabon", 
	"city": "Port Gentil"}, 
{
	"citycode": "TCH", 
	"airport": "Tchibanga Airport", 
	"country": "Gabon", 
	"city": "Tchibanga"}, 
{
	"citycode": "ZKM", 
	"airport": "Sette Cama Airport", 
	"country": "Gabon", 
	"city": "Sette Cama"}, 
{
	"citycode": "BJL", 
	"airport": "Banjul International Airport", 
	"country": "Gambia", 
	"city": "Banjul"}, 
{
	"citycode": "BUS", 
	"airport": "Alexander Kartveli Batumi International Airport", 
	"country": "Georgia", 
	"city": "Batumi"}, 
{
	"citycode": "KUT", 
	"airport": "Kutaisi International Airport", 
	"country": "Georgia", 
	"city": "Kutaisi"}, 
{
	"citycode": "SUI", 
	"airport": "Sukhumi Babushara Airport", 
	"country": "Georgia", 
	"city": "Sukhumi"}, 
{
	"citycode": "TBS", 
	"airport": "Tbilisi International Airport", 
	"country": "Georgia", 
	"city": "Tbilisi"}, 
{
	"citycode": "GIB", 
	"airport": "Gibraltar International Airport", 
	"country": "Gibraltar", 
	"city": "Gibraltar"}, 
{
	"citycode": "CRU", 
	"airport": "Lauriston/Carriacou Airport", 
	"country": "Grenada", 
	"city": "Carriacou Island"}, 
{
	"citycode": "GND", 
	"airport": "Maurice Bishop International Airport", 
	"country": "Grenada", 
	"city": "Grenada"}, 
{
	"citycode": "DSD", 
	"airport": "La Desirade Airport", 
	"country": "Guadeloupe", 
	"city": "La Desirade"}, 
{
	"citycode": "GBJ", 
	"airport": "Marie-Galante Airport", 
	"country": "Guadeloupe", 
	"city": "Marie Galante"}, 
{
	"citycode": "LSS", 
	"airport": "Les Saintes Airport", 
	"country": "Guadeloupe", 
	"city": "Terre-de-Haut"}, 
{
	"citycode": "PTP", 
	"airport": "Pointe-à-Pitre International Airport", 
	"country": "Guadeloupe", 
	"city": "Pointe-a-Pitre"}, 
{
	"citycode": "SBH", 
	"airport": "Gustaf III Airport", 
	"country": "Guadeloupe", 
	"city": "St Barthelemy"}, 
{
	"citycode": "SFG", 
	"airport": "Grand Case-Esperance Airport", 
	"country": "Guadeloupe", 
	"city": "St Martin"}, 
{
	"citycode": "GUM", 
	"airport": "Antonio B. Won Pat International Airport", 
	"country": "Guam", 
	"city": "Guam"}, 
{
	"citycode": "FRS", 
	"airport": "Mundo Maya International Airport", 
	"country": "Guatemala", 
	"city": "Flores"}, 
{
	"citycode": "GUA", 
	"airport": "La Aurora International Airport", 
	"country": "Guatemala", 
	"city": "Guatemala City"}, 
{
	"citycode": "BKJ", 
	"airport": "Boké Baralande Airport", 
	"country": "Guinea", 
	"city": "Boke"}, 
{
	"citycode": "BXO", 
	"airport": "BISSAU OSWALDO VIEIRA INTERNATIONAL", 
	"country": "Guinea", 
	"city": "GUINEA BISSAU"}, 
{
	"citycode": "CKY", 
	"airport": "Ahmed Sékou Touré International Airport", 
	"country": "Guinea", 
	"city": "Conakry"}, 
{
	"citycode": "FIG", 
	"airport": "Fria Airport", 
	"country": "Guinea", 
	"city": "Fria"}, 
{
	"citycode": "GII", 
	"airport": "Siguiri Airport", 
	"country": "Guinea", 
	"city": "Siguiri"}, 
{
	"citycode": "KNN", 
	"airport": "Kankan Airport", 
	"country": "Guinea", 
	"city": "Kankan"}, 
{
	"citycode": "KSI", 
	"airport": "Kissidougou Airport", 
	"country": "Guinea", 
	"city": "Kissidougou"}, 
{
	"citycode": "LEK", 
	"airport": "Tata Airport", 
	"country": "Guinea", 
	"city": "Labe"}, 
{
	"citycode": "MCA", 
	"airport": "Macenta Airport", 
	"country": "Guinea", 
	"city": "Macenta"}, 
{
	"citycode": "NZE", 
	"airport": "Nzerekore Airport", 
	"country": "Guinea", 
	"city": "Nzerekore"}, 
{
	"citycode": "SBI", 
	"airport": "Sambailo Airport", 
	"country": "Guinea", 
	"city": "Koundara"}, 
{
	"citycode": "GEO", 
	"airport": "Cheddi Jagan International Airport", 
	"country": "Guyana", 
	"city": "Georgetown"}, 
{
	"citycode": "CAP", 
	"airport": "Cap Haitien International Airport", 
	"country": "Haiti", 
	"city": "Cap Haitien"}, 
{
	"citycode": "PAP", 
	"airport": "Toussaint Louverture International Airport", 
	"country": "Haiti", 
	"city": "Port Au Prince"}, 
{
	"citycode": "BHG", 
	"airport": "Brus Laguna Airport", 
	"country": "Honduras", 
	"city": "Brus Laguna"}, 
{
	"citycode": "GJA", 
	"airport": "Guanaja Airport", 
	"country": "Honduras", 
	"city": "Guanaja"}, 
{
	"citycode": "LCE", 
	"airport": "Goloson International Airport", 
	"country": "Honduras", 
	"city": "La Ceiba"}, 
{
	"citycode": "PEU", 
	"airport": "Puerto Lempira Airport", 
	"country": "Honduras", 
	"city": "Puerto Lempira"}, 
{
	"citycode": "RTB", 
	"airport": "Juan Manuel Galvez International Airport", 
	"country": "Honduras", 
	"city": "Roatan"}, 
{
	"citycode": "SAP", 
	"airport": "Ram?n Villeda Morales International Airport", 
	"country": "Honduras", 
	"city": "San Pedro Sula"}, 
{
	"citycode": "TGU", 
	"airport": "Toncont?n International Airport", 
	"country": "Honduras", 
	"city": "Tegucigalpa"}, 
{
	"citycode": "UII", 
	"airport": "Utila Airport", 
	"country": "Honduras", 
	"city": "Utila"}, 
{
	"citycode": "KIN", 
	"airport": "Norman Manley International Airport", 
	"country": "Jamaica", 
	"city": "Kingston"}, 
{
	"citycode": "KTP", 
	"airport": "Tinson Pen Aerodrome", 
	"country": "Jamaica", 
	"city": "Kingston"}, 
{
	"citycode": "MBJ", 
	"airport": "Sangster International Airport", 
	"country": "Jamaica", 
	"city": "Montego Bay"}, 
{
	"citycode": "NEG", 
	"airport": "Negril Aerodrome", 
	"country": "Jamaica", 
	"city": "Negril"}, 
{
	"citycode": "OCJ", 
	"airport": "Ian Fleming International Airport", 
	"country": "Jamaica", 
	"city": "Ocho Rios"}, 
{
	"citycode": "POT", 
	"airport": "Ken Jones Aerodrome", 
	"country": "Jamaica", 
	"city": "Port Antonio"}, 
{
	"citycode": "AKX", 
	"airport": "Aktobe International Airport", 
	"country": "Kazakhstan", 
	"city": "Aktyubinsk"}, 
{
	"citycode": "ALA", 
	"airport": "Almaty International Airport", 
	"country": "Kazakhstan", 
	"city": "Almaty"}, 
{
	"citycode": "CIT", 
	"airport": "Shymkent International Airport", 
	"country": "Kazakhstan", 
	"city": "Shimkent"}, 
{
	"citycode": "DMB", 
	"airport": "Taraz Airport", 
	"country": "Kazakhstan", 
	"city": "Zhambyl"}, 
{
	"citycode": "GUW", 
	"airport": "Atyrau International Airport", 
	"country": "Kazakhstan", 
	"city": "Atyrau"}, 
{
	"citycode": "KGF", 
	"airport": "Sary-Arka Airport", 
	"country": "Kazakhstan", 
	"city": "Karaganda"}, 
{
	"citycode": "KOV", 
	"airport": "Kokshetau Airport", 
	"country": "Kazakhstan", 
	"city": "Kokshetau"}, 
{
	"citycode": "KSN", 
	"airport": "Kostanay Airport", 
	"country": "Kazakhstan", 
	"city": "Kostanay"}, 
{
	"citycode": "NQZ", 
	"airport": "Nursultan Nazarbayev International Airport", 
	"country": "Kazakhstan", 
	"city": "Akmola"}, 
{
	"citycode": "PLX", 
	"airport": "Semey Airport", 
	"country": "Kazakhstan", 
	"city": "Semipalatinsk"}, 
{
	"citycode": "PWQ", 
	"airport": "Pavlodar Airport", 
	"country": "Kazakhstan", 
	"city": "Pavlodar"}, 
{
	"citycode": "SCO", 
	"airport": "Aktau Airport", 
	"country": "Kazakhstan", 
	"city": "Aktau"}, 
{
	"citycode": "TSE", 
	"airport": "Astana International Airport", 
	"country": "Kazakhstan", 
	"city": "Astana"}, 
{
	"citycode": "UKK", 
	"airport": "Oskemen Airport", 
	"country": "Kazakhstan", 
	"city": "Ust-Kamenogorsk"}, 
{
	"citycode": "FRU", 
	"airport": "Manas International Airport", 
	"country": "Kyrgyzstan", 
	"city": "Bishkek"}, 
{
	"citycode": "OSS", 
	"airport": "Osh International Airport", 
	"country": "Kyrgyzstan", 
	"city": "Osh"}, 
{
	"citycode": "HOE", 
	"airport": "Huay Xai Airport", 
	"country": "Lao PDR", 
	"city": "Houeisay"}, 
{
	"citycode": "LPQ", 
	"airport": "Luang Prabang International Airport ", 
	"country": "Lao PDR", 
	"city": "Luang Prabang"}, 
{
	"citycode": "LXG", 
	"airport": "Louangnamtha Airport", 
	"country": "Lao PDR", 
	"city": "Luang Namtha"}, 
{
	"citycode": "ODY", 
	"airport": "Oudomsay Airport", 
	"country": "Lao PDR", 
	"city": "Oudomxay"}, 
{
	"citycode": "PKZ", 
	"airport": "Pakse International Airport", 
	"country": "Lao PDR", 
	"city": "Pakse"}, 
{
	"citycode": "THK", 
	"airport": "Thakhek Airport", 
	"country": "Lao PDR", 
	"city": "Thakhek"}, 
{
	"citycode": "VNA", 
	"airport": "Saravane Airport", 
	"country": "Lao PDR", 
	"city": "Saravane"}, 
{
	"citycode": "VNG", 
	"airport": "Viengxay Airport", 
	"country": "Lao PDR", 
	"city": "Viengxay"}, 
{
	"citycode": "VTE", 
	"airport": "Wattay International Airport", 
	"country": "Lao PDR", 
	"city": "Vientiane"}, 
{
	"citycode": "XKH", 
	"airport": "Xieng Khouang Airport", 
	"country": "Lao PDR", 
	"city": "Xieng Khouang"}, 
{
	"citycode": "ZBY", 
	"airport": "Sayaboury Airport", 
	"country": "Lao PDR", 
	"city": "Sayaboury"}, 
{
	"citycode": "ZVK", 
	"airport": "Savannakhet Airport", 
	"country": "Lao PDR", 
	"city": "Savannakhet"}, 
{
	"citycode": "LES", 
	"airport": "Lesobeng Airport", 
	"country": "Lesotho", 
	"city": "Lesobeng"}, 
{
	"citycode": "LRB", 
	"airport": "Leribe Airport", 
	"country": "Lesotho", 
	"city": "Leribe"}, 
{
	"citycode": "MFC", 
	"airport": "Mafeteng Airport", 
	"country": "Lesotho", 
	"city": "Mafeteng"}, 
{
	"citycode": "MKH", 
	"airport": "Mokhotlong Airport", 
	"country": "Lesotho", 
	"city": "Mokhotlong"}, 
{
	"citycode": "MSU", 
	"airport": "Moshoeshoe International Airport", 
	"country": "Lesotho", 
	"city": "Maseru"}, 
{
	"citycode": "NKU", 
	"airport": "Nkaus Airport", 
	"country": "Lesotho", 
	"city": "Nkaus"}, 
{
	"citycode": "SHK", 
	"airport": "Sehonghong Airport", 
	"country": "Lesotho", 
	"city": "Sehonghong"}, 
{
	"citycode": "SOK", 
	"airport": "Semongkong Airport", 
	"country": "Lesotho", 
	"city": "Semongkong"}, 
{
	"citycode": "UNE", 
	"airport": "Qachas Nek Airport", 
	"country": "Lesotho", 
	"city": "Qachas Nek"}, 
{
	"citycode": "AKF", 
	"airport": "Kufra Airport", 
	"country": "Libya", 
	"city": "Kufrah"}, 
{
	"citycode": "BEN", 
	"airport": "Benina International Airport", 
	"country": "Libya", 
	"city": "Benghazi"}, 
{
	"citycode": "GHT", 
	"airport": "Ghat Airport", 
	"country": "Libya", 
	"city": "Ghat"}, 
{
	"citycode": "HUQ", 
	"airport": "Hun Airport", 
	"country": "Libya", 
	"city": "Houn"}, 
{
	"citycode": "LAQ", 
	"airport": "Al Abraq International Airport", 
	"country": "Libya", 
	"city": "Beida"}, 
{
	"citycode": "LTD", 
	"airport": "Ghadames Airport", 
	"country": "Libya", 
	"city": "Ghadames"}, 
{
	"citycode": "MJI", 
	"airport": "Mitiga International Airport", 
	"country": "Libya", 
	"city": "Tripoli"}, 
{
	"citycode": "MRA", 
	"airport": "Misrata Airport", 
	"country": "Libya", 
	"city": "Misurata"}, 
{
	"citycode": "SEB", 
	"airport": "Sebha International Airport", 
	"country": "Libya", 
	"city": "Sebha"}, 
{
	"citycode": "SRX", 
	"airport": "Sirte Airport", 
	"country": "Libya", 
	"city": "Sert"}, 
{
	"citycode": "TIP", 
	"airport": "Tripoli International Airport", 
	"country": "Libya", 
	"city": "Tripoli"}, 
{
	"citycode": "TOB", 
	"airport": "Tobruk International Airport", 
	"country": "Libya", 
	"city": "Tobruk"}, 
{
	"citycode": "KUN", 
	"airport": "Kaunas International Airport", 
	"country": "Lithuania", 
	"city": "Kaunas"}, 
{
	"citycode": "PLQ", 
	"airport": "Palanga International Airport ", 
	"country": "Lithuania", 
	"city": "Palanga"}, 
{
	"citycode": "VNO", 
	"airport": "Vilnius International Airport", 
	"country": "Lithuania", 
	"city": "Vilnius"}, 
{
	"citycode": "LUX", 
	"airport": "Luxembourg Airport", 
	"country": "Luxembourg", 
	"city": "Luxembourg"}, 
{
	"citycode": "OHD", 
	"airport": "Ohrid St. Paul The Apostle Airport", 
	"country": "Macedonia", 
	"city": "Ohrid"}, 
{
	"citycode": "SKP", 
	"airport": "Skopje International Airport", 
	"country": "Macedonia", 
	"city": "Skopje"}, 
{
	"citycode": "AMB", 
	"airport": "Ambilobe Airport", 
	"country": "Madagascar", 
	"city": "Ambilobe"}, 
{
	"citycode": "AMP", 
	"airport": "Ampanihy Airport", 
	"country": "Madagascar", 
	"city": "Ampanihy"}, 
{
	"citycode": "AMY", 
	"airport": "Ambatomainty Airport", 
	"country": "Madagascar", 
	"city": "Ambatomainty"}, 
{
	"citycode": "ANM", 
	"airport": "Antsirabato Airport", 
	"country": "Madagascar", 
	"city": "Antalaha"}, 
{
	"citycode": "ATJ", 
	"airport": "Antsirabe Airport", 
	"country": "Madagascar", 
	"city": "Antsirabe"}, 
{
	"citycode": "BKU", 
	"airport": "Betioky Airport", 
	"country": "Madagascar", 
	"city": "Betioky"}, 
{
	"citycode": "BMD", 
	"airport": "Belo sur Tsiribihina Airport", 
	"country": "Madagascar", 
	"city": "Belo"}, 
{
	"citycode": "BPY", 
	"airport": "Besalampy Airport", 
	"country": "Madagascar", 
	"city": "Besalampy"}, 
{
	"citycode": "BSV", 
	"airport": "Besakoa Airport", 
	"country": "Madagascar", 
	"city": "Besakoa"}, 
{
	"citycode": "DIE", 
	"airport": "Arrachart Airport", 
	"country": "Madagascar", 
	"city": "Antsiranana"}, 
{
	"citycode": "DOA", 
	"airport": "Doany Airport", 
	"country": "Madagascar", 
	"city": "Doany"}, 
{
	"citycode": "DWB", 
	"airport": "Soalala Airport", 
	"country": "Madagascar", 
	"city": "Soalala"}, 
{
	"citycode": "FTU", 
	"airport": "Tolagnaro Airport", 
	"country": "Madagascar", 
	"city": "Fort Dauphin"}, 
{
	"citycode": "HVA", 
	"airport": "Analalava Airport", 
	"country": "Madagascar", 
	"city": "Analalava"}, 
{
	"citycode": "IHO", 
	"airport": "Ihosy Airport", 
	"country": "Madagascar", 
	"city": "Ihosy"}, 
{
	"citycode": "ILK", 
	"airport": "Atsinanana Airport", 
	"country": "Madagascar", 
	"city": "Ilaka"}, 
{
	"citycode": "IVA", 
	"airport": "Ampampamena Airport", 
	"country": "Madagascar", 
	"city": "Ambanja"}, 
{
	"citycode": "JVA", 
	"airport": "Ankavandra Airport", 
	"country": "Madagascar", 
	"city": "Ankavandra"}, 
{
	"citycode": "MJA", 
	"airport": "Manja Airport", 
	"country": "Madagascar", 
	"city": "Manja"}, 
{
	"citycode": "MJN", 
	"airport": "Amborovy Airport", 
	"country": "Madagascar", 
	"city": "Majunga"}, 
{
	"citycode": "MNJ", 
	"airport": "Mananjary Airport", 
	"country": "Madagascar", 
	"city": "Mananjary"}, 
{
	"citycode": "MOQ", 
	"airport": "Morondava Airport", 
	"country": "Madagascar", 
	"city": "Morondava"}, 
{
	"citycode": "MXM", 
	"airport": "Morombe Airport", 
	"country": "Madagascar", 
	"city": "Morombe"}, 
{
	"citycode": "MXT", 
	"airport": "Maintirano Airport", 
	"country": "Madagascar", 
	"city": "Maintirano"}, 
{
	"citycode": "NOS", 
	"airport": "Fascene Airport", 
	"country": "Madagascar", 
	"city": "Nossi-be"}, 
{
	"citycode": "OVA", 
	"airport": "Bekily Airport", 
	"country": "Madagascar", 
	"city": "Bekily"}, 
{
	"citycode": "RVA", 
	"airport": "Farafangana Airport", 
	"country": "Madagascar", 
	"city": "Farafangana"}, 
{
	"citycode": "SMS", 
	"airport": "Sainte Marie Airport", 
	"country": "Madagascar", 
	"city": "Sainte Marie"}, 
{
	"citycode": "SVB", 
	"airport": "Sambava Airport", 
	"country": "Madagascar", 
	"city": "Sambava"}, 
{
	"citycode": "TDV", 
	"airport": "Tanandava Airport", 
	"country": "Madagascar", 
	"city": "Tanandava"}, 
{
	"citycode": "TLE", 
	"airport": "Toliara Airport", 
	"country": "Madagascar", 
	"city": "Tulear"}, 
{
	"citycode": "TMM", 
	"airport": "Toamasina Ambalamanasy Airport", 
	"country": "Madagascar", 
	"city": "Tamatave"}, 
{
	"citycode": "TNR", 
	"airport": "Ivato International Airport", 
	"country": "Madagascar", 
	"city": "Antananarivo"}, 
{
	"citycode": "TTS", 
	"airport": "Tsaratanana Airport", 
	"country": "Madagascar", 
	"city": "Tsaratanana"}, 
{
	"citycode": "TVA", 
	"airport": "Morafenobe Airport", 
	"country": "Madagascar", 
	"city": "Morafenobe"}, 
{
	"citycode": "VAT", 
	"airport": "Vatomandry Airport", 
	"country": "Madagascar", 
	"city": "Vatomandry"}, 
{
	"citycode": "VOH", 
	"airport": "Vohemar Airport", 
	"country": "Madagascar", 
	"city": "Vohemar"}, 
{
	"citycode": "VVB", 
	"airport": "Mahanoro Airport", 
	"country": "Madagascar", 
	"city": "Mahanoro"}, 
{
	"citycode": "WAI", 
	"airport": "Ambalabe Airport ", 
	"country": "Madagascar", 
	"city": "Antsohihy"}, 
{
	"citycode": "WAQ", 
	"airport": "Antsalova Airport", 
	"country": "Madagascar", 
	"city": "Antsalova"}, 
{
	"citycode": "WBD", 
	"airport": "Befandriana Airport", 
	"country": "Madagascar", 
	"city": "Befandriana"}, 
{
	"citycode": "WBE", 
	"airport": "Bealanana Airport", 
	"country": "Madagascar", 
	"city": "Bealanana"}, 
{
	"citycode": "WBO", 
	"airport": "Antsoa Airport", 
	"country": "Madagascar", 
	"city": "Beroroha"}, 
{
	"citycode": "WFI", 
	"airport": "Fianarantsoa Airport", 
	"country": "Madagascar", 
	"city": "Fianarantsoa"}, 
{
	"citycode": "WMA", 
	"airport": "Mandritsara Airport", 
	"country": "Madagascar", 
	"city": "Mandritsara"}, 
{
	"citycode": "WMD", 
	"airport": "Mandabe Airport", 
	"country": "Madagascar", 
	"city": "Mandabe"}, 
{
	"citycode": "WML", 
	"airport": "Malaimbandy Airport", 
	"country": "Madagascar", 
	"city": "Malaimbandy"}, 
{
	"citycode": "WMN", 
	"airport": "Maroantsetra Airport", 
	"country": "Madagascar", 
	"city": "Maroantsetra"}, 
{
	"citycode": "WMR", 
	"airport": "Mananara Nord Airport", 
	"country": "Madagascar", 
	"city": "Mananara"}, 
{
	"citycode": "WPB", 
	"airport": "Port Berge Airport", 
	"country": "Madagascar", 
	"city": "Port Berge"}, 
{
	"citycode": "WTA", 
	"airport": "Tambohorano Airport", 
	"country": "Madagascar", 
	"city": "Tambohorano"}, 
{
	"citycode": "WTS", 
	"airport": "Tsiroanomandidy Airport", 
	"country": "Madagascar", 
	"city": "Tsiroanomandidy"}, 
{
	"citycode": "WVK", 
	"airport": "Manakara Airport", 
	"country": "Madagascar", 
	"city": "Manakara"}, 
{
	"citycode": "ZVA", 
	"airport": "Miandrivazo Airport", 
	"country": "Madagascar", 
	"city": "Miandrivazo"}, 
{
	"citycode": "ZWA", 
	"airport": "Andapa Airport", 
	"country": "Madagascar", 
	"city": "Andapa"}, 
{
	"citycode": "BLZ", 
	"airport": "Chileka International Airport", 
	"country": "Malawi", 
	"city": "Blantyre"}, 
{
	"citycode": "DWA", 
	"airport": "Dwangwa Airport", 
	"country": "Malawi", 
	"city": "Dwangwa"}, 
{
	"citycode": "KGJ", 
	"airport": "Karonga Airport", 
	"country": "Malawi", 
	"city": "Karonga"}, 
{
	"citycode": "LLW", 
	"airport": "Kamuzu International Airport", 
	"country": "Malawi", 
	"city": "Lilongwe"}, 
{
	"citycode": "LMB", 
	"airport": "Salima Airport", 
	"country": "Malawi", 
	"city": "Salima"}, 
{
	"citycode": "MYZ", 
	"airport": "Monkey Bay Airport", 
	"country": "Malawi", 
	"city": "Monkey Bay"}, 
{
	"citycode": "ZZU", 
	"airport": "Mzuzu Airport", 
	"country": "Malawi", 
	"city": "MZUZU"}, 
{
	"citycode": "MLA", 
	"airport": "Malta International Airport", 
	"country": "Malta", 
	"city": "Malta, Valletta"}, 
{
	"citycode": "FDF", 
	"airport": "Martinique Aime Cesaire International Airport", 
	"country": "Martinique", 
	"city": "Fort De France"}, 
{
	"citycode": "RMO", 
	"airport": "ChisinauChisinau International Airport", 
	"country": "Moldova", 
	"city": "Chisinau"}, 
{
	"citycode": "MCM", 
	"airport": "Monaco Airport", 
	"country": "Monaco", 
	"city": "Monte Carlo"}, 
{
	"citycode": "UBN", 
	"airport": "Chinggis Khaan International Airport", 
	"country": "Mongolia", 
	"city": "Mongolia"}, 
{
	"citycode": "ULN", 
	"airport": "Buyant-Ukhaa International Airport", 
	"country": "Mongolia", 
	"city": "Ulaanbaatar"}, 
{
	"citycode": "TGD", 
	"airport": "Podgorica Airport", 
	"country": "Montenegro", 
	"city": "Montenegro"}, 
{
	"citycode": "ANO", 
	"airport": "Angoche Airport", 
	"country": "Mozambique", 
	"city": "Angoche"}, 
{
	"citycode": "APL", 
	"airport": "Nampula Airport", 
	"country": "Mozambique", 
	"city": "Nampula"}, 
{
	"citycode": "BEW", 
	"airport": "Beira Airport", 
	"country": "Mozambique", 
	"city": "Beira"}, 
{
	"citycode": "FXO", 
	"airport": "Cuamba Airport", 
	"country": "Mozambique", 
	"city": "Cuamba"}, 
{
	"citycode": "INH", 
	"airport": "Inhambane Airport", 
	"country": "Mozambique", 
	"city": "Inhambane"}, 
{
	"citycode": "MNC", 
	"airport": "Nacala Airport", 
	"country": "Mozambique", 
	"city": "Nacala"}, 
{
	"citycode": "MPM", 
	"airport": "Maputo International Airport ", 
	"country": "Mozambique", 
	"city": "Maputo"}, 
{
	"citycode": "MZB", 
	"airport": "Mocimboa Praia Airport", 
	"country": "Mozambique", 
	"city": "Mocimboa Praia"}, 
{
	"citycode": "POL", 
	"airport": "Pemba Airport", 
	"country": "Mozambique", 
	"city": "Pemba"}, 
{
	"citycode": "TET", 
	"airport": "Chingozi Airport", 
	"country": "Mozambique", 
	"city": "Tete"}, 
{
	"citycode": "UEL", 
	"airport": "Quelimane Airport", 
	"country": "Mozambique", 
	"city": "Quelimane"}, 
{
	"citycode": "VNX", 
	"airport": "Vilankulo Airport", 
	"country": "Mozambique", 
	"city": "Vilanculos"}, 
{
	"citycode": "VXC", 
	"airport": "Lichinga Airport", 
	"country": "Mozambique", 
	"city": "Lichinga"}, 
{
	"citycode": "AKY", 
	"airport": "Sittwe Airport", 
	"country": "Myanmar", 
	"city": "Sittwe"}, 
{
	"citycode": "BMO", 
	"airport": "Bhamo Airport", 
	"country": "Myanmar", 
	"city": "Bhamo"}, 
{
	"citycode": "HEH", 
	"airport": "Heho Airport", 
	"country": "Myanmar", 
	"city": "Heho"}, 
{
	"citycode": "KAW", 
	"airport": "Kawthaung Airport", 
	"country": "Myanmar", 
	"city": "Kawthaung"}, 
{
	"citycode": "KET", 
	"airport": "Keng Tung Airport", 
	"country": "Myanmar", 
	"city": "Keng Tung"}, 
{
	"citycode": "KMV", 
	"airport": "Kalaymyo Airport", 
	"country": "Myanmar", 
	"city": "Kalemyo"}, 
{
	"citycode": "KYP", 
	"airport": "Kyaukpyu Airport", 
	"country": "Myanmar", 
	"city": "Kyaukpyu"}, 
{
	"citycode": "LIW", 
	"airport": "Loikaw Airport", 
	"country": "Myanmar", 
	"city": "Loikaw"}, 
{
	"citycode": "LSH", 
	"airport": "Lashio Airport", 
	"country": "Myanmar", 
	"city": "Lashio"}, 
{
	"citycode": "MDL", 
	"airport": "Mandalay International Airport", 
	"country": "Myanmar", 
	"city": "Mandalay"}, 
{
	"citycode": "MGZ", 
	"airport": "Myeik Airport", 
	"country": "Myanmar", 
	"city": "Myeik"}, 
{
	"citycode": "MNU", 
	"airport": "Maulmyine Airport", 
	"country": "Myanmar", 
	"city": "Maulmyine"}, 
{
	"citycode": "MOG", 
	"airport": "Monghsat Airport", 
	"country": "Myanmar", 
	"city": "Mong Hsat"}, 
{
	"citycode": "MYT", 
	"airport": "Myitkyina Airport", 
	"country": "Myanmar", 
	"city": "Myitkyina"}, 
{
	"citycode": "NYU", 
	"airport": "Nyaung U Airport", 
	"country": "Myanmar", 
	"city": "Nyaung-u"}, 
{
	"citycode": "PBU", 
	"airport": "Putao Airport", 
	"country": "Myanmar", 
	"city": "Putao"}, 
{
	"citycode": "RGN", 
	"airport": "Yangon International Airport", 
	"country": "Myanmar", 
	"city": "Yangon"}, 
{
	"citycode": "SNW", 
	"airport": "Thandwe Airport", 
	"country": "Myanmar", 
	"city": "Thandwe"}, 
{
	"citycode": "THL", 
	"airport": "Tachilek Airport", 
	"country": "Myanmar", 
	"city": "Tachilek"}, 
{
	"citycode": "BMY", 
	"airport": "Wala Airport", 
	"country": "New Caledonia", 
	"city": "Belep Island"}, 
{
	"citycode": "GEA", 
	"airport": "Noumea Magenta Airport", 
	"country": "New Caledonia", 
	"city": "Noumea"}, 
{
	"citycode": "ILP", 
	"airport": "Ile Des Pins Airport", 
	"country": "New Caledonia", 
	"city": "Ile Des Pins"}, 
{
	"citycode": "KNQ", 
	"airport": "Kone Airport", 
	"country": "New Caledonia", 
	"city": "Kone"}, 
{
	"citycode": "KOC", 
	"airport": "Koumac Airport", 
	"country": "New Caledonia", 
	"city": "Koumac"}, 
{
	"citycode": "LIF", 
	"airport": "Ouanaham Airport ", 
	"country": "New Caledonia", 
	"city": "Lifou"}, 
{
	"citycode": "MEE", 
	"airport": "Mare Airport", 
	"country": "New Caledonia", 
	"city": "Mare"}, 
{
	"citycode": "NOU", 
	"airport": "La Tontouta International Airport", 
	"country": "New Caledonia", 
	"city": "Noumea"}, 
{
	"citycode": "TGJ", 
	"airport": "Tiga Airport", 
	"country": "New Caledonia", 
	"city": "Tiga"}, 
{
	"citycode": "TOU", 
	"airport": "Touho Airport", 
	"country": "New Caledonia", 
	"city": "Touho"}, 
{
	"citycode": "UVE", 
	"airport": "Ouvea Airport", 
	"country": "New Caledonia", 
	"city": "Ouvea"}, 
{
	"citycode": "BEF", 
	"airport": "Bluefields Airport", 
	"country": "Nicaragua", 
	"city": "Bluefields"}, 
{
	"citycode": "MGA", 
	"airport": "Augusto Cesar Sandino International Airport", 
	"country": "Nicaragua", 
	"city": "Managua"}, 
{
	"citycode": "PUZ", 
	"airport": "Puerto Cabezas", 
	"country": "Nicaragua", 
	"city": "Puerto Cabezas"}, 
{
	"citycode": "SIU", 
	"airport": "Siuna Airport", 
	"country": "Nicaragua", 
	"city": "Siuna"}, 
{
	"citycode": "NLK", 
	"airport": "Norfolk Island Airport", 
	"country": "Norfolk Island", 
	"city": "Norfolk Island"}, 
{
	"citycode": "BOC", 
	"airport": "Bocas Del Toro International Airport", 
	"country": "Panama", 
	"city": "Bocas Del Toro"}, 

{
	"citycode": "DAV", 
	"airport": "Enrique Malek International Airport", 
	"country": "Panama", 
	"city": "David"}, 
{
	"citycode": "NMG", 
	"airport": "San Miguel Airport", 
	"country": "Panama", 
	"city": "San Miguel"}, 
{
	"citycode": "ONX", 
	"airport": "Enrique Adolfo Jiménez International Airport", 
	"country": "Panama", 
	"city": "Colon"}, 
{
	"citycode": "OTD", 
	"airport": "Contadora Airport", 
	"country": "Panama", 
	"city": "Contadora"}, 
{
	"citycode": "PAC", 
	"airport": "Albrook Gelabert Airport", 
	"country": "Panama", 
	"city": "Panama City"}, 
{
	"citycode": "PTY", 
	"airport": "Tocumen International Airport", 
	"country": "Panama", 
	"city": "Panama City"}, 
{
	"citycode": "AMU", 
	"airport": "Amanab Airport", 
	"country": "Papua New Guinea", 
	"city": "Amanab"}, 
{
	"citycode": "APP", 
	"airport": "Asapa", 
	"country": "Papua New Guinea", 
	"city": "Asapa"}, 
{
	"citycode": "ARP", 
	"airport": "Aragip Airport", 
	"country": "Papua New Guinea", 
	"city": "Aragip"}, 
{
	"citycode": "ATP", 
	"airport": "Aitape Airport", 
	"country": "Papua New Guinea", 
	"city": "Aitape"}, 
{
	"citycode": "AUJ", 
	"airport": "Ambunti Airport", 
	"country": "Papua New Guinea", 
	"city": "Ambunti"}, 
{
	"citycode": "AUP", 
	"airport": "Agaun Airport", 
	"country": "Papua New Guinea", 
	"city": "Agaun"}, 
{
	"citycode": "AZB", 
	"airport": "Amazon Bay", 
	"country": "Papua New Guinea", 
	"city": "Amazon Bay"}, 
{
	"citycode": "BAA", 
	"airport": "Bialla Airport", 
	"country": "Papua New Guinea", 
	"city": "Bialla"}, 
{
	"citycode": "BSP", 
	"airport": "Bensbach Airport", 
	"country": "Papua New Guinea", 
	"city": "Bensbach"}, 
{
	"citycode": "BUA", 
	"airport": "Buka Airport", 
	"country": "Papua New Guinea", 
	"city": "Buka"}, 
{
	"citycode": "BUL", 
	"airport": "Bulolo Airport", 
	"country": "Papua New Guinea", 
	"city": "Bulolo"}, 
{
	"citycode": "CMU", 
	"airport": "Chimbu Airport", 
	"country": "Papua New Guinea", 
	"city": "Kundiawa"}, 
{
	"citycode": "CPN", 
	"airport": "Cape Rodney Airport", 
	"country": "Papua New Guinea", 
	"city": "Cape Rodney"}, 
{
	"citycode": "CVL", 
	"airport": "Cape Vogel Airport", 
	"country": "Papua New Guinea", 
	"city": "Cape Vogel"}, 
{
	"citycode": "DAU", 
	"airport": "Daru Airport", 
	"country": "Papua New Guinea", 
	"city": "Daru"}, 
{
	"citycode": "DBP", 
	"airport": "Debepare Airport", 
	"country": "Papua New Guinea", 
	"city": "Debepare"}, 
{
	"citycode": "DDM", 
	"airport": "Dodoima Airport", 
	"country": "Papua New Guinea", 
	"city": "Dodoima"}, 
{
	"citycode": "DER", 
	"airport": "Derim Airport", 
	"country": "Papua New Guinea", 
	"city": "Derim"}, 
{
	"citycode": "EIA", 
	"airport": "Popondetta Airport", 
	"country": "Papua New Guinea", 
	"city": "Eia"}, 
{
	"citycode": "EMO", 
	"airport": "Emo River Airstrip Airport", 
	"country": "Papua New Guinea", 
	"city": "Emo"}, 
{
	"citycode": "EMS", 
	"airport": "Embessa Airport", 
	"country": "Papua New Guinea", 
	"city": "Embessa"}, 
{
	"citycode": "ESA", 
	"airport": "Esa`Ala Airport", 
	"country": "Papua New Guinea", 
	"city": "Esa`Ala"}, 
{
	"citycode": "FAA", 
	"airport": "Faranah Airport", 
	"country": "Papua New Guinea", 
	"city": "GUINEA"}, 
{
	"citycode": "FIN", 
	"airport": "Finschhafen Airport", 
	"country": "Papua New Guinea", 
	"city": "Finschhafen"}, 
{
	"citycode": "GBC", 
	"airport": "Gasuke Airport", 
	"country": "Papua New Guinea", 
	"city": "Gasuke"}, 
{
	"citycode": "GEW", 
	"airport": "Gewoia Airport", 
	"country": "Papua New Guinea", 
	"city": "Gewoia"}, 
{
	"citycode": "GKA", 
	"airport": "Goroka Airport", 
	"country": "Papua New Guinea", 
	"city": "Goroka"}, 
{
	"citycode": "GOC", 
	"airport": "Gora Airport", 
	"country": "Papua New Guinea", 
	"city": "Gora"}, 
{
	"citycode": "GUR", 
	"airport": "Gurney Airport", 
	"country": "Papua New Guinea", 
	"city": "Alotau"}, 
{
	"citycode": "GUV", 
	"airport": "Mougulu Airport", 
	"country": "Papua New Guinea", 
	"city": "Mougulu"}, 
{
	"citycode": "GVI", 
	"airport": "Green River Airport", 
	"country": "Papua New Guinea", 
	"city": "Green River"}, 
{
	"citycode": "HGU", 
	"airport": "Mount Hagen (Kagamuga) Airport", 
	"country": "Papua New Guinea", 
	"city": "Mount Hagen"}, 
{
	"citycode": "HKN", 
	"airport": "Hoskins Airport", 
	"country": "Papua New Guinea", 
	"city": "Hoskins"}, 
{
	"citycode": "IDN", 
	"airport": "Indagen Airport", 
	"country": "Papua New Guinea", 
	"city": "Indagen"}, 
{
	"citycode": "IHU", 
	"airport": "Ihu Airport", 
	"country": "Papua New Guinea", 
	"city": "Ihu"}, 
{
	"citycode": "IMA", 
	"airport": "Iamalele Airport", 
	"country": "Papua New Guinea", 
	"city": "Iamalele"}, 
{
	"citycode": "IMD", 
	"airport": "Imonda Airport", 
	"country": "Papua New Guinea", 
	"city": "Imonda"}, 
{
	"citycode": "IOP", 
	"airport": "Ioma Airport", 
	"country": "Papua New Guinea", 
	"city": "Ioma"}, 
{
	"citycode": "ITK", 
	"airport": "Itokama Airport", 
	"country": "Papua New Guinea", 
	"city": "Itokama"}, 
{
	"citycode": "KBM", 
	"airport": "Kabwum Airport", 
	"country": "Papua New Guinea", 
	"city": "Kabwum"}, 
{
	"citycode": "KGB", 
	"airport": "Konge Airport", 
	"country": "Papua New Guinea", 
	"city": "Konge"}, 
{
	"citycode": "KIQ", 
	"airport": "Kira Airport", 
	"country": "Papua New Guinea", 
	"city": "Kira"}, 
{
	"citycode": "KKD", 
	"airport": "Kokoda Airport", 
	"country": "Papua New Guinea", 
	"city": "Kokoda"}, 
{
	"citycode": "KPE", 
	"airport": "Yapsiei Airport", 
	"country": "Papua New Guinea", 
	"city": "Yapsiei"}, 
{
	"citycode": "KRI", 
	"airport": "Kikori Airport", 
	"country": "Papua New Guinea", 
	"city": "Kikori"}, 
{
	"citycode": "KRJ", 
	"airport": "Karawari Airport", 
	"country": "Papua New Guinea", 
	"city": "Karawari"}, 
{
	"citycode": "KRX", 
	"airport": "Kar Kar Airport", 
	"country": "Papua New Guinea", 
	"city": "Kar Kar"}, 
{
	"citycode": "KUP", 
	"airport": "Kupiano Airport", 
	"country": "Papua New Guinea", 
	"city": "Kupiano"}, 
{
	"citycode": "KVG", 
	"airport": "Kavieng Airport", 
	"country": "Papua New Guinea", 
	"city": "Kavieng"}, 
{
	"citycode": "KYX", 
	"airport": "Yalumet Airport", 
	"country": "Papua New Guinea", 
	"city": "Yalumet"}, 
{
	"citycode": "KZF", 
	"airport": "Kaintiba Airport", 
	"country": "Papua New Guinea", 
	"city": "Kaintiba"}, 
{
	"citycode": "LAB", 
	"airport": "Lablab Airport", 
	"country": "Papua New Guinea", 
	"city": "Lablab"}, 
{
	"citycode": "LAE", 
	"airport": "Lae Nadzab Airport", 
	"country": "Papua New Guinea", 
	"city": "Lae"}, 
{
	"citycode": "LMI", 
	"airport": "Lumi Airport", 
	"country": "Papua New Guinea", 
	"city": "Lumi"}, 
{
	"citycode": "LMY", 
	"airport": "Lake Murray Airport", 
	"country": "Papua New Guinea", 
	"city": "Lake Murray"}, 
{
	"citycode": "LNF", 
	"airport": "Munbil Airport", 
	"country": "Papua New Guinea", 
	"city": "Munbil"}, 
{
	"citycode": "LSA", 
	"airport": "Losuia Airport", 
	"country": "Papua New Guinea", 
	"city": "Losuia"}, 
{
	"citycode": "MAG", 
	"airport": "Madang Airport", 
	"country": "Papua New Guinea", 
	"city": "Madang"}, 
{
	"citycode": "MAP", 
	"airport": "Mamai Airport", 
	"country": "Papua New Guinea", 
	"city": "Mamai"}, 
{
	"citycode": "MAS", 
	"airport": "Momote Airport", 
	"country": "Papua New Guinea", 
	"city": "Manus Island"}, 
{
	"citycode": "MDU", 
	"airport": "Mendi Airport", 
	"country": "Papua New Guinea", 
	"city": "Mendi"}, 
{
	"citycode": "MHY", 
	"airport": "Morehead Airport", 
	"country": "Papua New Guinea", 
	"city": "Morehead"}, 
{
	"citycode": "MIS", 
	"airport": "Misima Airport", 
	"country": "Papua New Guinea", 
	"city": "Misima Island"}, 
{
	"citycode": "MLQ", 
	"airport": "Malalaua Airport", 
	"country": "Papua New Guinea", 
	"city": "Malalaua"}, 
{
	"citycode": "NOM", 
	"airport": "Nosara Airport ", 
	"country": "Papua New Guinea", 
	"city": "Nomad River"}, 
{
	"citycode": "NWT", 
	"airport": "Nowata Municipal Airport", 
	"country": "Papua New Guinea", 
	"city": "Nowata"}, 
{
	"citycode": "OBM", 
	"airport": "Morobe Airport", 
	"country": "Papua New Guinea", 
	"city": "Morobe"}, 
{
	"citycode": "OBX", 
	"airport": "Obo Airport", 
	"country": "Papua New Guinea", 
	"city": "Obo"}, 
{
	"citycode": "OKP", 
	"airport": "Oksapmin Airport", 
	"country": "Papua New Guinea", 
	"city": "Oksapmin"}, 
{
	"citycode": "OLQ", 
	"airport": "Olsobip Airport", 
	"country": "Papua New Guinea", 
	"city": "Olsobip"}, 
{
	"citycode": "OPU", 
	"airport": "Balimo Airport", 
	"country": "Papua New Guinea", 
	"city": "Balimo"}, 
{
	"citycode": "PMN", 
	"airport": "Pumani Airport", 
	"country": "Papua New Guinea", 
	"city": "Pumani"}, 
{
	"citycode": "PNP", 
	"airport": "Girua Airport", 
	"country": "Papua New Guinea", 
	"city": "Popondetta"}, 
{
	"citycode": "POM", 
	"airport": "Jacksons International Airport", 
	"country": "Papua New Guinea", 
	"city": "Port Moresby"}, 
{
	"citycode": "RAB", 
	"airport": "Tokua Airport", 
	"country": "Papua New Guinea", 
	"city": "Rabaul"}, 
{
	"citycode": "RBP", 
	"airport": "Raba Raba Airport", 
	"country": "Papua New Guinea", 
	"city": "Rabaraba"}, 
{
	"citycode": "RGE", 
	"airport": "Porgera Airport", 
	"country": "Papua New Guinea", 
	"city": "Porgera"}, 
{
	"citycode": "RNR", 
	"airport": "Robinson River Airport", 
	"country": "Papua New Guinea", 
	"city": "Robinson River"}, 
{
	"citycode": "SAM", 
	"airport": "Salamo Airport", 
	"country": "Papua New Guinea", 
	"city": "Salamo"}, 
{
	"citycode": "SBE", 
	"airport": "Suabi Airport", 
	"country": "Papua New Guinea", 
	"city": "Suabi"}, 
{
	"citycode": "SFU", 
	"airport": "Safia Airport", 
	"country": "Papua New Guinea", 
	"city": "Safia"}, 
{
	"citycode": "SKC", 
	"airport": "Salt Lake City International Airport", 
	"country": "Papua New Guinea", 
	"city": "Suki"}, 
{
	"citycode": "SSS", 
	"airport": "Siassi Airport", 
	"country": "Papua New Guinea", 
	"city": "Siassi"}, 
{
	"citycode": "SWG", 
	"airport": "Satwag Airport", 
	"country": "Papua New Guinea", 
	"city": "Satwag"}, 
{
	"citycode": "SXH", 
	"airport": "Sehulea Airport", 
	"country": "Papua New Guinea", 
	"city": "Sehulea"}, 
{
	"citycode": "TBE", 
	"airport": "Timbunke Airport", 
	"country": "Papua New Guinea", 
	"city": "Timbunke"}, 
{
	"citycode": "TBG", 
	"airport": "Tabubil Airport", 
	"country": "Papua New Guinea", 
	"city": "Tabubil"}, 
{
	"citycode": "TDB", 
	"airport": "Tetabedi Airport", 
	"country": "Papua New Guinea", 
	"city": "Tetabedi"}, 
{
	"citycode": "TEO", 
	"airport": "Terapo Airport", 
	"country": "Papua New Guinea", 
	"city": "Terapo"}, 
{
	"citycode": "TFI", 
	"airport": "Tufi Airport", 
	"country": "Papua New Guinea", 
	"city": "Tufi"}, 
{
	"citycode": "TFM", 
	"airport": "Telefomin Airport", 
	"country": "Papua New Guinea", 
	"city": "Telefomin"}, 
{
	"citycode": "TIZ", 
	"airport": "Tari Airport", 
	"country": "Papua New Guinea", 
	"city": "Tari"}, 
{
	"citycode": "TLP", 
	"airport": "Tumolbil Airport", 
	"country": "Papua New Guinea", 
	"city": "Tumolbil"}, 
{
	"citycode": "UKU", 
	"airport": "Nuku Airport", 
	"country": "Papua New Guinea", 
	"city": "Nuku"}, 
{
	"citycode": "UNG", 
	"airport": "Kiunga Airport", 
	"country": "Papua New Guinea", 
	"city": "Kiunga"}, 
{
	"citycode": "VAI", 
	"airport": "Vanimo Airport", 
	"country": "Papua New Guinea", 
	"city": "Vanimo"}, 
{
	"citycode": "VIV", 
	"airport": "Vivigani Airport", 
	"country": "Papua New Guinea", 
	"city": "Vivigani"}, 
{
	"citycode": "VMU", 
	"airport": "Baimuru Airport", 
	"country": "Papua New Guinea", 
	"city": "Baimuru"}, 
{
	"citycode": "WBM", 
	"airport": "Wapenamanda Airport", 
	"country": "Papua New Guinea", 
	"city": "Wapenamanda"}, 
{
	"citycode": "WED", 
	"airport": "Wedau Airport", 
	"country": "Papua New Guinea", 
	"city": "Wedau"}, 
{
	"citycode": "WPM", 
	"airport": "Wipim Airport", 
	"country": "Papua New Guinea", 
	"city": "Wipim"}, 
{
	"citycode": "WSU", 
	"airport": "Wasu Airport", 
	"country": "Papua New Guinea", 
	"city": "Wasu"}, 
{
	"citycode": "WUG", 
	"airport": "Wau Airport", 
	"country": "Papua New Guinea", 
	"city": "Wau"}, 
{
	"citycode": "WUV", 
	"airport": "Wuvulu Island Airport", 
	"country": "Papua New Guinea", 
	"city": "Wuvulu Island"}, 
{
	"citycode": "WWK", 
	"airport": "Wewak Airport", 
	"country": "Papua New Guinea", 
	"city": "Wewak"}, 
{
	"citycode": "XBN", 
	"airport": "Biniguni Airport", 
	"country": "Papua New Guinea", 
	"city": "Biniguni"}, 
{
	"citycode": "ASU", 
	"airport": "Silvio Pettirossi International Airport", 
	"country": "Paraguay", 
	"city": "Asuncion"}, 
{
	"citycode": "ANS", 
	"airport": "Andahuaylas Airport", 
	"country": "Peru", 
	"city": "Andahuaylas"}, 
{
	"citycode": "AQP", 
	"airport": "Rodriguez Ballon International Airport", 
	"country": "Peru", 
	"city": "Arequipa"}, 
{
	"citycode": "AYP", 
	"airport": "Coronel FAP Alfredo Mend?vil Duarte Airport", 
	"country": "Peru", 
	"city": "Ayacucho"}, 
{
	"citycode": "CHH", 
	"airport": "Chachapoyas Airport", 
	"country": "Peru", 
	"city": "Chachapoyas"}, 
{
	"citycode": "CHM", 
	"airport": "Teniente FAP Jaime Montreuil Morales Airport", 
	"country": "Peru", 
	"city": "Chimbote"}, 
{
	"citycode": "CIX", 
	"airport": "Captain José Abelardo Qui?ones Gonz?lez International Airport", 
	"country": "Peru", 
	"city": "Chiclayo"}, 
{
	"citycode": "CJA", 
	"airport": "Cajamarca airport ", 
	"country": "Peru", 
	"city": "Cajamarca"}, 
{
	"citycode": "CUZ", 
	"airport": "Alejandro Velasco Astete International Airport", 
	"country": "Peru", 
	"city": "Cuzco"}, 
{
	"citycode": "IQT", 
	"airport": "Coronel FAP Francisco Secada Vignetta International Airport", 
	"country": "Peru", 
	"city": "Iquitos"}, 
{
	"citycode": "JJI", 
	"airport": "Juanjui Airport", 
	"country": "Peru", 
	"city": "Juanjui"}, 
{
	"citycode": "JUL", 
	"airport": "Juliaca Airport", 
	"country": "Peru", 
	"city": "Juliaca"}, 
{
	"citycode": "LIM", 
	"airport": "Jorge Ch?vez International Airport", 
	"country": "Peru", 
	"city": "Lima"}, 
{
	"citycode": "PCL", 
	"airport": "FAP Captain David Abensur Rengifo International Airport", 
	"country": "Peru", 
	"city": "Pucallpa"}, 
{
	"citycode": "PEM", 
	"airport": "Padre Aldamiz International Airport", 
	"country": "Peru", 
	"city": "Puerto Maldonado"}, 
{
	"citycode": "PIU", 
	"airport": "PAF Captain Guillermo Concha Iberico International Airport", 
	"country": "Peru", 
	"city": "Piura"}, 
{
	"citycode": "RIJ", 
	"airport": "Juan Simons Vela Airport", 
	"country": "Peru", 
	"city": "Rioja"}, 
{
	"citycode": "TBP", 
	"airport": "Cap. FAP Pedro Canga Rodr?guez Airport", 
	"country": "Peru", 
	"city": "Tumbes"}, 
{
	"citycode": "TCQ", 
	"airport": "Coronel FAP Carlos Ciriani Santa Rosa International Airport", 
	"country": "Peru", 
	"city": "Tacna"}, 
{
	"citycode": "TGI", 
	"airport": "Tingo Maria Airport", 
	"country": "Peru", 
	"city": "Tingo Maria"}, 
{
	"citycode": "TPP", 
	"airport": "Cadete FAP Guillermo Del Castillo Paredes Airport", 
	"country": "Peru", 
	"city": "Tarapoto"}, 
{
	"citycode": "TRU", 
	"airport": "Trujillo International Airport", 
	"country": "Peru", 
	"city": "Trujillo"}, 
{
	"citycode": "TYL", 
	"airport": "Berlin Tegel Airport", 
	"country": "Peru", 
	"city": "Talara"}, 
{
	"citycode": "YMS", 
	"airport": "Moises Benzaquen Rengifo Airport", 
	"country": "Peru", 
	"city": "Yurimaguas"}, 
{
	"citycode": "BQN", 
	"airport": "Rafael Hern?ndez International Airport", 
	"country": "Puerto Rico", 
	"city": "Aguadilla"}, 
{
	"citycode": "CPX", 
	"airport": "Benjam?n Rivera Noriega Airport", 
	"country": "Puerto Rico", 
	"city": "Culebra"}, 
{
	"citycode": "FAJ", 
	"airport": "Diego Jiménez Torres Airport", 
	"country": "Puerto Rico", 
	"city": "Fajardo"}, 
{
	"citycode": "MAZ", 
	"airport": "Eugenio Mar?a de Hostos Airport", 
	"country": "Puerto Rico", 
	"city": "Mayaguez"}, 
{
	"citycode": "PSE", 
	"airport": "Mercedita International Airport", 
	"country": "Puerto Rico", 
	"city": "Ponce"}, 
{
	"citycode": "SIG", 
	"airport": "Fernando Luis Ribas Dominicci Airport", 
	"country": "Puerto Rico", 
	"city": "San Juan"}, 
{
	"citycode": "SJU", 
	"airport": "Luis Munoz Marin International Airport", 
	"country": "Puerto Rico", 
	"city": "San Juan"}, 
{
	"citycode": "VQS", 
	"airport": "Antonio Rivera Rodr?guez Airport", 
	"country": "Puerto Rico", 
	"city": "Vieques"}, 
{
	"citycode": "ARW", 
	"airport": "Arad International Airport", 
	"country": "Romania", 
	"city": "Arad"}, 
{
	"citycode": "BAY", 
	"airport": "Maramures International Airport", 
	"country": "Romania", 
	"city": "Baia Mare"}, 
{
	"citycode": "BBU", 
	"airport": "Bucharest Aurel Vlaicu Airport", 
	"country": "Romania", 
	"city": "Bucharest"}, 
{
	"citycode": "BUH", 
	"airport": "Bucharest All Airports", 
	"country": "Romania", 
	"city": "Bucharest"}, 
{
	"citycode": "CLJ", 
	"airport": "Avram Iancu Cluj International Airport", 
	"country": "Romania", 
	"city": "Cluj"}, 
{
	"citycode": "CND", 
	"airport": "Mihail Kog?lniceanu International Airport", 
	"country": "Romania", 
	"city": "Constanta"}, 
{
	"citycode": "CSB", 
	"airport": "Caransebes Airport", 
	"country": "Romania", 
	"city": "Caransebes"}, 
{
	"citycode": "IAS", 
	"airport": "Iasi International Airport", 
	"country": "Romania", 
	"city": "Iasi"}, 
{
	"citycode": "OMR", 
	"airport": "Oradea Airport", 
	"country": "Romania", 
	"city": "Oradea"}, 
{
	"citycode": "OTP", 
	"airport": "Otopeni International Airport", 
	"country": "Romania", 
	"city": "Bucharest"}, 
{
	"citycode": "SBZ", 
	"airport": "Sibiu International Airport", 
	"country": "Romania", 
	"city": "Sibiu"}, 
{
	"citycode": "SCV", 
	"airport": "Suceava Stefan cel Mare International Airport", 
	"country": "Romania", 
	"city": "Suceava"}, 
{
	"citycode": "SUJ", 
	"airport": "Satu Mare Airport", 
	"country": "Romania", 
	"city": "Satu Mare"}, 
{
	"citycode": "TGM", 
	"airport": "Târgu Mure? Transilvania Airport", 
	"country": "Romania", 
	"city": "Tirgu Mures"}, 
{
	"citycode": "TSR", 
	"airport": "Timisoara International Airport", 
	"country": "Romania", 
	"city": "Timisoara"}, 
{
	"citycode": "GYI", 
	"airport": "Gisenyi Airport", 
	"country": "Rwanda", 
	"city": "Gisenyi"}, 
{
	"citycode": "KGL", 
	"airport": "Kigali International Airport", 
	"country": "Rwanda", 
	"city": "Kigali"}, 
{
	"citycode": "KME", 
	"airport": "Kamembe International Airport", 
	"country": "Rwanda", 
	"city": "Kamembe"}, 
{
	"citycode": "RHG", 
	"airport": "Ruhengeri Airport", 
	"country": "Rwanda", 
	"city": "Ruhengeri"}, 
{
	"citycode": "NEV", 
	"airport": "Vance W. Amory International Airport", 
	"country": "St. Kitts And Nevis", 
	"city": "Nevis"}, 
{
	"citycode": "SKB", 
	"airport": "Robert L. Bradshaw International Airport", 
	"country": "St. Kitts And Nevis", 
	"city": "St Kitts"}, 
{
	"citycode": "CIW", 
	"airport": "Canouan Airport", 
	"country": "Saint Vincent and the Grenadines", 
	"city": "Canouan Island"}, 
{
	"citycode": "MQS", 
	"airport": "Mustique Airport", 
	"country": "Saint Vincent and the Grenadines", 
	"city": "Mustique Island"}, 
{
	"citycode": "SVD", 
	"airport": "Argyle International Airport", 
	"country": "Saint Vincent and the Grenadines", 
	"city": "St Vincent"}, 
{
	"citycode": "UNI", 
	"airport": "Union Island Airport", 
	"country": "Saint Vincent and the Grenadines", 
	"city": "Union Island"}, 
{
	"citycode": "APW", 
	"airport": "Faleolo International Airport", 
	"country": "Samoa", 
	"city": "Apia"}, 
{
	"citycode": "MXS", 
	"airport": "Maota Airport", 
	"country": "Samoa", 
	"city": "Maota Savaii Is"}, 
{
	"citycode": "PCP", 
	"airport": "Principe Airport", 
	"country": "Sao Tome and Principe", 
	"city": "Principe"}, 
{
	"citycode": "TMS", 
	"airport": "Sao Tome International Airport", 
	"country": "Sao Tome and Principe", 
	"city": "Sao Tome Island"}, 
{
	"citycode": "BXE", 
	"airport": "Bakel Airport", 
	"country": "Senegal", 
	"city": "Bakel"}, 
{
	"citycode": "CSK", 
	"airport": "Cap Skirring Airport", 
	"country": "Senegal", 
	"city": "Cap Skirring"}, 
{
	"citycode": "DKR", 
	"airport": "Leopold Sedar Senghor International Airport", 
	"country": "Senegal", 
	"city": "Dakar"}, 
{
	"citycode": "DSS", 
	"airport": "Blaise Diagne International Airport", 
	"country": "Senegal", 
	"city": "Ndiass"}, 
{
	"citycode": "KDA", 
	"airport": "Kolda North Airport ", 
	"country": "Senegal", 
	"city": "Kolda"}, 
{
	"citycode": "KGG", 
	"airport": "Kedougou Airport", 
	"country": "Senegal", 
	"city": "Kedougou"}, 
{
	"citycode": "KLC", 
	"airport": "Kaolack Airport", 
	"country": "Senegal", 
	"city": "Kaolack"}, 
{
	"citycode": "MAX", 
	"airport": "Ouro Sogui Airport ", 
	"country": "Senegal", 
	"city": "Matam"}, 
{
	"citycode": "POD", 
	"airport": "Podor Airport", 
	"country": "Senegal", 
	"city": "Podor"}, 
{
	"citycode": "RDT", 
	"airport": "Richard Toll Airport", 
	"country": "Senegal", 
	"city": "Richard Toll"}, 
{
	"citycode": "SMY", 
	"airport": "Simenti Airport", 
	"country": "Senegal", 
	"city": "Simenti"}, 
{
	"citycode": "TUD", 
	"airport": "Tambacounda Airport", 
	"country": "Senegal", 
	"city": "Tambacounda"}, 
{
	"citycode": "XLS", 
	"airport": "St Louis Airport", 
	"country": "Senegal", 
	"city": "St Louis"}, 
{
	"citycode": "ZIG", 
	"airport": "Ziguinchor Airport", 
	"country": "Senegal", 
	"city": "Ziguinchor"}, 
{
	"citycode": "BEG", 
	"airport": "Belgrade Nikola Tesla Airport", 
	"country": "Serbia", 
	"city": "Belgrade"}, 
{
	"citycode": "INI", 
	"airport": "Nis Constantine the Great Airport", 
	"country": "Serbia", 
	"city": "Nis"}, 
{
	"citycode": "PRN", 
	"airport": "Prishtina International Airport", 
	"country": "Serbia", 
	"city": "Pristina"}, 
{
	"citycode": "BDI", 
	"airport": "Bird Island Airport", 
	"country": "Seychelles", 
	"city": "Bird Island"}, 
{
	"citycode": "DEI", 
	"airport": "Denis Island", 
	"country": "Seychelles", 
	"city": "Denis Island"}, 
{
	"citycode": "DES", 
	"airport": "Desroches Airport", 
	"country": "Seychelles", 
	"city": "Desroches"}, 
{
	"citycode": "PRI", 
	"airport": "Praslin Island Airport", 
	"country": "Seychelles", 
	"city": "Praslin Island"}, 
{
	"citycode": "SEZ", 
	"airport": "Seychelles International Airport", 
	"country": "Seychelles", 
	"city": "Mahe Island"}, 
{
	"citycode": "BTS", 
	"airport": "Bratislava Airport", 
	"country": "Slovakia", 
	"city": "Bratislava"}, 
{
	"citycode": "KSC", 
	"airport": "Kosice International Airport", 
	"country": "Slovakia", 
	"city": "Kosice"}, 
{
	"citycode": "PZY", 
	"airport": "Piestany Airport", 
	"country": "Slovakia", 
	"city": "Piestany"}, 
{
	"citycode": "SLD", 
	"airport": "Sliac Airport", 
	"country": "Slovakia", 
	"city": "Sliac"}, 
{
	"citycode": "TAT", 
	"airport": "Poprad-Tatry Airport", 
	"country": "Slovakia", 
	"city": "Poprad-Tatry"}, 
{
	"citycode": "LJU", 
	"airport": "Ljubljana Airport", 
	"country": "Slovenia", 
	"city": "Ljubljana"}, 
{
	"citycode": "MBX", 
	"airport": "Maribor Edvard Rusjan Airport", 
	"country": "Slovenia", 
	"city": "Maribor"}, 
{
	"citycode": "POW", 
	"airport": "Portoroz Airport", 
	"country": "Slovenia", 
	"city": "Portoroz"}, 
{
	"citycode": "AVU", 
	"airport": "Avu Avu Airport", 
	"country": "Solomon Islands", 
	"city": "Avu Avu"}, 
{
	"citycode": "BAS", 
	"airport": "Ballalae Airport", 
	"country": "Solomon Islands", 
	"city": "Balalae"}, 
{
	"citycode": "BNY", 
	"airport": "Bellona Airport", 
	"country": "Solomon Islands", 
	"city": "Bellona"}, 
{
	"citycode": "CHY", 
	"airport": "Choiseul Bay Airport", 
	"country": "Solomon Islands", 
	"city": "Choiseul Bay"}, 
{
	"citycode": "EGM", 
	"airport": "Seghe Airport", 
	"country": "Solomon Islands", 
	"city": "Sege"}, 
{
	"citycode": "FRE", 
	"airport": "Fera Airport", 
	"country": "Solomon Islands", 
	"city": "Fera Island"}, 
{
	"citycode": "GZO", 
	"airport": "Gizo Airport", 
	"country": "Solomon Islands", 
	"city": "Gizo"}, 
{
	"citycode": "HIR", 
	"airport": "Honiara International Airport", 
	"country": "Solomon Islands", 
	"city": "Honiara"}, 
{
	"citycode": "IRA", 
	"airport": "Kirakira Airport", 
	"country": "Solomon Islands", 
	"city": "Kirakira"}, 
{
	"citycode": "MBU", 
	"airport": "Mbambanakira Airport", 
	"country": "Solomon Islands", 
	"city": "Mbambanakira"}, 
{
	"citycode": "MNY", 
	"airport": "Mono Airport", 
	"country": "Solomon Islands", 
	"city": "Mono"}, 
{
	"citycode": "MUA", 
	"airport": "Munda Airport", 
	"country": "Solomon Islands", 
	"city": "Munda"}, 
{
	"citycode": "NNB", 
	"airport": "Santa Ana Airport", 
	"country": "Solomon Islands", 
	"city": "Santa Ana"}, 
{
	"citycode": "PRS", 
	"airport": "Parasi Airport", 
	"country": "Solomon Islands", 
	"city": "Parasi"}, 
{
	"citycode": "RIN", 
	"airport": "Ringi Cove Airport", 
	"country": "Solomon Islands", 
	"city": "Ringi Cove"}, 
{
	"citycode": "RNL", 
	"airport": "Rennell/Tingoa Airport", 
	"country": "Solomon Islands", 
	"city": "Rennell"}, 
{
	"citycode": "RUS", 
	"airport": "Marau Airport", 
	"country": "Solomon Islands", 
	"city": "Marau Sound"}, 
{
	"citycode": "SCZ", 
	"airport": "Santa Cruz Island Airport", 
	"country": "Solomon Islands", 
	"city": "Santa Cruz Island"}, 
{
	"citycode": "XYA", 
	"airport": "Yandina Airport", 
	"country": "Solomon Islands", 
	"city": "Yandina"}, 
{
	"citycode": "ATB", 
	"airport": "Atbara Airport", 
	"country": "Sudan", 
	"city": "Atbara"}, 
{
	"citycode": "DOG", 
	"airport": "Dongola Airport", 
	"country": "Sudan", 
	"city": "Dongola"}, 
{
	"citycode": "EBD", 
	"airport": "El Obeid Airport", 
	"country": "Sudan", 
	"city": "El Obeid"}, 
{
	"citycode": "EDB", 
	"airport": "Al Dabbah Airport", 
	"country": "Sudan", 
	"city": "Eldebba"}, 
{
	"citycode": "EGN", 
	"airport": "Geneina Airport", 
	"country": "Sudan", 
	"city": "Geneina"}, 
{
	"citycode": "ELF", 
	"airport": "El Fasher Airport", 
	"country": "Sudan", 
	"city": "El Fasher"}, 
{
	"citycode": "JUB", 
	"airport": "Juba International Airport", 
	"country": "Sudan", 
	"city": "Juba"}, 
{
	"citycode": "KRT", 
	"airport": "Khartoum International Airport", 
	"country": "Sudan", 
	"city": "Khartoum"}, 
{
	"citycode": "KSL", 
	"airport": "Kassala Airport", 
	"country": "Sudan", 
	"city": "Kassala"}, 
{
	"citycode": "MWE", 
	"airport": "Merowe Airport", 
	"country": "Sudan", 
	"city": "Merowe"}, 
{
	"citycode": "PZU", 
	"airport": "Port Sudan New International Airport", 
	"country": "Sudan", 
	"city": "Port Sudan"}, 
{
	"citycode": "RSS", 
	"airport": "Damazin Airport", 
	"country": "Sudan", 
	"city": "Roseires"}, 
{
	"citycode": "UYL", 
	"airport": "Nyala Airport", 
	"country": "Sudan", 
	"city": "Nyala"}, 
{
	"citycode": "ICK", 
	"airport": "Majoor Henry Fernandes Airport", 
	"country": "Suriname", 
	"city": "Nieuw Nickerie"}, 
{
	"citycode": "ORG", 
	"airport": "Zorg En Hoop Airport", 
	"country": "Suriname", 
	"city": "Paramaribo"}, 
{
	"citycode": "PBM", 
	"airport": "Johan Adolf Pengel International Airport", 
	"country": "Suriname", 
	"city": "Paramaribo"}, 
{
	"citycode": "MTS", 
	"airport": "Matsapha International Airport", 
	"country": "Swaziland", 
	"city": "Manzini (Mbabane)"}, 
{
	"citycode": "ACH", 
	"airport": "St Gallen Altenrhein Airport", 
	"country": "Switzerland", 
	"city": "Altenrhein"}, 
{
	"citycode": "BRN", 
	"airport": "Bern Airport", 
	"country": "Switzerland", 
	"city": "Berne"}, 
{
	"citycode": "BSL", 
	"airport": "EuroAirport Basel Mulhouse Freiburg", 
	"country": "Switzerland", 
	"city": "Basel-Mulhouse"}, 
{
	"citycode": "GVA", 
	"airport": "Geneva Airport", 
	"country": "Switzerland", 
	"city": "Geneva"}, 
{
	"citycode": "LUG", 
	"airport": "Lugano Airport", 
	"country": "Switzerland", 
	"city": "Lugano"}, 
{
	"citycode": "SIR", 
	"airport": "Sion Airport", 
	"country": "Switzerland", 
	"city": "Sion"}, 
{
	"citycode": "SMV", 
	"airport": "Samedan Airport", 
	"country": "Switzerland", 
	"city": "St Moritz"}, 
{
	"citycode": "ZRH", 
	"airport": "Zurich International Airport", 
	"country": "Switzerland", 
	"city": "Zurich"}, 
{
	"citycode": "BKZ", 
	"airport": "Bukoba Airport", 
	"country": "Tanzania", 
	"city": "Bukoba"}, 
{
	"citycode": "DAR", 
	"airport": "Julius Nyerere International Airport", 
	"country": "Tanzania", 
	"city": "Dar Es Salaam"}, 
{
	"citycode": "DOD", 
	"airport": "Dodoma Airport", 
	"country": "Tanzania", 
	"city": "Dodoma"}, 
{
	"citycode": "IRI", 
	"airport": "Iringa Airport", 
	"country": "Tanzania", 
	"city": "Iringa"}, 
{
	"citycode": "JRO", 
	"airport": "Kilimanjaro International Airport", 
	"country": "Tanzania", 
	"city": "Kilimanjaro"}, 
{
	"citycode": "LDI", 
	"airport": "Lindi Airport", 
	"country": "Tanzania", 
	"city": "Lindi"}, 
{
	"citycode": "MFA", 
	"airport": "Mafia Airport", 
	"country": "Tanzania", 
	"city": "Mafia"}, 
{
	"citycode": "MUZ", 
	"airport": "Musoma International Airport", 
	"country": "Tanzania", 
	"city": "Musoma"}, 
{
	"citycode": "MWZ", 
	"airport": "Mwanza International Airport", 
	"country": "Tanzania", 
	"city": "Mwanza"}, 
{
	"citycode": "MYW", 
	"airport": "Mtwara Airport", 
	"country": "Tanzania", 
	"city": "Mtwara"}, 
{
	"citycode": "NCH", 
	"airport": "Nachingwea Airport", 
	"country": "Tanzania", 
	"city": "Nachingwea"}, 
{
	"citycode": "PMA", 
	"airport": "Pemba Airport", 
	"country": "Tanzania", 
	"city": "Pemba"}, 
{
	"citycode": "SGX", 
	"airport": "Songea Airport", 
	"country": "Tanzania", 
	"city": "Songea"}, 
{
	"citycode": "SHY", 
	"airport": "Shinyanga Airport", 
	"country": "Tanzania", 
	"city": "Shinyanga"}, 
{
	"citycode": "SUT", 
	"airport": "Sumbawanga Airport", 
	"country": "Tanzania", 
	"city": "Sumbawanga"}, 
{
	"citycode": "TBO", 
	"airport": "Tabora Airport", 
	"country": "Tanzania", 
	"city": "Tabora"}, 
{
	"citycode": "TGT", 
	"airport": "Tanga Airport", 
	"country": "Tanzania", 
	"city": "Tanga"}, 
{
	"citycode": "TKQ", 
	"airport": "Kigoma Airport", 
	"country": "Tanzania", 
	"city": "Kigoma"}, 
{
	"citycode": "ZNZ", 
	"airport": "Abeid Amani Karume International Airport", 
	"country": "Tanzania", 
	"city": "Zanzibar"}, 
{
	"citycode": "LFW", 
	"airport": "Lomé–Tokoin International Airport", 
	"country": "Togo", 
	"city": "Lome"}, 
{
	"citycode": "EUA", 
	"airport": "Kaufana Airport", 
	"country": "Tonga", 
	"city": "Eua"}, 
{
	"citycode": "HPA", 
	"airport": "Salote Pilolevu Lifuka Island Airport", 
	"country": "Tonga", 
	"city": "Ha`Apai"}, 
{
	"citycode": "NFO", 
	"airport": "Niuafo?ou Airport", 
	"country": "Tonga", 
	"city": "Niuafo`ou"}, 
{
	"citycode": "NTT", 
	"airport": "Mataaho Airport", 
	"country": "Tonga", 
	"city": "Niuatoputapu"}, 
{
	"citycode": "TBU", 
	"airport": "Fua`Amotu International Airport", 
	"country": "Tonga", 
	"city": "Nuku`Alofa"}, 
{
	"citycode": "VAV", 
	"airport": "Vava?u International Airport", 
	"country": "Tonga", 
	"city": "Vava`u"}, 
{
	"citycode": "POS", 
	"airport": "Piarco International Airport", 
	"country": "Trinidad and Tobago", 
	"city": "Port of Spain"}, 
{
	"citycode": "TAB", 
	"airport": "A.N.R. Robinson International Airport", 
	"country": "Trinidad and Tobago", 
	"city": "Tobago"}, 
{
	"citycode": "ADA", 
	"airport": "Adana Airport ", 
	"country": "Turkey", 
	"city": "Adana"}, 
{
	"citycode": "ADB", 
	"airport": "Izmir Adnan Menderes Airport", 
	"country": "Turkey", 
	"city": "Izmir"}, 
{
	"citycode": "ASR", 
	"airport": "Kayseri Erkilet Airport", 
	"country": "Turkey", 
	"city": "Kayseri"}, 
{
	"citycode": "AYT", 
	"airport": "Antalya Airport", 
	"country": "Turkey", 
	"city": "Antalya"}, 
{
	"citycode": "BAL", 
	"airport": "Batman Airport", 
	"country": "Turkey", 
	"city": "Batman"}, 
{
	"citycode": "BJV", 
	"airport": "Milas–Bodrum Airport", 
	"country": "Turkey", 
	"city": "Bodrum."}, 
{
	"citycode": "COV", 
	"airport": "Cukurova International Airport", 
	"country": "Turkey", 
	"city": "Adana"}, 
{
	"citycode": "DIY", 
	"airport": "Diyarbakir Airport", 
	"country": "Turkey", 
	"city": "Diyarbakir"}, 
{
	"citycode": "DLM", 
	"airport": "Dalaman Airport", 
	"country": "Turkey", 
	"city": "Dalaman"}, 
{
	"citycode": "DNZ", 
	"airport": "Denizli Cardak Airport", 
	"country": "Turkey", 
	"city": "Denizli"}, 
{
	"citycode": "EDO", 
	"airport": "Bal?kesir Koca Seyit Airport", 
	"country": "Turkey", 
	"city": "Edremit Korfez"}, 
{
	"citycode": "ERZ", 
	"airport": "Erzurum Airport", 
	"country": "Turkey", 
	"city": "Erzurum"}, 
{
	"citycode": "ESB", 
	"airport": "Ankara Esenboga Airport", 
	"country": "Turkey", 
	"city": "Ankara"}, 
{
	"citycode": "GNY", 
	"airport": "Sanliurfa GAP Airport", 
	"country": "Turkey", 
	"city": "Sanliurfa"}, 
{
	"citycode": "GZP", 
	"airport": "Gazipasa Alanya Airport", 
	"country": "Turkey", 
	"city": "Gazipasa"}, 
{
	"citycode": "GZT", 
	"airport": "Gaziantep O?uzeli International Airport", 
	"country": "Turkey", 
	"city": "Gaziantep"}, 
{
	"citycode": "HTY", 
	"airport": "Hatay", 
	"country": "Turkey", 
	"city": "Hatay"}, 
{
	"citycode": "IST", 
	"airport": "Istanbul Airport", 
	"country": "Turkey", 
	"city": "Istanbul"}, 
{
	"citycode": "IZM", 
	"airport": "Izmir", 
	"country": "Turkey", 
	"city": "Izmir"}, 
{
	"citycode": "KYA", 
	"airport": "Konya Airport", 
	"country": "Turkey", 
	"city": "Konya"}, 
{
	"citycode": "MLX", 
	"airport": "Malatya Airport", 
	"country": "Turkey", 
	"city": "Malatya"}, 
{
	"citycode": "MQM", 
	"airport": "Mardin Airport", 
	"country": "Turkey", 
	"city": "Mardin"}, 
{
	"citycode": "SAW", 
	"airport": "Sabiha Gokcen International Airport", 
	"country": "Turkey", 
	"city": "Istanbul"}, 
{
	"citycode": "SZF", 
	"airport": "Samsun Carsamba Airport", 
	"country": "Turkey", 
	"city": "Samsun"}, 
{
	"citycode": "TZX", 
	"airport": "Trabzon Airport", 
	"country": "Turkey", 
	"city": "Trabzon"}, 
{
	"citycode": "VAN", 
	"airport": "Van Ferit Melen Airport", 
	"country": "Turkey", 
	"city": "Van"}, 
{
	"citycode": "MDS", 
	"airport": "Middle Caicos Airport", 
	"country": "Turks and Caicos Islands", 
	"city": "Middle Caicos"}, 
{
	"citycode": "NCA", 
	"airport": "North Caicos Airport", 
	"country": "Turks and Caicos Islands", 
	"city": "North Caicos"}, 
{
	"citycode": "PLS", 
	"airport": "Providenciales International Airport", 
	"country": "Turks and Caicos Islands", 
	"city": "Providenciales"}, 
{
	"citycode": "SLX", 
	"airport": "Salt Cay Airport", 
	"country": "Turks and Caicos Islands", 
	"city": "Salt Cay"}, 
{
	"citycode": "XSC", 
	"airport": "South Caicos Airport", 
	"country": "Turks and Caicos Islands", 
	"city": "South Caicos"}, 
{
	"citycode": "SSB", 
	"airport": "St Croix Island Airport", 
	"country": "U.S. Virgin Islands", 
	"city": "St Croix Island"}, 
{
	"citycode": "STT", 
	"airport": "Cyril E. King Airport", 
	"country": "U.S. Virgin Islands", 
	"city": "St Thomas Island"}, 
{
	"citycode": "STX", 
	"airport": "Henry E. Rohlsen Airport", 
	"country": "U.S. Virgin Islands", 
	"city": "St Croix Island"}, 
{
	"citycode": "EBB", 
	"airport": "Entebbe International Airport", 
	"country": "Uganda", 
	"city": "Entebbe"}, 
{
	"citycode": "KSE", 
	"airport": "Kasese Airport", 
	"country": "Uganda", 
	"city": "Kasese"}, 
{
	"citycode": "RUA", 
	"airport": "Arua Airport", 
	"country": "Uganda", 
	"city": "Arua"}, 
{
	"citycode": "DNK", 
	"airport": "Dnipropetrovsk International Airport", 
	"country": "Ukraine", 
	"city": "Dnepropetrovsk"}, 
{
	"citycode": "DOK", 
	"airport": "Donetsk International Airport", 
	"country": "Ukraine", 
	"city": "Donetsk"}, 
{
	"citycode": "HMJ", 
	"airport": "Khmelnitskyi Airport", 
	"country": "Ukraine", 
	"city": "Khmelnitskiy"}, 
{
	"citycode": "HRK", 
	"airport": "Kharkiv International Airport", 
	"country": "Ukraine", 
	"city": "Kharkov"}, 
{
	"citycode": "IEV", 
	"airport": "Sikorsky International Airport", 
	"country": "Ukraine", 
	"city": "Kiev"}, 
{
	"citycode": "IFO", 
	"airport": "Ivano-Frankivsk International Airport", 
	"country": "Ukraine", 
	"city": "Ivano-Frankovsk"}, 
{
	"citycode": "KBP", 
	"airport": "Boryspil International Airport", 
	"country": "Ukraine", 
	"city": "Kiev"}, 
{
	"citycode": "KHE", 
	"airport": "Kherson International Airport", 
	"country": "Ukraine", 
	"city": "Kherson"}, 
{
	"citycode": "KWG", 
	"airport": "Kryvyi Rih International Airport", 
	"country": "Ukraine", 
	"city": "Krivoy Rog"}, 
{
	"citycode": "LWO", 
	"airport": "Danylo Halytskyi International Airport", 
	"country": "Ukraine", 
	"city": "Lvov"}, 
{
	"citycode": "MPW", 
	"airport": "Mariupol International Airport", 
	"country": "Ukraine", 
	"city": "Mariupol"}, 
{
	"citycode": "ODS", 
	"airport": "Odesa International Airport", 
	"country": "Ukraine", 
	"city": "Odessa"}, 
{
	"citycode": "OZH", 
	"airport": "Zaporizhzhia International Airport", 
	"country": "Ukraine", 
	"city": "Zaporozhye"}, 
{
	"citycode": "SDZ", 
	"airport": "All Airports Shetland Islands", 
	"country": "Ukraine", 
	"city": "Shetland Islands"}, 
{
	"citycode": "SIP", 
	"airport": "Simferopol International Airport", 
	"country": "Ukraine", 
	"city": "Simferopol"}, 
{
	"citycode": "UDJ", 
	"airport": "Uzhhorod International Airport", 
	"country": "Ukraine", 
	"city": "Uzhgorod"}, 
{
	"citycode": "VSG", 
	"airport": "Luhansk International Airport", 
	"country": "Ukraine", 
	"city": "Lugansk"}, 
{
	"citycode": "ATI", 
	"airport": "Artigas International Airport", 
	"country": "Uruguay", 
	"city": "Artigas"}, 
{
	"citycode": "CYR", 
	"airport": "Colonia Airport", 
	"country": "Uruguay", 
	"city": "Colonia"}, 
{
	"citycode": "MLZ", 
	"airport": "Melo", 
	"country": "Uruguay", 
	"city": "Melo"}, 
{
	"citycode": "MVD", 
	"airport": "Carrasco International Airport", 
	"country": "Uruguay", 
	"city": "Montevideo"}, 
{
	"citycode": "PDP", 
	"airport": "Capit?n de Corbeta Carlos A. Curbelo International Airport", 
	"country": "Uruguay", 
	"city": "Punta Del Este"}, 
{
	"citycode": "PDU", 
	"airport": "Paysandu Airport", 
	"country": "Uruguay", 
	"city": "Paysandu"}, 
{
	"citycode": "RVY", 
	"airport": "Oscar D. Gestido International Airport", 
	"country": "Uruguay", 
	"city": "Rivera"}, 
{
	"citycode": "STY", 
	"airport": "Nueva Hesperides International Airport", 
	"country": "Uruguay", 
	"city": "Salto"}, 
{
	"citycode": "TAW", 
	"airport": "Tacuarembo Airport", 
	"country": "Uruguay", 
	"city": "Tacuarembo"}, 
{
	"citycode": "AUY", 
	"airport": "Aneityum Airport", 
	"country": "Vanuatu", 
	"city": "Aneityum"}, 
{
	"citycode": "AWD", 
	"airport": "Aniwa Airport", 
	"country": "Vanuatu", 
	"city": "Aniwa"}, 
{
	"citycode": "CCV", 
	"airport": "Craig Cove Airport", 
	"country": "Vanuatu", 
	"city": "Craig Cove"}, 
{
	"citycode": "DLY", 
	"airport": "Dillons Bay Airport", 
	"country": "Vanuatu", 
	"city": "Dillons Bay"}, 
{
	"citycode": "EAE", 
	"airport": "Siwo Aromai Airport", 
	"country": "Vanuatu", 
	"city": "Emae"}, 
{
	"citycode": "FTA", 
	"airport": "Futuna Airport", 
	"country": "Vanuatu", 
	"city": "Futuna Island"}, 
{
	"citycode": "IPA", 
	"airport": "Ipota Airport", 
	"country": "Vanuatu", 
	"city": "Ipota"}, 
{
	"citycode": "LNB", 
	"airport": "Lamen Bay Airport", 
	"country": "Vanuatu", 
	"city": "Lamen Bay"}, 
{
	"citycode": "LNE", 
	"airport": "Lonorore Airport", 
	"country": "Vanuatu", 
	"city": "Lonorore"}, 
{
	"citycode": "LOD", 
	"airport": "Longana Airport", 
	"country": "Vanuatu", 
	"city": "Longana"}, 
{
	"citycode": "LPM", 
	"airport": "Lamap Airport", 
	"country": "Vanuatu", 
	"city": "Lamap"}, 
{
	"citycode": "MTV", 
	"airport": "Mota Lava Airport", 
	"country": "Vanuatu", 
	"city": "Mota Lava"}, 
{
	"citycode": "MWF", 
	"airport": "Maewo-Naone Airport", 
	"country": "Vanuatu", 
	"city": "Maewo"}, 
{
	"citycode": "NUS", 
	"airport": "Norsup Airport", 
	"country": "Vanuatu", 
	"city": "Norsup"}, 
{
	"citycode": "OLJ", 
	"airport": "Olpoi Airport", 
	"country": "Vanuatu", 
	"city": "Olpoi"}, 
{
	"citycode": "SLH", 
	"airport": "Sola Airport", 
	"country": "Vanuatu", 
	"city": "Sola"}, 
{
	"citycode": "SON", 
	"airport": "Santo International Airport", 
	"country": "Vanuatu", 
	"city": "Espiritu Santo"}, 
{
	"citycode": "SSR", 
	"airport": "Sara Airport", 
	"country": "Vanuatu", 
	"city": "Sara"}, 
{
	"citycode": "SWJ", 
	"airport": "South West Bay Airport", 
	"country": "Vanuatu", 
	"city": "South West Bay"}, 
{
	"citycode": "TAH", 
	"airport": "Whitegrass Airport", 
	"country": "Vanuatu", 
	"city": "Tanna"}, 
{
	"citycode": "TGH", 
	"airport": "Tongoa Airport", 
	"country": "Vanuatu", 
	"city": "Tongoa"}, 
{
	"citycode": "TOH", 
	"airport": "Torres Airport", 
	"country": "Vanuatu", 
	"city": "Torres"}, 
{
	"citycode": "ULB", 
	"airport": "Ulei Airport", 
	"country": "Vanuatu", 
	"city": "ULEI"}, 
{
	"citycode": "VLI", 
	"airport": "Bauerfield International Airport", 
	"country": "Vanuatu", 
	"city": "Port Vila"}, 
{
	"citycode": "VLS", 
	"airport": "Valesdir Airport", 
	"country": "Vanuatu", 
	"city": "Valesdir"}, 
{
	"citycode": "WLH", 
	"airport": "Walaha Airport", 
	"country": "Vanuatu", 
	"city": "Walaha"}, 
{
	"citycode": "AAO", 
	"airport": "Colonel James Jabara Airport", 
	"country": "Venezuela", 
	"city": "Anaco"}, 
{
	"citycode": "AGV", 
	"airport": "Oswaldo Guevara Mujica Airport", 
	"country": "Venezuela", 
	"city": "Acarigua"}, 
{
	"citycode": "BLA", 
	"airport": "General J A Anzoategui International Airport", 
	"country": "Venezuela", 
	"city": "Barcelona"}, 
{
	"citycode": "BNS", 
	"airport": "Barinas Airport", 
	"country": "Venezuela", 
	"city": "Barinas"}, 
{
	"citycode": "BRM", 
	"airport": "Jacinto Lara International Airport", 
	"country": "Venezuela", 
	"city": "Barquisimeto"}, 
{
	"citycode": "CAJ", 
	"airport": "Canaima Airport", 
	"country": "Venezuela", 
	"city": "Canaima"}, 
{
	"citycode": "CBL", 
	"airport": "Tom?s de Heres Airport", 
	"country": "Venezuela", 
	"city": "Ciudad Bolivar"}, 
{
	"citycode": "CCS", 
	"airport": "Sim?n Bol?var International Airport", 
	"country": "Venezuela", 
	"city": "Caracas"}, 
{
	"citycode": "CUM", 
	"airport": "Antonio José de Sucre Airport", 
	"country": "Venezuela", 
	"city": "Cumana"}, 
{
	"citycode": "CUP", 
	"airport": "General José Francisco Berm?dez Airport", 
	"country": "Venezuela", 
	"city": "Carupano"}, 
{
	"citycode": "CXA", 
	"airport": "Caicara del Orinoco Airport ", 
	"country": "Venezuela", 
	"city": "Caicara De Oro"}, 
{
	"citycode": "CZE", 
	"airport": "José Leonardo Chirino International Airport", 
	"country": "Venezuela", 
	"city": "Coro"}, 
{
	"citycode": "GUI", 
	"airport": "Cristobal Colon Airport", 
	"country": "Venezuela", 
	"city": "Guiria"}, 
{
	"citycode": "GUQ", 
	"airport": "Guanare Airport", 
	"country": "Venezuela", 
	"city": "Guanare"}, 
{
	"citycode": "LFR", 
	"airport": "La Fria Airport", 
	"country": "Venezuela", 
	"city": "La Fria"}, 
{
	"citycode": "LRV", 
	"airport": "Los Roques Airport", 
	"country": "Venezuela", 
	"city": "Los Roques"}, 
{
	"citycode": "LSP", 
	"airport": "Josefa Camejo International Airport", 
	"country": "Venezuela", 
	"city": "Las Piedras"}, 
{
	"citycode": "MAR", 
	"airport": "La Chinita International Airport", 
	"country": "Venezuela", 
	"city": "Maracaibo"}, 
{
	"citycode": "MRD", 
	"airport": "Alberto Carnevalli Airport", 
	"country": "Venezuela", 
	"city": "Merida"}, 
{
	"citycode": "MUN", 
	"airport": "José Tadeo Monagas International Airport", 
	"country": "Venezuela", 
	"city": "Maturin"}, 
{
	"citycode": "PBL", 
	"airport": "General Bartolome Salom Airport", 
	"country": "Venezuela", 
	"city": "Puerto Cabello"}, 
{
	"citycode": "PMV", 
	"airport": "Santiago Mari?o Caribbean International Airport", 
	"country": "Venezuela", 
	"city": "Porlamar"}, 
{
	"citycode": "PYH", 
	"airport": "Cacique Aramare Airport", 
	"country": "Venezuela", 
	"city": "Puerto Ayacucho"}, 
{
	"citycode": "PZO", 
	"airport": "Manuel Carlos Piar Guayana International Airport", 
	"country": "Venezuela", 
	"city": "Puerto Ordaz"}, 
{
	"citycode": "SFD", 
	"airport": "Las Flecheras Airport", 
	"country": "Venezuela", 
	"city": "San Fernando De Apure"}, 
{
	"citycode": "SOM", 
	"airport": "San Tome Airport", 
	"country": "Venezuela", 
	"city": "San Tome"}, 
{
	"citycode": "STB", 
	"airport": "Miguel Urdaneta Fernandez Airport", 
	"country": "Venezuela", 
	"city": "Santa Barbara Ed"}, 
{
	"citycode": "STD", 
	"airport": "Mayor Buenaventura Vivas Airport", 
	"country": "Venezuela", 
	"city": "Santo Domingo"}, 
{
	"citycode": "SVZ", 
	"airport": "San Antonio Del Tachira Airport", 
	"country": "Venezuela", 
	"city": "San Antonio"}, 
{
	"citycode": "TUV", 
	"airport": "San Rafael Airport", 
	"country": "Venezuela", 
	"city": "Tucupita"}, 
{
	"citycode": "VDP", 
	"airport": "Valle De Pascua", 
	"country": "Venezuela", 
	"city": "Valle De Pascua"}, 
{
	"citycode": "VLN", 
	"airport": "Arturo Michelena International Airport", 
	"country": "Venezuela", 
	"city": "Valencia"}, 
{
	"citycode": "VLV", 
	"airport": "Colonel Antonio Nicolas Briceno Airport", 
	"country": "Venezuela", 
	"city": "Valera"}, 
{
	"citycode": "DAD", 
	"airport": "Da Nang International Airport", 
	"country": "Viet Nam", 
	"city": "Da Nang"}, 
{
	"citycode": "HAN", 
	"airport": "Noi Bai International Airport", 
	"country": "Viet Nam", 
	"city": "Hanoi"}, 
{
	"citycode": "HUI", 
	"airport": "Phu Bai International Airport", 
	"country": "Viet Nam", 
	"city": "Hue"}, 
{
	"citycode": "NHA", 
	"airport": "Nha Trang Airport", 
	"country": "Viet Nam", 
	"city": "Nha Trang"}, 
{
	"citycode": "SGN", 
	"airport": "Tan Son Nhat International Airport", 
	"country": "Viet Nam", 
	"city": "Ho Chi Minh City"}, 
{
	"citycode": "VCA", 
	"airport": "Can Tho International Airport", 
	"country": "Viet Nam", 
	"city": "Can Tho"}, 
{
	"citycode": "EIS", 
	"airport": "Terrance B. Lettsome Airport", 
	"country": "British Virgin Islands", 
	"city": "Beef Island"}, 
{
	"citycode": "NGD", 
	"airport": "Auguste George Airport", 
	"country": "British Virgin Islands", 
	"city": "Anegada"}, 
{
	"citycode": "VIJ", 
	"airport": "Virgin Gorda Airport", 
	"country": "British Virgin Islands", 
	"city": "Virgin Gorda"}, 
{
	"citycode": "CIP", 
	"airport": "Chipata Airport", 
	"country": "Zambia", 
	"city": "Chipata"}, 
{
	"citycode": "KAA", 
	"airport": "Kasama Airport", 
	"country": "Zambia", 
	"city": "Kasama"}, 
{
	"citycode": "LUN", 
	"airport": "Kenneth Kaunda International Airport", 
	"country": "Zambia", 
	"city": "Lusaka"}, 
{
	"citycode": "LVI", 
	"airport": "Harry Mwanga Nkumbula International Airport", 
	"country": "Zambia", 
	"city": "Livingstone"}, 
{
	"citycode": "MFU", 
	"airport": "Mfuwe Airport", 
	"country": "Zambia", 
	"city": "Mfuwe"}, 
{
	"citycode": "NLA", 
	"airport": "Simon Mwansa Kapwepwe International Airport", 
	"country": "Zambia", 
	"city": "Ndola"}, 
{
	"citycode": "ZKB", 
	"airport": "Kasaba Bay", 
	"country": "Zambia", 
	"city": "Kasaba Bay"}, 
{
	"citycode": "ALU", 
	"airport": "Alula", 
	"country": "Somalia", 
	"city": "Alula"}, 
{
	"citycode": "BBO", 
	"airport": "Berbera International Airport", 
	"country": "Somalia", 
	"city": "Berbera"}, 
{
	"citycode": "BSA", 
	"airport": "Bosaso Airport", 
	"country": "Somalia", 
	"city": "Bossaso"}, 
{
	"citycode": "BUO", 
	"airport": "Burao Airport", 
	"country": "Somalia", 
	"city": "Burao"}, 
{
	"citycode": "GGR", 
	"airport": "General Mohamed Abshir Airport", 
	"country": "Somalia", 
	"city": "Garoe"}, 
{
	"citycode": "GLK", 
	"airport": "Abdullahi Yusuf Airport", 
	"country": "Somalia", 
	"city": "Galcaio"}, 
{
	"citycode": "HGA", 
	"airport": "Hargeisa International Airport", 
	"country": "Somalia", 
	"city": "Hargeisa"}, 
{
	"citycode": "KMU", 
	"airport": "Kismayo International Airport", 
	"country": "Somalia", 
	"city": "Kismayu"}, 
{
	"citycode": "MGQ", 
	"airport": "Aden Adde International Airport", 
	"country": "Somalia", 
	"city": "Mogadishu"}, 
{
	"citycode": "GZA", 
	"airport": "Gaza International Airport", 
	"country": "Palestinian Territory", 
	"city": "Gaza City"}, 
{
	"citycode": "ASA", 
	"airport": "Assab International Airport", 
	"country": "Eritrea", 
	"city": "Assab"}, 
{
	"citycode": "ASM", 
	"airport": "Asmara International Airport", 
	"country": "Eritrea", 
	"city": "Asmara"}, 
{
	"citycode": "MSW", 
	"airport": "Massawa International Airport", 
	"country": "Eritrea", 
	"city": "Massawa"}, 
{
	"citycode": "TES", 
	"airport": "Teseney Airport", 
	"country": "Eritrea", 
	"city": "Tessenei"}, 
{
	"citycode": "AEH", 
	"airport": "Abecher Airport", 
	"country": "Chad", 
	"city": "Abecher"}, 
{
	"citycode": "AKM", 
	"airport": "Zakouma Airport", 
	"country": "Chad", 
	"city": "Zakouma"}, 
{
	"citycode": "AMC", 
	"airport": "Am Timan Airport", 
	"country": "Chad", 
	"city": "Am Timan"}, 
{
	"citycode": "AMO", 
	"airport": "Mao Airport", 
	"country": "Chad", 
	"city": "Mao"}, 
{
	"citycode": "AOD", 
	"airport": "Abou Deia Airport", 
	"country": "Chad", 
	"city": "Abou Deia"}, 
{
	"citycode": "ATV", 
	"airport": "Ati Airport", 
	"country": "Chad", 
	"city": "Ati"}, 
{
	"citycode": "BKR", 
	"airport": "Bokoro Airport", 
	"country": "Chad", 
	"city": "Bokoro"}, 
{
	"citycode": "MEF", 
	"airport": "Melfi Airport ", 
	"country": "Chad", 
	"city": "Melfi"}, 
{
	"citycode": "MQQ", 
	"airport": "Moundou Airport", 
	"country": "Chad", 
	"city": "Moundou"}, 
{
	"citycode": "MVO", 
	"airport": "Mongo Airport", 
	"country": "Chad", 
	"city": "Mongo"}, 
{
	"citycode": "NDJ", 
	"airport": "Ndjamena International Airport", 
	"country": "Chad", 
	"city": "Ndjamena"}, 
{
	"citycode": "OGR", 
	"airport": "Bongor Airport", 
	"country": "Chad", 
	"city": "Bongor"}, 
{
	"citycode": "OTC", 
	"airport": "Bol Airport", 
	"country": "Chad", 
	"city": "Bol"}, 
{
	"citycode": "OUM", 
	"airport": "Oum Hadjer Airport", 
	"country": "Chad", 
	"city": "Oum Hadjer"}, 
{
	"citycode": "OUT", 
	"airport": "Bousso Airport", 
	"country": "Chad", 
	"city": "Bousso"}, 
{
	"citycode": "PLF", 
	"airport": "Pala Airport", 
	"country": "Chad", 
	"city": "Pala"}, 
{
	"citycode": "SRH", 
	"airport": "Sarh Airport", 
	"country": "Chad", 
	"city": "Sarh"}, 
{
	"citycode": "ACC", 
	"airport": "Kotoka International Airport", 
	"country": "Ghana", 
	"city": "Accra"}, 
{
	"citycode": "KMS", 
	"airport": "Kumasi International Airport", 
	"country": "Ghana", 
	"city": "Kumasi"}, 
{
	"citycode": "NYI", 
	"airport": "Sunyani Airport", 
	"country": "Ghana", 
	"city": "Sunyani"}, 
{
	"citycode": "TKD", 
	"airport": "Takoradi Airport", 
	"country": "Ghana", 
	"city": "Takoradi"}, 
{
	"citycode": "TML", 
	"airport": "Tamale International Airport", 
	"country": "Ghana", 
	"city": "Tamale"}, 
{
	"citycode": "DYU", 
	"airport": "Dushanbe International Airport", 
	"country": "Tajikistan", 
	"city": "Dushanbe"}, 
{
	"citycode": "AJY", 
	"airport": "Mano Dayak International Airport", 
	"country": "Niger", 
	"city": "Agades"}, 
{
	"citycode": "MFQ", 
	"airport": "Maradi Airport", 
	"country": "Niger", 
	"city": "Maradi"}, 
{
	"citycode": "NIM", 
	"airport": "Diori Hamani International Airport", 
	"country": "Niger", 
	"city": "Niamey"}, 
{
	"citycode": "THZ", 
	"airport": "Tahoua Airport", 
	"country": "Niger", 
	"city": "Tahoua"}, 
{
	"citycode": "ZND", 
	"airport": "Zinder International Airport", 
	"country": "Niger", 
	"city": "Zinder"}, 
{
	"citycode": "BTE", 
	"airport": "Sherbro International Airport", 
	"country": "Sierra Leone", 
	"city": "Bonthe"}, 
{
	"citycode": "FNA", 
	"airport": "Freetown International Airport", 
	"country": "Sierra Leone", 
	"city": "Freetown"}, 
{
	"citycode": "GBK", 
	"airport": "Gbangbatok Airport", 
	"country": "Sierra Leone", 
	"city": "Gbangbatok"}, 
{
	"citycode": "HGS", 
	"airport": "Hastings Airport", 
	"country": "Sierra Leone", 
	"city": "Freetown"}, 
{
	"citycode": "JMY", 
	"airport": "Mammy Yoko Heliport", 
	"country": "Sierra Leone", 
	"city": "Freetown"}, 
{
	"citycode": "KBA", 
	"airport": "Kabala Airport", 
	"country": "Sierra Leone", 
	"city": "Kabala"}, 
{
	"citycode": "KBS", 
	"airport": "Bo Airport", 
	"country": "Sierra Leone", 
	"city": "Bo"}, 
{
	"citycode": "KEN", 
	"airport": "Kenema Airport", 
	"country": "Sierra Leone", 
	"city": "Kenema"}, 
{
	"citycode": "WYE", 
	"airport": "Yengema Airport", 
	"country": "Sierra Leone", 
	"city": "Yengema"}, 
{
	"citycode": "AEO", 
	"airport": "Aioun El Atrouss Airport", 
	"country": "Mauritania", 
	"city": "Aioun El Atrouss"}, 
{
	"citycode": "AJJ", 
	"airport": "Akjoujt Airport", 
	"country": "Mauritania", 
	"city": "Akjoujt"}, 
{
	"citycode": "ATR", 
	"airport": "Atar International Airport", 
	"country": "Mauritania", 
	"city": "Atar"}, 
{
	"citycode": "BGH", 
	"airport": "Abbey Airport", 
	"country": "Mauritania", 
	"city": "Boghe"}, 
{
	"citycode": "EMN", 
	"airport": "Nema Airport", 
	"country": "Mauritania", 
	"city": "Nema"}, 
{
	"citycode": "FGD", 
	"airport": "Fderik Airport", 
	"country": "Mauritania", 
	"city": "Fderik"}, 
{
	"citycode": "KED", 
	"airport": "Kaedi Airport", 
	"country": "Mauritania", 
	"city": "Kaedi"}, 
{
	"citycode": "KFA", 
	"airport": "Kiffa Airport", 
	"country": "Mauritania", 
	"city": "Kiffa"}, 
{
	"citycode": "MOM", 
	"airport": "Letfotar Airport", 
	"country": "Mauritania", 
	"city": "Moudjeria"}, 
{
	"citycode": "NDB", 
	"airport": "Nouadhibou International Airport", 
	"country": "Mauritania", 
	"city": "Nouadhibou"}, 
{
	"citycode": "NKC", 
	"airport": "Nouakchott–Oumtounsy International Airport", 
	"country": "Mauritania", 
	"city": "Nouakchott"}, 
{
	"citycode": "OTL", 
	"airport": "Boutilimit Airport", 
	"country": "Mauritania", 
	"city": "Boutilimit"}, 
{
	"citycode": "OUZ", 
	"airport": "Zouerate International Airport", 
	"country": "Mauritania", 
	"city": "Zouerate"}, 
{
	"citycode": "SEY", 
	"airport": "Selibaby Airport", 
	"country": "Mauritania", 
	"city": "Selibaby"}, 
{
	"citycode": "THI", 
	"airport": "Tichit Airport", 
	"country": "Mauritania", 
	"city": "Tichitt"}, 
{
	"citycode": "THT", 
	"airport": "Tamchakett Airport", 
	"country": "Mauritania", 
	"city": "Tamchakett"}, 
{
	"citycode": "TIY", 
	"airport": "Tidjikja Airport", 
	"country": "Mauritania", 
	"city": "Tidjikja"}, 
{
	"citycode": "TMD", 
	"airport": "Timbedra Airport", 
	"country": "Mauritania", 
	"city": "Timbedra"}, 
{
	"citycode": "ABF", 
	"airport": "Abaiang Airport", 
	"country": "Kiribati", 
	"city": "Abaiang"}, 
{
	"citycode": "AEA", 
	"airport": "Abemama Airstrip", 
	"country": "Kiribati", 
	"city": "Abemama Atoll"}, 
{
	"citycode": "AIS", 
	"airport": "Arorae Airport", 
	"country": "Kiribati", 
	"city": "Arorae Island"}, 
{
	"citycode": "BBG", 
	"airport": "Branson Airport", 
	"country": "Kiribati", 
	"city": "Butaritari"}, 
{
	"citycode": "BEZ", 
	"airport": "Beru Airport", 
	"country": "Kiribati", 
	"city": "Beru"}, 
{
	"citycode": "CXI", 
	"airport": "Cassidy International Airport", 
	"country": "Kiribati", 
	"city": "Christmas Island"}, 
{
	"citycode": "KUC", 
	"airport": "Kuria Airport", 
	"country": "Kiribati", 
	"city": "Kuria"}, 
{
	"citycode": "MNK", 
	"airport": "Maiana Airport", 
	"country": "Kiribati", 
	"city": "Maiana"}, 
{
	"citycode": "MTK", 
	"airport": "Makin Airport", 
	"country": "Kiribati", 
	"city": "Makin Island"}, 
{
	"citycode": "MZK", 
	"airport": "Marakei Airport", 
	"country": "Kiribati", 
	"city": "Marakei"}, 
{
	"citycode": "NIG", 
	"airport": "Nikunau Airport", 
	"country": "Kiribati", 
	"city": "Nikunau"}, 
{
	"citycode": "NON", 
	"airport": "Nonouti Airport", 
	"country": "Kiribati", 
	"city": "Nonouti"}, 
{
	"citycode": "OOT", 
	"airport": "Onotoa Airport", 
	"country": "Kiribati", 
	"city": "Onotoa"}, 
{
	"citycode": "TBF", 
	"airport": "Tabiteuea North Airport", 
	"country": "Kiribati", 
	"city": "Tabiteuea North"}, 
{
	"citycode": "TMN", 
	"airport": "Tamana Airport", 
	"country": "Kiribati", 
	"city": "Tamana Island"}, 
{
	"citycode": "TRW", 
	"airport": "Bonriki International Airport", 
	"country": "Kiribati", 
	"city": "Tarawa"}, 
{
	"citycode": "TSU", 
	"airport": "Tabiteuea South Airport", 
	"country": "Kiribati", 
	"city": "Tabiteuea South"}, 
{
	"citycode": "KSA", 
	"airport": "Kosrae International Airport", 
	"country": "Micronesia", 
	"city": "Kosrae"}, 
{
	"citycode": "PNI", 
	"airport": "Pohnpei International Airport ", 
	"country": "Micronesia", 
	"city": "Pohnpei"}, 
{
	"citycode": "TKK", 
	"airport": "Chuuk International Airport", 
	"country": "Micronesia", 
	"city": "Truk"}, 
{
	"citycode": "YAP", 
	"airport": "Yap International Airport", 
	"country": "Micronesia", 
	"city": "Yap"}, 
{
	"citycode": "INU", 
	"airport": "Nauru International Airport", 
	"country": "Nauru", 
	"city": "Nauru Island"}, 
{
	"citycode": "SLU", 
	"airport": "George F. L. Charles Airport", 
	"country": "Saint Lucia", 
	"city": "Saint Lucia"}, 
{
	"citycode": "UVF", 
	"airport": "Hewanorra International Airport", 
	"country": "Saint Lucia", 
	"city": "Saint Lucia"}, 
{
	"citycode": "DIL", 
	"airport": "President Nicolau Lobato International Airport", 
	"country": "East Timor (Timor-Leste)", 
	"city": "Dili"}, 
{
	"citycode": "ASB", 
	"airport": "Ashgabat Airport", 
	"country": "Turkmenistan", 
	"city": "Ashgabat"}, 
{
	"citycode": "KRW", 
	"airport": "Turkmenbashi International Airport", 
	"country": "Turkmenistan", 
	"city": "Turkmenbashi"}, 
{
	"citycode": "TAZ", 
	"airport": "Dashoguz International Airport", 
	"country": "Turkmenistan", 
	"city": "Dashoguz"}, 
{
	"citycode": "ASK", 
	"airport": "Yamoussoukro International Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Yamoussoukro"}, 
{
	"citycode": "BBV", 
	"airport": "Nero-Mer Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Bereby"}, 
{
	"citycode": "BDK", 
	"airport": "Soko Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Bondoukou"}, 
{
	"citycode": "BQO", 
	"airport": "Bouna Tehini Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Bouna"}, 
{
	"citycode": "BXI", 
	"airport": "Boundiali", 
	"country": "Cote d`Ivoire", 
	"city": "Boundiali"}, 
{
	"citycode": "BYK", 
	"airport": "Bouake Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Bouake"}, 
{
	"citycode": "DIM", 
	"airport": "Dimbokro Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Dimbokro"}, 
{
	"citycode": "DJO", 
	"airport": "Daloa Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Daloa"}, 
{
	"citycode": "GGN", 
	"airport": "Gagnoa Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Gagnoa"}, 
{
	"citycode": "GGO", 
	"airport": "Guiglo Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Guiglo"}, 
{
	"citycode": "HGO", 
	"airport": "Korhogo Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Korhogo"}, 
{
	"citycode": "KEO", 
	"airport": "Odienne Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Odienne"}, 
{
	"citycode": "KTC", 
	"airport": "Katiola Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Katiola"}, 
{
	"citycode": "MJC", 
	"airport": "Man Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Man"}, 
{
	"citycode": "OFI", 
	"airport": "Ouango Fitini Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Ouango Fitini"}, 
{
	"citycode": "OGO", 
	"airport": "Abengourou Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Abengourou"}, 
{
	"citycode": "SEO", 
	"airport": "Seguela Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Seguela"}, 
{
	"citycode": "SPY", 
	"airport": "San Pedro Airport", 
	"country": "Cote d`Ivoire", 
	"city": "San Pedro"}, 
{
	"citycode": "TOZ", 
	"airport": "Mahana Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Touba"}, 
{
	"citycode": "TXU", 
	"airport": "Tabou Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Tabou"}, 
{
	"citycode": "ZSS", 
	"airport": "Sassandra Airport", 
	"country": "Cote d`Ivoire", 
	"city": "Sassandra"}, 
{
	"citycode": "ACE", 
	"airport": "Lanzarote Airport", 
	"country": "Canary Islands, Spain", 
	"city": "Lanzarote"}, 
{
	"citycode": "FUE", 
	"airport": "Fuerteventura Airport", 
	"country": "Canary Islands, Spain", 
	"city": "Fuerteventura"}, 
{
	"citycode": "LPA", 
	"airport": "Gran Canaria Airport", 
	"country": "Canary Islands, Spain", 
	"city": "Las Palmas"}, 
{
	"citycode": "SPC", 
	"airport": "La Palma Airport", 
	"country": "Canary Islands, Spain", 
	"city": "Santa Cruz De La Palma"}, 
{
	"citycode": "TFN", 
	"airport": "Tenerife North Airport", 
	"country": "Canary Islands, Spain", 
	"city": "Tenerife"}, 
{
	"citycode": "TFS", 
	"airport": "Tenerife South Airport", 
	"country": "Canary Islands, Spain", 
	"city": "Tenerife"}, 
{
	"citycode": "AIG", 
	"airport": "Yalinga", 
	"country": "Central African Republic", 
	"city": "Yalinga"}, 
{
	"citycode": "BBT", 
	"airport": "Berberati Airport", 
	"country": "Central African Republic", 
	"city": "Berberati"}, 
{
	"citycode": "BBY", 
	"airport": "Bambari Airport", 
	"country": "Central African Republic", 
	"city": "Bambari"}, 
{
	"citycode": "BCF", 
	"airport": "Bouca Airport", 
	"country": "Central African Republic", 
	"city": "Bouca"}, 
{
	"citycode": "BEM", 
	"airport": "Beni Mellal Airport", 
	"country": "Central African Republic", 
	"city": "Bossembele"}, 
{
	"citycode": "BGF", 
	"airport": "Bangui M`Poko International Airport", 
	"country": "Central African Republic", 
	"city": "Bangui"}, 
{
	"citycode": "BGU", 
	"airport": "Bangassou Airport", 
	"country": "Central African Republic", 
	"city": "Bangassou"}, 
{
	"citycode": "BIV", 
	"airport": "West Michigan Regional Airport", 
	"country": "Central African Republic", 
	"city": "Bria"}, 
{
	"citycode": "BMF", 
	"airport": "Luchthaven Bakouma Airport", 
	"country": "Central African Republic", 
	"city": "Bakouma"}, 
{
	"citycode": "BOP", 
	"airport": "Bouar Airport", 
	"country": "Central African Republic", 
	"city": "Bouar"}, 
{
	"citycode": "BOZ", 
	"airport": "Bozoum Airport", 
	"country": "Central African Republic", 
	"city": "Bozoum"}, 
{
	"citycode": "BSN", 
	"airport": "Bossangoa Airport", 
	"country": "Central African Republic", 
	"city": "Bossangoa"}, 
{
	"citycode": "BTG", 
	"airport": "Batangafo Airport", 
	"country": "Central African Republic", 
	"city": "Batangafo"}, 
{
	"citycode": "CRF", 
	"airport": "Carnot Airport", 
	"country": "Central African Republic", 
	"city": "Carnot"}, 
{
	"citycode": "GDI", 
	"airport": "Gordil Airport", 
	"country": "Central African Republic", 
	"city": "Gordil"}, 
{
	"citycode": "IMO", 
	"airport": "Sam Mbakwe International Cargo Airport", 
	"country": "Central African Republic", 
	"city": "Zemio"}, 
{
	"citycode": "IRO", 
	"airport": "Birao Airport", 
	"country": "Central African Republic", 
	"city": "Birao"}, 
{
	"citycode": "MKI", 
	"airport": "M`Boki Airport", 
	"country": "Central African Republic", 
	"city": "M`Boki"}, 
{
	"citycode": "NDL", 
	"airport": "Ndele Airport", 
	"country": "Central African Republic", 
	"city": "Ndele"}, 
{
	"citycode": "ODA", 
	"airport": "Ouadda Airport", 
	"country": "Central African Republic", 
	"city": "Ouadda"}, 
{
	"citycode": "ODJ", 
	"airport": "Ouanda Djalle Airport", 
	"country": "Central African Republic", 
	"city": "Ouanda Djalle"}, 
{
	"citycode": "RFA", 
	"airport": "Rafai Airport", 
	"country": "Central African Republic", 
	"city": "Rafai"}, 
{
	"citycode": "MPN", 
	"airport": "RAF Mount Pleasant", 
	"country": "Falkland Islands", 
	"city": "Mount Pleasant"}, 
{
	"citycode": "FAE", 
	"airport": "Vagar Airport", 
	"country": "Faroe Islands", 
	"city": "Faroe Islands"}, 
{
	"citycode": "GOH", 
	"airport": "Nuuk International Airport", 
	"country": "Greenland", 
	"city": "Nuuk"}, 
{
	"citycode": "JAV", 
	"airport": "Ilulissat Airport", 
	"country": "Greenland", 
	"city": "Ilulissat"}, 
{
	"citycode": "JCH", 
	"airport": "Qasigiannguit Airport", 
	"country": "Greenland", 
	"city": "Qasigiannguit"}, 
{
	"citycode": "JEG", 
	"airport": "Aasiaat Airport", 
	"country": "Greenland", 
	"city": "Aasiaat"}, 
{
	"citycode": "JFR", 
	"airport": "Paamiut Airport", 
	"country": "Greenland", 
	"city": "Paamiut"}, 
{
	"citycode": "JGO", 
	"airport": "Qeqertarsuaq Heliport", 
	"country": "Greenland", 
	"city": "Qeqertarsuaq"}, 
{
	"citycode": "JGR", 
	"airport": "Groennedal Airport", 
	"country": "Greenland", 
	"city": "Groennedal"}, 
{
	"citycode": "JHS", 
	"airport": "Sisimiut Airport", 
	"country": "Greenland", 
	"city": "Sisimiut"}, 
{
	"citycode": "JJU", 
	"airport": "Qaqortoq Heliport", 
	"country": "Greenland", 
	"city": "Qaqortoq"}, 
{
	"citycode": "JNN", 
	"airport": "Nanortalik Heliport", 
	"country": "Greenland", 
	"city": "Nanortalik"}, 
{
	"citycode": "JNS", 
	"airport": "Narsaq Heliport", 
	"country": "Greenland", 
	"city": "Narsaq"}, 
{
	"citycode": "JSU", 
	"airport": "Maniitsoq Airport", 
	"country": "Greenland", 
	"city": "Maniitsoq"}, 
{
	"citycode": "JUV", 
	"airport": "Upernavik Airport", 
	"country": "Greenland", 
	"city": "Upernavik"}, 
{
	"citycode": "KUS", 
	"airport": "Kulusuk Airport", 
	"country": "Greenland", 
	"city": "Kulusuk"}, 
{
	"citycode": "SFJ", 
	"airport": "Kangerlussuaq Airport", 
	"country": "Greenland", 
	"city": "Kangerlussuaq"}, 
{
	"citycode": "UAK", 
	"airport": "Narsarsuaq International Airport", 
	"country": "Greenland", 
	"city": "Narsarsuaq"}, 
{
	"citycode": "UMD", 
	"airport": "Uummannaq Airport", 
	"country": "Greenland", 
	"city": "Uummannaq"}, 
{
	"citycode": "FNJ", 
	"airport": "Pyongyang Sunan International Airport", 
	"country": "Korea, DPR", 
	"city": "Pyongyang"}, 
{
	"citycode": "AIC", 
	"airport": "Ailinglaplap Airok Airport", 
	"country": "Marshall Islands", 
	"city": "Airok"}, 
{
	"citycode": "AIM", 
	"airport": "Ailuk Airport", 
	"country": "Marshall Islands", 
	"city": "Ailuk Island"}, 
{
	"citycode": "BII", 
	"airport": "Bikini Atoll Airport", 
	"country": "Marshall Islands", 
	"city": "Bikini Atoll"}, 
{
	"citycode": "ENT", 
	"airport": "Enewetak Auxiliary Airfield", 
	"country": "Marshall Islands", 
	"city": "Enewetak Island"}, 
{
	"citycode": "IMI", 
	"airport": "Ine Airport", 
	"country": "Marshall Islands", 
	"city": "Ine Island"}, 
{
	"citycode": "JAT", 
	"airport": "Jabot Airport", 
	"country": "Marshall Islands", 
	"city": "Jabot"}, 
{
	"citycode": "JEJ", 
	"airport": "Jeh Airport", 
	"country": "Marshall Islands", 
	"city": "Jeh"}, 
{
	"citycode": "KBT", 
	"airport": "Kaben Airport", 
	"country": "Marshall Islands", 
	"city": "Kaben"}, 
{
	"citycode": "KIO", 
	"airport": "Kili Airport", 
	"country": "Marshall Islands", 
	"city": "Kili Island"}, 
{
	"citycode": "KWA", 
	"airport": "Bucholz Army Airfield", 
	"country": "Marshall Islands", 
	"city": "Kwajalein"}, 
{
	"citycode": "LIK", 
	"airport": "Likiep Airport", 
	"country": "Marshall Islands", 
	"city": "Likiep Island"}, 
{
	"citycode": "LML", 
	"airport": "Lae Airport", 
	"country": "Marshall Islands", 
	"city": "Lae Island"}, 
{
	"citycode": "LOF", 
	"airport": "Loen Airport", 
	"country": "Marshall Islands", 
	"city": "Loen"}, 
{
	"citycode": "MAJ", 
	"airport": "Marshall Islands International Airport", 
	"country": "Marshall Islands", 
	"city": "Majuro"}, 
{
	"citycode": "MAV", 
	"airport": "Maloelap Airport", 
	"country": "Marshall Islands", 
	"city": "Maloelap Island"}, 
{
	"citycode": "MJB", 
	"airport": "Mejit Airport", 
	"country": "Marshall Islands", 
	"city": "Mejit Island"}, 
{
	"citycode": "MJE", 
	"airport": "Majkin Airport", 
	"country": "Marshall Islands", 
	"city": "Majkin"}, 
{
	"citycode": "NDK", 
	"airport": "Namorik Airport", 
	"country": "Marshall Islands", 
	"city": "Namdrik Island"}, 
{
	"citycode": "TIC", 
	"airport": "Tinak Airport", 
	"country": "Marshall Islands", 
	"city": "Tinak Island"}, 
{
	"citycode": "UIT", 
	"airport": "Jaluit Airport", 
	"country": "Marshall Islands", 
	"city": "Jaluit Island"}, 
{
	"citycode": "UJE", 
	"airport": "Ujae Airport", 
	"country": "Marshall Islands", 
	"city": "Ujae Island"}, 
{
	"citycode": "UTK", 
	"airport": "Utirik Airport", 
	"country": "Marshall Islands", 
	"city": "Utirik Island"}, 
{
	"citycode": "WJA", 
	"airport": "Woja Airport", 
	"country": "Marshall Islands", 
	"city": "Woja"}, 
{
	"citycode": "WTE", 
	"airport": "Wotje Airport", 
	"country": "Marshall Islands", 
	"city": "Wotje Island"}, 
{
	"citycode": "WTO", 
	"airport": "Wotho Airport", 
	"country": "Marshall Islands", 
	"city": "Wotho Island"}, 
{
	"citycode": "DZA", 
	"airport": "Dzaoudzi–Pamandzi International Airport", 
	"country": "Mayotte", 
	"city": "Dzaoudzi"}, 
{
	"citycode": "MNI", 
	"airport": "John A. Osborne / Gerald`s Airport", 
	"country": "Montserrat", 
	"city": "Montserrat"}, 
{
	"citycode": "BON", 
	"airport": "Bonaire International Airport", 
	"country": "Netherlands Antilles", 
	"city": "Bonaire"}, 
{
	"citycode": "CUR", 
	"airport": "Curaçao International Airport", 
	"country": "Netherlands Antilles", 
	"city": "Curacao"}, 
{
	"citycode": "EUX", 
	"airport": "F D Roosevelt Airport", 
	"country": "Netherlands Antilles", 
	"city": "St Eustatius"}, 
{
	"citycode": "SAB", 
	"airport": "Juancho E Yrausquin Airport", 
	"country": "Netherlands Antilles", 
	"city": "Saba Island"}, 
{
	"citycode": "SXM", 
	"airport": "Princess Juliana International Airport", 
	"country": "Netherlands Antilles", 
	"city": "St Maarten"}, 
{
	"citycode": "IUE", 
	"airport": "Hanan Niue International Airport", 
	"country": "Niue", 
	"city": "Niue Island"}, 
{
	"citycode": "ROP", 
	"airport": "Rota International Airport", 
	"country": "Northern Mariana Islands", 
	"city": "Rota"}, 
{
	"citycode": "SPN", 
	"airport": "Saipan International Airport", 
	"country": "Northern Mariana Islands", 
	"city": "Saipan"}, 
{
	"citycode": "TIQ", 
	"airport": "Tinian International Airport", 
	"country": "Northern Mariana Islands", 
	"city": "Tinian"}, 
{
	"citycode": "ROR", 
	"airport": "Roman Tmetuchl International Airport", 
	"country": "Palau", 
	"city": "Koror"}, 
{
	"citycode": "RUN", 
	"airport": "Roland Garros Airport", 
	"country": "Reunion", 
	"city": "St Denis de la Reunion"}, 
{
	"citycode": "ZSE", 
	"airport": "Saint-Pierre Pierrefonds Airport", 
	"country": "Reunion", 
	"city": "St Pierre dela Reunion"}, 
{
	"citycode": "FSP", 
	"airport": "St Pierre Airport", 
	"country": "St. Pierre and Miquelon", 
	"city": "St Pierre"}, 
{
	"citycode": "LYR", 
	"airport": "Svalbard Airport", 
	"country": "Svalbard (Norway)", 
	"city": "Longyearbyen"}, 
{
	"citycode": "FUN", 
	"airport": "Funafuti International Airport", 
	"country": "Tuvalu", 
	"city": "Funafuti Atol"}, 
{
	"citycode": "JON", 
	"airport": "Johnston Atoll Airport", 
	"country": "US Minor Outlying Islands", 
	"city": "Johnston Island"}, 
{
	"citycode": "FUT", 
	"airport": "Pointe Vele Airport", 
	"country": "Wallis and Futuna", 
	"city": "Futuna Island"}, 
{
	"citycode": "WLS", 
	"airport": "Hihifo Airport", 
	"country": "Wallis and Futuna Islands", 
	"city": "Wallis Island"}, 
{
	"citycode": "TIV", 
	"airport": "Tivat Airport", 
	"country": "Yugoslavia", 
	"city": "TIVAT"}, 
{
	"citycode": "GM", 
	"airport": "GM International Airport", 
	"country": "INDIA", 
	"city": "VI"}, 
{
	"citycode": "HBE", 
	"airport": "Borg El Arab Airport", 
	"country": "Egypt", 
	"city": "Borg El Arab"}, 
{
	"citycode": "TEC", 
	"airport": "Test Airport new updatedfefef", 
	"country": "AE - United Arab Emirates", 
	"city": "Test City 21"}, 
{
	"citycode": "NB", 
	"airport": "New Mumbai International Airport", 
	"country": "INDIA", 
	"city": "Mumbai"}, 
{
	"citycode": "LHR", 
	"airport": "Heathrow Airport", 
	"country": "United Kingdom", 
	"city": "London"}, 
]